(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File === 'function' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.et.cq === region.e0.cq)
	{
		return 'on line ' + region.et.cq;
	}
	return 'on lines ' + region.et.cq + ' through ' + region.e0.cq;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return word
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.hX,
		impl.jg,
		impl.i2,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	result = init(result.a);
	var model = result.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		result = A2(update, msg, model);
		stepper(model = result.a, viewMetadata);
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	}

	_Platform_dispatchEffects(managers, result.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				p: bag.n,
				q: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.q)
		{
			x = temp.p(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		r: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		r: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		aQ: func(record.aQ),
		eu: record.eu,
		el: record.el
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.aQ;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.eu;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.el) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.hX,
		impl.jg,
		impl.i2,
		function(sendToApp, initialModel) {
			var view = impl.ji;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.hX,
		impl.jg,
		impl.i2,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.eq && impl.eq(sendToApp)
			var view = impl.ji;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.gW);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.jb) && (_VirtualDom_doc.title = title = doc.jb);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.iA;
	var onUrlRequest = impl.iB;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		eq: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.gd === next.gd
							&& curr.fi === next.fi
							&& curr.f8.a === next.f8.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		hX: function(flags)
		{
			return A3(impl.hX, flags, _Browser_getUrl(), key);
		},
		ji: impl.ji,
		jg: impl.jg,
		i2: impl.i2
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { hR: 'hidden', g7: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { hR: 'mozHidden', g7: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { hR: 'msHidden', g7: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { hR: 'webkitHidden', g7: 'webkitvisibilitychange' }
		: { hR: 'hidden', g7: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		gk: _Browser_getScene(),
		jj: {
			cF: _Browser_window.pageXOffset,
			cG: _Browser_window.pageYOffset,
			jm: _Browser_doc.documentElement.clientWidth,
			hP: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		jm: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		hP: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			gk: {
				jm: node.scrollWidth,
				hP: node.scrollHeight
			},
			jj: {
				cF: node.scrollLeft,
				cG: node.scrollTop,
				jm: node.clientWidth,
				hP: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			gk: _Browser_getScene(),
			jj: {
				cF: x,
				cG: y,
				jm: _Browser_doc.documentElement.clientWidth,
				hP: _Browser_doc.documentElement.clientHeight
			},
			ht: {
				cF: x + rect.left,
				cG: y + rect.top,
				jm: rect.width,
				hP: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


/*
 * Copyright (c) 2010 Mozilla Corporation
 * Copyright (c) 2010 Vladimir Vukicevic
 * Copyright (c) 2013 John Mayer
 * Copyright (c) 2018 Andrey Kuzmin
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 */

// Vector2

var _MJS_v2 = F2(function(x, y) {
    return new Float64Array([x, y]);
});

var _MJS_v2getX = function(a) {
    return a[0];
};

var _MJS_v2getY = function(a) {
    return a[1];
};

var _MJS_v2setX = F2(function(x, a) {
    return new Float64Array([x, a[1]]);
});

var _MJS_v2setY = F2(function(y, a) {
    return new Float64Array([a[0], y]);
});

var _MJS_v2toRecord = function(a) {
    return { cF: a[0], cG: a[1] };
};

var _MJS_v2fromRecord = function(r) {
    return new Float64Array([r.cF, r.cG]);
};

var _MJS_v2add = F2(function(a, b) {
    var r = new Float64Array(2);
    r[0] = a[0] + b[0];
    r[1] = a[1] + b[1];
    return r;
});

var _MJS_v2sub = F2(function(a, b) {
    var r = new Float64Array(2);
    r[0] = a[0] - b[0];
    r[1] = a[1] - b[1];
    return r;
});

var _MJS_v2negate = function(a) {
    var r = new Float64Array(2);
    r[0] = -a[0];
    r[1] = -a[1];
    return r;
};

var _MJS_v2direction = F2(function(a, b) {
    var r = new Float64Array(2);
    r[0] = a[0] - b[0];
    r[1] = a[1] - b[1];
    var im = 1.0 / _MJS_v2lengthLocal(r);
    r[0] = r[0] * im;
    r[1] = r[1] * im;
    return r;
});

function _MJS_v2lengthLocal(a) {
    return Math.sqrt(a[0] * a[0] + a[1] * a[1]);
}
var _MJS_v2length = _MJS_v2lengthLocal;

var _MJS_v2lengthSquared = function(a) {
    return a[0] * a[0] + a[1] * a[1];
};

var _MJS_v2distance = F2(function(a, b) {
    var dx = a[0] - b[0];
    var dy = a[1] - b[1];
    return Math.sqrt(dx * dx + dy * dy);
});

var _MJS_v2distanceSquared = F2(function(a, b) {
    var dx = a[0] - b[0];
    var dy = a[1] - b[1];
    return dx * dx + dy * dy;
});

var _MJS_v2normalize = function(a) {
    var r = new Float64Array(2);
    var im = 1.0 / _MJS_v2lengthLocal(a);
    r[0] = a[0] * im;
    r[1] = a[1] * im;
    return r;
};

var _MJS_v2scale = F2(function(k, a) {
    var r = new Float64Array(2);
    r[0] = a[0] * k;
    r[1] = a[1] * k;
    return r;
});

var _MJS_v2dot = F2(function(a, b) {
    return a[0] * b[0] + a[1] * b[1];
});

// Vector3

var _MJS_v3temp1Local = new Float64Array(3);
var _MJS_v3temp2Local = new Float64Array(3);
var _MJS_v3temp3Local = new Float64Array(3);

var _MJS_v3 = F3(function(x, y, z) {
    return new Float64Array([x, y, z]);
});

var _MJS_v3getX = function(a) {
    return a[0];
};

var _MJS_v3getY = function(a) {
    return a[1];
};

var _MJS_v3getZ = function(a) {
    return a[2];
};

var _MJS_v3setX = F2(function(x, a) {
    return new Float64Array([x, a[1], a[2]]);
});

var _MJS_v3setY = F2(function(y, a) {
    return new Float64Array([a[0], y, a[2]]);
});

var _MJS_v3setZ = F2(function(z, a) {
    return new Float64Array([a[0], a[1], z]);
});

var _MJS_v3toRecord = function(a) {
    return { cF: a[0], cG: a[1], cH: a[2] };
};

var _MJS_v3fromRecord = function(r) {
    return new Float64Array([r.cF, r.cG, r.cH]);
};

var _MJS_v3add = F2(function(a, b) {
    var r = new Float64Array(3);
    r[0] = a[0] + b[0];
    r[1] = a[1] + b[1];
    r[2] = a[2] + b[2];
    return r;
});

function _MJS_v3subLocal(a, b, r) {
    if (r === undefined) {
        r = new Float64Array(3);
    }
    r[0] = a[0] - b[0];
    r[1] = a[1] - b[1];
    r[2] = a[2] - b[2];
    return r;
}
var _MJS_v3sub = F2(_MJS_v3subLocal);

var _MJS_v3negate = function(a) {
    var r = new Float64Array(3);
    r[0] = -a[0];
    r[1] = -a[1];
    r[2] = -a[2];
    return r;
};

function _MJS_v3directionLocal(a, b, r) {
    if (r === undefined) {
        r = new Float64Array(3);
    }
    return _MJS_v3normalizeLocal(_MJS_v3subLocal(a, b, r), r);
}
var _MJS_v3direction = F2(_MJS_v3directionLocal);

function _MJS_v3lengthLocal(a) {
    return Math.sqrt(a[0] * a[0] + a[1] * a[1] + a[2] * a[2]);
}
var _MJS_v3length = _MJS_v3lengthLocal;

var _MJS_v3lengthSquared = function(a) {
    return a[0] * a[0] + a[1] * a[1] + a[2] * a[2];
};

var _MJS_v3distance = F2(function(a, b) {
    var dx = a[0] - b[0];
    var dy = a[1] - b[1];
    var dz = a[2] - b[2];
    return Math.sqrt(dx * dx + dy * dy + dz * dz);
});

var _MJS_v3distanceSquared = F2(function(a, b) {
    var dx = a[0] - b[0];
    var dy = a[1] - b[1];
    var dz = a[2] - b[2];
    return dx * dx + dy * dy + dz * dz;
});

function _MJS_v3normalizeLocal(a, r) {
    if (r === undefined) {
        r = new Float64Array(3);
    }
    var im = 1.0 / _MJS_v3lengthLocal(a);
    r[0] = a[0] * im;
    r[1] = a[1] * im;
    r[2] = a[2] * im;
    return r;
}
var _MJS_v3normalize = _MJS_v3normalizeLocal;

var _MJS_v3scale = F2(function(k, a) {
    return new Float64Array([a[0] * k, a[1] * k, a[2] * k]);
});

var _MJS_v3dotLocal = function(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
};
var _MJS_v3dot = F2(_MJS_v3dotLocal);

function _MJS_v3crossLocal(a, b, r) {
    if (r === undefined) {
        r = new Float64Array(3);
    }
    r[0] = a[1] * b[2] - a[2] * b[1];
    r[1] = a[2] * b[0] - a[0] * b[2];
    r[2] = a[0] * b[1] - a[1] * b[0];
    return r;
}
var _MJS_v3cross = F2(_MJS_v3crossLocal);

var _MJS_v3mul4x4 = F2(function(m, v) {
    var w;
    var tmp = _MJS_v3temp1Local;
    var r = new Float64Array(3);

    tmp[0] = m[3];
    tmp[1] = m[7];
    tmp[2] = m[11];
    w = _MJS_v3dotLocal(v, tmp) + m[15];
    tmp[0] = m[0];
    tmp[1] = m[4];
    tmp[2] = m[8];
    r[0] = (_MJS_v3dotLocal(v, tmp) + m[12]) / w;
    tmp[0] = m[1];
    tmp[1] = m[5];
    tmp[2] = m[9];
    r[1] = (_MJS_v3dotLocal(v, tmp) + m[13]) / w;
    tmp[0] = m[2];
    tmp[1] = m[6];
    tmp[2] = m[10];
    r[2] = (_MJS_v3dotLocal(v, tmp) + m[14]) / w;
    return r;
});

// Vector4

var _MJS_v4 = F4(function(x, y, z, w) {
    return new Float64Array([x, y, z, w]);
});

var _MJS_v4getX = function(a) {
    return a[0];
};

var _MJS_v4getY = function(a) {
    return a[1];
};

var _MJS_v4getZ = function(a) {
    return a[2];
};

var _MJS_v4getW = function(a) {
    return a[3];
};

var _MJS_v4setX = F2(function(x, a) {
    return new Float64Array([x, a[1], a[2], a[3]]);
});

var _MJS_v4setY = F2(function(y, a) {
    return new Float64Array([a[0], y, a[2], a[3]]);
});

var _MJS_v4setZ = F2(function(z, a) {
    return new Float64Array([a[0], a[1], z, a[3]]);
});

var _MJS_v4setW = F2(function(w, a) {
    return new Float64Array([a[0], a[1], a[2], w]);
});

var _MJS_v4toRecord = function(a) {
    return { cF: a[0], cG: a[1], cH: a[2], gF: a[3] };
};

var _MJS_v4fromRecord = function(r) {
    return new Float64Array([r.cF, r.cG, r.cH, r.gF]);
};

var _MJS_v4add = F2(function(a, b) {
    var r = new Float64Array(4);
    r[0] = a[0] + b[0];
    r[1] = a[1] + b[1];
    r[2] = a[2] + b[2];
    r[3] = a[3] + b[3];
    return r;
});

var _MJS_v4sub = F2(function(a, b) {
    var r = new Float64Array(4);
    r[0] = a[0] - b[0];
    r[1] = a[1] - b[1];
    r[2] = a[2] - b[2];
    r[3] = a[3] - b[3];
    return r;
});

var _MJS_v4negate = function(a) {
    var r = new Float64Array(4);
    r[0] = -a[0];
    r[1] = -a[1];
    r[2] = -a[2];
    r[3] = -a[3];
    return r;
};

var _MJS_v4direction = F2(function(a, b) {
    var r = new Float64Array(4);
    r[0] = a[0] - b[0];
    r[1] = a[1] - b[1];
    r[2] = a[2] - b[2];
    r[3] = a[3] - b[3];
    var im = 1.0 / _MJS_v4lengthLocal(r);
    r[0] = r[0] * im;
    r[1] = r[1] * im;
    r[2] = r[2] * im;
    r[3] = r[3] * im;
    return r;
});

function _MJS_v4lengthLocal(a) {
    return Math.sqrt(a[0] * a[0] + a[1] * a[1] + a[2] * a[2] + a[3] * a[3]);
}
var _MJS_v4length = _MJS_v4lengthLocal;

var _MJS_v4lengthSquared = function(a) {
    return a[0] * a[0] + a[1] * a[1] + a[2] * a[2] + a[3] * a[3];
};

var _MJS_v4distance = F2(function(a, b) {
    var dx = a[0] - b[0];
    var dy = a[1] - b[1];
    var dz = a[2] - b[2];
    var dw = a[3] - b[3];
    return Math.sqrt(dx * dx + dy * dy + dz * dz + dw * dw);
});

var _MJS_v4distanceSquared = F2(function(a, b) {
    var dx = a[0] - b[0];
    var dy = a[1] - b[1];
    var dz = a[2] - b[2];
    var dw = a[3] - b[3];
    return dx * dx + dy * dy + dz * dz + dw * dw;
});

var _MJS_v4normalize = function(a) {
    var r = new Float64Array(4);
    var im = 1.0 / _MJS_v4lengthLocal(a);
    r[0] = a[0] * im;
    r[1] = a[1] * im;
    r[2] = a[2] * im;
    r[3] = a[3] * im;
    return r;
};

var _MJS_v4scale = F2(function(k, a) {
    var r = new Float64Array(4);
    r[0] = a[0] * k;
    r[1] = a[1] * k;
    r[2] = a[2] * k;
    r[3] = a[3] * k;
    return r;
});

var _MJS_v4dot = F2(function(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
});

// Matrix4

var _MJS_m4x4temp1Local = new Float64Array(16);
var _MJS_m4x4temp2Local = new Float64Array(16);

var _MJS_m4x4identity = new Float64Array([
    1.0, 0.0, 0.0, 0.0,
    0.0, 1.0, 0.0, 0.0,
    0.0, 0.0, 1.0, 0.0,
    0.0, 0.0, 0.0, 1.0
]);

var _MJS_m4x4fromRecord = function(r) {
    var m = new Float64Array(16);
    m[0] = r.h8;
    m[1] = r.ib;
    m[2] = r.ie;
    m[3] = r.fE;
    m[4] = r.h9;
    m[5] = r.ic;
    m[6] = r.$8;
    m[7] = r.fF;
    m[8] = r.ia;
    m[9] = r.id;
    m[10] = r.ig;
    m[11] = r.fG;
    m[12] = r.fB;
    m[13] = r.fC;
    m[14] = r.fD;
    m[15] = r.fH;
    return m;
};

var _MJS_m4x4toRecord = function(m) {
    return {
        h8: m[0], ib: m[1], ie: m[2], fE: m[3],
        h9: m[4], ic: m[5], $8: m[6], fF: m[7],
        ia: m[8], id: m[9], ig: m[10], fG: m[11],
        fB: m[12], fC: m[13], fD: m[14], fH: m[15]
    };
};

var _MJS_m4x4inverse = function(m) {
    var r = new Float64Array(16);

    r[0] = m[5] * m[10] * m[15] - m[5] * m[11] * m[14] - m[9] * m[6] * m[15] +
        m[9] * m[7] * m[14] + m[13] * m[6] * m[11] - m[13] * m[7] * m[10];
    r[4] = -m[4] * m[10] * m[15] + m[4] * m[11] * m[14] + m[8] * m[6] * m[15] -
        m[8] * m[7] * m[14] - m[12] * m[6] * m[11] + m[12] * m[7] * m[10];
    r[8] = m[4] * m[9] * m[15] - m[4] * m[11] * m[13] - m[8] * m[5] * m[15] +
        m[8] * m[7] * m[13] + m[12] * m[5] * m[11] - m[12] * m[7] * m[9];
    r[12] = -m[4] * m[9] * m[14] + m[4] * m[10] * m[13] + m[8] * m[5] * m[14] -
        m[8] * m[6] * m[13] - m[12] * m[5] * m[10] + m[12] * m[6] * m[9];
    r[1] = -m[1] * m[10] * m[15] + m[1] * m[11] * m[14] + m[9] * m[2] * m[15] -
        m[9] * m[3] * m[14] - m[13] * m[2] * m[11] + m[13] * m[3] * m[10];
    r[5] = m[0] * m[10] * m[15] - m[0] * m[11] * m[14] - m[8] * m[2] * m[15] +
        m[8] * m[3] * m[14] + m[12] * m[2] * m[11] - m[12] * m[3] * m[10];
    r[9] = -m[0] * m[9] * m[15] + m[0] * m[11] * m[13] + m[8] * m[1] * m[15] -
        m[8] * m[3] * m[13] - m[12] * m[1] * m[11] + m[12] * m[3] * m[9];
    r[13] = m[0] * m[9] * m[14] - m[0] * m[10] * m[13] - m[8] * m[1] * m[14] +
        m[8] * m[2] * m[13] + m[12] * m[1] * m[10] - m[12] * m[2] * m[9];
    r[2] = m[1] * m[6] * m[15] - m[1] * m[7] * m[14] - m[5] * m[2] * m[15] +
        m[5] * m[3] * m[14] + m[13] * m[2] * m[7] - m[13] * m[3] * m[6];
    r[6] = -m[0] * m[6] * m[15] + m[0] * m[7] * m[14] + m[4] * m[2] * m[15] -
        m[4] * m[3] * m[14] - m[12] * m[2] * m[7] + m[12] * m[3] * m[6];
    r[10] = m[0] * m[5] * m[15] - m[0] * m[7] * m[13] - m[4] * m[1] * m[15] +
        m[4] * m[3] * m[13] + m[12] * m[1] * m[7] - m[12] * m[3] * m[5];
    r[14] = -m[0] * m[5] * m[14] + m[0] * m[6] * m[13] + m[4] * m[1] * m[14] -
        m[4] * m[2] * m[13] - m[12] * m[1] * m[6] + m[12] * m[2] * m[5];
    r[3] = -m[1] * m[6] * m[11] + m[1] * m[7] * m[10] + m[5] * m[2] * m[11] -
        m[5] * m[3] * m[10] - m[9] * m[2] * m[7] + m[9] * m[3] * m[6];
    r[7] = m[0] * m[6] * m[11] - m[0] * m[7] * m[10] - m[4] * m[2] * m[11] +
        m[4] * m[3] * m[10] + m[8] * m[2] * m[7] - m[8] * m[3] * m[6];
    r[11] = -m[0] * m[5] * m[11] + m[0] * m[7] * m[9] + m[4] * m[1] * m[11] -
        m[4] * m[3] * m[9] - m[8] * m[1] * m[7] + m[8] * m[3] * m[5];
    r[15] = m[0] * m[5] * m[10] - m[0] * m[6] * m[9] - m[4] * m[1] * m[10] +
        m[4] * m[2] * m[9] + m[8] * m[1] * m[6] - m[8] * m[2] * m[5];

    var det = m[0] * r[0] + m[1] * r[4] + m[2] * r[8] + m[3] * r[12];

    if (det === 0) {
        return $elm$core$Maybe$Nothing;
    }

    det = 1.0 / det;

    for (var i = 0; i < 16; i = i + 1) {
        r[i] = r[i] * det;
    }

    return $elm$core$Maybe$Just(r);
};

var _MJS_m4x4inverseOrthonormal = function(m) {
    var r = _MJS_m4x4transposeLocal(m);
    var t = [m[12], m[13], m[14]];
    r[3] = r[7] = r[11] = 0;
    r[12] = -_MJS_v3dotLocal([r[0], r[4], r[8]], t);
    r[13] = -_MJS_v3dotLocal([r[1], r[5], r[9]], t);
    r[14] = -_MJS_v3dotLocal([r[2], r[6], r[10]], t);
    return r;
};

function _MJS_m4x4makeFrustumLocal(left, right, bottom, top, znear, zfar) {
    var r = new Float64Array(16);

    r[0] = 2 * znear / (right - left);
    r[1] = 0;
    r[2] = 0;
    r[3] = 0;
    r[4] = 0;
    r[5] = 2 * znear / (top - bottom);
    r[6] = 0;
    r[7] = 0;
    r[8] = (right + left) / (right - left);
    r[9] = (top + bottom) / (top - bottom);
    r[10] = -(zfar + znear) / (zfar - znear);
    r[11] = -1;
    r[12] = 0;
    r[13] = 0;
    r[14] = -2 * zfar * znear / (zfar - znear);
    r[15] = 0;

    return r;
}
var _MJS_m4x4makeFrustum = F6(_MJS_m4x4makeFrustumLocal);

var _MJS_m4x4makePerspective = F4(function(fovy, aspect, znear, zfar) {
    var ymax = znear * Math.tan(fovy * Math.PI / 360.0);
    var ymin = -ymax;
    var xmin = ymin * aspect;
    var xmax = ymax * aspect;

    return _MJS_m4x4makeFrustumLocal(xmin, xmax, ymin, ymax, znear, zfar);
});

function _MJS_m4x4makeOrthoLocal(left, right, bottom, top, znear, zfar) {
    var r = new Float64Array(16);

    r[0] = 2 / (right - left);
    r[1] = 0;
    r[2] = 0;
    r[3] = 0;
    r[4] = 0;
    r[5] = 2 / (top - bottom);
    r[6] = 0;
    r[7] = 0;
    r[8] = 0;
    r[9] = 0;
    r[10] = -2 / (zfar - znear);
    r[11] = 0;
    r[12] = -(right + left) / (right - left);
    r[13] = -(top + bottom) / (top - bottom);
    r[14] = -(zfar + znear) / (zfar - znear);
    r[15] = 1;

    return r;
}
var _MJS_m4x4makeOrtho = F6(_MJS_m4x4makeOrthoLocal);

var _MJS_m4x4makeOrtho2D = F4(function(left, right, bottom, top) {
    return _MJS_m4x4makeOrthoLocal(left, right, bottom, top, -1, 1);
});

function _MJS_m4x4mulLocal(a, b) {
    var r = new Float64Array(16);
    var a11 = a[0];
    var a21 = a[1];
    var a31 = a[2];
    var a41 = a[3];
    var a12 = a[4];
    var a22 = a[5];
    var a32 = a[6];
    var a42 = a[7];
    var a13 = a[8];
    var a23 = a[9];
    var a33 = a[10];
    var a43 = a[11];
    var a14 = a[12];
    var a24 = a[13];
    var a34 = a[14];
    var a44 = a[15];
    var b11 = b[0];
    var b21 = b[1];
    var b31 = b[2];
    var b41 = b[3];
    var b12 = b[4];
    var b22 = b[5];
    var b32 = b[6];
    var b42 = b[7];
    var b13 = b[8];
    var b23 = b[9];
    var b33 = b[10];
    var b43 = b[11];
    var b14 = b[12];
    var b24 = b[13];
    var b34 = b[14];
    var b44 = b[15];

    r[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
    r[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
    r[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
    r[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
    r[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
    r[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
    r[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
    r[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
    r[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
    r[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
    r[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
    r[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
    r[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
    r[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
    r[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
    r[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;

    return r;
}
var _MJS_m4x4mul = F2(_MJS_m4x4mulLocal);

var _MJS_m4x4mulAffine = F2(function(a, b) {
    var r = new Float64Array(16);
    var a11 = a[0];
    var a21 = a[1];
    var a31 = a[2];
    var a12 = a[4];
    var a22 = a[5];
    var a32 = a[6];
    var a13 = a[8];
    var a23 = a[9];
    var a33 = a[10];
    var a14 = a[12];
    var a24 = a[13];
    var a34 = a[14];

    var b11 = b[0];
    var b21 = b[1];
    var b31 = b[2];
    var b12 = b[4];
    var b22 = b[5];
    var b32 = b[6];
    var b13 = b[8];
    var b23 = b[9];
    var b33 = b[10];
    var b14 = b[12];
    var b24 = b[13];
    var b34 = b[14];

    r[0] = a11 * b11 + a12 * b21 + a13 * b31;
    r[1] = a21 * b11 + a22 * b21 + a23 * b31;
    r[2] = a31 * b11 + a32 * b21 + a33 * b31;
    r[3] = 0;
    r[4] = a11 * b12 + a12 * b22 + a13 * b32;
    r[5] = a21 * b12 + a22 * b22 + a23 * b32;
    r[6] = a31 * b12 + a32 * b22 + a33 * b32;
    r[7] = 0;
    r[8] = a11 * b13 + a12 * b23 + a13 * b33;
    r[9] = a21 * b13 + a22 * b23 + a23 * b33;
    r[10] = a31 * b13 + a32 * b23 + a33 * b33;
    r[11] = 0;
    r[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14;
    r[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24;
    r[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34;
    r[15] = 1;

    return r;
});

var _MJS_m4x4makeRotate = F2(function(angle, axis) {
    var r = new Float64Array(16);
    axis = _MJS_v3normalizeLocal(axis, _MJS_v3temp1Local);
    var x = axis[0];
    var y = axis[1];
    var z = axis[2];
    var c = Math.cos(angle);
    var c1 = 1 - c;
    var s = Math.sin(angle);

    r[0] = x * x * c1 + c;
    r[1] = y * x * c1 + z * s;
    r[2] = z * x * c1 - y * s;
    r[3] = 0;
    r[4] = x * y * c1 - z * s;
    r[5] = y * y * c1 + c;
    r[6] = y * z * c1 + x * s;
    r[7] = 0;
    r[8] = x * z * c1 + y * s;
    r[9] = y * z * c1 - x * s;
    r[10] = z * z * c1 + c;
    r[11] = 0;
    r[12] = 0;
    r[13] = 0;
    r[14] = 0;
    r[15] = 1;

    return r;
});

var _MJS_m4x4rotate = F3(function(angle, axis, m) {
    var r = new Float64Array(16);
    var im = 1.0 / _MJS_v3lengthLocal(axis);
    var x = axis[0] * im;
    var y = axis[1] * im;
    var z = axis[2] * im;
    var c = Math.cos(angle);
    var c1 = 1 - c;
    var s = Math.sin(angle);
    var xs = x * s;
    var ys = y * s;
    var zs = z * s;
    var xyc1 = x * y * c1;
    var xzc1 = x * z * c1;
    var yzc1 = y * z * c1;
    var t11 = x * x * c1 + c;
    var t21 = xyc1 + zs;
    var t31 = xzc1 - ys;
    var t12 = xyc1 - zs;
    var t22 = y * y * c1 + c;
    var t32 = yzc1 + xs;
    var t13 = xzc1 + ys;
    var t23 = yzc1 - xs;
    var t33 = z * z * c1 + c;
    var m11 = m[0], m21 = m[1], m31 = m[2], m41 = m[3];
    var m12 = m[4], m22 = m[5], m32 = m[6], m42 = m[7];
    var m13 = m[8], m23 = m[9], m33 = m[10], m43 = m[11];
    var m14 = m[12], m24 = m[13], m34 = m[14], m44 = m[15];

    r[0] = m11 * t11 + m12 * t21 + m13 * t31;
    r[1] = m21 * t11 + m22 * t21 + m23 * t31;
    r[2] = m31 * t11 + m32 * t21 + m33 * t31;
    r[3] = m41 * t11 + m42 * t21 + m43 * t31;
    r[4] = m11 * t12 + m12 * t22 + m13 * t32;
    r[5] = m21 * t12 + m22 * t22 + m23 * t32;
    r[6] = m31 * t12 + m32 * t22 + m33 * t32;
    r[7] = m41 * t12 + m42 * t22 + m43 * t32;
    r[8] = m11 * t13 + m12 * t23 + m13 * t33;
    r[9] = m21 * t13 + m22 * t23 + m23 * t33;
    r[10] = m31 * t13 + m32 * t23 + m33 * t33;
    r[11] = m41 * t13 + m42 * t23 + m43 * t33;
    r[12] = m14,
    r[13] = m24;
    r[14] = m34;
    r[15] = m44;

    return r;
});

function _MJS_m4x4makeScale3Local(x, y, z) {
    var r = new Float64Array(16);

    r[0] = x;
    r[1] = 0;
    r[2] = 0;
    r[3] = 0;
    r[4] = 0;
    r[5] = y;
    r[6] = 0;
    r[7] = 0;
    r[8] = 0;
    r[9] = 0;
    r[10] = z;
    r[11] = 0;
    r[12] = 0;
    r[13] = 0;
    r[14] = 0;
    r[15] = 1;

    return r;
}
var _MJS_m4x4makeScale3 = F3(_MJS_m4x4makeScale3Local);

var _MJS_m4x4makeScale = function(v) {
    return _MJS_m4x4makeScale3Local(v[0], v[1], v[2]);
};

var _MJS_m4x4scale3 = F4(function(x, y, z, m) {
    var r = new Float64Array(16);

    r[0] = m[0] * x;
    r[1] = m[1] * x;
    r[2] = m[2] * x;
    r[3] = m[3] * x;
    r[4] = m[4] * y;
    r[5] = m[5] * y;
    r[6] = m[6] * y;
    r[7] = m[7] * y;
    r[8] = m[8] * z;
    r[9] = m[9] * z;
    r[10] = m[10] * z;
    r[11] = m[11] * z;
    r[12] = m[12];
    r[13] = m[13];
    r[14] = m[14];
    r[15] = m[15];

    return r;
});

var _MJS_m4x4scale = F2(function(v, m) {
    var r = new Float64Array(16);
    var x = v[0];
    var y = v[1];
    var z = v[2];

    r[0] = m[0] * x;
    r[1] = m[1] * x;
    r[2] = m[2] * x;
    r[3] = m[3] * x;
    r[4] = m[4] * y;
    r[5] = m[5] * y;
    r[6] = m[6] * y;
    r[7] = m[7] * y;
    r[8] = m[8] * z;
    r[9] = m[9] * z;
    r[10] = m[10] * z;
    r[11] = m[11] * z;
    r[12] = m[12];
    r[13] = m[13];
    r[14] = m[14];
    r[15] = m[15];

    return r;
});

function _MJS_m4x4makeTranslate3Local(x, y, z) {
    var r = new Float64Array(16);

    r[0] = 1;
    r[1] = 0;
    r[2] = 0;
    r[3] = 0;
    r[4] = 0;
    r[5] = 1;
    r[6] = 0;
    r[7] = 0;
    r[8] = 0;
    r[9] = 0;
    r[10] = 1;
    r[11] = 0;
    r[12] = x;
    r[13] = y;
    r[14] = z;
    r[15] = 1;

    return r;
}
var _MJS_m4x4makeTranslate3 = F3(_MJS_m4x4makeTranslate3Local);

var _MJS_m4x4makeTranslate = function(v) {
    return _MJS_m4x4makeTranslate3Local(v[0], v[1], v[2]);
};

var _MJS_m4x4translate3 = F4(function(x, y, z, m) {
    var r = new Float64Array(16);
    var m11 = m[0];
    var m21 = m[1];
    var m31 = m[2];
    var m41 = m[3];
    var m12 = m[4];
    var m22 = m[5];
    var m32 = m[6];
    var m42 = m[7];
    var m13 = m[8];
    var m23 = m[9];
    var m33 = m[10];
    var m43 = m[11];

    r[0] = m11;
    r[1] = m21;
    r[2] = m31;
    r[3] = m41;
    r[4] = m12;
    r[5] = m22;
    r[6] = m32;
    r[7] = m42;
    r[8] = m13;
    r[9] = m23;
    r[10] = m33;
    r[11] = m43;
    r[12] = m11 * x + m12 * y + m13 * z + m[12];
    r[13] = m21 * x + m22 * y + m23 * z + m[13];
    r[14] = m31 * x + m32 * y + m33 * z + m[14];
    r[15] = m41 * x + m42 * y + m43 * z + m[15];

    return r;
});

var _MJS_m4x4translate = F2(function(v, m) {
    var r = new Float64Array(16);
    var x = v[0];
    var y = v[1];
    var z = v[2];
    var m11 = m[0];
    var m21 = m[1];
    var m31 = m[2];
    var m41 = m[3];
    var m12 = m[4];
    var m22 = m[5];
    var m32 = m[6];
    var m42 = m[7];
    var m13 = m[8];
    var m23 = m[9];
    var m33 = m[10];
    var m43 = m[11];

    r[0] = m11;
    r[1] = m21;
    r[2] = m31;
    r[3] = m41;
    r[4] = m12;
    r[5] = m22;
    r[6] = m32;
    r[7] = m42;
    r[8] = m13;
    r[9] = m23;
    r[10] = m33;
    r[11] = m43;
    r[12] = m11 * x + m12 * y + m13 * z + m[12];
    r[13] = m21 * x + m22 * y + m23 * z + m[13];
    r[14] = m31 * x + m32 * y + m33 * z + m[14];
    r[15] = m41 * x + m42 * y + m43 * z + m[15];

    return r;
});

var _MJS_m4x4makeLookAt = F3(function(eye, center, up) {
    var z = _MJS_v3directionLocal(eye, center, _MJS_v3temp1Local);
    var x = _MJS_v3normalizeLocal(_MJS_v3crossLocal(up, z, _MJS_v3temp2Local), _MJS_v3temp2Local);
    var y = _MJS_v3normalizeLocal(_MJS_v3crossLocal(z, x, _MJS_v3temp3Local), _MJS_v3temp3Local);
    var tm1 = _MJS_m4x4temp1Local;
    var tm2 = _MJS_m4x4temp2Local;

    tm1[0] = x[0];
    tm1[1] = y[0];
    tm1[2] = z[0];
    tm1[3] = 0;
    tm1[4] = x[1];
    tm1[5] = y[1];
    tm1[6] = z[1];
    tm1[7] = 0;
    tm1[8] = x[2];
    tm1[9] = y[2];
    tm1[10] = z[2];
    tm1[11] = 0;
    tm1[12] = 0;
    tm1[13] = 0;
    tm1[14] = 0;
    tm1[15] = 1;

    tm2[0] = 1; tm2[1] = 0; tm2[2] = 0; tm2[3] = 0;
    tm2[4] = 0; tm2[5] = 1; tm2[6] = 0; tm2[7] = 0;
    tm2[8] = 0; tm2[9] = 0; tm2[10] = 1; tm2[11] = 0;
    tm2[12] = -eye[0]; tm2[13] = -eye[1]; tm2[14] = -eye[2]; tm2[15] = 1;

    return _MJS_m4x4mulLocal(tm1, tm2);
});


function _MJS_m4x4transposeLocal(m) {
    var r = new Float64Array(16);

    r[0] = m[0]; r[1] = m[4]; r[2] = m[8]; r[3] = m[12];
    r[4] = m[1]; r[5] = m[5]; r[6] = m[9]; r[7] = m[13];
    r[8] = m[2]; r[9] = m[6]; r[10] = m[10]; r[11] = m[14];
    r[12] = m[3]; r[13] = m[7]; r[14] = m[11]; r[15] = m[15];

    return r;
}
var _MJS_m4x4transpose = _MJS_m4x4transposeLocal;

var _MJS_m4x4makeBasis = F3(function(vx, vy, vz) {
    var r = new Float64Array(16);

    r[0] = vx[0];
    r[1] = vx[1];
    r[2] = vx[2];
    r[3] = 0;
    r[4] = vy[0];
    r[5] = vy[1];
    r[6] = vy[2];
    r[7] = 0;
    r[8] = vz[0];
    r[9] = vz[1];
    r[10] = vz[2];
    r[11] = 0;
    r[12] = 0;
    r[13] = 0;
    r[14] = 0;
    r[15] = 1;

    return r;
});



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


var _WebGL_guid = 0;

function _WebGL_listEach(fn, list) {
  for (; list.b; list = list.b) {
    fn(list.a);
  }
}

function _WebGL_listLength(list) {
  var length = 0;
  for (; list.b; list = list.b) {
    length++;
  }
  return length;
}

var _WebGL_rAF = typeof requestAnimationFrame !== 'undefined' ?
  requestAnimationFrame :
  function (cb) { setTimeout(cb, 1000 / 60); };

// eslint-disable-next-line no-unused-vars
var _WebGL_entity = F5(function (settings, vert, frag, mesh, uniforms) {
  return {
    $: 0,
    a: settings,
    b: vert,
    c: frag,
    d: mesh,
    e: uniforms
  };
});

// eslint-disable-next-line no-unused-vars
var _WebGL_enableBlend = F2(function (cache, setting) {
  var blend = cache.blend;
  blend.toggle = cache.toggle;

  if (!blend.enabled) {
    cache.gl.enable(cache.gl.BLEND);
    blend.enabled = true;
  }

  // a   b   c   d   e   f   g h i j
  // eq1 f11 f12 eq2 f21 f22 r g b a
  if (blend.a !== setting.a || blend.d !== setting.d) {
    cache.gl.blendEquationSeparate(setting.a, setting.d);
    blend.a = setting.a;
    blend.d = setting.d;
  }
  if (blend.b !== setting.b || blend.c !== setting.c || blend.e !== setting.e || blend.f !== setting.f) {
    cache.gl.blendFuncSeparate(setting.b, setting.c, setting.e, setting.f);
    blend.b = setting.b;
    blend.c = setting.c;
    blend.e = setting.e;
    blend.f = setting.f;
  }
  if (blend.g !== setting.g || blend.h !== setting.h || blend.i !== setting.i || blend.j !== setting.j) {
    cache.gl.blendColor(setting.g, setting.h, setting.i, setting.j);
    blend.g = setting.g;
    blend.h = setting.h;
    blend.i = setting.i;
    blend.j = setting.j;
  }
});

// eslint-disable-next-line no-unused-vars
var _WebGL_enableDepthTest = F2(function (cache, setting) {
  var depthTest = cache.depthTest;
  depthTest.toggle = cache.toggle;

  if (!depthTest.enabled) {
    cache.gl.enable(cache.gl.DEPTH_TEST);
    depthTest.enabled = true;
  }

  // a    b    c    d
  // func mask near far
  if (depthTest.a !== setting.a) {
    cache.gl.depthFunc(setting.a);
    depthTest.a = setting.a;
  }
  if (depthTest.b !== setting.b) {
    cache.gl.depthMask(setting.b);
    depthTest.b = setting.b;
  }
  if (depthTest.c !== setting.c || depthTest.d !== setting.d) {
    cache.gl.depthRange(setting.c, setting.d);
    depthTest.c = setting.c;
    depthTest.d = setting.d;
  }
});

// eslint-disable-next-line no-unused-vars
var _WebGL_enableStencilTest = F2(function (cache, setting) {
  var stencilTest = cache.stencilTest;
  stencilTest.toggle = cache.toggle;

  if (!stencilTest.enabled) {
    cache.gl.enable(cache.gl.STENCIL_TEST);
    stencilTest.enabled = true;
  }

  // a   b    c         d     e     f      g      h     i     j      k
  // ref mask writeMask test1 fail1 zfail1 zpass1 test2 fail2 zfail2 zpass2
  if (stencilTest.d !== setting.d || stencilTest.a !== setting.a || stencilTest.b !== setting.b) {
    cache.gl.stencilFuncSeparate(cache.gl.FRONT, setting.d, setting.a, setting.b);
    stencilTest.d = setting.d;
    // a and b are set in the cache.gl.BACK diffing because they should be the same
  }
  if (stencilTest.e !== setting.e || stencilTest.f !== setting.f || stencilTest.g !== setting.g) {
    cache.gl.stencilOpSeparate(cache.gl.FRONT, setting.e, setting.f, setting.g);
    stencilTest.e = setting.e;
    stencilTest.f = setting.f;
    stencilTest.g = setting.g;
  }
  if (stencilTest.c !== setting.c) {
    cache.gl.stencilMask(setting.c);
    stencilTest.c = setting.c;
  }
  if (stencilTest.h !== setting.h || stencilTest.a !== setting.a || stencilTest.b !== setting.b) {
    cache.gl.stencilFuncSeparate(cache.gl.BACK, setting.h, setting.a, setting.b);
    stencilTest.h = setting.h;
    stencilTest.a = setting.a;
    stencilTest.b = setting.b;
  }
  if (stencilTest.i !== setting.i || stencilTest.j !== setting.j || stencilTest.k !== setting.k) {
    cache.gl.stencilOpSeparate(cache.gl.BACK, setting.i, setting.j, setting.k);
    stencilTest.i = setting.i;
    stencilTest.j = setting.j;
    stencilTest.k = setting.k;
  }
});

// eslint-disable-next-line no-unused-vars
var _WebGL_enableScissor = F2(function (cache, setting) {
  var scissor = cache.scissor;
  scissor.toggle = cache.toggle;

  if (!scissor.enabled) {
    cache.gl.enable(cache.gl.SCISSOR_TEST);
    scissor.enabled = true;
  }

  if (scissor.a !== setting.a || scissor.b !== setting.b || scissor.c !== setting.c || scissor.d !== setting.d) {
    cache.gl.scissor(setting.a, setting.b, setting.c, setting.d);
    scissor.a = setting.a;
    scissor.b = setting.b;
    scissor.c = setting.c;
    scissor.d = setting.d;
  }
});

// eslint-disable-next-line no-unused-vars
var _WebGL_enableColorMask = F2(function (cache, setting) {
  var colorMask = cache.colorMask;
  colorMask.toggle = cache.toggle;
  colorMask.enabled = true;

  if (colorMask.a !== setting.a || colorMask.b !== setting.b || colorMask.c !== setting.c || colorMask.d !== setting.d) {
    cache.gl.colorMask(setting.a, setting.b, setting.c, setting.d);
    colorMask.a = setting.a;
    colorMask.b = setting.b;
    colorMask.c = setting.c;
    colorMask.d = setting.d;
  }
});

// eslint-disable-next-line no-unused-vars
var _WebGL_enableCullFace = F2(function (cache, setting) {
  var cullFace = cache.cullFace;
  cullFace.toggle = cache.toggle;

  if (!cullFace.enabled) {
    cache.gl.enable(cache.gl.CULL_FACE);
    cullFace.enabled = true;
  }

  if (cullFace.a !== setting.a) {
    cache.gl.cullFace(setting.a);
    cullFace.a = setting.a;
  }
});

// eslint-disable-next-line no-unused-vars
var _WebGL_enablePolygonOffset = F2(function (cache, setting) {
  var polygonOffset = cache.polygonOffset;
  polygonOffset.toggle = cache.toggle;

  if (!polygonOffset.enabled) {
    cache.gl.enable(cache.gl.POLYGON_OFFSET_FILL);
    polygonOffset.enabled = true;
  }

  if (polygonOffset.a !== setting.a || polygonOffset.b !== setting.b) {
    cache.gl.polygonOffset(setting.a, setting.b);
    polygonOffset.a = setting.a;
    polygonOffset.b = setting.b;
  }
});

// eslint-disable-next-line no-unused-vars
var _WebGL_enableSampleCoverage = F2(function (cache, setting) {
  var sampleCoverage = cache.sampleCoverage;
  sampleCoverage.toggle = cache.toggle;

  if (!sampleCoverage.enabled) {
    cache.gl.enable(cache.gl.SAMPLE_COVERAGE);
    sampleCoverage.enabled = true;
  }

  if (sampleCoverage.a !== setting.a || sampleCoverage.b !== setting.b) {
    cache.gl.sampleCoverage(setting.a, setting.b);
    sampleCoverage.a = setting.a;
    sampleCoverage.b = setting.b;
  }
});

// eslint-disable-next-line no-unused-vars
var _WebGL_enableSampleAlphaToCoverage = function (cache) {
  var sampleAlphaToCoverage = cache.sampleAlphaToCoverage;
  sampleAlphaToCoverage.toggle = cache.toggle;

  if (!sampleAlphaToCoverage.enabled) {
    cache.gl.enable(cache.gl.SAMPLE_ALPHA_TO_COVERAGE);
    sampleAlphaToCoverage.enabled = true;
  }
};

var _WebGL_disableBlend = function (cache) {
  if (cache.blend.enabled) {
    cache.gl.disable(cache.gl.BLEND);
    cache.blend.enabled = false;
  }
};

var _WebGL_disableDepthTest = function (cache) {
  if (cache.depthTest.enabled) {
    cache.gl.disable(cache.gl.DEPTH_TEST);
    cache.depthTest.enabled = false;
  }
};

var _WebGL_disableStencilTest = function (cache) {
  if (cache.stencilTest.enabled) {
    cache.gl.disable(cache.gl.STENCIL_TEST);
    cache.stencilTest.enabled = false;
  }
};

var _WebGL_disableScissor = function (cache) {
  if (cache.scissor.enabled) {
    cache.gl.disable(cache.gl.SCISSOR_TEST);
    cache.scissor.enabled = false;
  }
};

var _WebGL_disableColorMask = function (cache) {
  var colorMask = cache.colorMask;
  if (!colorMask.a || !colorMask.b || !colorMask.c || !colorMask.d) {
    cache.gl.colorMask(true, true, true, true);
    colorMask.a = true;
    colorMask.b = true;
    colorMask.c = true;
    colorMask.d = true;
  }
};

var _WebGL_disableCullFace = function (cache) {
  cache.gl.disable(cache.gl.CULL_FACE);
};

var _WebGL_disablePolygonOffset = function (cache) {
  cache.gl.disable(cache.gl.POLYGON_OFFSET_FILL);
};

var _WebGL_disableSampleCoverage = function (cache) {
  cache.gl.disable(cache.gl.SAMPLE_COVERAGE);
};

var _WebGL_disableSampleAlphaToCoverage = function (cache) {
  cache.gl.disable(cache.gl.SAMPLE_ALPHA_TO_COVERAGE);
};

var _WebGL_settings = ['blend', 'depthTest', 'stencilTest', 'scissor', 'colorMask', 'cullFace', 'polygonOffset', 'sampleCoverage', 'sampleAlphaToCoverage'];
var _WebGL_disableFunctions = [_WebGL_disableBlend, _WebGL_disableDepthTest, _WebGL_disableStencilTest, _WebGL_disableScissor, _WebGL_disableColorMask, _WebGL_disableCullFace, _WebGL_disablePolygonOffset, _WebGL_disableSampleCoverage, _WebGL_disableSampleAlphaToCoverage];

function _WebGL_doCompile(gl, src, type) {
  var shader = gl.createShader(type);
  // Enable OES_standard_derivatives extension
  gl.shaderSource(shader, '#extension GL_OES_standard_derivatives : enable\n' + src);
  gl.compileShader(shader);
  return shader;
}

function _WebGL_doLink(gl, vshader, fshader) {
  var program = gl.createProgram();

  gl.attachShader(program, vshader);
  gl.attachShader(program, fshader);
  gl.linkProgram(program);
  if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
    throw ('Link failed: ' + gl.getProgramInfoLog(program) +
      '\nvs info-log: ' + gl.getShaderInfoLog(vshader) +
      '\nfs info-log: ' + gl.getShaderInfoLog(fshader));
  }

  return program;
}

function _WebGL_getAttributeInfo(gl, type) {
  switch (type) {
    case gl.FLOAT:
      return { size: 1, arraySize: 1, type: Float32Array, baseType: gl.FLOAT };
    case gl.FLOAT_VEC2:
      return { size: 2, arraySize: 1, type: Float32Array, baseType: gl.FLOAT };
    case gl.FLOAT_VEC3:
      return { size: 3, arraySize: 1, type: Float32Array, baseType: gl.FLOAT };
    case gl.FLOAT_VEC4:
      return { size: 4, arraySize: 1, type: Float32Array, baseType: gl.FLOAT };
    case gl.FLOAT_MAT4:
      return { size: 4, arraySize: 4, type: Float32Array, baseType: gl.FLOAT };
    case gl.INT:
      return { size: 1, arraySize: 1, type: Int32Array, baseType: gl.INT };
  }
}

/**
 *  Form the buffer for a given attribute.
 *
 *  @param {WebGLRenderingContext} gl context
 *  @param {WebGLActiveInfo} attribute the attribute to bind to.
 *         We use its name to grab the record by name and also to know
 *         how many elements we need to grab.
 *  @param {Mesh} mesh The mesh coming in from Elm.
 *  @param {Object} attributes The mapping between the attribute names and Elm fields
 *  @return {WebGLBuffer}
 */
function _WebGL_doBindAttribute(gl, attribute, mesh, attributes) {
  // The length of the number of vertices that
  // complete one 'thing' based on the drawing mode.
  // ie, 2 for Lines, 3 for Triangles, etc.
  var elemSize = mesh.a.e$;

  var idxKeys = [];
  for (var i = 0; i < elemSize; i++) {
    idxKeys.push(String.fromCharCode(97 + i));
  }

  function dataFill(data, cnt, fillOffset, elem, key) {
    var i;
    if (elemSize === 1) {
      for (i = 0; i < cnt; i++) {
        data[fillOffset++] = cnt === 1 ? elem[key] : elem[key][i];
      }
    } else {
      idxKeys.forEach(function (idx) {
        for (i = 0; i < cnt; i++) {
          data[fillOffset++] = cnt === 1 ? elem[idx][key] : elem[idx][key][i];
        }
      });
    }
  }

  var attributeInfo = _WebGL_getAttributeInfo(gl, attribute.type);

  if (attributeInfo === undefined) {
    throw new Error('No info available for: ' + attribute.type);
  }

  var dataIdx = 0;
  var dataOffset = attributeInfo.size * attributeInfo.arraySize * elemSize;
  var array = new attributeInfo.type(_WebGL_listLength(mesh.b) * dataOffset);

  _WebGL_listEach(function (elem) {
    dataFill(array, attributeInfo.size * attributeInfo.arraySize, dataIdx, elem, attributes[attribute.name] || attribute.name);
    dataIdx += dataOffset;
  }, mesh.b);

  var buffer = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
  gl.bufferData(gl.ARRAY_BUFFER, array, gl.STATIC_DRAW);
  return buffer;
}

/**
 *  This sets up the binding caching buffers.
 *
 *  We don't actually bind any buffers now except for the indices buffer.
 *  The problem with filling the buffers here is that it is possible to
 *  have a buffer shared between two webgl shaders;
 *  which could have different active attributes. If we bind it here against
 *  a particular program, we might not bind them all. That final bind is now
 *  done right before drawing.
 *
 *  @param {WebGLRenderingContext} gl context
 *  @param {Mesh} mesh a mesh object from Elm
 *  @return {Object} buffer - an object with the following properties
 *  @return {Number} buffer.numIndices
 *  @return {WebGLBuffer|null} buffer.indexBuffer - optional index buffer
 *  @return {Object} buffer.buffers - will be used to buffer attributes
 */
function _WebGL_doBindSetup(gl, mesh) {
  if (mesh.a.fk > 0) {
    var indexBuffer = gl.createBuffer();
    var indices = _WebGL_makeIndexedBuffer(mesh.c, mesh.a.fk);
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, indices, gl.STATIC_DRAW);
    return {
      numIndices: indices.length,
      indexBuffer: indexBuffer,
      buffers: {}
    };
  } else {
    return {
      numIndices: mesh.a.e$ * _WebGL_listLength(mesh.b),
      indexBuffer: null,
      buffers: {}
    };
  }
}

/**
 *  Create an indices array and fill it from indices
 *  based on the size of the index
 *
 *  @param {List} indicesList the list of indices
 *  @param {Number} indexSize the size of the index
 *  @return {Uint32Array} indices
 */
function _WebGL_makeIndexedBuffer(indicesList, indexSize) {
  var indices = new Uint32Array(_WebGL_listLength(indicesList) * indexSize);
  var fillOffset = 0;
  var i;
  _WebGL_listEach(function (elem) {
    if (indexSize === 1) {
      indices[fillOffset++] = elem;
    } else {
      for (i = 0; i < indexSize; i++) {
        indices[fillOffset++] = elem[String.fromCharCode(97 + i)];
      }
    }
  }, indicesList);
  return indices;
}

function _WebGL_getProgID(vertID, fragID) {
  return vertID + '#' + fragID;
}

var _WebGL_drawGL = F2(function (model, domNode) {
  var cache = model.f;
  var gl = cache.gl;

  if (!gl) {
    return domNode;
  }

  gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);

  if (!cache.depthTest.b) {
    gl.depthMask(true);
    cache.depthTest.b = true;
  }
  if (cache.stencilTest.c !== cache.STENCIL_WRITEMASK) {
    gl.stencilMask(cache.STENCIL_WRITEMASK);
    cache.stencilTest.c = cache.STENCIL_WRITEMASK;
  }
  _WebGL_disableScissor(cache);
  _WebGL_disableColorMask(cache);
  gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT | gl.STENCIL_BUFFER_BIT);

  function drawEntity(entity) {
    if (!entity.d.b.b) {
      return; // Empty list
    }

    var progid;
    var program;
    var i;

    if (entity.b.id && entity.c.id) {
      progid = _WebGL_getProgID(entity.b.id, entity.c.id);
      program = cache.programs[progid];
    }

    if (!program) {

      var vshader;
      if (entity.b.id) {
        vshader = cache.shaders[entity.b.id];
      } else {
        entity.b.id = _WebGL_guid++;
      }

      if (!vshader) {
        vshader = _WebGL_doCompile(gl, entity.b.src, gl.VERTEX_SHADER);
        cache.shaders[entity.b.id] = vshader;
      }

      var fshader;
      if (entity.c.id) {
        fshader = cache.shaders[entity.c.id];
      } else {
        entity.c.id = _WebGL_guid++;
      }

      if (!fshader) {
        fshader = _WebGL_doCompile(gl, entity.c.src, gl.FRAGMENT_SHADER);
        cache.shaders[entity.c.id] = fshader;
      }

      var glProgram = _WebGL_doLink(gl, vshader, fshader);

      program = {
        glProgram: glProgram,
        attributes: Object.assign({}, entity.b.attributes, entity.c.attributes),
        currentUniforms: {},
        activeAttributes: [],
        activeAttributeLocations: []
      };

      program.uniformSetters = _WebGL_createUniformSetters(
        gl,
        model,
        program,
        Object.assign({}, entity.b.uniforms, entity.c.uniforms)
      );

      var numActiveAttributes = gl.getProgramParameter(glProgram, gl.ACTIVE_ATTRIBUTES);
      for (i = 0; i < numActiveAttributes; i++) {
        var attribute = gl.getActiveAttrib(glProgram, i);
        var attribLocation = gl.getAttribLocation(glProgram, attribute.name);
        program.activeAttributes.push(attribute);
        program.activeAttributeLocations.push(attribLocation);
      }

      progid = _WebGL_getProgID(entity.b.id, entity.c.id);
      cache.programs[progid] = program;
    }

    if (cache.lastProgId !== progid) {
      gl.useProgram(program.glProgram);
      cache.lastProgId = progid;
    }

    _WebGL_setUniforms(program.uniformSetters, entity.e);

    var buffer = cache.buffers.get(entity.d);

    if (!buffer) {
      buffer = _WebGL_doBindSetup(gl, entity.d);
      cache.buffers.set(entity.d, buffer);
    }

    for (i = 0; i < program.activeAttributes.length; i++) {
      attribute = program.activeAttributes[i];
      attribLocation = program.activeAttributeLocations[i];

      if (buffer.buffers[attribute.name] === undefined) {
        buffer.buffers[attribute.name] = _WebGL_doBindAttribute(gl, attribute, entity.d, program.attributes);
      }
      gl.bindBuffer(gl.ARRAY_BUFFER, buffer.buffers[attribute.name]);

      var attributeInfo = _WebGL_getAttributeInfo(gl, attribute.type);
      if (attributeInfo.arraySize === 1) {
        gl.enableVertexAttribArray(attribLocation);
        gl.vertexAttribPointer(attribLocation, attributeInfo.size, attributeInfo.baseType, false, 0, 0);
      } else {
        // Point to four vec4 in case of mat4
        var offset = attributeInfo.size * 4; // float32 takes 4 bytes
        var stride = offset * attributeInfo.arraySize;
        for (var m = 0; m < attributeInfo.arraySize; m++) {
          gl.enableVertexAttribArray(attribLocation + m);
          gl.vertexAttribPointer(attribLocation + m, attributeInfo.size, attributeInfo.baseType, false, stride, offset * m);
        }
      }
    }

    // Apply all the new settings
    cache.toggle = !cache.toggle;
    _WebGL_listEach($elm_explorations$webgl$WebGL$Internal$enableSetting(cache), entity.a);
    // Disable the settings that were applied in the previous draw call
    for (i = 0; i < _WebGL_settings.length; i++) {
      var setting = cache[_WebGL_settings[i]];
      if (setting.toggle !== cache.toggle && setting.enabled) {
        _WebGL_disableFunctions[i](cache);
        setting.enabled = false;
        setting.toggle = cache.toggle;
      }
    }

    if (buffer.indexBuffer) {
      gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, buffer.indexBuffer);
      gl.drawElements(entity.d.a.fR, buffer.numIndices, gl.UNSIGNED_INT, 0);
    } else {
      gl.drawArrays(entity.d.a.fR, 0, buffer.numIndices);
    }
  }

  _WebGL_listEach(drawEntity, model.g);
  return domNode;
});

function _WebGL_createUniformSetters(gl, model, program, uniformsMap) {
  var glProgram = program.glProgram;
  var currentUniforms = program.currentUniforms;
  var textureCounter = 0;
  var cache = model.f;
  function createUniformSetter(glProgram, uniform) {
    var uniformName = uniform.name;
    var uniformLocation = gl.getUniformLocation(glProgram, uniformName);
    switch (uniform.type) {
      case gl.INT:
        return function (value) {
          if (currentUniforms[uniformName] !== value) {
            gl.uniform1i(uniformLocation, value);
            currentUniforms[uniformName] = value;
          }
        };
      case gl.FLOAT:
        return function (value) {
          if (currentUniforms[uniformName] !== value) {
            gl.uniform1f(uniformLocation, value);
            currentUniforms[uniformName] = value;
          }
        };
      case gl.FLOAT_VEC2:
        return function (value) {
          if (currentUniforms[uniformName] !== value) {
            gl.uniform2f(uniformLocation, value[0], value[1]);
            currentUniforms[uniformName] = value;
          }
        };
      case gl.FLOAT_VEC3:
        return function (value) {
          if (currentUniforms[uniformName] !== value) {
            gl.uniform3f(uniformLocation, value[0], value[1], value[2]);
            currentUniforms[uniformName] = value;
          }
        };
      case gl.FLOAT_VEC4:
        return function (value) {
          if (currentUniforms[uniformName] !== value) {
            gl.uniform4f(uniformLocation, value[0], value[1], value[2], value[3]);
            currentUniforms[uniformName] = value;
          }
        };
      case gl.FLOAT_MAT4:
        return function (value) {
          if (currentUniforms[uniformName] !== value) {
            gl.uniformMatrix4fv(uniformLocation, false, new Float32Array(value));
            currentUniforms[uniformName] = value;
          }
        };
      case gl.SAMPLER_2D:
        var currentTexture = textureCounter++;
        return function (texture) {
          gl.activeTexture(gl.TEXTURE0 + currentTexture);
          var tex = cache.textures.get(texture);
          if (!tex) {
            tex = texture.hj(gl);
            cache.textures.set(texture, tex);
          }
          gl.bindTexture(gl.TEXTURE_2D, tex);
          if (currentUniforms[uniformName] !== texture) {
            gl.uniform1i(uniformLocation, currentTexture);
            currentUniforms[uniformName] = texture;
          }
        };
      case gl.BOOL:
        return function (value) {
          if (currentUniforms[uniformName] !== value) {
            gl.uniform1i(uniformLocation, value);
            currentUniforms[uniformName] = value;
          }
        };
      default:
        return function () { };
    }
  }

  var uniformSetters = {};
  var numUniforms = gl.getProgramParameter(glProgram, gl.ACTIVE_UNIFORMS);
  for (var i = 0; i < numUniforms; i++) {
    var uniform = gl.getActiveUniform(glProgram, i);
    uniformSetters[uniformsMap[uniform.name] || uniform.name] = createUniformSetter(glProgram, uniform);
  }

  return uniformSetters;
}

function _WebGL_setUniforms(setters, values) {
  Object.keys(values).forEach(function (name) {
    var setter = setters[name];
    if (setter) {
      setter(values[name]);
    }
  });
}

// VIRTUAL-DOM WIDGET

// eslint-disable-next-line no-unused-vars
var _WebGL_toHtml = F3(function (options, factList, entities) {
  return _VirtualDom_custom(
    factList,
    {
      g: entities,
      f: {},
      h: options
    },
    _WebGL_render,
    _WebGL_diff
  );
});

// eslint-disable-next-line no-unused-vars
var _WebGL_enableAlpha = F2(function (options, option) {
  options.contextAttributes.alpha = true;
  options.contextAttributes.premultipliedAlpha = option.a;
});

// eslint-disable-next-line no-unused-vars
var _WebGL_enableDepth = F2(function (options, option) {
  options.contextAttributes.depth = true;
  options.sceneSettings.push(function (gl) {
    gl.clearDepth(option.a);
  });
});

// eslint-disable-next-line no-unused-vars
var _WebGL_enableStencil = F2(function (options, option) {
  options.contextAttributes.stencil = true;
  options.sceneSettings.push(function (gl) {
    gl.clearStencil(option.a);
  });
});

// eslint-disable-next-line no-unused-vars
var _WebGL_enableAntialias = F2(function (options, option) {
  options.contextAttributes.antialias = true;
});

// eslint-disable-next-line no-unused-vars
var _WebGL_enableClearColor = F2(function (options, option) {
  options.sceneSettings.push(function (gl) {
    gl.clearColor(option.a, option.b, option.c, option.d);
  });
});

// eslint-disable-next-line no-unused-vars
var _WebGL_enablePreserveDrawingBuffer = F2(function (options, option) {
  options.contextAttributes.preserveDrawingBuffer = true;
});

/**
 *  Creates canvas and schedules initial _WebGL_drawGL
 *  @param {Object} model
 *  @param {Object} model.f that may contain the following properties:
           gl, shaders, programs, buffers, textures
 *  @param {List<Option>} model.h list of options coming from Elm
 *  @param {List<Entity>} model.g list of entities coming from Elm
 *  @return {HTMLElement} <canvas> if WebGL is supported, otherwise a <div>
 */
function _WebGL_render(model) {
  var options = {
    contextAttributes: {
      alpha: false,
      depth: false,
      stencil: false,
      antialias: false,
      premultipliedAlpha: false,
      preserveDrawingBuffer: false
    },
    sceneSettings: []
  };

  _WebGL_listEach(function (option) {
    return A2($elm_explorations$webgl$WebGL$Internal$enableOption, options, option);
  }, model.h);

  var canvas = _VirtualDom_doc.createElement('canvas');
  var gl = canvas.getContext && (
    canvas.getContext('webgl', options.contextAttributes) ||
    canvas.getContext('experimental-webgl', options.contextAttributes)
  );

  if (gl && typeof WeakMap !== 'undefined') {
    options.sceneSettings.forEach(function (sceneSetting) {
      sceneSetting(gl);
    });

    // Activate extensions
    gl.getExtension('OES_standard_derivatives');
    gl.getExtension('OES_element_index_uint');

    model.f.gl = gl;

    // Cache the current settings in order to diff them to avoid redundant calls
    // https://emscripten.org/docs/optimizing/Optimizing-WebGL.html#avoid-redundant-calls
    model.f.toggle = false; // used to diff the settings from the previous and current draw calls
    model.f.blend = { enabled: false, toggle: false };
    model.f.depthTest = { enabled: false, toggle: false };
    model.f.stencilTest = { enabled: false, toggle: false };
    model.f.scissor = { enabled: false, toggle: false };
    model.f.colorMask = { enabled: false, toggle: false };
    model.f.cullFace = { enabled: false, toggle: false };
    model.f.polygonOffset = { enabled: false, toggle: false };
    model.f.sampleCoverage = { enabled: false, toggle: false };
    model.f.sampleAlphaToCoverage = { enabled: false, toggle: false };

    model.f.shaders = [];
    model.f.programs = {};
    model.f.lastProgId = null;
    model.f.buffers = new WeakMap();
    model.f.textures = new WeakMap();
    // Memorize the initial stencil write mask, because
    // browsers may have different number of stencil bits
    model.f.STENCIL_WRITEMASK = gl.getParameter(gl.STENCIL_WRITEMASK);

    // Render for the first time.
    // This has to be done in animation frame,
    // because the canvas is not in the DOM yet
    _WebGL_rAF(function () {
      return A2(_WebGL_drawGL, model, canvas);
    });

  } else {
    canvas = _VirtualDom_doc.createElement('div');
    canvas.innerHTML = '<a href="https://get.webgl.org/">Enable WebGL</a> to see this content!';
  }

  return canvas;
}

function _WebGL_diff(oldModel, newModel) {
  newModel.f = oldModel.f;
  return _WebGL_drawGL(newModel);
}


// eslint-disable-next-line no-unused-vars
var _Texture_load = F6(function (magnify, mininify, horizontalWrap, verticalWrap, flipY, url) {
  var isMipmap = mininify !== 9728 && mininify !== 9729;
  return _Scheduler_binding(function (callback) {
    var img = new Image();
    function createTexture(gl) {
      var texture = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, texture);
      gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, flipY);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, img);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, magnify);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, mininify);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, horizontalWrap);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, verticalWrap);
      if (isMipmap) {
        gl.generateMipmap(gl.TEXTURE_2D);
      }
      gl.bindTexture(gl.TEXTURE_2D, null);
      return texture;
    }
    img.onload = function () {
      var width = img.width;
      var height = img.height;
      var widthPowerOfTwo = (width & (width - 1)) === 0;
      var heightPowerOfTwo = (height & (height - 1)) === 0;
      var isSizeValid = (widthPowerOfTwo && heightPowerOfTwo) || (
        !isMipmap
        && horizontalWrap === 33071 // clamp to edge
        && verticalWrap === 33071
      );
      if (isSizeValid) {
        callback(_Scheduler_succeed({
          $: 0,
          hj: createTexture,
          a: width,
          b: height
        }));
      } else {
        callback(_Scheduler_fail(A2(
          $elm_explorations$webgl$WebGL$Texture$SizeError,
          width,
          height
        )));
      }
    };
    img.onerror = function () {
      callback(_Scheduler_fail($elm_explorations$webgl$WebGL$Texture$LoadError));
    };
    if (url.slice(0, 5) !== 'data:') {
      img.crossOrigin = 'Anonymous';
    }
    img.src = url;
  });
});

// eslint-disable-next-line no-unused-vars
var _Texture_size = function (texture) {
  return _Utils_Tuple2(texture.a, texture.b);
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $author$project$Game$Playing$BodiesUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Main$ClientUpdate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Game$Playing$Delta = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $author$project$Game$Playing$KeyDown = function (a) {
	return {$: 8, a: a};
};
var $author$project$Game$Playing$KeyUp = function (a) {
	return {$: 9, a: a};
};
var $author$project$Game$Lobby$LinkActionReceived = function (a) {
	return {$: 11, a: a};
};
var $author$project$Game$LobbyMsg = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $author$project$Game$Playing$PlayerMeshLoaded = function (a) {
	return {$: 7, a: a};
};
var $author$project$Game$PlayingMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Main$ServerUpdate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Game$Playing$WindowResized = {$: 2};
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.r) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.v),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.v);
		} else {
			var treeLen = builder.r * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.G) : builder.G;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.r);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.v) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.v);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{G: nodeList, r: (len / $elm$core$Array$branchFactor) | 0, v: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $author$project$Main$bodiesUpdated = _Platform_incomingPort('bodiesUpdated', $elm$json$Json$Decode$value);
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {e9: fragment, fi: host, f3: path, f8: port_, gd: protocol, ge: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$element = _Browser_element;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Game$Lobby$gameLinkAction = _Platform_incomingPort('gameLinkAction', $elm$json$Json$Decode$string);
var $author$project$Main$gameUpdated = _Platform_incomingPort('gameUpdated', $elm$json$Json$Decode$value);
var $author$project$Game$PreLobby = function (a) {
	return {$: 0, a: a};
};
var $author$project$Game$init = F2(
	function (playerId, initialGameCode) {
		return $author$project$Game$PreLobby(
			{hJ: initialGameCode, h_: false, iJ: playerId, jd: ''});
	});
var $elm$core$Maybe$destruct = F3(
	function (_default, func, maybe) {
		if (!maybe.$) {
			var a = maybe.a;
			return func(a);
		} else {
			return _default;
		}
	});
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Game$PreLobby$joinGame = _Platform_outgoingPort(
	'joinGame',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'gameId',
					function ($) {
						return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
					}($.fb)),
					_Utils_Tuple2(
					'playerId',
					$elm$json$Json$Encode$string($.iJ)),
					_Utils_Tuple2(
					'topic',
					function ($) {
						return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
					}($.jd))
				]));
	});
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Main$init = function (_v0) {
	var playerId = _v0.iJ;
	var savedPlayerName = _v0.be;
	var skipGameSetup = _v0.es;
	var gameCode = _v0.hJ;
	var debugCmd = skipGameSetup ? $author$project$Game$PreLobby$joinGame(
		{
			fb: $elm$core$Maybe$Nothing,
			iJ: playerId,
			jd: $elm$core$Maybe$Just('Debug Game')
		}) : $elm$core$Platform$Cmd$none;
	return _Utils_Tuple2(
		{
			aO: A2(
				$author$project$Game$init,
				playerId,
				A2($elm$core$Maybe$withDefault, '', gameCode)),
			iJ: playerId,
			be: savedPlayerName
		},
		debugCmd);
};
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$browser$Browser$AnimationManager$Delta = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$AnimationManager$State = F3(
	function (subs, request, oldTime) {
		return {ea: oldTime, gg: request, gs: subs};
	});
var $elm$browser$Browser$AnimationManager$init = $elm$core$Task$succeed(
	A3($elm$browser$Browser$AnimationManager$State, _List_Nil, $elm$core$Maybe$Nothing, 0));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$browser$Browser$AnimationManager$now = _Browser_now(0);
var $elm$browser$Browser$AnimationManager$rAF = _Browser_rAF(0);
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$browser$Browser$AnimationManager$onEffects = F3(
	function (router, subs, _v0) {
		var request = _v0.gg;
		var oldTime = _v0.ea;
		var _v1 = _Utils_Tuple2(request, subs);
		if (_v1.a.$ === 1) {
			if (!_v1.b.b) {
				var _v2 = _v1.a;
				return $elm$browser$Browser$AnimationManager$init;
			} else {
				var _v4 = _v1.a;
				return A2(
					$elm$core$Task$andThen,
					function (pid) {
						return A2(
							$elm$core$Task$andThen,
							function (time) {
								return $elm$core$Task$succeed(
									A3(
										$elm$browser$Browser$AnimationManager$State,
										subs,
										$elm$core$Maybe$Just(pid),
										time));
							},
							$elm$browser$Browser$AnimationManager$now);
					},
					$elm$core$Process$spawn(
						A2(
							$elm$core$Task$andThen,
							$elm$core$Platform$sendToSelf(router),
							$elm$browser$Browser$AnimationManager$rAF)));
			}
		} else {
			if (!_v1.b.b) {
				var pid = _v1.a.a;
				return A2(
					$elm$core$Task$andThen,
					function (_v3) {
						return $elm$browser$Browser$AnimationManager$init;
					},
					$elm$core$Process$kill(pid));
			} else {
				return $elm$core$Task$succeed(
					A3($elm$browser$Browser$AnimationManager$State, subs, request, oldTime));
			}
		}
	});
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$browser$Browser$AnimationManager$onSelfMsg = F3(
	function (router, newTime, _v0) {
		var subs = _v0.gs;
		var oldTime = _v0.ea;
		var send = function (sub) {
			if (!sub.$) {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(
						$elm$time$Time$millisToPosix(newTime)));
			} else {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(newTime - oldTime));
			}
		};
		return A2(
			$elm$core$Task$andThen,
			function (pid) {
				return A2(
					$elm$core$Task$andThen,
					function (_v1) {
						return $elm$core$Task$succeed(
							A3(
								$elm$browser$Browser$AnimationManager$State,
								subs,
								$elm$core$Maybe$Just(pid),
								newTime));
					},
					$elm$core$Task$sequence(
						A2($elm$core$List$map, send, subs)));
			},
			$elm$core$Process$spawn(
				A2(
					$elm$core$Task$andThen,
					$elm$core$Platform$sendToSelf(router),
					$elm$browser$Browser$AnimationManager$rAF)));
	});
var $elm$browser$Browser$AnimationManager$Time = function (a) {
	return {$: 0, a: a};
};
var $elm$browser$Browser$AnimationManager$subMap = F2(
	function (func, sub) {
		if (!sub.$) {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Time(
				A2($elm$core$Basics$composeL, func, tagger));
		} else {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Delta(
				A2($elm$core$Basics$composeL, func, tagger));
		}
	});
_Platform_effectManagers['Browser.AnimationManager'] = _Platform_createManager($elm$browser$Browser$AnimationManager$init, $elm$browser$Browser$AnimationManager$onEffects, $elm$browser$Browser$AnimationManager$onSelfMsg, 0, $elm$browser$Browser$AnimationManager$subMap);
var $elm$browser$Browser$AnimationManager$subscription = _Platform_leaf('Browser.AnimationManager');
var $elm$browser$Browser$AnimationManager$onAnimationFrameDelta = function (tagger) {
	return $elm$browser$Browser$AnimationManager$subscription(
		$elm$browser$Browser$AnimationManager$Delta(tagger));
};
var $elm$browser$Browser$Events$onAnimationFrameDelta = $elm$browser$Browser$AnimationManager$onAnimationFrameDelta;
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {f4: pids, gs: subs};
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {e3: event, fo: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.f4,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.fo;
		var event = _v0.e3;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.gs);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onKeyDown = A2($elm$browser$Browser$Events$on, 0, 'keydown');
var $elm$browser$Browser$Events$onKeyUp = A2($elm$browser$Browser$Events$on, 0, 'keyup');
var $elm$browser$Browser$Events$Window = 1;
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$browser$Browser$Events$onResize = function (func) {
	return A3(
		$elm$browser$Browser$Events$on,
		1,
		'resize',
		A2(
			$elm$json$Json$Decode$field,
			'target',
			A3(
				$elm$json$Json$Decode$map2,
				func,
				A2($elm$json$Json$Decode$field, 'innerWidth', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'innerHeight', $elm$json$Json$Decode$int))));
};
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $author$project$Main$playerMeshLoaded = _Platform_incomingPort('playerMeshLoaded', $elm$json$Json$Decode$string);
var $author$project$Game$Lobby = function (a) {
	return {$: 1, a: a};
};
var $author$project$Game$Lobby$LobbyUpdated = function (a) {
	return {$: 13, a: a};
};
var $author$project$Game$Playing = function (a) {
	return {$: 2, a: a};
};
var $author$project$Game$PostGame = function (a) {
	return {$: 3, a: a};
};
var $author$project$Game$PostGameMsg = function (a) {
	return {$: 3, a: a};
};
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$Server$State$State = F9(
	function (id, topic, players, teams, bodies, lastUpdated, status, ownerId, code) {
		return {eK: bodies, eP: code, hT: id, a6: lastUpdated, iF: ownerId, an: players, i_: status, bV: teams, jd: topic};
	});
var $author$project$Server$Player$Player = F3(
	function (id, name, teamId) {
		return {hT: id, aH: name, i7: teamId};
	});
var $elm$json$Json$Decode$map3 = _Json_map3;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$Server$Player$decoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Server$Player$Player,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'team_id',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)));
var $author$project$Server$Team$Team = F4(
	function (id, ownerId, cause, color) {
		return {g5: cause, he: color, hT: id, iF: ownerId};
	});
var $avh4$elm_color$Color$RgbaSpace = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $avh4$elm_color$Color$black = A4($avh4$elm_color$Color$RgbaSpace, 0 / 255, 0 / 255, 0 / 255, 1.0);
var $avh4$elm_color$Color$blue = A4($avh4$elm_color$Color$RgbaSpace, 52 / 255, 101 / 255, 164 / 255, 1.0);
var $avh4$elm_color$Color$brown = A4($avh4$elm_color$Color$RgbaSpace, 193 / 255, 125 / 255, 17 / 255, 1.0);
var $avh4$elm_color$Color$darkBlue = A4($avh4$elm_color$Color$RgbaSpace, 32 / 255, 74 / 255, 135 / 255, 1.0);
var $avh4$elm_color$Color$darkBrown = A4($avh4$elm_color$Color$RgbaSpace, 143 / 255, 89 / 255, 2 / 255, 1.0);
var $avh4$elm_color$Color$darkGreen = A4($avh4$elm_color$Color$RgbaSpace, 78 / 255, 154 / 255, 6 / 255, 1.0);
var $avh4$elm_color$Color$darkOrange = A4($avh4$elm_color$Color$RgbaSpace, 206 / 255, 92 / 255, 0 / 255, 1.0);
var $avh4$elm_color$Color$darkPurple = A4($avh4$elm_color$Color$RgbaSpace, 92 / 255, 53 / 255, 102 / 255, 1.0);
var $avh4$elm_color$Color$darkRed = A4($avh4$elm_color$Color$RgbaSpace, 164 / 255, 0 / 255, 0 / 255, 1.0);
var $avh4$elm_color$Color$darkYellow = A4($avh4$elm_color$Color$RgbaSpace, 196 / 255, 160 / 255, 0 / 255, 1.0);
var $avh4$elm_color$Color$green = A4($avh4$elm_color$Color$RgbaSpace, 115 / 255, 210 / 255, 22 / 255, 1.0);
var $avh4$elm_color$Color$lightBlue = A4($avh4$elm_color$Color$RgbaSpace, 114 / 255, 159 / 255, 207 / 255, 1.0);
var $avh4$elm_color$Color$lightBrown = A4($avh4$elm_color$Color$RgbaSpace, 233 / 255, 185 / 255, 110 / 255, 1.0);
var $avh4$elm_color$Color$lightGreen = A4($avh4$elm_color$Color$RgbaSpace, 138 / 255, 226 / 255, 52 / 255, 1.0);
var $avh4$elm_color$Color$lightOrange = A4($avh4$elm_color$Color$RgbaSpace, 252 / 255, 175 / 255, 62 / 255, 1.0);
var $avh4$elm_color$Color$lightPurple = A4($avh4$elm_color$Color$RgbaSpace, 173 / 255, 127 / 255, 168 / 255, 1.0);
var $avh4$elm_color$Color$lightYellow = A4($avh4$elm_color$Color$RgbaSpace, 255 / 255, 233 / 255, 79 / 255, 1.0);
var $avh4$elm_color$Color$orange = A4($avh4$elm_color$Color$RgbaSpace, 245 / 255, 121 / 255, 0 / 255, 1.0);
var $avh4$elm_color$Color$purple = A4($avh4$elm_color$Color$RgbaSpace, 117 / 255, 80 / 255, 123 / 255, 1.0);
var $avh4$elm_color$Color$red = A4($avh4$elm_color$Color$RgbaSpace, 204 / 255, 0 / 255, 0 / 255, 1.0);
var $avh4$elm_color$Color$yellow = A4($avh4$elm_color$Color$RgbaSpace, 237 / 255, 212 / 255, 0 / 255, 1.0);
var $author$project$Server$Team$colorDecoder = A2(
	$elm$json$Json$Decode$map,
	function (colorString) {
		switch (colorString) {
			case 'red':
				return $avh4$elm_color$Color$red;
			case 'orange':
				return $avh4$elm_color$Color$orange;
			case 'yellow':
				return $avh4$elm_color$Color$yellow;
			case 'green':
				return $avh4$elm_color$Color$green;
			case 'blue':
				return $avh4$elm_color$Color$blue;
			case 'purple':
				return $avh4$elm_color$Color$purple;
			case 'brown':
				return $avh4$elm_color$Color$brown;
			case 'light-red':
				return $avh4$elm_color$Color$red;
			case 'light-orange':
				return $avh4$elm_color$Color$lightOrange;
			case 'light-yellow':
				return $avh4$elm_color$Color$lightYellow;
			case 'light-green':
				return $avh4$elm_color$Color$lightGreen;
			case 'light-blue':
				return $avh4$elm_color$Color$lightBlue;
			case 'light-purple':
				return $avh4$elm_color$Color$lightPurple;
			case 'light-brown':
				return $avh4$elm_color$Color$lightBrown;
			case 'dark-red':
				return $avh4$elm_color$Color$darkRed;
			case 'dark-orange':
				return $avh4$elm_color$Color$darkOrange;
			case 'dark-yellow':
				return $avh4$elm_color$Color$darkYellow;
			case 'dark-green':
				return $avh4$elm_color$Color$darkGreen;
			case 'dark-blue':
				return $avh4$elm_color$Color$darkBlue;
			case 'dark-purple':
				return $avh4$elm_color$Color$darkPurple;
			case 'dark-brown':
				return $avh4$elm_color$Color$darkBrown;
			default:
				return $avh4$elm_color$Color$black;
		}
	},
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$Server$Team$decoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Server$Team$Team,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'owner_id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'cause', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'color', $author$project$Server$Team$colorDecoder));
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$json$Json$Decode$fail = _Json_fail;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Server$Body$Body = function (id) {
	return function (teamId) {
		return function (ownerId) {
			return function (translation) {
				return function (rotation) {
					return function (linearVelocity) {
						return function (angularVelocity) {
							return function (dimensions) {
								return function (mass) {
									return function (_class) {
										return function (hp) {
											return function (obstacleType) {
												return function (shotsFired) {
													return function (shotsHit) {
														return function (eliminations) {
															return {cL: angularVelocity, hb: _class, hq: dimensions, hu: eliminations, hS: hp, hT: id, fy: linearVelocity, d1: mass, iz: obstacleType, iF: ownerId, gh: rotation, iV: shotsFired, iW: shotsHit, i7: teamId, dD: translation};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$BodyData$Bullet = 2;
var $author$project$BodyData$NPC = 1;
var $author$project$BodyData$Obstacle = 3;
var $author$project$Server$Body$classDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (_class) {
		switch (_class) {
			case 'player':
				return $elm$json$Json$Decode$succeed(1);
			case 'bullet':
				return $elm$json$Json$Decode$succeed(2);
			case 'obstacle':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Unknown body class: ' + _class);
		}
	},
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$BodyData$Boulder = 1;
var $author$project$BodyData$Column = 3;
var $author$project$BodyData$Crate = 4;
var $author$project$BodyData$Rock = 0;
var $author$project$BodyData$Tree = 2;
var $author$project$Server$Body$obstacleTypeDecoder = $elm$json$Json$Decode$nullable(
	A2(
		$elm$json$Json$Decode$andThen,
		function (s) {
			switch (s) {
				case 'rock':
					return $elm$json$Json$Decode$succeed(0);
				case 'boulder':
					return $elm$json$Json$Decode$succeed(1);
				case 'tree':
					return $elm$json$Json$Decode$succeed(2);
				case 'column':
					return $elm$json$Json$Decode$succeed(3);
				case 'crate':
					return $elm$json$Json$Decode$succeed(4);
				default:
					return $elm$json$Json$Decode$fail('Unknown obstacle type: ' + s);
			}
		},
		$elm$json$Json$Decode$string));
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Server$Body$Vector = F3(
	function (x, y, z) {
		return {cF: x, cG: y, cH: z};
	});
var $author$project$Server$Body$vectorDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Server$Body$Vector,
	A2($elm$json$Json$Decode$field, 'x', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'y', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'z', $elm$json$Json$Decode$float));
var $author$project$Server$Body$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'el',
	$elm$json$Json$Decode$int,
	0,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'sh',
		$elm$json$Json$Decode$int,
		0,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'sf',
			$elm$json$Json$Decode$int,
			0,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'ot',
				$author$project$Server$Body$obstacleTypeDecoder,
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'hp',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'cl',
						$author$project$Server$Body$classDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'm',
							$elm$json$Json$Decode$float,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'd',
								$author$project$Server$Body$vectorDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'av',
									$author$project$Server$Body$vectorDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'lv',
										$author$project$Server$Body$vectorDecoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'rot',
											$elm$json$Json$Decode$float,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'tra',
												$author$project$Server$Body$vectorDecoder,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'oid',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
													$elm$core$Maybe$Nothing,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'tid',
														$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'id',
															$elm$json$Json$Decode$string,
															$elm$json$Json$Decode$succeed($author$project$Server$Body$Body))))))))))))))));
var $author$project$Internal$Body$Protected = $elm$core$Basics$identity;
var $author$project$Internal$Vector3$cross = F2(
	function (a, b) {
		return {cF: (a.cG * b.cH) - (a.cH * b.cG), cG: (a.cH * b.cF) - (a.cF * b.cH), cH: (a.cF * b.cG) - (a.cG * b.cF)};
	});
var $author$project$Internal$Transform3d$originPoint = function (_v0) {
	var localOrigin = _v0.a;
	return localOrigin;
};
var $author$project$Internal$Vector3$scale = F2(
	function (s, v3) {
		return {cF: s * v3.cF, cG: s * v3.cG, cH: s * v3.cH};
	});
var $author$project$Internal$Vector3$sub = F2(
	function (a, b) {
		return {cF: a.cF - b.cF, cG: a.cG - b.cG, cH: a.cH - b.cH};
	});
var $author$project$Internal$Body$applyImpulse = F4(
	function (amount, direction, point, body) {
		var relativePoint = A2(
			$author$project$Internal$Vector3$sub,
			point,
			$author$project$Internal$Transform3d$originPoint(body.cA));
		var impulse = A2($author$project$Internal$Vector3$scale, amount, direction);
		var _v0 = A2($author$project$Internal$Vector3$cross, relativePoint, impulse);
		var x = _v0.cF;
		var y = _v0.cG;
		var z = _v0.cH;
		var _v1 = body;
		var angularVelocity = _v1.cL;
		var invInertiaWorld = _v1.c2;
		var velocity = _v1.dF;
		var invMass = _v1.c3;
		return _Utils_update(
			body,
			{
				cL: {cF: ((angularVelocity.cF + (invInertiaWorld.h8 * x)) + (invInertiaWorld.h9 * y)) + (invInertiaWorld.ia * z), cG: ((angularVelocity.cG + (invInertiaWorld.ib * x)) + (invInertiaWorld.ic * y)) + (invInertiaWorld.id * z), cH: ((angularVelocity.cH + (invInertiaWorld.ie * x)) + (invInertiaWorld.$8 * y)) + (invInertiaWorld.ig * z)},
				dF: {cF: velocity.cF + (invMass * impulse.cF), cG: velocity.cG + (invMass * impulse.cG), cH: velocity.cH + (invMass * impulse.cH)}
			});
	});
var $ianmackenzie$elm_geometry$Point3d$toMeters = function (_v0) {
	var pointCoordinates = _v0;
	return pointCoordinates;
};
var $ianmackenzie$elm_geometry$Direction3d$unwrap = function (_v0) {
	var coordinates = _v0;
	return coordinates;
};
var $author$project$Physics$Body$applyImpulse = F4(
	function (_v0, direction, point, _v1) {
		var impulse = _v0;
		var body = _v1;
		return (body.d1 > 0) ? A4(
			$author$project$Internal$Body$applyImpulse,
			impulse,
			$ianmackenzie$elm_geometry$Direction3d$unwrap(direction),
			$ianmackenzie$elm_geometry$Point3d$toMeters(point),
			body) : body;
	});
var $ianmackenzie$elm_geometry$Geometry$Types$Frame3d = $elm$core$Basics$identity;
var $ianmackenzie$elm_geometry$Geometry$Types$Point3d = $elm$core$Basics$identity;
var $ianmackenzie$elm_geometry$Point3d$origin = {cF: 0, cG: 0, cH: 0};
var $ianmackenzie$elm_geometry$Geometry$Types$Direction3d = $elm$core$Basics$identity;
var $ianmackenzie$elm_geometry$Direction3d$unsafe = function (givenComponents) {
	return givenComponents;
};
var $ianmackenzie$elm_geometry$Direction3d$positiveX = $ianmackenzie$elm_geometry$Direction3d$unsafe(
	{cF: 1, cG: 0, cH: 0});
var $ianmackenzie$elm_geometry$Direction3d$x = $ianmackenzie$elm_geometry$Direction3d$positiveX;
var $ianmackenzie$elm_geometry$Direction3d$positiveY = $ianmackenzie$elm_geometry$Direction3d$unsafe(
	{cF: 0, cG: 1, cH: 0});
var $ianmackenzie$elm_geometry$Direction3d$y = $ianmackenzie$elm_geometry$Direction3d$positiveY;
var $ianmackenzie$elm_geometry$Direction3d$positiveZ = $ianmackenzie$elm_geometry$Direction3d$unsafe(
	{cF: 0, cG: 0, cH: 1});
var $ianmackenzie$elm_geometry$Direction3d$z = $ianmackenzie$elm_geometry$Direction3d$positiveZ;
var $ianmackenzie$elm_geometry$Frame3d$atOrigin = {iE: $ianmackenzie$elm_geometry$Point3d$origin, jr: $ianmackenzie$elm_geometry$Direction3d$x, jv: $ianmackenzie$elm_geometry$Direction3d$y, jz: $ianmackenzie$elm_geometry$Direction3d$z};
var $elm$core$Basics$pi = _Basics_pi;
var $ianmackenzie$elm_units$Quantity$Quantity = $elm$core$Basics$identity;
var $ianmackenzie$elm_units$Angle$radians = function (numRadians) {
	return numRadians;
};
var $ianmackenzie$elm_units$Angle$degrees = function (numDegrees) {
	return $ianmackenzie$elm_units$Angle$radians($elm$core$Basics$pi * (numDegrees / 180));
};
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $elm$core$Basics$sqrt = _Basics_sqrt;
var $ianmackenzie$elm_geometry$Vector3d$direction = function (_v0) {
	var v = _v0;
	var largestComponent = A2(
		$elm$core$Basics$max,
		$elm$core$Basics$abs(v.cF),
		A2(
			$elm$core$Basics$max,
			$elm$core$Basics$abs(v.cG),
			$elm$core$Basics$abs(v.cH)));
	if (!largestComponent) {
		return $elm$core$Maybe$Nothing;
	} else {
		var scaledZ = v.cH / largestComponent;
		var scaledY = v.cG / largestComponent;
		var scaledX = v.cF / largestComponent;
		var scaledLength = $elm$core$Basics$sqrt(((scaledX * scaledX) + (scaledY * scaledY)) + (scaledZ * scaledZ));
		return $elm$core$Maybe$Just(
			{cF: scaledX / scaledLength, cG: scaledY / scaledLength, cH: scaledZ / scaledLength});
	}
};
var $ianmackenzie$elm_geometry$Point3d$fromMeters = function (givenCoordinates) {
	return givenCoordinates;
};
var $author$project$Internal$Transform3d$Orientation3d = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $author$project$Internal$Transform3d$Transform3d = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Internal$Transform3d$derotate = F2(
	function (_v0, _v1) {
		var qx = _v0.a;
		var qy = _v0.b;
		var qz = _v0.c;
		var qw = _v0.d;
		var x = _v1.cF;
		var y = _v1.cG;
		var z = _v1.cH;
		var iz = (((-qw) * z) + (qx * y)) - (qy * x);
		var iy = (((-qw) * y) + (qz * x)) - (qx * z);
		var ix = (((-qw) * x) + (qy * z)) - (qz * y);
		var iw = (((-qx) * x) - (qy * y)) - (qz * z);
		return {cF: (((ix * (-qw)) + (iw * (-qx))) + (iy * (-qz))) - (iz * (-qy)), cG: (((iy * (-qw)) + (iw * (-qy))) + (iz * (-qx))) - (ix * (-qz)), cH: (((iz * (-qw)) + (iw * (-qz))) + (ix * (-qy))) - (iy * (-qx))};
	});
var $author$project$Internal$Transform3d$pointRelativeTo = F2(
	function (_v0, worldPoint) {
		var localOrigin = _v0.a;
		var localOrientation = _v0.b;
		return A2(
			$author$project$Internal$Transform3d$derotate,
			localOrientation,
			A2($author$project$Internal$Vector3$sub, worldPoint, localOrigin));
	});
var $author$project$Internal$Vector3$zero = {cF: 0, cG: 0, cH: 0};
var $author$project$Internal$Transform3d$inverse = function (transform3d) {
	var _v0 = transform3d.b;
	var x = _v0.a;
	var y = _v0.b;
	var z = _v0.c;
	var w = _v0.d;
	return A2(
		$author$project$Internal$Transform3d$Transform3d,
		A2($author$project$Internal$Transform3d$pointRelativeTo, transform3d, $author$project$Internal$Vector3$zero),
		A4($author$project$Internal$Transform3d$Orientation3d, -x, -y, -z, w));
};
var $author$project$Internal$Transform3d$orientation = function (_v0) {
	var _v1 = _v0.b;
	var x = _v1.a;
	var y = _v1.b;
	var z = _v1.c;
	var w = _v1.d;
	return {h8: (1 - ((2 * y) * y)) - ((2 * z) * z), h9: ((2 * x) * y) - ((2 * w) * z), ia: ((2 * x) * z) + ((2 * w) * y), ib: ((2 * x) * y) + ((2 * w) * z), ic: (1 - ((2 * x) * x)) - ((2 * z) * z), id: ((2 * y) * z) - ((2 * w) * x), ie: ((2 * x) * z) - ((2 * w) * y), $8: ((2 * y) * z) + ((2 * w) * x), ig: (1 - ((2 * x) * x)) - ((2 * y) * y)};
};
var $author$project$Internal$Vector3$add = F2(
	function (a, b) {
		return {cF: a.cF + b.cF, cG: a.cG + b.cG, cH: a.cH + b.cH};
	});
var $author$project$Internal$Transform3d$mul = F2(
	function (_v0, _v1) {
		var q1x = _v0.a;
		var q1y = _v0.b;
		var q1z = _v0.c;
		var q1w = _v0.d;
		var q2x = _v1.a;
		var q2y = _v1.b;
		var q2z = _v1.c;
		var q2w = _v1.d;
		return A4($author$project$Internal$Transform3d$Orientation3d, (((q1x * q2w) + (q1y * q2z)) - (q1z * q2y)) + (q1w * q2x), ((((-q1x) * q2z) + (q1y * q2w)) + (q1z * q2x)) + (q1w * q2y), (((q1x * q2y) - (q1y * q2x)) + (q1z * q2w)) + (q1w * q2z), ((((-q1x) * q2x) - (q1y * q2y)) - (q1z * q2z)) + (q1w * q2w));
	});
var $author$project$Internal$Transform3d$rotate = F2(
	function (_v0, _v1) {
		var qx = _v0.a;
		var qy = _v0.b;
		var qz = _v0.c;
		var qw = _v0.d;
		var x = _v1.cF;
		var y = _v1.cG;
		var z = _v1.cH;
		var iz = ((qw * z) + (qx * y)) - (qy * x);
		var iy = ((qw * y) + (qz * x)) - (qx * z);
		var ix = ((qw * x) + (qy * z)) - (qz * y);
		var iw = (((-qx) * x) - (qy * y)) - (qz * z);
		return {cF: (((ix * qw) + (iw * (-qx))) + (iy * (-qz))) - (iz * (-qy)), cG: (((iy * qw) + (iw * (-qy))) + (iz * (-qx))) - (ix * (-qz)), cH: (((iz * qw) + (iw * (-qz))) + (ix * (-qy))) - (iy * (-qx))};
	});
var $author$project$Internal$Transform3d$placeIn = F2(
	function (_v0, _v1) {
		var globalPosition = _v0.a;
		var globalOrientation = _v0.b;
		var localPosition = _v1.a;
		var localOrientation = _v1.b;
		return A2(
			$author$project$Internal$Transform3d$Transform3d,
			A2(
				$author$project$Internal$Vector3$add,
				globalPosition,
				A2($author$project$Internal$Transform3d$rotate, globalOrientation, localPosition)),
			A2($author$project$Internal$Transform3d$mul, globalOrientation, localOrientation));
	});
var $ianmackenzie$elm_geometry$Frame3d$unsafe = function (properties) {
	return properties;
};
var $author$project$Physics$Body$frame = function (_v0) {
	var transform3d = _v0.cA;
	var centerOfMassTransform3d = _v0.cR;
	var bodyCoordinatesTransform3d = A2(
		$author$project$Internal$Transform3d$placeIn,
		transform3d,
		$author$project$Internal$Transform3d$inverse(centerOfMassTransform3d));
	var _v1 = $author$project$Internal$Transform3d$orientation(bodyCoordinatesTransform3d);
	var m11 = _v1.h8;
	var m21 = _v1.ib;
	var m31 = _v1.ie;
	var m12 = _v1.h9;
	var m22 = _v1.ic;
	var m32 = _v1.$8;
	var m13 = _v1.ia;
	var m23 = _v1.id;
	var m33 = _v1.ig;
	return $ianmackenzie$elm_geometry$Frame3d$unsafe(
		{
			iE: $ianmackenzie$elm_geometry$Point3d$fromMeters(
				$author$project$Internal$Transform3d$originPoint(bodyCoordinatesTransform3d)),
			jr: $ianmackenzie$elm_geometry$Direction3d$unsafe(
				{cF: m11, cG: m21, cH: m31}),
			jv: $ianmackenzie$elm_geometry$Direction3d$unsafe(
				{cF: m12, cG: m22, cH: m32}),
			jz: $ianmackenzie$elm_geometry$Direction3d$unsafe(
				{cF: m13, cG: m23, cH: m33})
		});
};
var $author$project$BodyData$Block = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$BodyData$Cylinder = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$BodyData$Me = 0;
var $author$project$BodyData$None = {$: 3};
var $author$project$BodyData$Sphere = function (a) {
	return {$: 1, a: a};
};
var $ianmackenzie$elm_geometry$Geometry$Types$Sphere3d = $elm$core$Basics$identity;
var $ianmackenzie$elm_units$Quantity$abs = function (_v0) {
	var value = _v0;
	return $elm$core$Basics$abs(value);
};
var $ianmackenzie$elm_geometry$Sphere3d$withRadius = F2(
	function (givenRadius, givenCenterPoint) {
		return {
			g6: givenCenterPoint,
			em: $ianmackenzie$elm_units$Quantity$abs(givenRadius)
		};
	});
var $ianmackenzie$elm_geometry$Sphere3d$atPoint = F2(
	function (givenCenterPoint, givenRadius) {
		return A2($ianmackenzie$elm_geometry$Sphere3d$withRadius, givenRadius, givenCenterPoint);
	});
var $ianmackenzie$elm_geometry$Sphere3d$atOrigin = function (givenRadius) {
	return A2($ianmackenzie$elm_geometry$Sphere3d$atPoint, $ianmackenzie$elm_geometry$Point3d$origin, givenRadius);
};
var $author$project$Internal$Shape$Convex = function (a) {
	return {$: 0, a: a};
};
var $author$project$Internal$Shape$Protected = $elm$core$Basics$identity;
var $ianmackenzie$elm_geometry$Frame3d$copy = function (_v0) {
	var properties = _v0;
	return properties;
};
var $ianmackenzie$elm_geometry$Block3d$axes = function (_v0) {
	var block = _v0;
	return $ianmackenzie$elm_geometry$Frame3d$copy(block.gP);
};
var $ianmackenzie$elm_geometry$Block3d$dimensions = function (_v0) {
	var block = _v0;
	return block.hq;
};
var $author$project$Internal$Vector3$xAxis = {cF: 1, cG: 0, cH: 0};
var $author$project$Internal$Vector3$yAxis = {cF: 0, cG: 1, cH: 0};
var $author$project$Internal$Vector3$zAxis = {cF: 0, cG: 0, cH: 1};
var $author$project$Internal$Vector3$basis = _List_fromArray(
	[$author$project$Internal$Vector3$xAxis, $author$project$Internal$Vector3$yAxis, $author$project$Internal$Vector3$zAxis]);
var $author$project$Internal$Vector3$xNegative = {cF: -1, cG: 0, cH: 0};
var $author$project$Internal$Vector3$yNegative = {cF: 0, cG: -1, cH: 0};
var $author$project$Internal$Vector3$zNegative = {cF: 0, cG: 0, cH: -1};
var $author$project$Shapes$Convex$fromBlock = F3(
	function (sizeX, sizeY, sizeZ) {
		var z = sizeZ / 2;
		var y = sizeY / 2;
		var x = sizeX / 2;
		var volume = (sizeX * sizeY) * sizeZ;
		var v7 = {cF: -x, cG: y, cH: z};
		var v6 = {cF: x, cG: y, cH: z};
		var v5 = {cF: x, cG: -y, cH: z};
		var v4 = {cF: -x, cG: -y, cH: z};
		var v3 = {cF: -x, cG: y, cH: -z};
		var v2 = {cF: x, cG: y, cH: -z};
		var v1 = {cF: x, cG: -y, cH: -z};
		var v0 = {cF: -x, cG: -y, cH: -z};
		var inertia = {h8: (volume / 12) * ((sizeY * sizeY) + (sizeZ * sizeZ)), h9: 0, ia: 0, ib: 0, ic: (volume / 12) * ((sizeX * sizeX) + (sizeZ * sizeZ)), id: 0, ie: 0, $8: 0, ig: (volume / 12) * ((sizeY * sizeY) + (sizeX * sizeX))};
		return {
			e5: _List_fromArray(
				[
					{
					aS: $author$project$Internal$Vector3$zNegative,
					cE: _List_fromArray(
						[v3, v2, v1, v0])
				},
					{
					aS: $author$project$Internal$Vector3$zAxis,
					cE: _List_fromArray(
						[v4, v5, v6, v7])
				},
					{
					aS: $author$project$Internal$Vector3$yNegative,
					cE: _List_fromArray(
						[v5, v4, v0, v1])
				},
					{
					aS: $author$project$Internal$Vector3$yAxis,
					cE: _List_fromArray(
						[v2, v3, v7, v6])
				},
					{
					aS: $author$project$Internal$Vector3$xNegative,
					cE: _List_fromArray(
						[v0, v4, v7, v3])
				},
					{
					aS: $author$project$Internal$Vector3$xAxis,
					cE: _List_fromArray(
						[v1, v2, v6, v5])
				}
				]),
			fl: inertia,
			f9: $author$project$Internal$Vector3$zero,
			eB: $author$project$Internal$Vector3$basis,
			gx: $author$project$Internal$Vector3$basis,
			cE: _List_fromArray(
				[v0, v1, v2, v3, v4, v5, v6, v7]),
			gE: volume
		};
	});
var $author$project$Internal$Transform3d$fromOriginAndBasis = F4(
	function (origin, x, y, z) {
		var m22 = z.cH;
		var m21 = y.cH;
		var m20 = x.cH;
		var m12 = z.cG;
		var m11 = y.cG;
		var m10 = x.cG;
		var m02 = z.cF;
		var m01 = y.cF;
		var m00 = x.cF;
		var tr = (m00 + m11) + m22;
		if (tr > 0) {
			var s = $elm$core$Basics$sqrt(tr + 1.0) * 2;
			return A2(
				$author$project$Internal$Transform3d$Transform3d,
				origin,
				A4($author$project$Internal$Transform3d$Orientation3d, (m21 - m12) / s, (m02 - m20) / s, (m10 - m01) / s, 0.25 * s));
		} else {
			if ((_Utils_cmp(m00, m11) > 0) && (_Utils_cmp(m00, m22) > 0)) {
				var s = $elm$core$Basics$sqrt(((1.0 + m00) - m11) - m22) * 2;
				return A2(
					$author$project$Internal$Transform3d$Transform3d,
					origin,
					A4($author$project$Internal$Transform3d$Orientation3d, 0.25 * s, (m01 + m10) / s, (m02 + m20) / s, (m21 - m12) / s));
			} else {
				if (_Utils_cmp(m11, m22) > 0) {
					var s = $elm$core$Basics$sqrt(((1.0 + m11) - m00) - m22) * 2;
					return A2(
						$author$project$Internal$Transform3d$Transform3d,
						origin,
						A4($author$project$Internal$Transform3d$Orientation3d, (m01 + m10) / s, 0.25 * s, (m12 + m21) / s, (m02 - m20) / s));
				} else {
					var s = $elm$core$Basics$sqrt(((1.0 + m22) - m00) - m11) * 2;
					return A2(
						$author$project$Internal$Transform3d$Transform3d,
						origin,
						A4($author$project$Internal$Transform3d$Orientation3d, (m02 + m20) / s, (m12 + m21) / s, 0.25 * s, (m10 - m01) / s));
				}
			}
		}
	});
var $ianmackenzie$elm_units$Length$inMeters = function (_v0) {
	var numMeters = _v0;
	return numMeters;
};
var $ianmackenzie$elm_geometry$Direction3d$xComponent = function (_v0) {
	var d = _v0;
	return d.cF;
};
var $ianmackenzie$elm_geometry$Direction3d$yComponent = function (_v0) {
	var d = _v0;
	return d.cG;
};
var $ianmackenzie$elm_geometry$Direction3d$zComponent = function (_v0) {
	var d = _v0;
	return d.cH;
};
var $ianmackenzie$elm_geometry$Frame3d$isRightHanded = function (_v0) {
	var frame = _v0;
	var i = $ianmackenzie$elm_geometry$Direction3d$zComponent(frame.jz);
	var h = $ianmackenzie$elm_geometry$Direction3d$yComponent(frame.jz);
	var g = $ianmackenzie$elm_geometry$Direction3d$xComponent(frame.jz);
	var f = $ianmackenzie$elm_geometry$Direction3d$zComponent(frame.jv);
	var e = $ianmackenzie$elm_geometry$Direction3d$yComponent(frame.jv);
	var d = $ianmackenzie$elm_geometry$Direction3d$xComponent(frame.jv);
	var c = $ianmackenzie$elm_geometry$Direction3d$zComponent(frame.jr);
	var b = $ianmackenzie$elm_geometry$Direction3d$yComponent(frame.jr);
	var a = $ianmackenzie$elm_geometry$Direction3d$xComponent(frame.jr);
	return (((((((a * e) * i) + ((b * f) * g)) + ((c * d) * h)) - ((c * e) * g)) - ((b * d) * i)) - ((a * f) * h)) > 0;
};
var $ianmackenzie$elm_geometry$Frame3d$originPoint = function (_v0) {
	var properties = _v0;
	return properties.iE;
};
var $author$project$Internal$Transform3d$directionPlaceIn = F2(
	function (_v0, worldVector) {
		var globalOrientation = _v0.b;
		return A2($author$project$Internal$Transform3d$rotate, globalOrientation, worldVector);
	});
var $author$project$Internal$Transform3d$directionsPlaceInHelp = F3(
	function (transform, directions, result) {
		directionsPlaceInHelp:
		while (true) {
			if (directions.b) {
				var point = directions.a;
				var remainingdirections = directions.b;
				var $temp$transform = transform,
					$temp$directions = remainingdirections,
					$temp$result = A2(
					$elm$core$List$cons,
					A2($author$project$Internal$Transform3d$directionPlaceIn, transform, point),
					result);
				transform = $temp$transform;
				directions = $temp$directions;
				result = $temp$result;
				continue directionsPlaceInHelp;
			} else {
				return result;
			}
		}
	});
var $author$project$Internal$Transform3d$directionsPlaceIn = F2(
	function (transform, directions) {
		return A3($author$project$Internal$Transform3d$directionsPlaceInHelp, transform, directions, _List_Nil);
	});
var $author$project$Internal$Transform3d$pointPlaceIn = F2(
	function (_v0, _v2) {
		var globalOrigin = _v0.a;
		var _v1 = _v0.b;
		var qx = _v1.a;
		var qy = _v1.b;
		var qz = _v1.c;
		var qw = _v1.d;
		var x = _v2.cF;
		var y = _v2.cG;
		var z = _v2.cH;
		var iz = ((qw * z) + (qx * y)) - (qy * x);
		var iy = ((qw * y) + (qz * x)) - (qx * z);
		var ix = ((qw * x) + (qy * z)) - (qz * y);
		var iw = (((-qx) * x) - (qy * y)) - (qz * z);
		return {cF: ((((ix * qw) + (iw * (-qx))) + (iy * (-qz))) - (iz * (-qy))) + globalOrigin.cF, cG: ((((iy * qw) + (iw * (-qy))) + (iz * (-qx))) - (ix * (-qz))) + globalOrigin.cG, cH: ((((iz * qw) + (iw * (-qz))) + (ix * (-qy))) - (iy * (-qx))) + globalOrigin.cH};
	});
var $author$project$Internal$Transform3d$pointsPlaceInHelp = F3(
	function (transform, points, result) {
		pointsPlaceInHelp:
		while (true) {
			if (points.b) {
				var point = points.a;
				var remainingPoints = points.b;
				var $temp$transform = transform,
					$temp$points = remainingPoints,
					$temp$result = A2(
					$elm$core$List$cons,
					A2($author$project$Internal$Transform3d$pointPlaceIn, transform, point),
					result);
				transform = $temp$transform;
				points = $temp$points;
				result = $temp$result;
				continue pointsPlaceInHelp;
			} else {
				return result;
			}
		}
	});
var $author$project$Internal$Transform3d$pointsPlaceIn = F2(
	function (transform, points) {
		return A3($author$project$Internal$Transform3d$pointsPlaceInHelp, transform, points, _List_Nil);
	});
var $author$project$Shapes$Convex$facesPlaceInHelp = F3(
	function (transform3d, faces, result) {
		facesPlaceInHelp:
		while (true) {
			if (faces.b) {
				var vertices = faces.a.cE;
				var normal = faces.a.aS;
				var remainingFaces = faces.b;
				var $temp$transform3d = transform3d,
					$temp$faces = remainingFaces,
					$temp$result = A2(
					$elm$core$List$cons,
					{
						aS: A2($author$project$Internal$Transform3d$directionPlaceIn, transform3d, normal),
						cE: $elm$core$List$reverse(
							A2($author$project$Internal$Transform3d$pointsPlaceIn, transform3d, vertices))
					},
					result);
				transform3d = $temp$transform3d;
				faces = $temp$faces;
				result = $temp$result;
				continue facesPlaceInHelp;
			} else {
				return result;
			}
		}
	});
var $author$project$Internal$Matrix3$mul = F2(
	function (a, b) {
		return {h8: ((a.h8 * b.h8) + (a.h9 * b.ib)) + (a.ia * b.ie), h9: ((a.h8 * b.h9) + (a.h9 * b.ic)) + (a.ia * b.$8), ia: ((a.h8 * b.ia) + (a.h9 * b.id)) + (a.ia * b.ig), ib: ((a.ib * b.h8) + (a.ic * b.ib)) + (a.id * b.ie), ic: ((a.ib * b.h9) + (a.ic * b.ic)) + (a.id * b.$8), id: ((a.ib * b.ia) + (a.ic * b.id)) + (a.id * b.ig), ie: ((a.ie * b.h8) + (a.$8 * b.ib)) + (a.ig * b.ie), $8: ((a.ie * b.h9) + (a.$8 * b.ic)) + (a.ig * b.$8), ig: ((a.ie * b.ia) + (a.$8 * b.id)) + (a.ig * b.ig)};
	});
var $author$project$Internal$Matrix3$transpose = function (m) {
	return {h8: m.h8, h9: m.ib, ia: m.ie, ib: m.h9, ic: m.ic, id: m.$8, ie: m.ia, $8: m.id, ig: m.ig};
};
var $author$project$Internal$Transform3d$inertiaRotateIn = F2(
	function (transform3d, inertia) {
		var rotation = $author$project$Internal$Transform3d$orientation(transform3d);
		return A2(
			$author$project$Internal$Matrix3$mul,
			rotation,
			A2(
				$author$project$Internal$Matrix3$mul,
				inertia,
				$author$project$Internal$Matrix3$transpose(rotation)));
	});
var $author$project$Shapes$Convex$placeIn = F2(
	function (transform3d, _v0) {
		var faces = _v0.e5;
		var vertices = _v0.cE;
		var uniqueEdges = _v0.eB;
		var uniqueNormals = _v0.gx;
		var position = _v0.f9;
		var volume = _v0.gE;
		var inertia = _v0.fl;
		return {
			e5: A3($author$project$Shapes$Convex$facesPlaceInHelp, transform3d, faces, _List_Nil),
			fl: A2($author$project$Internal$Transform3d$inertiaRotateIn, transform3d, inertia),
			f9: A2($author$project$Internal$Transform3d$pointPlaceIn, transform3d, position),
			eB: A2($author$project$Internal$Transform3d$directionsPlaceIn, transform3d, uniqueEdges),
			gx: A2($author$project$Internal$Transform3d$directionsPlaceIn, transform3d, uniqueNormals),
			cE: A2($author$project$Internal$Transform3d$pointsPlaceIn, transform3d, vertices),
			gE: volume
		};
	});
var $ianmackenzie$elm_geometry$Direction3d$reverse = function (_v0) {
	var d = _v0;
	return {cF: -d.cF, cG: -d.cG, cH: -d.cH};
};
var $ianmackenzie$elm_geometry$Frame3d$xDirection = function (_v0) {
	var properties = _v0;
	return properties.jr;
};
var $ianmackenzie$elm_geometry$Frame3d$yDirection = function (_v0) {
	var properties = _v0;
	return properties.jv;
};
var $ianmackenzie$elm_geometry$Frame3d$zDirection = function (_v0) {
	var properties = _v0;
	return properties.jz;
};
var $ianmackenzie$elm_geometry$Frame3d$reverseZ = function (frame) {
	return $ianmackenzie$elm_geometry$Frame3d$unsafe(
		{
			iE: $ianmackenzie$elm_geometry$Frame3d$originPoint(frame),
			jr: $ianmackenzie$elm_geometry$Frame3d$xDirection(frame),
			jv: $ianmackenzie$elm_geometry$Frame3d$yDirection(frame),
			jz: $ianmackenzie$elm_geometry$Direction3d$reverse(
				$ianmackenzie$elm_geometry$Frame3d$zDirection(frame))
		});
};
var $ianmackenzie$elm_geometry$Point3d$unwrap = function (_v0) {
	var pointCoordinates = _v0;
	return pointCoordinates;
};
var $author$project$Physics$Shape$block = function (block3d) {
	var frame3d = $ianmackenzie$elm_geometry$Block3d$axes(block3d);
	var rightHandedFrame3d = $ianmackenzie$elm_geometry$Frame3d$isRightHanded(frame3d) ? frame3d : $ianmackenzie$elm_geometry$Frame3d$reverseZ(frame3d);
	var origin = $ianmackenzie$elm_geometry$Point3d$unwrap(
		$ianmackenzie$elm_geometry$Frame3d$originPoint(rightHandedFrame3d));
	var x = $ianmackenzie$elm_geometry$Direction3d$unwrap(
		$ianmackenzie$elm_geometry$Frame3d$xDirection(rightHandedFrame3d));
	var y = $ianmackenzie$elm_geometry$Direction3d$unwrap(
		$ianmackenzie$elm_geometry$Frame3d$yDirection(rightHandedFrame3d));
	var z = $ianmackenzie$elm_geometry$Direction3d$unwrap(
		$ianmackenzie$elm_geometry$Frame3d$zDirection(rightHandedFrame3d));
	var tranform3d = A4($author$project$Internal$Transform3d$fromOriginAndBasis, origin, x, y, z);
	var _v0 = $ianmackenzie$elm_geometry$Block3d$dimensions(block3d);
	var sizeX = _v0.a;
	var sizeY = _v0.b;
	var sizeZ = _v0.c;
	return $author$project$Internal$Shape$Convex(
		A2(
			$author$project$Shapes$Convex$placeIn,
			tranform3d,
			A3(
				$author$project$Shapes$Convex$fromBlock,
				$ianmackenzie$elm_units$Length$inMeters(sizeX),
				$ianmackenzie$elm_units$Length$inMeters(sizeY),
				$ianmackenzie$elm_units$Length$inMeters(sizeZ))));
};
var $author$project$Internal$Transform3d$identity = A4($author$project$Internal$Transform3d$Orientation3d, 0, 0, 0, 1);
var $author$project$Internal$Transform3d$atOrigin = A2($author$project$Internal$Transform3d$Transform3d, $author$project$Internal$Vector3$zero, $author$project$Internal$Transform3d$identity);
var $author$project$Internal$Transform3d$atPoint = function (point) {
	return A2($author$project$Internal$Transform3d$Transform3d, point, $author$project$Internal$Transform3d$identity);
};
var $author$project$Internal$Shape$volume = function (shape) {
	switch (shape.$) {
		case 2:
			var sphere = shape.a;
			return sphere.gE;
		case 0:
			var convex = shape.a;
			return convex.gE;
		case 1:
			return 0;
		default:
			return 0;
	}
};
var $author$project$Internal$Body$centerOfMass = function (shapes) {
	var totalVolume = A3(
		$elm$core$List$foldl,
		F2(
			function (shape, sum) {
				return sum + $author$project$Internal$Shape$volume(shape);
			}),
		0,
		shapes);
	return (totalVolume > 0) ? A3(
		$elm$core$List$foldl,
		function (shape) {
			return $author$project$Internal$Vector3$add(
				A2(
					$author$project$Internal$Vector3$scale,
					$author$project$Internal$Shape$volume(shape) / totalVolume,
					function () {
						switch (shape.$) {
							case 0:
								var position = shape.a.f9;
								return position;
							case 3:
								var position = shape.a;
								return position;
							case 2:
								var position = shape.a.f9;
								return position;
							default:
								var position = shape.a.f9;
								return position;
						}
					}()));
		},
		$author$project$Internal$Vector3$zero,
		shapes) : $author$project$Internal$Vector3$zero;
};
var $author$project$Internal$Material$default = {cP: 0, c_: 0.3};
var $author$project$Internal$Vector3$lengthSquared = function (_v0) {
	var x = _v0.cF;
	var y = _v0.cG;
	var z = _v0.cH;
	return ((x * x) + (y * y)) + (z * z);
};
var $author$project$Shapes$Convex$expandBoundingSphereRadius = F2(
	function (_v0, boundingSphereRadius) {
		var vertices = _v0.cE;
		return $elm$core$Basics$sqrt(
			A3(
				$elm$core$List$foldl,
				function (vertex) {
					return $elm$core$Basics$max(
						$author$project$Internal$Vector3$lengthSquared(vertex));
				},
				boundingSphereRadius * boundingSphereRadius,
				vertices));
	});
var $author$project$Internal$Vector3$length = function (_v0) {
	var x = _v0.cF;
	var y = _v0.cG;
	var z = _v0.cH;
	return $elm$core$Basics$sqrt(((x * x) + (y * y)) + (z * z));
};
var $author$project$Shapes$Sphere$expandBoundingSphereRadius = F2(
	function (_v0, boundingSphereRadius) {
		var radius = _v0.em;
		var position = _v0.f9;
		return A2(
			$elm$core$Basics$max,
			$author$project$Internal$Vector3$length(position) + radius,
			boundingSphereRadius);
	});
var $author$project$Internal$Const$maxNumber = 3.40282347e38;
var $author$project$Internal$Shape$expandBoundingSphereRadius = F2(
	function (shape, boundingSphereRadius) {
		switch (shape.$) {
			case 0:
				var convex = shape.a;
				return A2($author$project$Shapes$Convex$expandBoundingSphereRadius, convex, boundingSphereRadius);
			case 2:
				var sphere = shape.a;
				return A2($author$project$Shapes$Sphere$expandBoundingSphereRadius, sphere, boundingSphereRadius);
			case 1:
				return $author$project$Internal$Const$maxNumber;
			default:
				var position = shape.a;
				return A2(
					$elm$core$Basics$max,
					boundingSphereRadius,
					$author$project$Internal$Vector3$length(position));
		}
	});
var $author$project$Internal$Shape$Particle = function (a) {
	return {$: 3, a: a};
};
var $author$project$Internal$Shape$Plane = function (a) {
	return {$: 1, a: a};
};
var $author$project$Internal$Shape$Sphere = function (a) {
	return {$: 2, a: a};
};
var $author$project$Shapes$Plane$placeIn = F2(
	function (transform3d, _v0) {
		var normal = _v0.aS;
		var position = _v0.f9;
		return {
			aS: A2($author$project$Internal$Transform3d$directionPlaceIn, transform3d, normal),
			f9: A2($author$project$Internal$Transform3d$pointPlaceIn, transform3d, position)
		};
	});
var $author$project$Shapes$Sphere$placeIn = F2(
	function (transform3d, _v0) {
		var radius = _v0.em;
		var position = _v0.f9;
		var volume = _v0.gE;
		var inertia = _v0.fl;
		return {
			fl: inertia,
			f9: A2($author$project$Internal$Transform3d$pointPlaceIn, transform3d, position),
			em: radius,
			gE: volume
		};
	});
var $author$project$Internal$Shape$shapesPlaceInHelp = F3(
	function (transform3d, shapes, result) {
		shapesPlaceInHelp:
		while (true) {
			if (shapes.b) {
				var shape = shapes.a;
				var remainingShapes = shapes.b;
				var $temp$transform3d = transform3d,
					$temp$shapes = remainingShapes,
					$temp$result = A2(
					$elm$core$List$cons,
					function () {
						switch (shape.$) {
							case 0:
								var convex = shape.a;
								return $author$project$Internal$Shape$Convex(
									A2($author$project$Shapes$Convex$placeIn, transform3d, convex));
							case 1:
								var plane = shape.a;
								return $author$project$Internal$Shape$Plane(
									A2($author$project$Shapes$Plane$placeIn, transform3d, plane));
							case 2:
								var sphere = shape.a;
								return $author$project$Internal$Shape$Sphere(
									A2($author$project$Shapes$Sphere$placeIn, transform3d, sphere));
							default:
								var position = shape.a;
								return $author$project$Internal$Shape$Particle(
									A2($author$project$Internal$Transform3d$pointPlaceIn, transform3d, position));
						}
					}(),
					result);
				transform3d = $temp$transform3d;
				shapes = $temp$shapes;
				result = $temp$result;
				continue shapesPlaceInHelp;
			} else {
				return result;
			}
		}
	});
var $author$project$Internal$Shape$shapesPlaceIn = F2(
	function (transform3d, shapes) {
		return A3($author$project$Internal$Shape$shapesPlaceInHelp, transform3d, shapes, _List_Nil);
	});
var $author$project$Internal$Matrix3$add = F2(
	function (a, b) {
		return {h8: a.h8 + b.h8, h9: a.h9 + b.h9, ia: a.ia + b.ia, ib: a.ib + b.ib, ic: a.ic + b.ic, id: a.id + b.id, ie: a.ie + b.ie, $8: a.$8 + b.$8, ig: a.ig + b.ig};
	});
var $author$project$Internal$Shape$centerOfMass = function (shape) {
	switch (shape.$) {
		case 2:
			var sphere = shape.a;
			return sphere.f9;
		case 0:
			var convex = shape.a;
			return convex.f9;
		case 1:
			return $author$project$Internal$Vector3$zero;
		default:
			return $author$project$Internal$Vector3$zero;
	}
};
var $author$project$Internal$Matrix3$zero = {h8: 0, h9: 0, ia: 0, ib: 0, ic: 0, id: 0, ie: 0, $8: 0, ig: 0};
var $author$project$Internal$Shape$inertia = function (shape) {
	switch (shape.$) {
		case 2:
			var sphere = shape.a;
			return sphere.fl;
		case 0:
			var convex = shape.a;
			return convex.fl;
		case 1:
			return $author$project$Internal$Matrix3$zero;
		default:
			return $author$project$Internal$Matrix3$zero;
	}
};
var $author$project$Internal$Matrix3$pointInertia = F4(
	function (m, x, y, z) {
		var m32 = ((-m) * y) * z;
		var m31 = ((-m) * x) * z;
		var m21 = ((-m) * x) * y;
		return {h8: m * ((y * y) + (z * z)), h9: m21, ia: m31, ib: m21, ic: m * ((z * z) + (x * x)), id: m32, ie: m31, $8: m32, ig: m * ((x * x) + (y * y))};
	});
var $author$project$Internal$Transform3d$inertiaPlaceIn = F4(
	function (transform3d, centerOfMass, mass, inertia) {
		var x = transform3d.a.cF;
		var y = transform3d.a.cG;
		var z = transform3d.a.cH;
		var rotatedInertia = A2($author$project$Internal$Transform3d$inertiaRotateIn, transform3d, inertia);
		var inertiaOffset = A4($author$project$Internal$Matrix3$pointInertia, mass, x - centerOfMass.cF, y - centerOfMass.cG, z - centerOfMass.cH);
		return A2($author$project$Internal$Matrix3$add, rotatedInertia, inertiaOffset);
	});
var $author$project$Internal$Matrix3$inverse = function (_v0) {
	var m11 = _v0.h8;
	var m21 = _v0.ib;
	var m31 = _v0.ie;
	var m12 = _v0.h9;
	var m22 = _v0.ic;
	var m32 = _v0.$8;
	var m13 = _v0.ia;
	var m23 = _v0.id;
	var m33 = _v0.ig;
	var det = ((m11 * ((m22 * m33) - (m32 * m23))) - (m12 * ((m21 * m33) - (m23 * m31)))) + (m13 * ((m21 * m32) - (m22 * m31)));
	var invdet = 1 / det;
	return (!det) ? $author$project$Internal$Matrix3$zero : {h8: ((m22 * m33) - (m32 * m23)) * invdet, h9: ((m13 * m32) - (m12 * m33)) * invdet, ia: ((m12 * m23) - (m13 * m22)) * invdet, ib: ((m23 * m31) - (m21 * m33)) * invdet, ic: ((m11 * m33) - (m13 * m31)) * invdet, id: ((m21 * m13) - (m11 * m23)) * invdet, ie: ((m21 * m32) - (m31 * m22)) * invdet, $8: ((m31 * m12) - (m11 * m32)) * invdet, ig: ((m11 * m22) - (m21 * m12)) * invdet};
};
var $author$project$Internal$Transform3d$invertedInertiaRotateIn = F2(
	function (transform3d, inertia) {
		var rotation = $author$project$Internal$Transform3d$orientation(transform3d);
		return A2(
			$author$project$Internal$Matrix3$mul,
			$author$project$Internal$Matrix3$transpose(rotation),
			A2($author$project$Internal$Matrix3$mul, inertia, rotation));
	});
var $author$project$Internal$Matrix3$scale = F2(
	function (k, m) {
		return {h8: k * m.h8, h9: k * m.h9, ia: k * m.ia, ib: k * m.ib, ic: k * m.ic, id: k * m.id, ie: k * m.ie, $8: k * m.$8, ig: k * m.ig};
	});
var $author$project$Internal$Body$updateMassProperties = function (body) {
	var mass = body.d1;
	var shapes = body.er;
	var totalVolume = A3(
		$elm$core$List$foldl,
		F2(
			function (shape, result) {
				return $author$project$Internal$Shape$volume(shape) + result;
			}),
		0,
		shapes);
	var invMass = (!mass) ? 0 : (1 / mass);
	var density = mass / totalVolume;
	var inertia = A2(
		$author$project$Internal$Matrix3$scale,
		density,
		A3(
			$elm$core$List$foldl,
			function (shape) {
				var shapeVolume = $author$project$Internal$Shape$volume(shape);
				var shapeInertia = $author$project$Internal$Shape$inertia(shape);
				var shapeCenterOfMass = $author$project$Internal$Shape$centerOfMass(shape);
				var resultInertia = A4(
					$author$project$Internal$Transform3d$inertiaPlaceIn,
					body.cR,
					A2($author$project$Internal$Transform3d$pointPlaceIn, body.cR, shapeCenterOfMass),
					shapeVolume,
					shapeInertia);
				return $author$project$Internal$Matrix3$add(resultInertia);
			},
			$author$project$Internal$Matrix3$zero,
			shapes));
	var invInertia = $author$project$Internal$Matrix3$inverse(inertia);
	return _Utils_update(
		body,
		{
			dR: invInertia,
			c2: A2($author$project$Internal$Transform3d$invertedInertiaRotateIn, body.cA, invInertia),
			c3: invMass
		});
};
var $author$project$Internal$Body$compound = F2(
	function (shapes, data) {
		var centerOfMassPoint = $author$project$Internal$Body$centerOfMass(shapes);
		var centerOfMassTransform3d = $author$project$Internal$Transform3d$atPoint(centerOfMassPoint);
		var inverseCenterOfMassTransform3d = $author$project$Internal$Transform3d$inverse(centerOfMassTransform3d);
		var movedShapes = A2($author$project$Internal$Shape$shapesPlaceIn, inverseCenterOfMassTransform3d, shapes);
		var bodyTransform3d = $author$project$Internal$Transform3d$atOrigin;
		var transform3d = A2($author$project$Internal$Transform3d$placeIn, bodyTransform3d, centerOfMassTransform3d);
		var shapeTransform = A2($author$project$Internal$Transform3d$placeIn, transform3d, inverseCenterOfMassTransform3d);
		return $author$project$Internal$Body$updateMassProperties(
			{
				eI: 0.01,
				cL: $author$project$Internal$Vector3$zero,
				eM: A3($elm$core$List$foldl, $author$project$Internal$Shape$expandBoundingSphereRadius, 0, movedShapes),
				cR: centerOfMassTransform3d,
				eS: data,
				cZ: $author$project$Internal$Vector3$zero,
				hT: -1,
				dR: $author$project$Internal$Matrix3$zero,
				c2: $author$project$Internal$Matrix3$zero,
				c3: 0,
				fx: 0.01,
				d1: 0,
				fI: $author$project$Internal$Material$default,
				er: movedShapes,
				dC: $author$project$Internal$Vector3$zero,
				cA: transform3d,
				dF: $author$project$Internal$Vector3$zero,
				eD: A2($author$project$Internal$Shape$shapesPlaceIn, shapeTransform, shapes)
			});
	});
var $author$project$Physics$Body$compound = F2(
	function (shapes, newData) {
		var unprotectedShapes = A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, result) {
					var shape = _v0;
					return A2($elm$core$List$cons, shape, result);
				}),
			_List_Nil,
			shapes);
		return A2($author$project$Internal$Body$compound, unprotectedShapes, newData);
	});
var $author$project$Physics$Body$block = function (block3d) {
	return $author$project$Physics$Body$compound(
		_List_fromArray(
			[
				$author$project$Physics$Shape$block(block3d)
			]));
};
var $ianmackenzie$elm_geometry$Geometry$Types$Block3d = $elm$core$Basics$identity;
var $ianmackenzie$elm_geometry$Block3d$centeredOn = F2(
	function (givenAxes, _v0) {
		var xDimension = _v0.a;
		var yDimension = _v0.b;
		var zDimension = _v0.c;
		return {
			gP: $ianmackenzie$elm_geometry$Frame3d$copy(givenAxes),
			hq: _Utils_Tuple3(
				$ianmackenzie$elm_units$Quantity$abs(xDimension),
				$ianmackenzie$elm_units$Quantity$abs(yDimension),
				$ianmackenzie$elm_units$Quantity$abs(zDimension))
		};
	});
var $ianmackenzie$elm_geometry$Geometry$Types$Cylinder3d = $elm$core$Basics$identity;
var $ianmackenzie$elm_geometry$Geometry$Types$Axis3d = $elm$core$Basics$identity;
var $ianmackenzie$elm_geometry$Axis3d$through = F2(
	function (givenPoint, givenDirection) {
		return {eW: givenDirection, iE: givenPoint};
	});
var $ianmackenzie$elm_geometry$Cylinder3d$centeredOn = F3(
	function (givenCenterPoint, givenDirection, _arguments) {
		return {
			p: A2($ianmackenzie$elm_geometry$Axis3d$through, givenCenterPoint, givenDirection),
			dU: $ianmackenzie$elm_units$Quantity$abs(_arguments.dU),
			em: $ianmackenzie$elm_units$Quantity$abs(_arguments.em)
		};
	});
var $ianmackenzie$elm_units$Length$meters = function (numMeters) {
	return numMeters;
};
var $ianmackenzie$elm_units$Length$centimeters = function (numCentimeters) {
	return $ianmackenzie$elm_units$Length$meters(0.01 * numCentimeters);
};
var $ianmackenzie$elm_geometry$Cylinder3d$axis = function (_v0) {
	var cylinder = _v0;
	return cylinder.p;
};
var $ianmackenzie$elm_geometry$Axis3d$direction = function (_v0) {
	var axis = _v0;
	return axis.eW;
};
var $ianmackenzie$elm_geometry$Cylinder3d$axialDirection = function (cylinder) {
	return $ianmackenzie$elm_geometry$Axis3d$direction(
		$ianmackenzie$elm_geometry$Cylinder3d$axis(cylinder));
};
var $ianmackenzie$elm_geometry$Axis3d$originPoint = function (_v0) {
	var axis = _v0;
	return axis.iE;
};
var $ianmackenzie$elm_geometry$Cylinder3d$centerPoint = function (cylinder) {
	return $ianmackenzie$elm_geometry$Axis3d$originPoint(
		$ianmackenzie$elm_geometry$Cylinder3d$axis(cylinder));
};
var $elm$core$Basics$cos = _Basics_cos;
var $elm$core$Basics$pow = _Basics_pow;
var $author$project$Internal$Matrix3$cylinderInertia = F3(
	function (m, radius, height) {
		var a = (m * ((3 * A2($elm$core$Basics$pow, radius, 2)) + A2($elm$core$Basics$pow, height, 2))) / 12;
		return {
			h8: a,
			h9: 0,
			ia: 0,
			ib: 0,
			ic: a,
			id: 0,
			ie: 0,
			$8: 0,
			ig: (m * A2($elm$core$Basics$pow, radius, 2)) / 2
		};
	});
var $elm$core$Basics$modBy = _Basics_modBy;
var $elm$core$Basics$sin = _Basics_sin;
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $author$project$Shapes$Convex$fromCylinder = F3(
	function (subdivisions, radius, length) {
		var volume = ((2 * $elm$core$Basics$pi) * length) * A2($elm$core$Basics$pow, radius, 2);
		var top = length * 0.5;
		var cap = function (z) {
			return A2(
				$elm$core$List$map,
				function (value) {
					var r0 = ((2 * $elm$core$Basics$pi) * (value - 0.5)) / subdivisions;
					return {
						cF: $elm$core$Basics$sin(r0) * radius,
						cG: $elm$core$Basics$cos(r0) * radius,
						cH: z
					};
				},
				A2($elm$core$List$range, 0, subdivisions - 1));
		};
		var topCap = {
			aS: $author$project$Internal$Vector3$zAxis,
			cE: $elm$core$List$reverse(
				cap(top))
		};
		var bottom = length * (-0.5);
		var bottomCap = {
			aS: $author$project$Internal$Vector3$zNegative,
			cE: cap(bottom)
		};
		var sides = A2(
			$elm$core$List$map,
			function (value) {
				var r2 = ((2 * $elm$core$Basics$pi) * (value + 0.5)) / subdivisions;
				var r1 = ((2 * $elm$core$Basics$pi) * value) / subdivisions;
				var r0 = ((2 * $elm$core$Basics$pi) * (value - 0.5)) / subdivisions;
				return {
					aS: {
						cF: $elm$core$Basics$sin(r1),
						cG: $elm$core$Basics$cos(r1),
						cH: 0
					},
					gA: {
						cF: $elm$core$Basics$sin(r0) * radius,
						cG: $elm$core$Basics$cos(r0) * radius,
						cH: top
					},
					gB: {
						cF: $elm$core$Basics$sin(r2) * radius,
						cG: $elm$core$Basics$cos(r2) * radius,
						cH: top
					},
					gC: {
						cF: $elm$core$Basics$sin(r2) * radius,
						cG: $elm$core$Basics$cos(r2) * radius,
						cH: bottom
					},
					gD: {
						cF: $elm$core$Basics$sin(r0) * radius,
						cG: $elm$core$Basics$cos(r0) * radius,
						cH: bottom
					}
				};
			},
			A2($elm$core$List$range, 0, subdivisions - 1));
		var uniqueSideNormals = A2(
			$elm$core$List$map,
			function ($) {
				return $.aS;
			},
			(!A2($elm$core$Basics$modBy, 2, subdivisions)) ? A2($elm$core$List$take, (subdivisions / 2) | 0, sides) : sides);
		return {
			e5: A2(
				$elm$core$List$cons,
				topCap,
				A2(
					$elm$core$List$cons,
					bottomCap,
					A2(
						$elm$core$List$map,
						function (_v0) {
							var v0 = _v0.gA;
							var v1 = _v0.gB;
							var v2 = _v0.gC;
							var v3 = _v0.gD;
							var normal = _v0.aS;
							return {
								aS: normal,
								cE: _List_fromArray(
									[v0, v1, v2, v3])
							};
						},
						sides))),
			fl: A3($author$project$Internal$Matrix3$cylinderInertia, volume, radius, length),
			f9: $author$project$Internal$Vector3$zero,
			eB: A2(
				$elm$core$List$cons,
				$author$project$Internal$Vector3$zAxis,
				A2(
					$elm$core$List$map,
					function (_v1) {
						var x = _v1.cF;
						var y = _v1.cG;
						return {cF: -y, cG: x, cH: 0};
					},
					uniqueSideNormals)),
			gx: A2($elm$core$List$cons, $author$project$Internal$Vector3$zAxis, uniqueSideNormals),
			cE: _Utils_ap(topCap.cE, bottomCap.cE),
			gE: volume
		};
	});
var $ianmackenzie$elm_geometry$Cylinder3d$length = function (_v0) {
	var cylinder = _v0;
	return cylinder.dU;
};
var $ianmackenzie$elm_geometry$Direction3d$perpendicularTo = function (_v0) {
	var d = _v0;
	var absZ = $elm$core$Basics$abs(d.cH);
	var absY = $elm$core$Basics$abs(d.cG);
	var absX = $elm$core$Basics$abs(d.cF);
	if (_Utils_cmp(absX, absY) < 1) {
		if (_Utils_cmp(absX, absZ) < 1) {
			var scale = $elm$core$Basics$sqrt((d.cH * d.cH) + (d.cG * d.cG));
			return {cF: 0, cG: (-d.cH) / scale, cH: d.cG / scale};
		} else {
			var scale = $elm$core$Basics$sqrt((d.cG * d.cG) + (d.cF * d.cF));
			return {cF: (-d.cG) / scale, cG: d.cF / scale, cH: 0};
		}
	} else {
		if (_Utils_cmp(absY, absZ) < 1) {
			var scale = $elm$core$Basics$sqrt((d.cH * d.cH) + (d.cF * d.cF));
			return {cF: d.cH / scale, cG: 0, cH: (-d.cF) / scale};
		} else {
			var scale = $elm$core$Basics$sqrt((d.cF * d.cF) + (d.cG * d.cG));
			return {cF: (-d.cG) / scale, cG: d.cF / scale, cH: 0};
		}
	}
};
var $ianmackenzie$elm_geometry$Direction3d$perpendicularBasis = function (direction) {
	var xDirection = $ianmackenzie$elm_geometry$Direction3d$perpendicularTo(direction);
	var _v0 = xDirection;
	var dX = _v0;
	var _v1 = direction;
	var d = _v1;
	var yDirection = {cF: (d.cG * dX.cH) - (d.cH * dX.cG), cG: (d.cH * dX.cF) - (d.cF * dX.cH), cH: (d.cF * dX.cG) - (d.cG * dX.cF)};
	return _Utils_Tuple2(xDirection, yDirection);
};
var $ianmackenzie$elm_geometry$Cylinder3d$radius = function (_v0) {
	var cylinder = _v0;
	return cylinder.em;
};
var $author$project$Physics$Shape$cylinder = F2(
	function (subdivisions, cylinder3d) {
		var _v0 = $ianmackenzie$elm_geometry$Direction3d$perpendicularBasis(
			$ianmackenzie$elm_geometry$Cylinder3d$axialDirection(cylinder3d));
		var a = _v0.a;
		var b = _v0.b;
		var transform3d = A4(
			$author$project$Internal$Transform3d$fromOriginAndBasis,
			$ianmackenzie$elm_geometry$Point3d$toMeters(
				$ianmackenzie$elm_geometry$Cylinder3d$centerPoint(cylinder3d)),
			$ianmackenzie$elm_geometry$Direction3d$unwrap(a),
			$ianmackenzie$elm_geometry$Direction3d$unwrap(b),
			$ianmackenzie$elm_geometry$Direction3d$unwrap(
				$ianmackenzie$elm_geometry$Cylinder3d$axialDirection(cylinder3d)));
		return $author$project$Internal$Shape$Convex(
			A2(
				$author$project$Shapes$Convex$placeIn,
				transform3d,
				A3(
					$author$project$Shapes$Convex$fromCylinder,
					A2($elm$core$Basics$max, 3, subdivisions),
					$ianmackenzie$elm_units$Length$inMeters(
						$ianmackenzie$elm_geometry$Cylinder3d$radius(cylinder3d)),
					$ianmackenzie$elm_units$Length$inMeters(
						$ianmackenzie$elm_geometry$Cylinder3d$length(cylinder3d)))));
	});
var $author$project$Physics$Body$cylinder = function (cylinder3d) {
	return $author$project$Physics$Body$compound(
		_List_fromArray(
			[
				A2($author$project$Physics$Shape$cylinder, 12, cylinder3d)
			]));
};
var $author$project$Physics$Body$Dynamic = function (a) {
	return {$: 0, a: a};
};
var $author$project$Physics$Body$Static = {$: 1};
var $ianmackenzie$elm_units$Mass$inKilograms = function (_v0) {
	var numKilograms = _v0;
	return numKilograms;
};
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $author$project$Physics$Body$dynamic = function (kilos) {
	var mass_ = $ianmackenzie$elm_units$Mass$inKilograms(kilos);
	return ($elm$core$Basics$isNaN(mass_) || ($elm$core$Basics$isInfinite(mass_) || (mass_ <= 0))) ? $author$project$Physics$Body$Static : $author$project$Physics$Body$Dynamic(mass_);
};
var $ianmackenzie$elm_units$Mass$kilograms = function (numKilograms) {
	return numKilograms;
};
var $ianmackenzie$elm_units$Mass$grams = function (numGrams) {
	return $ianmackenzie$elm_units$Mass$kilograms(0.001 * numGrams);
};
var $ianmackenzie$elm_units$Length$meter = $ianmackenzie$elm_units$Length$meters(1);
var $ianmackenzie$elm_geometry$Point3d$meters = F3(
	function (x, y, z) {
		return {cF: x, cG: y, cH: z};
	});
var $author$project$Config$playerRadiusMeters = 0.525;
var $author$project$Internal$Matrix3$sphereInertia = F2(
	function (m, radius) {
		var i = (((m * 2) / 5) * radius) * radius;
		return {h8: i, h9: 0, ia: 0, ib: 0, ic: i, id: 0, ie: 0, $8: 0, ig: i};
	});
var $author$project$Shapes$Sphere$atOrigin = function (radius) {
	var volume = ((4 / 3) * $elm$core$Basics$pi) * A2($elm$core$Basics$pow, radius, 3);
	return {
		fl: A2($author$project$Internal$Matrix3$sphereInertia, volume, radius),
		f9: $author$project$Internal$Vector3$zero,
		em: radius,
		gE: volume
	};
};
var $ianmackenzie$elm_geometry$Sphere3d$centerPoint = function (_v0) {
	var properties = _v0;
	return properties.g6;
};
var $ianmackenzie$elm_geometry$Sphere3d$radius = function (_v0) {
	var properties = _v0;
	return properties.em;
};
var $author$project$Physics$Shape$sphere = function (sphere3d) {
	var radius = $ianmackenzie$elm_units$Length$inMeters(
		$ianmackenzie$elm_geometry$Sphere3d$radius(sphere3d));
	var origin = $ianmackenzie$elm_geometry$Point3d$toMeters(
		$ianmackenzie$elm_geometry$Sphere3d$centerPoint(sphere3d));
	return $author$project$Internal$Shape$Sphere(
		A2(
			$author$project$Shapes$Sphere$placeIn,
			$author$project$Internal$Transform3d$atPoint(origin),
			$author$project$Shapes$Sphere$atOrigin(radius)));
};
var $author$project$Physics$Body$sphere = function (sphere3d) {
	return $author$project$Physics$Body$compound(
		_List_fromArray(
			[
				$author$project$Physics$Shape$sphere(sphere3d)
			]));
};
var $author$project$Physics$Body$withBehavior = F2(
	function (behavior, _v0) {
		var body = _v0;
		if (!behavior.$) {
			var mass_ = behavior.a;
			var _v2 = body.er;
			if (!_v2.b) {
				return body;
			} else {
				if (!_v2.b.b) {
					var shape = _v2.a;
					if (shape.$ === 1) {
						return body;
					} else {
						return $author$project$Internal$Body$updateMassProperties(
							_Utils_update(
								body,
								{d1: mass_}));
					}
				} else {
					return $author$project$Internal$Body$updateMassProperties(
						_Utils_update(
							body,
							{d1: mass_}));
				}
			}
		} else {
			return $author$project$Internal$Body$updateMassProperties(
				_Utils_update(
					body,
					{d1: 0}));
		}
	});
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $author$project$Physics$Body$withDamping = F2(
	function (_v0, _v1) {
		var linear = _v0.h7;
		var angular = _v0.gL;
		var body = _v1;
		return _Utils_update(
			body,
			{
				eI: A3($elm$core$Basics$clamp, 0, 1, angular),
				fx: A3($elm$core$Basics$clamp, 0, 1, linear)
			});
	});
var $author$project$Server$Body$getDefaultBody = F2(
	function (isMe, body) {
		var _v0 = body.hb;
		switch (_v0) {
			case 1:
				return A2(
					$author$project$Physics$Body$withDamping,
					{gL: 1.0, h7: 0.0},
					A2(
						$author$project$Physics$Body$cylinder,
						A3(
							$ianmackenzie$elm_geometry$Cylinder3d$centeredOn,
							$ianmackenzie$elm_geometry$Point3d$origin,
							$ianmackenzie$elm_geometry$Direction3d$z,
							{
								dU: $ianmackenzie$elm_units$Length$meter,
								em: $ianmackenzie$elm_units$Length$meters($author$project$Config$playerRadiusMeters)
							}),
						{
							hb: isMe ? 0 : 1,
							hq: $author$project$BodyData$None,
							hu: body.hu,
							hS: body.hS,
							hT: body.hT,
							iz: $elm$core$Maybe$Nothing,
							iF: $elm$core$Maybe$Nothing,
							iV: body.iV,
							iW: body.iW,
							i7: body.i7
						}));
			case 2:
				return A2(
					$author$project$Physics$Body$withBehavior,
					$author$project$Physics$Body$dynamic(
						$ianmackenzie$elm_units$Mass$grams(50)),
					A2(
						$author$project$Physics$Body$sphere,
						$ianmackenzie$elm_geometry$Sphere3d$atOrigin(
							$ianmackenzie$elm_units$Length$centimeters(5)),
						{hb: 2, hq: $author$project$BodyData$None, hu: 0, hS: 0, hT: body.hT, iz: $elm$core$Maybe$Nothing, iF: body.iF, iV: 0, iW: 0, i7: body.i7}));
			case 3:
				var _v1 = body.hq;
				var x = _v1.cF;
				var y = _v1.cG;
				var z = _v1.cH;
				var _v2 = body.iz;
				_v2$4:
				while (true) {
					if (!_v2.$) {
						switch (_v2.a) {
							case 0:
								var _v3 = _v2.a;
								return A2(
									$author$project$Physics$Body$sphere,
									A2(
										$ianmackenzie$elm_geometry$Sphere3d$atPoint,
										A3($ianmackenzie$elm_geometry$Point3d$meters, 0, 0, 0.5 - (x / 2)),
										$ianmackenzie$elm_units$Length$meters(x / 2)),
									{
										hb: 3,
										hq: $author$project$BodyData$Sphere(x / 2),
										hu: 0,
										hS: 0,
										hT: body.hT,
										iz: body.iz,
										iF: $elm$core$Maybe$Nothing,
										iV: 0,
										iW: 0,
										i7: $elm$core$Maybe$Nothing
									});
							case 1:
								var _v4 = _v2.a;
								return A2(
									$author$project$Physics$Body$sphere,
									A2(
										$ianmackenzie$elm_geometry$Sphere3d$atPoint,
										A3($ianmackenzie$elm_geometry$Point3d$meters, 0, 0, 0.5 - (x / 2)),
										$ianmackenzie$elm_units$Length$meters(x / 2)),
									{
										hb: 3,
										hq: $author$project$BodyData$Sphere(x / 2),
										hu: 0,
										hS: 0,
										hT: body.hT,
										iz: body.iz,
										iF: $elm$core$Maybe$Nothing,
										iV: 0,
										iW: 0,
										i7: $elm$core$Maybe$Nothing
									});
							case 2:
								var _v5 = _v2.a;
								return A2(
									$author$project$Physics$Body$cylinder,
									A3(
										$ianmackenzie$elm_geometry$Cylinder3d$centeredOn,
										$ianmackenzie$elm_geometry$Point3d$origin,
										$ianmackenzie$elm_geometry$Direction3d$z,
										{
											dU: $ianmackenzie$elm_units$Length$meters(z),
											em: $ianmackenzie$elm_units$Length$meters(x / 2)
										}),
									{
										hb: 3,
										hq: A2($author$project$BodyData$Cylinder, x / 2, z),
										hu: 0,
										hS: 0,
										hT: body.hT,
										iz: body.iz,
										iF: $elm$core$Maybe$Nothing,
										iV: 0,
										iW: 0,
										i7: $elm$core$Maybe$Nothing
									});
							case 3:
								var _v6 = _v2.a;
								return A2(
									$author$project$Physics$Body$cylinder,
									A3(
										$ianmackenzie$elm_geometry$Cylinder3d$centeredOn,
										$ianmackenzie$elm_geometry$Point3d$origin,
										$ianmackenzie$elm_geometry$Direction3d$z,
										{
											dU: $ianmackenzie$elm_units$Length$meters(z),
											em: $ianmackenzie$elm_units$Length$meters(x / 2)
										}),
									{
										hb: 3,
										hq: A2($author$project$BodyData$Cylinder, x / 2, z),
										hu: 0,
										hS: 0,
										hT: body.hT,
										iz: body.iz,
										iF: $elm$core$Maybe$Nothing,
										iV: 0,
										iW: 0,
										i7: $elm$core$Maybe$Nothing
									});
							default:
								break _v2$4;
						}
					} else {
						break _v2$4;
					}
				}
				return A2(
					$author$project$Physics$Body$block,
					A2(
						$ianmackenzie$elm_geometry$Block3d$centeredOn,
						$ianmackenzie$elm_geometry$Frame3d$atOrigin,
						_Utils_Tuple3(
							$ianmackenzie$elm_units$Length$meters(x),
							$ianmackenzie$elm_units$Length$meters(y),
							$ianmackenzie$elm_units$Length$meters(z))),
					{
						hb: 3,
						hq: A3($author$project$BodyData$Block, x, y, z),
						hu: 0,
						hS: 0,
						hT: body.hT,
						iz: body.iz,
						iF: $elm$core$Maybe$Nothing,
						iV: 0,
						iW: 0,
						i7: $elm$core$Maybe$Nothing
					});
			default:
				return A2(
					$author$project$Physics$Body$withDamping,
					{gL: 1.0, h7: 0.0},
					A2(
						$author$project$Physics$Body$cylinder,
						A3(
							$ianmackenzie$elm_geometry$Cylinder3d$centeredOn,
							$ianmackenzie$elm_geometry$Point3d$origin,
							$ianmackenzie$elm_geometry$Direction3d$z,
							{
								dU: $ianmackenzie$elm_units$Length$meter,
								em: $ianmackenzie$elm_units$Length$meters($author$project$Config$playerRadiusMeters)
							}),
						{hb: 0, hq: $author$project$BodyData$None, hu: body.hu, hS: body.hS, hT: body.hT, iz: $elm$core$Maybe$Nothing, iF: $elm$core$Maybe$Nothing, iV: body.iV, iW: body.iW, i7: body.i7}));
		}
	});
var $ianmackenzie$elm_units$Quantity$zero = 0;
var $ianmackenzie$elm_geometry$Vector3d$length = function (_v0) {
	var v = _v0;
	var largestComponent = A2(
		$elm$core$Basics$max,
		$elm$core$Basics$abs(v.cF),
		A2(
			$elm$core$Basics$max,
			$elm$core$Basics$abs(v.cG),
			$elm$core$Basics$abs(v.cH)));
	if (!largestComponent) {
		return $ianmackenzie$elm_units$Quantity$zero;
	} else {
		var scaledZ = v.cH / largestComponent;
		var scaledY = v.cG / largestComponent;
		var scaledX = v.cF / largestComponent;
		var scaledLength = $elm$core$Basics$sqrt(((scaledX * scaledX) + (scaledY * scaledY)) + (scaledZ * scaledZ));
		return scaledLength * largestComponent;
	}
};
var $ianmackenzie$elm_geometry$Geometry$Types$Vector3d = $elm$core$Basics$identity;
var $ianmackenzie$elm_geometry$Vector3d$meters = F3(
	function (x, y, z) {
		return {cF: x, cG: y, cH: z};
	});
var $ianmackenzie$elm_units$Force$newtons = function (numNewtons) {
	return numNewtons;
};
var $author$project$Physics$Body$originPoint = function (_v0) {
	var transform3d = _v0.cA;
	var centerOfMassTransform3d = _v0.cR;
	var bodyCoordinatesTransform3d = A2(
		$author$project$Internal$Transform3d$placeIn,
		transform3d,
		$author$project$Internal$Transform3d$inverse(centerOfMassTransform3d));
	return $ianmackenzie$elm_geometry$Point3d$fromMeters(
		$author$project$Internal$Transform3d$originPoint(bodyCoordinatesTransform3d));
};
var $ianmackenzie$elm_geometry$Direction3d$placeIn = F2(
	function (_v0, _v1) {
		var frame = _v0;
		var d = _v1;
		var _v2 = frame.jz;
		var k = _v2;
		var _v3 = frame.jv;
		var j = _v3;
		var _v4 = frame.jr;
		var i = _v4;
		return {cF: ((i.cF * d.cF) + (j.cF * d.cG)) + (k.cF * d.cH), cG: ((i.cG * d.cF) + (j.cG * d.cG)) + (k.cG * d.cH), cH: ((i.cH * d.cF) + (j.cH * d.cG)) + (k.cH * d.cH)};
	});
var $ianmackenzie$elm_geometry$Point3d$placeIn = F2(
	function (_v0, _v1) {
		var frame = _v0;
		var p = _v1;
		var _v2 = frame.iE;
		var p0 = _v2;
		var _v3 = frame.jz;
		var k = _v3;
		var _v4 = frame.jv;
		var j = _v4;
		var _v5 = frame.jr;
		var i = _v5;
		return {cF: ((p0.cF + (p.cF * i.cF)) + (p.cG * j.cF)) + (p.cH * k.cF), cG: ((p0.cG + (p.cF * i.cG)) + (p.cG * j.cG)) + (p.cH * k.cG), cH: ((p0.cH + (p.cF * i.cH)) + (p.cG * j.cH)) + (p.cH * k.cH)};
	});
var $ianmackenzie$elm_geometry$Axis3d$placeIn = F2(
	function (frame, _v0) {
		var axis = _v0;
		return A2(
			$ianmackenzie$elm_geometry$Axis3d$through,
			A2($ianmackenzie$elm_geometry$Point3d$placeIn, frame, axis.iE),
			A2($ianmackenzie$elm_geometry$Direction3d$placeIn, frame, axis.eW));
	});
var $ianmackenzie$elm_units$Angle$inRadians = function (_v0) {
	var numRadians = _v0;
	return numRadians;
};
var $author$project$Internal$Transform3d$moveTo = F2(
	function (newOrigin, _v0) {
		var localOrientation = _v0.b;
		return A2($author$project$Internal$Transform3d$Transform3d, newOrigin, localOrientation);
	});
var $ianmackenzie$elm_geometry$Point3d$rotateAround = F3(
	function (_v0, _v1, _v2) {
		var axis = _v0;
		var angle = _v1;
		var p = _v2;
		var halfAngle = 0.5 * angle;
		var qw = $elm$core$Basics$cos(halfAngle);
		var sinHalfAngle = $elm$core$Basics$sin(halfAngle);
		var _v3 = axis.iE;
		var p0 = _v3;
		var deltaX = p.cF - p0.cF;
		var deltaY = p.cG - p0.cG;
		var deltaZ = p.cH - p0.cH;
		var _v4 = axis.eW;
		var d = _v4;
		var qx = d.cF * sinHalfAngle;
		var wx = qw * qx;
		var xx = qx * qx;
		var qy = d.cG * sinHalfAngle;
		var wy = qw * qy;
		var xy = qx * qy;
		var yy = qy * qy;
		var a22 = 1 - (2 * (xx + yy));
		var qz = d.cH * sinHalfAngle;
		var wz = qw * qz;
		var a01 = 2 * (xy - wz);
		var a10 = 2 * (xy + wz);
		var xz = qx * qz;
		var a02 = 2 * (xz + wy);
		var a20 = 2 * (xz - wy);
		var yz = qy * qz;
		var a12 = 2 * (yz - wx);
		var a21 = 2 * (yz + wx);
		var zz = qz * qz;
		var a00 = 1 - (2 * (yy + zz));
		var a11 = 1 - (2 * (xx + zz));
		return {cF: ((p0.cF + (a00 * deltaX)) + (a01 * deltaY)) + (a02 * deltaZ), cG: ((p0.cG + (a10 * deltaX)) + (a11 * deltaY)) + (a12 * deltaZ), cH: ((p0.cH + (a20 * deltaX)) + (a21 * deltaY)) + (a22 * deltaZ)};
	});
var $author$project$Internal$Vector3$normalize = function (v3) {
	var len = $author$project$Internal$Vector3$length(v3);
	return {cF: v3.cF / len, cG: v3.cG / len, cH: v3.cH / len};
};
var $author$project$Internal$Transform3d$fromAngleAxis = F2(
	function (angle, axis) {
		var theta = angle * 0.5;
		var s = $elm$core$Basics$sin(theta);
		var c = $elm$core$Basics$cos(theta);
		var _v0 = $author$project$Internal$Vector3$normalize(axis);
		var x = _v0.cF;
		var y = _v0.cG;
		var z = _v0.cH;
		return A4($author$project$Internal$Transform3d$Orientation3d, x * s, y * s, z * s, c);
	});
var $author$project$Internal$Transform3d$rotateAroundOwn = F3(
	function (axis, angle, _v0) {
		var localOrigin = _v0.a;
		var localOrientation = _v0.b;
		return A2(
			$author$project$Internal$Transform3d$Transform3d,
			localOrigin,
			A2(
				$author$project$Internal$Transform3d$mul,
				A2($author$project$Internal$Transform3d$fromAngleAxis, angle, axis),
				localOrientation));
	});
var $author$project$Physics$Body$rotateAround = F3(
	function (axis, angle, _v0) {
		var body = _v0;
		var bodyCoordinatesTransform3d = A2(
			$author$project$Internal$Transform3d$placeIn,
			body.cA,
			$author$project$Internal$Transform3d$inverse(body.cR));
		var rotatedOrigin = A3(
			$ianmackenzie$elm_geometry$Point3d$rotateAround,
			axis,
			angle,
			$ianmackenzie$elm_geometry$Point3d$fromMeters(
				$author$project$Internal$Transform3d$originPoint(bodyCoordinatesTransform3d)));
		var newBodyCoordinatesTransform3d = A3(
			$author$project$Internal$Transform3d$rotateAroundOwn,
			$ianmackenzie$elm_geometry$Direction3d$unwrap(
				$ianmackenzie$elm_geometry$Axis3d$direction(axis)),
			$ianmackenzie$elm_units$Angle$inRadians(angle),
			A2(
				$author$project$Internal$Transform3d$moveTo,
				$ianmackenzie$elm_geometry$Point3d$toMeters(rotatedOrigin),
				bodyCoordinatesTransform3d));
		var newTransform3d = A2($author$project$Internal$Transform3d$placeIn, newBodyCoordinatesTransform3d, body.cR);
		return _Utils_update(
			body,
			{
				c2: A2($author$project$Internal$Transform3d$invertedInertiaRotateIn, newTransform3d, body.dR),
				cA: newTransform3d,
				eD: A2($author$project$Internal$Shape$shapesPlaceIn, newTransform3d, body.er)
			});
	});
var $ianmackenzie$elm_units$Duration$seconds = function (numSeconds) {
	return numSeconds;
};
var $ianmackenzie$elm_units$Quantity$times = F2(
	function (_v0, _v1) {
		var y = _v0;
		var x = _v1;
		return x * y;
	});
var $ianmackenzie$elm_geometry$Vector3d$toMeters = function (_v0) {
	var vectorComponents = _v0;
	return vectorComponents;
};
var $author$project$Internal$Transform3d$translateBy = F2(
	function (vector, _v0) {
		var localOrigin = _v0.a;
		var localOrientation = _v0.b;
		return A2(
			$author$project$Internal$Transform3d$Transform3d,
			A2($author$project$Internal$Vector3$add, vector, localOrigin),
			localOrientation);
	});
var $author$project$Physics$Body$translateBy = F2(
	function (vector3d, _v0) {
		var body = _v0;
		var bodyCoordinatesTransform3d = A2(
			$author$project$Internal$Transform3d$placeIn,
			body.cA,
			$author$project$Internal$Transform3d$inverse(body.cR));
		var newTransform3d = A2(
			$author$project$Internal$Transform3d$placeIn,
			A2(
				$author$project$Internal$Transform3d$translateBy,
				$ianmackenzie$elm_geometry$Vector3d$toMeters(vector3d),
				bodyCoordinatesTransform3d),
			body.cR);
		return _Utils_update(
			body,
			{
				cA: newTransform3d,
				eD: A2($author$project$Internal$Shape$shapesPlaceIn, newTransform3d, body.er)
			});
	});
var $ianmackenzie$elm_geometry$Frame3d$zAxis = function (_v0) {
	var frame = _v0;
	return A2($ianmackenzie$elm_geometry$Axis3d$through, frame.iE, frame.jz);
};
var $author$project$Server$Body$toPhysicsBody = F2(
	function (myId, body) {
		var linearVelocityCoords = body.fy;
		var linearVelocityVector = A3($ianmackenzie$elm_geometry$Vector3d$meters, linearVelocityCoords.cF, linearVelocityCoords.cG, linearVelocityCoords.cH);
		var isMe = _Utils_eq(body.hT, myId);
		var unrotatedPhysicsBody = A2(
			$author$project$Physics$Body$translateBy,
			A3($ianmackenzie$elm_geometry$Vector3d$meters, body.dD.cF, body.dD.cG, body.dD.cH),
			A2($author$project$Server$Body$getDefaultBody, isMe, body));
		var frame = $author$project$Physics$Body$frame(unrotatedPhysicsBody);
		var rotationAxis = A2(
			$ianmackenzie$elm_geometry$Axis3d$placeIn,
			$ianmackenzie$elm_geometry$Frame3d$atOrigin,
			$ianmackenzie$elm_geometry$Frame3d$zAxis(frame));
		var physicsBody = A3(
			$author$project$Physics$Body$rotateAround,
			rotationAxis,
			$ianmackenzie$elm_units$Angle$degrees(body.gh),
			unrotatedPhysicsBody);
		var _v0 = $ianmackenzie$elm_geometry$Vector3d$direction(linearVelocityVector);
		if (_v0.$ === 1) {
			return physicsBody;
		} else {
			var linearVelocityDirection = _v0.a;
			var velocity = $ianmackenzie$elm_units$Length$inMeters(
				$ianmackenzie$elm_geometry$Vector3d$length(linearVelocityVector));
			var impulseDurationSeconds = 0.1;
			var impulse = A2(
				$ianmackenzie$elm_units$Quantity$times,
				$ianmackenzie$elm_units$Duration$seconds(impulseDurationSeconds),
				$ianmackenzie$elm_units$Force$newtons((body.d1 * velocity) / impulseDurationSeconds));
			var nextPhysicsBody = A4(
				$author$project$Physics$Body$applyImpulse,
				impulse,
				linearVelocityDirection,
				$author$project$Physics$Body$originPoint(physicsBody),
				physicsBody);
			return nextPhysicsBody;
		}
	});
var $author$project$Server$Body$physicsBodiesDecoder = function (myId) {
	return $elm$json$Json$Decode$list(
		A2(
			$elm$json$Json$Decode$map,
			$author$project$Server$Body$toPhysicsBody(myId),
			$author$project$Server$Body$decoder));
};
var $author$project$Server$State$Finished = 2;
var $author$project$Server$State$Pending = 0;
var $author$project$Server$State$Playing = 1;
var $author$project$Server$State$statusDecoder = A2(
	$elm$json$Json$Decode$map,
	function (s) {
		switch (s) {
			case 'pending':
				return 0;
			case 'playing':
				return 1;
			case 'finished':
				return 2;
			default:
				return 2;
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Server$State$decoder = function (playerId) {
	return A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'code',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'owner_id',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$author$project$Server$State$statusDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'last_updated',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'bodies',
						$author$project$Server$Body$physicsBodiesDecoder(playerId),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'teams',
							$elm$json$Json$Decode$list($author$project$Server$Team$decoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'players',
								$elm$json$Json$Decode$list($author$project$Server$Player$decoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'topic',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Server$State$State))))))))));
};
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $elm$core$Basics$not = _Basics_not;
var $author$project$Game$Lobby$updatePlayerName = _Platform_outgoingPort(
	'updatePlayerName',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string($.aH)),
					_Utils_Tuple2(
					'playerId',
					$elm$json$Json$Encode$string($.iJ))
				]));
	});
var $author$project$Game$Lobby$init = F3(
	function (playerId, savedPlayerName, serverState) {
		var serverName = function () {
			var _v0 = A2(
				$elm_community$list_extra$List$Extra$find,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.hT;
					},
					$elm$core$Basics$eq(playerId)),
				serverState.an);
			if (!_v0.$) {
				var player = _v0.a;
				return player.aH;
			} else {
				return '';
			}
		}();
		var effectiveName = $elm$core$String$isEmpty(serverName) ? A2($elm$core$Maybe$withDefault, '', savedPlayerName) : serverName;
		var nameConfirmed = !$elm$core$String$isEmpty(effectiveName);
		return _Utils_Tuple2(
			{
				cb: false,
				hJ: $elm$core$String$isEmpty(serverState.eP) ? serverState.hT : serverState.eP,
				fb: serverState.hT,
				cm: false,
				cr: $elm$core$Maybe$Nothing,
				dd: nameConfirmed,
				iF: serverState.iF,
				iJ: playerId,
				aU: effectiveName,
				an: serverState.an,
				aX: '',
				bV: serverState.bV,
				jd: serverState.jd
			},
			(nameConfirmed && $elm$core$String$isEmpty(serverName)) ? $author$project$Game$Lobby$updatePlayerName(
				{aH: effectiveName, iJ: playerId}) : $elm$core$Platform$Cmd$none);
	});
var $author$project$Scene3d$Entity$Arena$ObstacleMaterials = F6(
	function (rock, boulder, stone, wood, bark, leaf) {
		return {gT: bark, g$: boulder, h3: leaf, iS: rock, i0: stone, jn: wood};
	});
var $author$project$Game$Playing$ViewportChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Internal$World$Protected = $elm$core$Basics$identity;
var $author$project$Physics$World$add = F2(
	function (_v0, _v1) {
		var body = _v0;
		var world = _v1;
		var _v2 = world.hH;
		if (!_v2.b) {
			return _Utils_update(
				world,
				{
					eK: A2(
						$elm$core$List$cons,
						_Utils_update(
							body,
							{hT: world.io}),
						world.eK),
					io: world.io + 1
				});
		} else {
			var freeId = _v2.a;
			var restFreeIds = _v2.b;
			return _Utils_update(
				world,
				{
					eK: A2(
						$elm$core$List$cons,
						_Utils_update(
							body,
							{hT: freeId}),
						world.eK),
					hH: restFreeIds
				});
		}
	});
var $author$project$Physics$World$Extra$addBodies = F2(
	function (bodies, world) {
		return A3($elm$core$List$foldl, $author$project$Physics$World$add, world, bodies);
	});
var $author$project$Config$arenaWidthMeters = 200;
var $ianmackenzie$elm_geometry$Frame3d$atPoint = function (point) {
	return $ianmackenzie$elm_geometry$Frame3d$unsafe(
		{iE: point, jr: $ianmackenzie$elm_geometry$Direction3d$x, jv: $ianmackenzie$elm_geometry$Direction3d$y, jz: $ianmackenzie$elm_geometry$Direction3d$z});
};
var $ianmackenzie$elm_3d_scene$Scene3d$Types$CullBackFaces = 1;
var $ianmackenzie$elm_3d_scene$Scene3d$Types$Facets = F4(
	function (a, b, c, d) {
		return {$: 2, a: a, b: b, c: c, d: d};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Types$Indexed = F4(
	function (a, b, c, d) {
		return {$: 3, a: a, b: b, c: c, d: d};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Types$MeshWithNormals = F4(
	function (a, b, c, d) {
		return {$: 4, a: a, b: b, c: c, d: d};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Types$MeshWithNormalsAndUvs = F4(
	function (a, b, c, d) {
		return {$: 6, a: a, b: b, c: c, d: d};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Types$MeshWithTangents = F4(
	function (a, b, c, d) {
		return {$: 7, a: a, b: b, c: c, d: d};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Types$MeshWithUvs = F4(
	function (a, b, c, d) {
		return {$: 5, a: a, b: b, c: c, d: d};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Types$Triangles = F4(
	function (a, b, c, d) {
		return {$: 1, a: a, b: b, c: c, d: d};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Mesh$cullBackFaces = function (mesh) {
	switch (mesh.$) {
		case 0:
			return mesh;
		case 1:
			var boundingBox = mesh.a;
			var meshTriangles = mesh.b;
			var webGLMesh = mesh.c;
			return A4($ianmackenzie$elm_3d_scene$Scene3d$Types$Triangles, boundingBox, meshTriangles, webGLMesh, 1);
		case 2:
			var boundingBox = mesh.a;
			var meshTriangles = mesh.b;
			var webGLMesh = mesh.c;
			return A4($ianmackenzie$elm_3d_scene$Scene3d$Types$Facets, boundingBox, meshTriangles, webGLMesh, 1);
		case 3:
			var boundingBox = mesh.a;
			var triangularMesh = mesh.b;
			var webGLMesh = mesh.c;
			return A4($ianmackenzie$elm_3d_scene$Scene3d$Types$Indexed, boundingBox, triangularMesh, webGLMesh, 1);
		case 4:
			var boundingBox = mesh.a;
			var triangularMesh = mesh.b;
			var webGLMesh = mesh.c;
			return A4($ianmackenzie$elm_3d_scene$Scene3d$Types$MeshWithNormals, boundingBox, triangularMesh, webGLMesh, 1);
		case 5:
			var boundingBox = mesh.a;
			var triangularMesh = mesh.b;
			var webGLMesh = mesh.c;
			return A4($ianmackenzie$elm_3d_scene$Scene3d$Types$MeshWithUvs, boundingBox, triangularMesh, webGLMesh, 1);
		case 6:
			var boundingBox = mesh.a;
			var triangularMesh = mesh.b;
			var webGLMesh = mesh.c;
			return A4($ianmackenzie$elm_3d_scene$Scene3d$Types$MeshWithNormalsAndUvs, boundingBox, triangularMesh, webGLMesh, 1);
		case 7:
			var boundingBox = mesh.a;
			var triangularMesh = mesh.b;
			var webGLMesh = mesh.c;
			return A4($ianmackenzie$elm_3d_scene$Scene3d$Types$MeshWithTangents, boundingBox, triangularMesh, webGLMesh, 1);
		case 8:
			return mesh;
		case 9:
			return mesh;
		default:
			return mesh;
	}
};
var $ianmackenzie$elm_3d_scene$Scene3d$Types$EmptyMesh = {$: 0};
var $ianmackenzie$elm_3d_scene$Scene3d$Types$KeepBackFaces = 0;
var $ianmackenzie$elm_geometry$Geometry$Types$BoundingBox3d = $elm$core$Basics$identity;
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $ianmackenzie$elm_geometry$BoundingBox3d$aggregateOfHelp = F8(
	function (currentMinX, currentMaxX, currentMinY, currentMaxY, currentMinZ, currentMaxZ, getBoundingBox, items) {
		aggregateOfHelp:
		while (true) {
			if (items.b) {
				var next = items.a;
				var rest = items.b;
				var _v1 = getBoundingBox(next);
				var b = _v1;
				var $temp$currentMinX = A2($elm$core$Basics$min, b.fN, currentMinX),
					$temp$currentMaxX = A2($elm$core$Basics$max, b.fK, currentMaxX),
					$temp$currentMinY = A2($elm$core$Basics$min, b.fO, currentMinY),
					$temp$currentMaxY = A2($elm$core$Basics$max, b.fL, currentMaxY),
					$temp$currentMinZ = A2($elm$core$Basics$min, b.fP, currentMinZ),
					$temp$currentMaxZ = A2($elm$core$Basics$max, b.fM, currentMaxZ),
					$temp$getBoundingBox = getBoundingBox,
					$temp$items = rest;
				currentMinX = $temp$currentMinX;
				currentMaxX = $temp$currentMaxX;
				currentMinY = $temp$currentMinY;
				currentMaxY = $temp$currentMaxY;
				currentMinZ = $temp$currentMinZ;
				currentMaxZ = $temp$currentMaxZ;
				getBoundingBox = $temp$getBoundingBox;
				items = $temp$items;
				continue aggregateOfHelp;
			} else {
				return {fK: currentMaxX, fL: currentMaxY, fM: currentMaxZ, fN: currentMinX, fO: currentMinY, fP: currentMinZ};
			}
		}
	});
var $ianmackenzie$elm_geometry$BoundingBox3d$aggregateOf = F3(
	function (getBoundingBox, first, rest) {
		var _v0 = getBoundingBox(first);
		var b1 = _v0;
		return A8($ianmackenzie$elm_geometry$BoundingBox3d$aggregateOfHelp, b1.fN, b1.fK, b1.fO, b1.fL, b1.fP, b1.fM, getBoundingBox, rest);
	});
var $ianmackenzie$elm_geometry$BoundingBox3d$fromExtrema = function (given) {
	var _v0 = given.fM;
	var z2 = _v0;
	var _v1 = given.fP;
	var z1 = _v1;
	var _v2 = given.fL;
	var y2 = _v2;
	var _v3 = given.fO;
	var y1 = _v3;
	var _v4 = given.fK;
	var x2 = _v4;
	var _v5 = given.fN;
	var x1 = _v5;
	return {
		fK: A2($elm$core$Basics$max, x1, x2),
		fL: A2($elm$core$Basics$max, y1, y2),
		fM: A2($elm$core$Basics$max, z1, z2),
		fN: A2($elm$core$Basics$min, x1, x2),
		fO: A2($elm$core$Basics$min, y1, y2),
		fP: A2($elm$core$Basics$min, z1, z2)
	};
};
var $ianmackenzie$elm_units$Quantity$max = F2(
	function (_v0, _v1) {
		var x = _v0;
		var y = _v1;
		return A2($elm$core$Basics$max, x, y);
	});
var $ianmackenzie$elm_units$Quantity$min = F2(
	function (_v0, _v1) {
		var x = _v0;
		var y = _v1;
		return A2($elm$core$Basics$min, x, y);
	});
var $ianmackenzie$elm_geometry$Triangle3d$vertices = function (_v0) {
	var triangleVertices = _v0;
	return triangleVertices;
};
var $ianmackenzie$elm_geometry$Point3d$xCoordinate = function (_v0) {
	var p = _v0;
	return p.cF;
};
var $ianmackenzie$elm_geometry$Point3d$yCoordinate = function (_v0) {
	var p = _v0;
	return p.cG;
};
var $ianmackenzie$elm_geometry$Point3d$zCoordinate = function (_v0) {
	var p = _v0;
	return p.cH;
};
var $ianmackenzie$elm_geometry$Triangle3d$boundingBox = function (triangle) {
	var _v0 = $ianmackenzie$elm_geometry$Triangle3d$vertices(triangle);
	var p1 = _v0.a;
	var p2 = _v0.b;
	var p3 = _v0.c;
	var x1 = $ianmackenzie$elm_geometry$Point3d$xCoordinate(p1);
	var y1 = $ianmackenzie$elm_geometry$Point3d$yCoordinate(p1);
	var z1 = $ianmackenzie$elm_geometry$Point3d$zCoordinate(p1);
	var x2 = $ianmackenzie$elm_geometry$Point3d$xCoordinate(p2);
	var y2 = $ianmackenzie$elm_geometry$Point3d$yCoordinate(p2);
	var z2 = $ianmackenzie$elm_geometry$Point3d$zCoordinate(p2);
	var x3 = $ianmackenzie$elm_geometry$Point3d$xCoordinate(p3);
	var y3 = $ianmackenzie$elm_geometry$Point3d$yCoordinate(p3);
	var z3 = $ianmackenzie$elm_geometry$Point3d$zCoordinate(p3);
	return $ianmackenzie$elm_geometry$BoundingBox3d$fromExtrema(
		{
			fK: A2(
				$ianmackenzie$elm_units$Quantity$max,
				x1,
				A2($ianmackenzie$elm_units$Quantity$max, x2, x3)),
			fL: A2(
				$ianmackenzie$elm_units$Quantity$max,
				y1,
				A2($ianmackenzie$elm_units$Quantity$max, y2, y3)),
			fM: A2(
				$ianmackenzie$elm_units$Quantity$max,
				z1,
				A2($ianmackenzie$elm_units$Quantity$max, z2, z3)),
			fN: A2(
				$ianmackenzie$elm_units$Quantity$min,
				x1,
				A2($ianmackenzie$elm_units$Quantity$min, x2, x3)),
			fO: A2(
				$ianmackenzie$elm_units$Quantity$min,
				y1,
				A2($ianmackenzie$elm_units$Quantity$min, y2, y3)),
			fP: A2(
				$ianmackenzie$elm_units$Quantity$min,
				z1,
				A2($ianmackenzie$elm_units$Quantity$min, z2, z3))
		});
};
var $elm_explorations$linear_algebra$Math$Vector3$fromRecord = _MJS_v3fromRecord;
var $ianmackenzie$elm_geometry_linear_algebra_interop$Geometry$Interop$LinearAlgebra$Point3d$toVec3 = function (point) {
	return $elm_explorations$linear_algebra$Math$Vector3$fromRecord(
		$ianmackenzie$elm_geometry$Point3d$unwrap(point));
};
var $ianmackenzie$elm_geometry$Vector3d$unwrap = function (_v0) {
	var givenComponents = _v0;
	return givenComponents;
};
var $ianmackenzie$elm_geometry_linear_algebra_interop$Geometry$Interop$LinearAlgebra$Vector3d$toVec3 = function (vector) {
	return $elm_explorations$linear_algebra$Math$Vector3$fromRecord(
		$ianmackenzie$elm_geometry$Vector3d$unwrap(vector));
};
var $ianmackenzie$elm_geometry$Vector3d$cross = F2(
	function (_v0, _v1) {
		var v2 = _v0;
		var v1 = _v1;
		return {cF: (v1.cG * v2.cH) - (v1.cH * v2.cG), cG: (v1.cH * v2.cF) - (v1.cF * v2.cH), cH: (v1.cF * v2.cG) - (v1.cG * v2.cF)};
	});
var $ianmackenzie$elm_geometry$Vector3d$from = F2(
	function (_v0, _v1) {
		var p1 = _v0;
		var p2 = _v1;
		return {cF: p2.cF - p1.cF, cG: p2.cG - p1.cG, cH: p2.cH - p1.cH};
	});
var $ianmackenzie$elm_units$Quantity$float = function (value) {
	return value;
};
var $ianmackenzie$elm_geometry$Vector3d$zero = {cF: 0, cG: 0, cH: 0};
var $ianmackenzie$elm_geometry$Vector3d$scaleTo = F2(
	function (_v0, _v1) {
		var q = _v0;
		var v = _v1;
		var largestComponent = A2(
			$elm$core$Basics$max,
			$elm$core$Basics$abs(v.cF),
			A2(
				$elm$core$Basics$max,
				$elm$core$Basics$abs(v.cG),
				$elm$core$Basics$abs(v.cH)));
		if (!largestComponent) {
			return $ianmackenzie$elm_geometry$Vector3d$zero;
		} else {
			var scaledZ = v.cH / largestComponent;
			var scaledY = v.cG / largestComponent;
			var scaledX = v.cF / largestComponent;
			var scaledLength = $elm$core$Basics$sqrt(((scaledX * scaledX) + (scaledY * scaledY)) + (scaledZ * scaledZ));
			return {cF: (q * scaledX) / scaledLength, cG: (q * scaledY) / scaledLength, cH: (q * scaledZ) / scaledLength};
		}
	});
var $ianmackenzie$elm_geometry$Vector3d$normalize = $ianmackenzie$elm_geometry$Vector3d$scaleTo(
	$ianmackenzie$elm_units$Quantity$float(1));
var $ianmackenzie$elm_3d_scene$Scene3d$Mesh$triangleNormal = F3(
	function (p1, p2, p3) {
		var v2 = A2($ianmackenzie$elm_geometry$Vector3d$from, p2, p3);
		var v1 = A2($ianmackenzie$elm_geometry$Vector3d$from, p1, p2);
		return $ianmackenzie$elm_geometry$Vector3d$normalize(
			A2($ianmackenzie$elm_geometry$Vector3d$cross, v2, v1));
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Mesh$facetAttributes = function (triangle) {
	var _v0 = $ianmackenzie$elm_geometry$Triangle3d$vertices(triangle);
	var p1 = _v0.a;
	var p2 = _v0.b;
	var p3 = _v0.c;
	var normal = $ianmackenzie$elm_geometry_linear_algebra_interop$Geometry$Interop$LinearAlgebra$Vector3d$toVec3(
		A3($ianmackenzie$elm_3d_scene$Scene3d$Mesh$triangleNormal, p1, p2, p3));
	return _Utils_Tuple3(
		{
			aS: normal,
			f9: $ianmackenzie$elm_geometry_linear_algebra_interop$Geometry$Interop$LinearAlgebra$Point3d$toVec3(p1)
		},
		{
			aS: normal,
			f9: $ianmackenzie$elm_geometry_linear_algebra_interop$Geometry$Interop$LinearAlgebra$Point3d$toVec3(p2)
		},
		{
			aS: normal,
			f9: $ianmackenzie$elm_geometry_linear_algebra_interop$Geometry$Interop$LinearAlgebra$Point3d$toVec3(p3)
		});
};
var $elm_explorations$webgl$WebGL$Mesh3 = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm_explorations$webgl$WebGL$triangles = $elm_explorations$webgl$WebGL$Mesh3(
	{e$: 3, fk: 0, fR: 4});
var $ianmackenzie$elm_3d_scene$Scene3d$Mesh$facets = function (givenTriangles) {
	if (!givenTriangles.b) {
		return $ianmackenzie$elm_3d_scene$Scene3d$Types$EmptyMesh;
	} else {
		var first = givenTriangles.a;
		var rest = givenTriangles.b;
		var webGLMesh = $elm_explorations$webgl$WebGL$triangles(
			A2($elm$core$List$map, $ianmackenzie$elm_3d_scene$Scene3d$Mesh$facetAttributes, givenTriangles));
		var bounds = A3($ianmackenzie$elm_geometry$BoundingBox3d$aggregateOf, $ianmackenzie$elm_geometry$Triangle3d$boundingBox, first, rest);
		return A4($ianmackenzie$elm_3d_scene$Scene3d$Types$Facets, bounds, givenTriangles, webGLMesh, 0);
	}
};
var $ianmackenzie$elm_geometry$Geometry$Types$Triangle3d = $elm$core$Basics$identity;
var $ianmackenzie$elm_geometry$Triangle3d$from = F3(
	function (p1, p2, p3) {
		return _Utils_Tuple3(p1, p2, p3);
	});
var $ianmackenzie$elm_units$Quantity$multiplyBy = F2(
	function (scale, _v0) {
		var value = _v0;
		return scale * value;
	});
var $ianmackenzie$elm_geometry$Point3d$xyz = F3(
	function (_v0, _v1, _v2) {
		var x = _v0;
		var y = _v1;
		var z = _v2;
		return {cF: x, cG: y, cH: z};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Primitives$block = function () {
	var z = $ianmackenzie$elm_units$Length$meters(1);
	var y = $ianmackenzie$elm_units$Length$meters(1);
	var x = $ianmackenzie$elm_units$Length$meters(1);
	var minZ = A2($ianmackenzie$elm_units$Quantity$multiplyBy, -0.5, z);
	var minY = A2($ianmackenzie$elm_units$Quantity$multiplyBy, -0.5, y);
	var minX = A2($ianmackenzie$elm_units$Quantity$multiplyBy, -0.5, x);
	var p0 = A3($ianmackenzie$elm_geometry$Point3d$xyz, minX, minY, minZ);
	var maxZ = A2($ianmackenzie$elm_units$Quantity$multiplyBy, 0.5, z);
	var p4 = A3($ianmackenzie$elm_geometry$Point3d$xyz, minX, minY, maxZ);
	var maxY = A2($ianmackenzie$elm_units$Quantity$multiplyBy, 0.5, y);
	var p3 = A3($ianmackenzie$elm_geometry$Point3d$xyz, minX, maxY, minZ);
	var p7 = A3($ianmackenzie$elm_geometry$Point3d$xyz, minX, maxY, maxZ);
	var maxX = A2($ianmackenzie$elm_units$Quantity$multiplyBy, 0.5, x);
	var p1 = A3($ianmackenzie$elm_geometry$Point3d$xyz, maxX, minY, minZ);
	var p2 = A3($ianmackenzie$elm_geometry$Point3d$xyz, maxX, maxY, minZ);
	var p5 = A3($ianmackenzie$elm_geometry$Point3d$xyz, maxX, minY, maxZ);
	var p6 = A3($ianmackenzie$elm_geometry$Point3d$xyz, maxX, maxY, maxZ);
	return $ianmackenzie$elm_3d_scene$Scene3d$Mesh$cullBackFaces(
		$ianmackenzie$elm_3d_scene$Scene3d$Mesh$facets(
			_List_fromArray(
				[
					A3($ianmackenzie$elm_geometry$Triangle3d$from, p0, p2, p1),
					A3($ianmackenzie$elm_geometry$Triangle3d$from, p0, p3, p2),
					A3($ianmackenzie$elm_geometry$Triangle3d$from, p4, p5, p6),
					A3($ianmackenzie$elm_geometry$Triangle3d$from, p4, p6, p7),
					A3($ianmackenzie$elm_geometry$Triangle3d$from, p1, p2, p6),
					A3($ianmackenzie$elm_geometry$Triangle3d$from, p1, p6, p5),
					A3($ianmackenzie$elm_geometry$Triangle3d$from, p0, p7, p3),
					A3($ianmackenzie$elm_geometry$Triangle3d$from, p0, p4, p7),
					A3($ianmackenzie$elm_geometry$Triangle3d$from, p0, p1, p5),
					A3($ianmackenzie$elm_geometry$Triangle3d$from, p0, p5, p4),
					A3($ianmackenzie$elm_geometry$Triangle3d$from, p3, p6, p2),
					A3($ianmackenzie$elm_geometry$Triangle3d$from, p3, p7, p6)
				])));
}();
var $ianmackenzie$elm_3d_scene$Scene3d$Types$EmptyShadow = {$: 0};
var $ianmackenzie$elm_3d_scene$Scene3d$Types$Shadow = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Mesh$collectShadowVertices = F3(
	function (getPosition, _v0, accumulated) {
		var mv1 = _v0.a;
		var mv2 = _v0.b;
		var mv3 = _v0.c;
		var p3 = getPosition(mv3);
		var p2 = getPosition(mv2);
		var p1 = getPosition(mv1);
		var faceNormal = $ianmackenzie$elm_geometry_linear_algebra_interop$Geometry$Interop$LinearAlgebra$Vector3d$toVec3(
			A3($ianmackenzie$elm_3d_scene$Scene3d$Mesh$triangleNormal, p1, p2, p3));
		var sv1 = {
			aS: faceNormal,
			f9: $ianmackenzie$elm_geometry_linear_algebra_interop$Geometry$Interop$LinearAlgebra$Point3d$toVec3(p1)
		};
		var sv2 = {
			aS: faceNormal,
			f9: $ianmackenzie$elm_geometry_linear_algebra_interop$Geometry$Interop$LinearAlgebra$Point3d$toVec3(p2)
		};
		var sv3 = {
			aS: faceNormal,
			f9: $ianmackenzie$elm_geometry_linear_algebra_interop$Geometry$Interop$LinearAlgebra$Point3d$toVec3(p3)
		};
		return A2(
			$elm$core$List$cons,
			sv1,
			A2(
				$elm$core$List$cons,
				sv2,
				A2($elm$core$List$cons, sv3, accumulated)));
	});
var $ianmackenzie$elm_triangular_mesh$TriangularMesh$faceIndices = function (_v0) {
	var mesh = _v0;
	return mesh.N;
};
var $elm$core$Maybe$map3 = F4(
	function (func, ma, mb, mc) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					return $elm$core$Maybe$Just(
						A3(func, a, b, c));
				}
			}
		}
	});
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $ianmackenzie$elm_triangular_mesh$TriangularMesh$vertices = function (_v0) {
	var mesh = _v0;
	return mesh.cE;
};
var $ianmackenzie$elm_triangular_mesh$TriangularMesh$vertex = F2(
	function (index, mesh) {
		return A2(
			$elm$core$Array$get,
			index,
			$ianmackenzie$elm_triangular_mesh$TriangularMesh$vertices(mesh));
	});
var $ianmackenzie$elm_triangular_mesh$TriangularMesh$faceVertices = function (mesh) {
	var toFace = function (_v0) {
		var i = _v0.a;
		var j = _v0.b;
		var k = _v0.c;
		return A4(
			$elm$core$Maybe$map3,
			F3(
				function (firstVertex, secondVertex, thirdVertex) {
					return _Utils_Tuple3(firstVertex, secondVertex, thirdVertex);
				}),
			A2($ianmackenzie$elm_triangular_mesh$TriangularMesh$vertex, i, mesh),
			A2($ianmackenzie$elm_triangular_mesh$TriangularMesh$vertex, j, mesh),
			A2($ianmackenzie$elm_triangular_mesh$TriangularMesh$vertex, k, mesh));
	};
	return A2(
		$elm$core$List$filterMap,
		toFace,
		$ianmackenzie$elm_triangular_mesh$TriangularMesh$faceIndices(mesh));
};
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{G: nodeList, r: nodeListSize, v: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $ianmackenzie$elm_triangular_mesh$TriangularMesh$TriangularMesh = $elm$core$Basics$identity;
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $ianmackenzie$elm_triangular_mesh$TriangularMesh$indexed = F2(
	function (vertices_, faceIndices_) {
		var numVertices = $elm$core$Array$length(vertices_);
		var validIndices = function (_v0) {
			var i = _v0.a;
			var j = _v0.b;
			var k = _v0.c;
			return ((i >= 0) && (_Utils_cmp(i, numVertices) < 0)) && (((j >= 0) && (_Utils_cmp(j, numVertices) < 0)) && ((k >= 0) && (_Utils_cmp(k, numVertices) < 0)));
		};
		return A2($elm$core$List$all, validIndices, faceIndices_) ? {N: faceIndices_, cE: vertices_} : {
			N: A2($elm$core$List$filter, validIndices, faceIndices_),
			cE: vertices_
		};
	});
var $elm_explorations$webgl$WebGL$MeshIndexed3 = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $elm_explorations$webgl$WebGL$indexedTriangles = $elm_explorations$webgl$WebGL$MeshIndexed3(
	{e$: 1, fk: 3, fR: 4});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $ianmackenzie$elm_3d_scene$Scene3d$Mesh$edgeKey = F2(
	function (firstPoint, secondPoint) {
		var p2 = $ianmackenzie$elm_geometry$Point3d$toMeters(secondPoint);
		var p1 = $ianmackenzie$elm_geometry$Point3d$toMeters(firstPoint);
		return _Utils_Tuple2(
			_Utils_Tuple3(p1.cF, p1.cG, p1.cH),
			_Utils_Tuple3(p2.cF, p2.cG, p2.cH));
	});
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm_explorations$linear_algebra$Math$Vector3$vec3 = _MJS_v3;
var $ianmackenzie$elm_3d_scene$Scene3d$Mesh$zeroVec3 = A3($elm_explorations$linear_algebra$Math$Vector3$vec3, 0, 0, 0);
var $ianmackenzie$elm_3d_scene$Scene3d$Mesh$joinEdge = F6(
	function (p1, p2, start, end, neighborDict, _v0) {
		var shadowFaceIndices = _v0.a;
		var extraShadowVertices = _v0.b;
		var nextShadowVertexIndex = _v0.c;
		var _v1 = A2(
			$elm$core$Dict$get,
			A2($ianmackenzie$elm_3d_scene$Scene3d$Mesh$edgeKey, p1, p2),
			neighborDict);
		if (!_v1.$) {
			var opposite = _v1.a;
			return _Utils_Tuple3(
				A2(
					$elm$core$List$cons,
					_Utils_Tuple3(start, opposite, end),
					shadowFaceIndices),
				extraShadowVertices,
				nextShadowVertexIndex);
		} else {
			var v2 = {
				aS: $ianmackenzie$elm_3d_scene$Scene3d$Mesh$zeroVec3,
				f9: $ianmackenzie$elm_geometry_linear_algebra_interop$Geometry$Interop$LinearAlgebra$Point3d$toVec3(p2)
			};
			var v1 = {
				aS: $ianmackenzie$elm_3d_scene$Scene3d$Mesh$zeroVec3,
				f9: $ianmackenzie$elm_geometry_linear_algebra_interop$Geometry$Interop$LinearAlgebra$Point3d$toVec3(p1)
			};
			var b = nextShadowVertexIndex + 1;
			var a = nextShadowVertexIndex;
			return _Utils_Tuple3(
				A2(
					$elm$core$List$cons,
					_Utils_Tuple3(start, a, b),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple3(start, b, end),
						shadowFaceIndices)),
				A2(
					$elm$core$List$cons,
					v2,
					A2($elm$core$List$cons, v1, extraShadowVertices)),
				nextShadowVertexIndex + 2);
		}
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Mesh$joinEdges = F5(
	function (getPosition, neighborDict, meshFaceVertices, nextShadowVertexIndex, state) {
		joinEdges:
		while (true) {
			if (meshFaceVertices.b) {
				var _v1 = meshFaceVertices.a;
				var mv1 = _v1.a;
				var mv2 = _v1.b;
				var mv3 = _v1.c;
				var remainingMeshFaceVertices = meshFaceVertices.b;
				var p3 = getPosition(mv3);
				var p2 = getPosition(mv2);
				var p1 = getPosition(mv1);
				var c = nextShadowVertexIndex + 2;
				var b = nextShadowVertexIndex + 1;
				var a = nextShadowVertexIndex;
				var $temp$getPosition = getPosition,
					$temp$neighborDict = neighborDict,
					$temp$meshFaceVertices = remainingMeshFaceVertices,
					$temp$nextShadowVertexIndex = nextShadowVertexIndex + 3,
					$temp$state = A6(
					$ianmackenzie$elm_3d_scene$Scene3d$Mesh$joinEdge,
					p3,
					p1,
					c,
					a,
					neighborDict,
					A6(
						$ianmackenzie$elm_3d_scene$Scene3d$Mesh$joinEdge,
						p2,
						p3,
						b,
						c,
						neighborDict,
						A6($ianmackenzie$elm_3d_scene$Scene3d$Mesh$joinEdge, p1, p2, a, b, neighborDict, state)));
				getPosition = $temp$getPosition;
				neighborDict = $temp$neighborDict;
				meshFaceVertices = $temp$meshFaceVertices;
				nextShadowVertexIndex = $temp$nextShadowVertexIndex;
				state = $temp$state;
				continue joinEdges;
			} else {
				var _v2 = state;
				var shadowFaceIndices = _v2.a;
				var extraShadowVertices = _v2.b;
				return _Utils_Tuple2(
					shadowFaceIndices,
					$elm$core$List$reverse(extraShadowVertices));
			}
		}
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Mesh$visitFaces = F5(
	function (getPosition, meshFaceVertices, nextShadowVertexIndex, shadowFaceIndices, neighborDict) {
		visitFaces:
		while (true) {
			if (meshFaceVertices.b) {
				var _v1 = meshFaceVertices.a;
				var mv1 = _v1.a;
				var mv2 = _v1.b;
				var mv3 = _v1.c;
				var remainingMeshFaceVertices = meshFaceVertices.b;
				var p3 = getPosition(mv3);
				var p2 = getPosition(mv2);
				var p1 = getPosition(mv1);
				var c = nextShadowVertexIndex + 2;
				var b = nextShadowVertexIndex + 1;
				var a = nextShadowVertexIndex;
				var updatedNeighborDict = A3(
					$elm$core$Dict$insert,
					A2($ianmackenzie$elm_3d_scene$Scene3d$Mesh$edgeKey, p1, p3),
					c,
					A3(
						$elm$core$Dict$insert,
						A2($ianmackenzie$elm_3d_scene$Scene3d$Mesh$edgeKey, p3, p2),
						b,
						A3(
							$elm$core$Dict$insert,
							A2($ianmackenzie$elm_3d_scene$Scene3d$Mesh$edgeKey, p2, p1),
							a,
							neighborDict)));
				var updatedShadowFaceIndices = A2(
					$elm$core$List$cons,
					_Utils_Tuple3(a, b, c),
					shadowFaceIndices);
				var $temp$getPosition = getPosition,
					$temp$meshFaceVertices = remainingMeshFaceVertices,
					$temp$nextShadowVertexIndex = nextShadowVertexIndex + 3,
					$temp$shadowFaceIndices = updatedShadowFaceIndices,
					$temp$neighborDict = updatedNeighborDict;
				getPosition = $temp$getPosition;
				meshFaceVertices = $temp$meshFaceVertices;
				nextShadowVertexIndex = $temp$nextShadowVertexIndex;
				shadowFaceIndices = $temp$shadowFaceIndices;
				neighborDict = $temp$neighborDict;
				continue visitFaces;
			} else {
				return _Utils_Tuple3(shadowFaceIndices, neighborDict, nextShadowVertexIndex);
			}
		}
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Mesh$shadowImpl = F3(
	function (meshBounds, getPosition, triangularMesh) {
		var meshFaceVertices = $ianmackenzie$elm_triangular_mesh$TriangularMesh$faceVertices(triangularMesh);
		var initialShadowVertices = A3(
			$elm$core$List$foldr,
			$ianmackenzie$elm_3d_scene$Scene3d$Mesh$collectShadowVertices(getPosition),
			_List_Nil,
			meshFaceVertices);
		var _v0 = A5($ianmackenzie$elm_3d_scene$Scene3d$Mesh$visitFaces, getPosition, meshFaceVertices, 0, _List_Nil, $elm$core$Dict$empty);
		var initialShadowFaceIndices = _v0.a;
		var neighborDict = _v0.b;
		var nextShadowVertexIndex = _v0.c;
		var _v1 = A5(
			$ianmackenzie$elm_3d_scene$Scene3d$Mesh$joinEdges,
			getPosition,
			neighborDict,
			meshFaceVertices,
			0,
			_Utils_Tuple3(initialShadowFaceIndices, _List_Nil, nextShadowVertexIndex));
		var allShadowFaceIndices = _v1.a;
		var extraShadowVertices = _v1.b;
		var allShadowVertices = $elm$core$List$isEmpty(extraShadowVertices) ? initialShadowVertices : _Utils_ap(initialShadowVertices, extraShadowVertices);
		return A3(
			$ianmackenzie$elm_3d_scene$Scene3d$Types$Shadow,
			meshBounds,
			A2(
				$ianmackenzie$elm_triangular_mesh$TriangularMesh$indexed,
				$elm$core$Array$fromList(allShadowVertices),
				allShadowFaceIndices),
			A2($elm_explorations$webgl$WebGL$indexedTriangles, allShadowVertices, allShadowFaceIndices));
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $ianmackenzie$elm_triangular_mesh$TriangularMesh$triangles = function (faceVertices_) {
	return {
		N: A2(
			$elm$core$List$map,
			function (i) {
				return _Utils_Tuple3(3 * i, (3 * i) + 1, (3 * i) + 2);
			},
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(faceVertices_) - 1)),
		cE: $elm$core$Array$fromList(
			$elm$core$List$concat(
				A2(
					$elm$core$List$map,
					function (_v0) {
						var v1 = _v0.a;
						var v2 = _v0.b;
						var v3 = _v0.c;
						return _List_fromArray(
							[v1, v2, v3]);
					},
					faceVertices_)))
	};
};
var $ianmackenzie$elm_3d_scene$Scene3d$Mesh$shadow = function (mesh) {
	switch (mesh.$) {
		case 0:
			return $ianmackenzie$elm_3d_scene$Scene3d$Types$EmptyShadow;
		case 1:
			var boundingBox = mesh.a;
			var meshTriangles = mesh.b;
			var vertexTriples = A2($elm$core$List$map, $ianmackenzie$elm_geometry$Triangle3d$vertices, meshTriangles);
			return A3(
				$ianmackenzie$elm_3d_scene$Scene3d$Mesh$shadowImpl,
				boundingBox,
				$elm$core$Basics$identity,
				$ianmackenzie$elm_triangular_mesh$TriangularMesh$triangles(vertexTriples));
		case 2:
			var boundingBox = mesh.a;
			var meshTriangles = mesh.b;
			var vertexTriples = A2($elm$core$List$map, $ianmackenzie$elm_geometry$Triangle3d$vertices, meshTriangles);
			return A3(
				$ianmackenzie$elm_3d_scene$Scene3d$Mesh$shadowImpl,
				boundingBox,
				$elm$core$Basics$identity,
				$ianmackenzie$elm_triangular_mesh$TriangularMesh$triangles(vertexTriples));
		case 3:
			var boundingBox = mesh.a;
			var triangularMesh = mesh.b;
			return A3($ianmackenzie$elm_3d_scene$Scene3d$Mesh$shadowImpl, boundingBox, $elm$core$Basics$identity, triangularMesh);
		case 4:
			var boundingBox = mesh.a;
			var triangularMesh = mesh.b;
			return A3(
				$ianmackenzie$elm_3d_scene$Scene3d$Mesh$shadowImpl,
				boundingBox,
				function ($) {
					return $.f9;
				},
				triangularMesh);
		case 5:
			var boundingBox = mesh.a;
			var triangularMesh = mesh.b;
			return A3(
				$ianmackenzie$elm_3d_scene$Scene3d$Mesh$shadowImpl,
				boundingBox,
				function ($) {
					return $.f9;
				},
				triangularMesh);
		case 6:
			var boundingBox = mesh.a;
			var triangularMesh = mesh.b;
			return A3(
				$ianmackenzie$elm_3d_scene$Scene3d$Mesh$shadowImpl,
				boundingBox,
				function ($) {
					return $.f9;
				},
				triangularMesh);
		case 7:
			var boundingBox = mesh.a;
			var triangularMesh = mesh.b;
			return A3(
				$ianmackenzie$elm_3d_scene$Scene3d$Mesh$shadowImpl,
				boundingBox,
				function ($) {
					return $.f9;
				},
				triangularMesh);
		case 8:
			return $ianmackenzie$elm_3d_scene$Scene3d$Types$EmptyShadow;
		case 9:
			return $ianmackenzie$elm_3d_scene$Scene3d$Types$EmptyShadow;
		default:
			return $ianmackenzie$elm_3d_scene$Scene3d$Types$EmptyShadow;
	}
};
var $ianmackenzie$elm_3d_scene$Scene3d$Primitives$blockShadow = $ianmackenzie$elm_3d_scene$Scene3d$Mesh$shadow($ianmackenzie$elm_3d_scene$Scene3d$Primitives$block);
var $ianmackenzie$elm_3d_scene$Scene3d$Types$EmptyNode = {$: 0};
var $ianmackenzie$elm_3d_scene$Scene3d$Types$Entity = $elm$core$Basics$identity;
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty = $ianmackenzie$elm_3d_scene$Scene3d$Types$EmptyNode;
var $ianmackenzie$elm_3d_scene$Scene3d$Types$Group = function (a) {
	return {$: 5, a: a};
};
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$collectNodes = F2(
	function (drawables, accumulated) {
		collectNodes:
		while (true) {
			if (!drawables.b) {
				return accumulated;
			} else {
				var node = drawables.a;
				var rest = drawables.b;
				var $temp$drawables = rest,
					$temp$accumulated = A2($elm$core$List$cons, node, accumulated);
				drawables = $temp$drawables;
				accumulated = $temp$accumulated;
				continue collectNodes;
			}
		}
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$group = function (drawables) {
	return $ianmackenzie$elm_3d_scene$Scene3d$Types$Group(
		A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$collectNodes, drawables, _List_Nil));
};
var $ianmackenzie$elm_3d_scene$Scene3d$Types$OpaqueMeshNode = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$bumpyVertex = {
	src: '\n        precision highp float;\n        \n        attribute highp vec3 position;\n        attribute highp vec3 normal;\n        attribute mediump vec2 uv;\n        attribute highp vec4 tangent;\n        \n        uniform highp vec4 modelScale;\n        uniform highp mat4 modelMatrix;\n        uniform highp mat4 viewMatrix;\n        uniform highp mat4 projectionMatrix;\n        uniform highp mat4 sceneProperties;\n        \n        varying highp vec3 interpolatedPosition;\n        varying highp vec3 interpolatedNormal;\n        varying mediump vec2 interpolatedUv;\n        varying highp vec4 interpolatedTangent;\n        \n        vec4 getWorldPosition(vec3 modelPosition, vec4 modelScale, mat4 modelMatrix) {\n            vec4 scaledPosition = vec4(modelScale.xyz * modelPosition, 1.0);\n            return modelMatrix * scaledPosition;\n        }\n        \n        vec3 safeNormalize(vec3 vector) {\n            if (vector == vec3(0.0, 0.0, 0.0)) {\n                return vector;\n            } else {\n                return normalize(vector);\n            }\n        }\n        \n        vec3 getWorldNormal(vec3 modelNormal, vec4 modelScale, mat4 modelMatrix) {\n            vec3 normalScale = vec3(modelScale.w / modelScale.x, modelScale.w / modelScale.y, modelScale.w / modelScale.z);\n            return (modelMatrix * vec4(safeNormalize(normalScale * modelNormal), 0.0)).xyz;\n        }\n        \n        vec4 getWorldTangent(vec4 modelTangent, vec4 modelScale, mat4 modelMatrix) {\n            return vec4((modelMatrix * vec4(safeNormalize(modelScale.xyz * modelTangent.xyz), 0.0)).xyz, modelScale.w * modelTangent.w);\n        }\n        \n        void main () {\n            vec4 worldPosition = getWorldPosition(position, modelScale, modelMatrix);\n            gl_Position = projectionMatrix * (viewMatrix * worldPosition);\n            interpolatedPosition = worldPosition.xyz;\n            interpolatedNormal = getWorldNormal(normal, modelScale, modelMatrix);\n            interpolatedUv = uv;\n            interpolatedTangent = getWorldTangent(tangent, modelScale, modelMatrix);\n        }\n    ',
	attributes: {normal: 'aS', position: 'f9', tangent: 'bR', uv: 'bZ'},
	uniforms: {modelMatrix: 'b', modelScale: 'c', projectionMatrix: 'd', sceneProperties: 'e', viewMatrix: 'f'}
};
var $elm_explorations$webgl$WebGL$Internal$enableOption = F2(
	function (ctx, option) {
		switch (option.$) {
			case 0:
				return A2(_WebGL_enableAlpha, ctx, option);
			case 1:
				return A2(_WebGL_enableDepth, ctx, option);
			case 2:
				return A2(_WebGL_enableStencil, ctx, option);
			case 3:
				return A2(_WebGL_enableAntialias, ctx, option);
			case 4:
				return A2(_WebGL_enableClearColor, ctx, option);
			default:
				return A2(_WebGL_enablePreserveDrawingBuffer, ctx, option);
		}
	});
var $elm_explorations$webgl$WebGL$Internal$enableSetting = F2(
	function (cache, setting) {
		switch (setting.$) {
			case 0:
				return A2(_WebGL_enableBlend, cache, setting);
			case 1:
				return A2(_WebGL_enableDepthTest, cache, setting);
			case 2:
				return A2(_WebGL_enableStencilTest, cache, setting);
			case 3:
				return A2(_WebGL_enableScissor, cache, setting);
			case 4:
				return A2(_WebGL_enableColorMask, cache, setting);
			case 5:
				return A2(_WebGL_enableCullFace, cache, setting);
			case 6:
				return A2(_WebGL_enablePolygonOffset, cache, setting);
			case 7:
				return A2(_WebGL_enableSampleCoverage, cache, setting);
			default:
				return _WebGL_enableSampleAlphaToCoverage(cache);
		}
	});
var $elm_explorations$webgl$WebGL$entityWith = _WebGL_entity;
var $ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$lambertianTextureFragment = {
	src: '\n        precision highp float;\n        \n        uniform highp mat4 sceneProperties;\n        uniform highp mat4 lights12;\n        uniform highp mat4 lights34;\n        uniform highp mat4 lights56;\n        uniform highp mat4 lights78;\n        uniform lowp vec4 enabledLights;\n        uniform mediump sampler2D materialColorTexture;\n        uniform lowp vec4 constantMaterialColor;\n        uniform mediump sampler2D ambientOcclusionTexture;\n        uniform lowp vec2 constantAmbientOcclusion;\n        uniform mediump sampler2D normalMapTexture;\n        uniform lowp float normalMapType;\n        uniform highp mat4 viewMatrix;\n        \n        varying highp vec3 interpolatedPosition;\n        varying highp vec3 interpolatedNormal;\n        varying mediump vec2 interpolatedUv;\n        varying highp vec4 interpolatedTangent;\n        \n        const lowp float kPerspectiveProjection = 0.0;\n        const lowp float kOrthographicProjection = 1.0;\n        const lowp float kDirectionalLight = 1.0;\n        const lowp float kPointLight = 2.0;\n        const highp float kPi = 3.14159265359;\n        const lowp float kDisabledLight = 0.0;\n        const lowp float kSoftLighting = 3.0;\n        \n        vec3 getLocalNormal(sampler2D normalMap, float normalMapType, vec2 uv) {\n            if (normalMapType == 0.0) {\n                return vec3(0.0, 0.0, 1.0);\n            } else {\n                vec3 rgb = texture2D(normalMap, uv).rgb;\n                float x = 2.0 * (rgb.r - 0.5);\n                float y = 2.0 * (rgb.g - 0.5) * normalMapType;\n                float z = 2.0 * (rgb.b - 0.5);\n                return normalize(vec3(x, y, z));\n            }\n        }\n        \n        float getNormalSign() {\n            return 2.0 * float(gl_FrontFacing) - 1.0;\n        }\n        \n        vec3 getMappedNormal(vec3 normal, vec4 tangent, vec3 localNormal) {\n            vec3 bitangent = cross(normal, tangent.xyz) * tangent.w;\n            return normalize(localNormal.x * tangent.xyz + localNormal.y * bitangent + localNormal.z * normal);\n        }\n        \n        float getFloatValue(sampler2D texture, vec2 uv, vec2 constantValue) {\n            if (constantValue.y == 1.0) {\n                return constantValue.x;\n            } else {\n                vec4 textureColor = texture2D(texture, uv);\n                return dot(textureColor, vec4(0.2126, 0.7152, 0.0722, 0.0));\n            }\n        }\n        \n        vec3 getDirectionToCamera(vec3 surfacePosition, mat4 sceneProperties) {\n            float projectionType = sceneProperties[1].w;\n            if (projectionType == kPerspectiveProjection) {\n                vec3 cameraPoint = sceneProperties[1].xyz;\n                return normalize(cameraPoint - surfacePosition);\n            } else if (projectionType == kOrthographicProjection) {\n                return sceneProperties[1].xyz;\n            } else {\n                return vec3(0.0, 0.0, 0.0);\n            }\n        }\n        \n        void getDirectionToLightAndNormalIlluminance(\n            vec4 xyz_type,\n            vec4 rgb_parameter,\n            vec3 surfacePosition,\n            out vec3 directionToLight,\n            out vec3 normalIlluminance\n        ) {\n            float lightType = xyz_type.w;\n            if (lightType == kDirectionalLight) {\n                directionToLight = xyz_type.xyz;\n                normalIlluminance = rgb_parameter.rgb;\n            } else if (lightType == kPointLight) {\n                vec3 lightPosition = xyz_type.xyz;\n                vec3 displacement = lightPosition - surfacePosition;\n                float distance = length(displacement);\n                directionToLight = displacement / distance;\n                normalIlluminance = rgb_parameter.rgb / (4.0 * kPi * distance * distance);\n            }\n        }\n        \n        float positiveDotProduct(vec3 v1, vec3 v2) {\n            return clamp(dot(v1, v2), 0.0, 1.0);\n        }\n        \n        vec3 softLightingLuminance(\n            vec3 aboveLuminance,\n            vec3 belowLuminance,\n            vec3 localUpDirection,\n            vec3 localLightDirection\n        ) {\n            float sinElevation = dot(localLightDirection, localUpDirection);\n            float t = (sinElevation + 1.0) / 2.0;\n            return aboveLuminance * t + belowLuminance * (1.0 - t);\n        }\n        \n        vec3 lambertianLight(\n            vec3 surfacePosition,\n            vec3 surfaceNormal,\n            vec3 materialColor,\n            float ambientOcclusion,\n            vec4 xyz_type,\n            vec4 rgb_parameter\n        ) {\n            float lightType = xyz_type.w;\n            if (lightType == kDisabledLight) {\n                return vec3(0.0, 0.0, 0.0);\n            } else if (lightType == kSoftLighting) {\n                vec3 upDirection = xyz_type.xyz;\n                vec3 aboveLuminance = rgb_parameter.rgb;\n                vec3 belowLuminance = rgb_parameter.a * aboveLuminance;\n                vec3 luminance = softLightingLuminance(aboveLuminance, belowLuminance, upDirection, surfaceNormal);\n                return luminance * materialColor * ambientOcclusion;\n            }\n        \n            vec3 directionToLight = vec3(0.0, 0.0, 0.0);\n            vec3 normalIlluminance = vec3(0.0, 0.0, 0.0);\n            getDirectionToLightAndNormalIlluminance(\n                xyz_type,\n                rgb_parameter,\n                surfacePosition,\n                directionToLight,\n                normalIlluminance\n            );\n        \n            float dotNL = positiveDotProduct(directionToLight, surfaceNormal);\n            return (normalIlluminance * dotNL) * (materialColor / kPi);\n        }\n        \n        vec3 lambertianLighting(\n            vec3 surfacePosition,\n            vec3 surfaceNormal,\n            vec3 materialColor,\n            float ambientOcclusion,\n            mat4 lights12,\n            mat4 lights34,\n            mat4 lights56,\n            mat4 lights78,\n            vec4 enabledLights\n        ) {\n            vec3 litColor1 = enabledLights[0] == 1.0 ? lambertianLight(surfacePosition, surfaceNormal, materialColor, ambientOcclusion, lights12[0], lights12[1]) : vec3(0.0, 0.0, 0.0);\n            vec3 litColor2 = enabledLights[1] == 1.0 ? lambertianLight(surfacePosition, surfaceNormal, materialColor, ambientOcclusion, lights12[2], lights12[3]) : vec3(0.0, 0.0, 0.0);\n            vec3 litColor3 = enabledLights[2] == 1.0 ? lambertianLight(surfacePosition, surfaceNormal, materialColor, ambientOcclusion, lights34[0], lights34[1]) : vec3(0.0, 0.0, 0.0);\n            vec3 litColor4 = enabledLights[3] == 1.0 ? lambertianLight(surfacePosition, surfaceNormal, materialColor, ambientOcclusion, lights34[2], lights34[3]) : vec3(0.0, 0.0, 0.0);\n            vec3 litColor5 = lambertianLight(surfacePosition, surfaceNormal, materialColor, ambientOcclusion, lights56[0], lights56[1]);\n            vec3 litColor6 = lambertianLight(surfacePosition, surfaceNormal, materialColor, ambientOcclusion, lights56[2], lights56[3]);\n            vec3 litColor7 = lambertianLight(surfacePosition, surfaceNormal, materialColor, ambientOcclusion, lights78[0], lights78[1]);\n            vec3 litColor8 = lambertianLight(surfacePosition, surfaceNormal, materialColor, ambientOcclusion, lights78[2], lights78[3]);\n            return litColor1 + litColor2 + litColor3 + litColor4 + litColor5 + litColor6 + litColor7 + litColor8;\n        }\n        \n        float inverseGamma(float u) {\n            if (u <= 0.04045) {\n                return clamp(u / 12.92, 0.0, 1.0);\n            } else {\n                return clamp(pow((u + 0.055) / 1.055, 2.4), 0.0, 1.0);\n            }\n        }\n        \n        float inverseAlpha(float value) {\n            // the value used for alpha cannot be less than zero\n            float signValue = float(sign(value));\n            return signValue / (value + (signValue - 1.0));\n        }\n        \n        vec4 fromSrgb(vec4 srgbColor) {\n            float invAlpha = inverseAlpha(srgbColor.a);\n            return vec4(\n                inverseGamma(srgbColor.r * invAlpha) * srgbColor.a,\n                inverseGamma(srgbColor.g * invAlpha) * srgbColor.a,\n                inverseGamma(srgbColor.b * invAlpha) * srgbColor.a,\n                srgbColor.a\n            );\n        }\n        \n        float gammaCorrect(float u) {\n            if (u <= 0.0031308) {\n                return 12.92 * u;\n            } else {\n                return 1.055 * pow(u, 1.0 / 2.4) - 0.055;\n            }\n        }\n        \n        vec3 gammaCorrectedColor(vec3 color) {\n            float red = gammaCorrect(color.r);\n            float green = gammaCorrect(color.g);\n            float blue = gammaCorrect(color.b);\n            return vec3(red, green, blue);\n        }\n        \n        vec3 reinhardLuminanceToneMap(vec3 color) {\n            float luminance = 0.2126 * color.r + 0.7152 * color.g + 0.0722 * color.b;\n            float scale = 1.0 / (1.0 + luminance);\n            return gammaCorrectedColor(color * scale);\n        }\n        \n        vec3 reinhardPerChannelToneMap(vec3 color) {\n            return gammaCorrectedColor(color / (color + 1.0));\n        }\n        \n        float extendedReinhardToneMap(float x, float xMax) {\n            return x * (1.0 + (x / (xMax * xMax))) / (1.0 + x);\n        }\n        \n        vec3 extendedReinhardLuminanceToneMap(vec3 color, float overexposureLimit) {\n            float luminance = 0.2126 * color.r + 0.7152 * color.g + 0.0722 * color.b;\n            float scaledLuminance = extendedReinhardToneMap(luminance, overexposureLimit);\n            float scale = scaledLuminance / luminance;\n            return gammaCorrectedColor(color * scale);\n        }\n        \n        vec3 extendedReinhardPerChannelToneMap(vec3 color, float overexposureLimit) {\n            float red = extendedReinhardToneMap(color.r, overexposureLimit);\n            float green = extendedReinhardToneMap(color.g, overexposureLimit);\n            float blue = extendedReinhardToneMap(color.b, overexposureLimit);\n            return gammaCorrectedColor(vec3(red, green, blue));\n        }\n        \n        vec3 hableFilmicHelper(vec3 color) {\n            float a = 0.15;\n            float b = 0.5;\n            float c = 0.1;\n            float d = 0.2;\n            float e = 0.02;\n            float f = 0.3;\n            return (color * (a * color + c * b) + d * e) / (color * (a * color + b) + d * f) - e / f;\n        }\n        \n        vec3 hableFilmicToneMap(vec3 color) {\n            float exposureBias = 2.0;\n            vec3 unscaled = hableFilmicHelper(exposureBias * color);\n            vec3 scale = 1.0 / hableFilmicHelper(vec3(11.2));\n            return gammaCorrectedColor(scale * unscaled);\n        }\n        \n        vec3 toneMap(vec3 color, float toneMapType, float toneMapParam) {\n            if (toneMapType == 0.0) {\n                return gammaCorrectedColor(color);\n            } else if (toneMapType == 1.0) {\n                return reinhardLuminanceToneMap(color);\n            } else if (toneMapType == 2.0) {\n                return reinhardPerChannelToneMap(color);\n            } else if (toneMapType == 3.0) {\n                return extendedReinhardLuminanceToneMap(color, toneMapParam);\n            } else if (toneMapType == 4.0) {\n                return extendedReinhardPerChannelToneMap(color, toneMapParam);\n            } else if (toneMapType == 5.0) {\n                return hableFilmicToneMap(color);\n            } else {\n                return vec3(0.0, 0.0, 0.0);\n            }\n        }\n        \n        vec4 toSrgb(vec4 linearColor, mat4 sceneProperties) {\n            vec3 referenceWhite = sceneProperties[2].rgb;\n            // linearColor has premultiplied alpha, but tone mapping works on\n            // non-premultiplied linear RGB so we need to temporarily \'undo\' the\n            // premultiplication before applying tone mapping\n            float invAlpha = inverseAlpha(linearColor.a);\n            float unitR = (linearColor.r * invAlpha) / referenceWhite.r;\n            float unitG = (linearColor.g * invAlpha) / referenceWhite.g;\n            float unitB = (linearColor.b * invAlpha) / referenceWhite.b;\n            float toneMapType = sceneProperties[3][2];\n            float toneMapParam = sceneProperties[3][3];\n            // Apply tone mapping\n            vec3 toneMapped = toneMap(vec3(unitR, unitG, unitB), toneMapType, toneMapParam);\n            // Re-apply premultiplied alpha after tone mapping\n            return vec4(toneMapped * linearColor.a, linearColor.a);\n        }\n        \n        void main() {\n            vec3 localNormal = getLocalNormal(normalMapTexture, normalMapType, interpolatedUv);\n            float normalSign = getNormalSign();\n            vec3 originalNormal = normalize(interpolatedNormal) * normalSign;\n            vec3 normalDirection = getMappedNormal(originalNormal, interpolatedTangent, localNormal);\n            float ambientOcclusion = getFloatValue(ambientOcclusionTexture, interpolatedUv, constantAmbientOcclusion);\n            vec3 directionToCamera = getDirectionToCamera(interpolatedPosition, sceneProperties);\n            float useConstantColor = float(sign(constantMaterialColor.a));  // 1.0 for color, 0.0 for texture\n            vec4 materialColor = fromSrgb(texture2D(materialColorTexture, interpolatedUv)) * (1.0 - useConstantColor) + constantMaterialColor * useConstantColor;\n        \n            vec3 linearColor = lambertianLighting(\n                interpolatedPosition,\n                normalDirection,\n                materialColor.rgb,\n                ambientOcclusion,\n                lights12,\n                lights34,\n                lights56,\n                lights78,\n                enabledLights\n            );\n        \n            gl_FragColor = toSrgb(vec4(linearColor, materialColor.a), sceneProperties);\n        }\n    ',
	attributes: {},
	uniforms: {ambientOcclusionTexture: 'ae', constantAmbientOcclusion: 'af', constantMaterialColor: 'bp', enabledLights: 't', lights12: 'cp', lights34: 'c6', lights56: 'c7', lights78: 'c8', materialColorTexture: 'bB', normalMapTexture: 'ai', normalMapType: 'aj', sceneProperties: 'e', viewMatrix: 'f'}
};
var $ianmackenzie$elm_3d_scene$Scene3d$Types$TransparentMeshNode = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$emptyMeshNode = F2(
	function (_v0, _v1) {
		return $ianmackenzie$elm_3d_scene$Scene3d$Types$EmptyNode;
	});
var $elm_explorations$linear_algebra$Math$Vector4$getW = _MJS_v4getW;
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$meshNode = function (color) {
	var alpha = $elm_explorations$linear_algebra$Math$Vector4$getW(color);
	return (alpha === 1) ? $ianmackenzie$elm_3d_scene$Scene3d$Types$OpaqueMeshNode : ((!alpha) ? $ianmackenzie$elm_3d_scene$Scene3d$Entity$emptyMeshNode : $ianmackenzie$elm_3d_scene$Scene3d$Types$TransparentMeshNode);
};
var $elm_explorations$webgl$WebGL$Settings$FaceMode = $elm$core$Basics$identity;
var $elm_explorations$webgl$WebGL$Settings$back = 1029;
var $elm_explorations$webgl$WebGL$Internal$CullFace = function (a) {
	return {$: 5, a: a};
};
var $elm_explorations$webgl$WebGL$Settings$cullFace = function (_v0) {
	var faceMode = _v0;
	return $elm_explorations$webgl$WebGL$Internal$CullFace(faceMode);
};
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$cullBackFaceSetting = $elm_explorations$webgl$WebGL$Settings$cullFace($elm_explorations$webgl$WebGL$Settings$back);
var $elm_explorations$webgl$WebGL$Settings$front = 1028;
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$cullFrontFaceSetting = $elm_explorations$webgl$WebGL$Settings$cullFace($elm_explorations$webgl$WebGL$Settings$front);
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$meshSettings = F3(
	function (isRightHanded, backFaceSetting, settings) {
		if (backFaceSetting === 1) {
			return isRightHanded ? A2($elm$core$List$cons, $ianmackenzie$elm_3d_scene$Scene3d$Entity$cullBackFaceSetting, settings) : A2($elm$core$List$cons, $ianmackenzie$elm_3d_scene$Scene3d$Entity$cullFrontFaceSetting, settings);
		} else {
			return settings;
		}
	});
var $elm_explorations$linear_algebra$Math$Vector4$toRecord = _MJS_v4toRecord;
var $elm_explorations$linear_algebra$Math$Vector4$vec4 = _MJS_v4;
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$premultiplyColor = function (color) {
	var _v0 = $elm_explorations$linear_algebra$Math$Vector4$toRecord(color);
	var x = _v0.cF;
	var y = _v0.cG;
	var z = _v0.cH;
	var w = _v0.gF;
	return A4($elm_explorations$linear_algebra$Math$Vector4$vec4, x * w, y * w, z * w, w);
};
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$zeroVec4 = A4($elm_explorations$linear_algebra$Math$Vector4$vec4, 0, 0, 0, 0);
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$bumpyLambertianMesh = F8(
	function (useTextureOrColor, ambientOcclusionData, constantAmbientOcclusion, normalMapData, normalMapType, bounds, webGLMesh, backFaceSetting) {
		if (!useTextureOrColor.$) {
			var materialColorData = useTextureOrColor.a;
			return A2(
				$ianmackenzie$elm_3d_scene$Scene3d$Types$OpaqueMeshNode,
				bounds,
				F8(
					function (sceneProperties, modelScale, modelMatrix, isRightHanded, viewMatrix, projectionMatrix, _v1, settings) {
						var lights = _v1.a;
						var enabledLights = _v1.b;
						return A5(
							$elm_explorations$webgl$WebGL$entityWith,
							A3($ianmackenzie$elm_3d_scene$Scene3d$Entity$meshSettings, isRightHanded, backFaceSetting, settings),
							$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$bumpyVertex,
							$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$lambertianTextureFragment,
							webGLMesh,
							{ae: ambientOcclusionData, af: constantAmbientOcclusion, bp: $ianmackenzie$elm_3d_scene$Scene3d$Entity$zeroVec4, t: enabledLights, cp: lights.cp, c6: lights.c6, c7: lights.c7, c8: lights.c8, bB: materialColorData, b: modelMatrix, c: modelScale, ai: normalMapData, aj: normalMapType, d: projectionMatrix, e: sceneProperties, f: viewMatrix});
					}));
		} else {
			var constantMaterialColor = useTextureOrColor.a;
			var dummyTexture = useTextureOrColor.b;
			return A3(
				$ianmackenzie$elm_3d_scene$Scene3d$Entity$meshNode,
				constantMaterialColor,
				bounds,
				F8(
					function (sceneProperties, modelScale, modelMatrix, isRightHanded, viewMatrix, projectionMatrix, _v2, settings) {
						var lights = _v2.a;
						var enabledLights = _v2.b;
						return A5(
							$elm_explorations$webgl$WebGL$entityWith,
							A3($ianmackenzie$elm_3d_scene$Scene3d$Entity$meshSettings, isRightHanded, backFaceSetting, settings),
							$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$bumpyVertex,
							$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$lambertianTextureFragment,
							webGLMesh,
							{
								ae: ambientOcclusionData,
								af: constantAmbientOcclusion,
								bp: $ianmackenzie$elm_3d_scene$Scene3d$Entity$premultiplyColor(constantMaterialColor),
								t: enabledLights,
								cp: lights.cp,
								c6: lights.c6,
								c7: lights.c7,
								c8: lights.c8,
								bB: dummyTexture,
								b: modelMatrix,
								c: modelScale,
								ai: normalMapData,
								aj: normalMapType,
								d: projectionMatrix,
								e: sceneProperties,
								f: viewMatrix
							});
					}));
		}
	});
var $ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$physicalTexturesFragment = {
	src: '\n        precision highp float;\n        \n        uniform highp mat4 sceneProperties;\n        uniform highp mat4 viewMatrix;\n        uniform highp mat4 lights12;\n        uniform highp mat4 lights34;\n        uniform highp mat4 lights56;\n        uniform highp mat4 lights78;\n        uniform lowp vec4 enabledLights;\n        uniform mediump sampler2D baseColorTexture;\n        uniform lowp vec4 constantBaseColor;\n        uniform mediump sampler2D roughnessTexture;\n        uniform lowp vec2 constantRoughness;\n        uniform mediump sampler2D metallicTexture;\n        uniform lowp vec2 constantMetallic;\n        uniform mediump sampler2D ambientOcclusionTexture;\n        uniform lowp vec2 constantAmbientOcclusion;\n        uniform mediump sampler2D normalMapTexture;\n        uniform lowp float normalMapType;\n        \n        varying highp vec3 interpolatedPosition;\n        varying highp vec3 interpolatedNormal;\n        varying mediump vec2 interpolatedUv;\n        varying highp vec4 interpolatedTangent;\n        \n        const lowp float kPerspectiveProjection = 0.0;\n        const lowp float kOrthographicProjection = 1.0;\n        const lowp float kDirectionalLight = 1.0;\n        const lowp float kPointLight = 2.0;\n        const highp float kPi = 3.14159265359;\n        const mediump float kMediumpFloatMax = 65504.0;\n        const lowp float kDisabledLight = 0.0;\n        const lowp float kSoftLighting = 3.0;\n        \n        float getFloatValue(sampler2D texture, vec2 uv, vec2 constantValue) {\n            if (constantValue.y == 1.0) {\n                return constantValue.x;\n            } else {\n                vec4 textureColor = texture2D(texture, uv);\n                return dot(textureColor, vec4(0.2126, 0.7152, 0.0722, 0.0));\n            }\n        }\n        \n        vec3 getLocalNormal(sampler2D normalMap, float normalMapType, vec2 uv) {\n            if (normalMapType == 0.0) {\n                return vec3(0.0, 0.0, 1.0);\n            } else {\n                vec3 rgb = texture2D(normalMap, uv).rgb;\n                float x = 2.0 * (rgb.r - 0.5);\n                float y = 2.0 * (rgb.g - 0.5) * normalMapType;\n                float z = 2.0 * (rgb.b - 0.5);\n                return normalize(vec3(x, y, z));\n            }\n        }\n        \n        float getNormalSign() {\n            return 2.0 * float(gl_FrontFacing) - 1.0;\n        }\n        \n        vec3 getMappedNormal(vec3 normal, vec4 tangent, vec3 localNormal) {\n            vec3 bitangent = cross(normal, tangent.xyz) * tangent.w;\n            return normalize(localNormal.x * tangent.xyz + localNormal.y * bitangent + localNormal.z * normal);\n        }\n        \n        vec3 getDirectionToCamera(vec3 surfacePosition, mat4 sceneProperties) {\n            float projectionType = sceneProperties[1].w;\n            if (projectionType == kPerspectiveProjection) {\n                vec3 cameraPoint = sceneProperties[1].xyz;\n                return normalize(cameraPoint - surfacePosition);\n            } else if (projectionType == kOrthographicProjection) {\n                return sceneProperties[1].xyz;\n            } else {\n                return vec3(0.0, 0.0, 0.0);\n            }\n        }\n        \n        void getDirectionToLightAndNormalIlluminance(\n            vec4 xyz_type,\n            vec4 rgb_parameter,\n            vec3 surfacePosition,\n            out vec3 directionToLight,\n            out vec3 normalIlluminance\n        ) {\n            float lightType = xyz_type.w;\n            if (lightType == kDirectionalLight) {\n                directionToLight = xyz_type.xyz;\n                normalIlluminance = rgb_parameter.rgb;\n            } else if (lightType == kPointLight) {\n                vec3 lightPosition = xyz_type.xyz;\n                vec3 displacement = lightPosition - surfacePosition;\n                float distance = length(displacement);\n                directionToLight = displacement / distance;\n                normalIlluminance = rgb_parameter.rgb / (4.0 * kPi * distance * distance);\n            }\n        }\n        \n        float positiveDotProduct(vec3 v1, vec3 v2) {\n            return clamp(dot(v1, v2), 0.0, 1.0);\n        }\n        \n        // Adapted from https://google.github.io/filament/Filament.md.html#materialsystem/specularbrdf/normaldistributionfunction(speculard)\n        float specularD(float alpha, float dotNH, vec3 normalDirection, vec3 halfDirection) {\n            vec3 crossNH = cross(normalDirection, halfDirection);\n            float a = dotNH * alpha;\n            float k = alpha / (dot(crossNH, crossNH) + a * a);\n            float d = k * k * (1.0 / kPi);\n            return min(d, kMediumpFloatMax);\n        }\n        \n        float safeQuotient(float numerator, float denominator) {\n            if (denominator == 0.0) {\n                return 0.0;\n            } else {\n                return numerator / denominator;\n            }\n        }\n        \n        float g1(float dotNV, float alphaSquared) {\n            return safeQuotient(2.0 * dotNV, dotNV + sqrt(alphaSquared + (1.0 - alphaSquared) * dotNV * dotNV));\n        }\n        \n        float specularG(float dotNL, float dotNV, float alphaSquared) {\n            return g1(dotNV, alphaSquared) * g1(dotNL, alphaSquared);\n        }\n        \n        vec3 fresnelColor(vec3 specularBaseColor, float dotVH) {\n            vec3 one = vec3(1.0, 1.0, 1.0);\n            float scale = exp2((-5.55473 * dotVH - 6.98316) * dotVH);\n            return specularBaseColor + (one - specularBaseColor) * scale;\n        }\n        \n        vec3 brdf(vec3 normalDirection, vec3 directionToCamera, vec3 directionToLight, float alpha, float dotNV, float dotNL, vec3 specularBaseColor, vec3 normalIlluminance) {\n            vec3 halfDirection = normalize(directionToCamera + directionToLight);\n            float dotVH = positiveDotProduct(directionToCamera, halfDirection);\n            float dotNH = positiveDotProduct(normalDirection, halfDirection);\n            float dotNHSquared = dotNH * dotNH;\n        \n            float d = specularD(alpha, dotNH, normalDirection, halfDirection);\n            float g = specularG(dotNL, dotNV, alpha * alpha);\n            vec3 f = fresnelColor(specularBaseColor, dotVH);\n            return safeQuotient(d * g, 4.0 * dotNL * dotNV) * f;\n        }\n        \n        vec3 sampleFacetNormal(vec3 vH, vec3 vT1, vec3 vT2, float s, float alpha) {\n            float t2 = (1.0 - s);\n            vec3 vNh = t2 * vT2 + sqrt(max(0.0, 1.0 - t2 * t2)) * vH;\n            return normalize(vec3(alpha * vNh.x, alpha * vNh.y, max(0.0, vNh.z)));\n        }\n        \n        vec3 softLightingLuminance(\n            vec3 aboveLuminance,\n            vec3 belowLuminance,\n            vec3 localUpDirection,\n            vec3 localLightDirection\n        ) {\n            float sinElevation = dot(localLightDirection, localUpDirection);\n            float t = (sinElevation + 1.0) / 2.0;\n            return aboveLuminance * t + belowLuminance * (1.0 - t);\n        }\n        \n        vec3 softLightingSpecularSample(\n            vec3 aboveLuminance,\n            vec3 belowLuminance,\n            vec3 localUpDirection,\n            vec3 localViewDirection,\n            vec3 localLightDirection,\n            vec3 localHalfDirection,\n            float alphaSquared,\n            vec3 specularBaseColor\n        ) {\n            vec3 luminance = softLightingLuminance(aboveLuminance, belowLuminance, localUpDirection, localLightDirection);\n            float dotVH = positiveDotProduct(localViewDirection, localHalfDirection);\n            float dotNL = localLightDirection.z;\n            return luminance * (fresnelColor(specularBaseColor, dotVH) * g1(dotNL, alphaSquared));\n        }\n        \n        vec3 softLighting(\n            vec3 normalDirection,\n            vec3 diffuseBaseColor,\n            vec3 specularBaseColor,\n            float alpha,\n            vec3 directionToCamera,\n            vec3 viewY,\n            vec4 xyz_type,\n            vec4 rgb_parameter\n        ) {\n            float alphaSquared = alpha * alpha;\n            vec3 upDirection = xyz_type.xyz;\n            vec3 luminanceAbove = rgb_parameter.rgb;\n            vec3 luminanceBelow = rgb_parameter.a * luminanceAbove;\n            vec3 crossProduct = cross(normalDirection, directionToCamera);\n            float crossMagnitude = length(crossProduct);\n            vec3 xDirection = vec3(0.0, 0.0, 0.0);\n            vec3 yDirection = vec3(0.0, 0.0, 0.0);\n            if (crossMagnitude > 1.0e-6) {\n                yDirection = (1.0 / crossMagnitude) * crossProduct;\n                xDirection = cross(yDirection, normalDirection);\n            } else {\n                vec3 viewY = vec3(viewMatrix[0][1], viewMatrix[1][1], viewMatrix[2][1]);\n                xDirection = normalize(cross(viewY, normalDirection));\n                yDirection = cross(normalDirection, xDirection);\n            }\n            float localViewX = dot(directionToCamera, xDirection);\n            float localViewZ = dot(directionToCamera, normalDirection);\n            vec3 localViewDirection = vec3(localViewX, 0, localViewZ);\n            float localUpX = dot(upDirection, xDirection);\n            float localUpY = dot(upDirection, yDirection);\n            float localUpZ = dot(upDirection, normalDirection);\n            vec3 localUpDirection = vec3(localUpX, localUpY, localUpZ);\n        \n            vec3 vH = normalize(vec3(alpha * localViewX, 0.0, localViewZ));\n            vec3 vT1 = vec3(0.0, 1.0, 0.0);\n            vec3 vT2 = cross(vH, vT1);\n            float s = 0.5 * (1.0 + vH.z);\n        \n            vec3 localHalfDirection = sampleFacetNormal(vH, vT1, vT2, s, alpha);\n            vec3 localLightDirection = vec3(0.0, 0.0, 0.0);\n        \n            localLightDirection = -reflect(localViewDirection, localHalfDirection);\n            vec3 specular = softLightingSpecularSample(luminanceAbove, luminanceBelow, localUpDirection, localViewDirection, localLightDirection, localHalfDirection, alphaSquared, specularBaseColor);\n        \n            localLightDirection = vec3(0.000000, 0.000000, 1.000000);\n            vec3 diffuse = softLightingLuminance(luminanceAbove, luminanceBelow, localUpDirection, localLightDirection) * localLightDirection.z;\n        \n            return specular + diffuse * diffuseBaseColor;\n        }\n        \n        vec3 physicalLight(\n            vec4 xyz_type,\n            vec4 rgb_parameter,\n            vec3 surfacePosition,\n            vec3 normalDirection,\n            vec3 directionToCamera,\n            vec3 viewY,\n            float dotNV,\n            vec3 diffuseBaseColor,\n            vec3 specularBaseColor,\n            float alpha,\n            float ambientOcclusion\n        ) {\n            float lightType = xyz_type.w;\n            if (lightType == kDisabledLight) {\n                return vec3(0.0, 0.0, 0.0);\n            } else if (lightType == kSoftLighting) {\n                return softLighting(normalDirection, diffuseBaseColor, specularBaseColor, alpha, directionToCamera, viewY, xyz_type, rgb_parameter) * ambientOcclusion;\n            }\n        \n            vec3 directionToLight = vec3(0.0, 0.0, 0.0);\n            vec3 normalIlluminance = vec3(0.0, 0.0, 0.0);\n            getDirectionToLightAndNormalIlluminance(xyz_type, rgb_parameter, surfacePosition, directionToLight, normalIlluminance);\n        \n            float dotNL = positiveDotProduct(normalDirection, directionToLight);\n            vec3 specularColor = brdf(normalDirection, directionToCamera, directionToLight, alpha, dotNV, dotNL, specularBaseColor, normalIlluminance);\n            return (normalIlluminance * dotNL) * ((diffuseBaseColor / kPi) + specularColor);\n        }\n        \n        vec3 physicalLighting(\n            vec3 surfacePosition,\n            vec3 surfaceNormal,\n            vec3 baseColor,\n            vec3 directionToCamera,\n            mat4 viewMatrix,\n            float roughness,\n            float metallic,\n            float ambientOcclusion,\n            mat4 lights12,\n            mat4 lights34,\n            mat4 lights56,\n            mat4 lights78,\n            vec4 enabledLights\n        ) {\n            float dotNV = positiveDotProduct(surfaceNormal, directionToCamera);\n            float alpha = roughness * roughness;\n            float nonmetallic = 1.0 - metallic;\n            vec3 diffuseBaseColor = nonmetallic * 0.96 * baseColor;\n            vec3 specularBaseColor = nonmetallic * 0.04 * vec3(1.0, 1.0, 1.0) + metallic * baseColor;\n            vec3 viewY = vec3(viewMatrix[0][1], viewMatrix[1][1], viewMatrix[2][1]);\n        \n            vec3 litColor1 = enabledLights[0] == 1.0 ? physicalLight(lights12[0], lights12[1], surfacePosition, surfaceNormal, directionToCamera, viewY, dotNV, diffuseBaseColor, specularBaseColor, alpha, ambientOcclusion) : vec3(0.0, 0.0, 0.0);\n            vec3 litColor2 = enabledLights[1] == 1.0 ? physicalLight(lights12[2], lights12[3], surfacePosition, surfaceNormal, directionToCamera, viewY, dotNV, diffuseBaseColor, specularBaseColor, alpha, ambientOcclusion) : vec3(0.0, 0.0, 0.0);\n            vec3 litColor3 = enabledLights[2] == 1.0 ? physicalLight(lights34[0], lights34[1], surfacePosition, surfaceNormal, directionToCamera, viewY, dotNV, diffuseBaseColor, specularBaseColor, alpha, ambientOcclusion) : vec3(0.0, 0.0, 0.0);\n            vec3 litColor4 = enabledLights[3] == 1.0 ? physicalLight(lights34[2], lights34[3], surfacePosition, surfaceNormal, directionToCamera, viewY, dotNV, diffuseBaseColor, specularBaseColor, alpha, ambientOcclusion) : vec3(0.0, 0.0, 0.0);\n            vec3 litColor5 = physicalLight(lights56[0], lights56[1], surfacePosition, surfaceNormal, directionToCamera, viewY, dotNV, diffuseBaseColor, specularBaseColor, alpha, ambientOcclusion);\n            vec3 litColor6 = physicalLight(lights56[2], lights56[3], surfacePosition, surfaceNormal, directionToCamera, viewY, dotNV, diffuseBaseColor, specularBaseColor, alpha, ambientOcclusion);\n            vec3 litColor7 = physicalLight(lights78[0], lights78[1], surfacePosition, surfaceNormal, directionToCamera, viewY, dotNV, diffuseBaseColor, specularBaseColor, alpha, ambientOcclusion);\n            vec3 litColor8 = physicalLight(lights78[2], lights78[3], surfacePosition, surfaceNormal, directionToCamera, viewY, dotNV, diffuseBaseColor, specularBaseColor, alpha, ambientOcclusion);\n            return litColor1 + litColor2 + litColor3 + litColor4 + litColor5 + litColor6 + litColor7 + litColor8;\n        }\n        \n        float inverseGamma(float u) {\n            if (u <= 0.04045) {\n                return clamp(u / 12.92, 0.0, 1.0);\n            } else {\n                return clamp(pow((u + 0.055) / 1.055, 2.4), 0.0, 1.0);\n            }\n        }\n        \n        float inverseAlpha(float value) {\n            // the value used for alpha cannot be less than zero\n            float signValue = float(sign(value));\n            return signValue / (value + (signValue - 1.0));\n        }\n        \n        vec4 fromSrgb(vec4 srgbColor) {\n            float invAlpha = inverseAlpha(srgbColor.a);\n            return vec4(\n                inverseGamma(srgbColor.r * invAlpha) * srgbColor.a,\n                inverseGamma(srgbColor.g * invAlpha) * srgbColor.a,\n                inverseGamma(srgbColor.b * invAlpha) * srgbColor.a,\n                srgbColor.a\n            );\n        }\n        \n        float gammaCorrect(float u) {\n            if (u <= 0.0031308) {\n                return 12.92 * u;\n            } else {\n                return 1.055 * pow(u, 1.0 / 2.4) - 0.055;\n            }\n        }\n        \n        vec3 gammaCorrectedColor(vec3 color) {\n            float red = gammaCorrect(color.r);\n            float green = gammaCorrect(color.g);\n            float blue = gammaCorrect(color.b);\n            return vec3(red, green, blue);\n        }\n        \n        vec3 reinhardLuminanceToneMap(vec3 color) {\n            float luminance = 0.2126 * color.r + 0.7152 * color.g + 0.0722 * color.b;\n            float scale = 1.0 / (1.0 + luminance);\n            return gammaCorrectedColor(color * scale);\n        }\n        \n        vec3 reinhardPerChannelToneMap(vec3 color) {\n            return gammaCorrectedColor(color / (color + 1.0));\n        }\n        \n        float extendedReinhardToneMap(float x, float xMax) {\n            return x * (1.0 + (x / (xMax * xMax))) / (1.0 + x);\n        }\n        \n        vec3 extendedReinhardLuminanceToneMap(vec3 color, float overexposureLimit) {\n            float luminance = 0.2126 * color.r + 0.7152 * color.g + 0.0722 * color.b;\n            float scaledLuminance = extendedReinhardToneMap(luminance, overexposureLimit);\n            float scale = scaledLuminance / luminance;\n            return gammaCorrectedColor(color * scale);\n        }\n        \n        vec3 extendedReinhardPerChannelToneMap(vec3 color, float overexposureLimit) {\n            float red = extendedReinhardToneMap(color.r, overexposureLimit);\n            float green = extendedReinhardToneMap(color.g, overexposureLimit);\n            float blue = extendedReinhardToneMap(color.b, overexposureLimit);\n            return gammaCorrectedColor(vec3(red, green, blue));\n        }\n        \n        vec3 hableFilmicHelper(vec3 color) {\n            float a = 0.15;\n            float b = 0.5;\n            float c = 0.1;\n            float d = 0.2;\n            float e = 0.02;\n            float f = 0.3;\n            return (color * (a * color + c * b) + d * e) / (color * (a * color + b) + d * f) - e / f;\n        }\n        \n        vec3 hableFilmicToneMap(vec3 color) {\n            float exposureBias = 2.0;\n            vec3 unscaled = hableFilmicHelper(exposureBias * color);\n            vec3 scale = 1.0 / hableFilmicHelper(vec3(11.2));\n            return gammaCorrectedColor(scale * unscaled);\n        }\n        \n        vec3 toneMap(vec3 color, float toneMapType, float toneMapParam) {\n            if (toneMapType == 0.0) {\n                return gammaCorrectedColor(color);\n            } else if (toneMapType == 1.0) {\n                return reinhardLuminanceToneMap(color);\n            } else if (toneMapType == 2.0) {\n                return reinhardPerChannelToneMap(color);\n            } else if (toneMapType == 3.0) {\n                return extendedReinhardLuminanceToneMap(color, toneMapParam);\n            } else if (toneMapType == 4.0) {\n                return extendedReinhardPerChannelToneMap(color, toneMapParam);\n            } else if (toneMapType == 5.0) {\n                return hableFilmicToneMap(color);\n            } else {\n                return vec3(0.0, 0.0, 0.0);\n            }\n        }\n        \n        vec4 toSrgb(vec4 linearColor, mat4 sceneProperties) {\n            vec3 referenceWhite = sceneProperties[2].rgb;\n            // linearColor has premultiplied alpha, but tone mapping works on\n            // non-premultiplied linear RGB so we need to temporarily \'undo\' the\n            // premultiplication before applying tone mapping\n            float invAlpha = inverseAlpha(linearColor.a);\n            float unitR = (linearColor.r * invAlpha) / referenceWhite.r;\n            float unitG = (linearColor.g * invAlpha) / referenceWhite.g;\n            float unitB = (linearColor.b * invAlpha) / referenceWhite.b;\n            float toneMapType = sceneProperties[3][2];\n            float toneMapParam = sceneProperties[3][3];\n            // Apply tone mapping\n            vec3 toneMapped = toneMap(vec3(unitR, unitG, unitB), toneMapType, toneMapParam);\n            // Re-apply premultiplied alpha after tone mapping\n            return vec4(toneMapped * linearColor.a, linearColor.a);\n        }\n        \n        void main() {\n            float useConstantColor = float(sign(constantBaseColor.a));  // 1.0 for color, 0.0 for texture\n            vec4 baseColor = fromSrgb(texture2D(baseColorTexture, interpolatedUv)) * (1.0 - useConstantColor) + constantBaseColor * useConstantColor;\n        \n            float roughness = getFloatValue(roughnessTexture, interpolatedUv, constantRoughness);\n            float metallic = getFloatValue(metallicTexture, interpolatedUv, constantMetallic);\n            float ambientOcclusion = getFloatValue(ambientOcclusionTexture, interpolatedUv, constantAmbientOcclusion);\n        \n            vec3 localNormal = getLocalNormal(normalMapTexture, normalMapType, interpolatedUv);\n            float normalSign = getNormalSign();\n            vec3 originalNormal = normalize(interpolatedNormal) * normalSign;\n            vec3 normalDirection = getMappedNormal(originalNormal, interpolatedTangent, localNormal);\n            vec3 directionToCamera = getDirectionToCamera(interpolatedPosition, sceneProperties);\n        \n            vec3 linearColor = physicalLighting(\n                interpolatedPosition,\n                normalDirection,\n                baseColor.rgb,\n                directionToCamera,\n                viewMatrix,\n                roughness,\n                metallic,\n                ambientOcclusion,\n                lights12,\n                lights34,\n                lights56,\n                lights78,\n                enabledLights\n            );\n        \n            gl_FragColor = toSrgb(vec4(linearColor, baseColor.a), sceneProperties);\n        }\n    ',
	attributes: {},
	uniforms: {ambientOcclusionTexture: 'ae', baseColorTexture: 'bm', constantAmbientOcclusion: 'af', constantBaseColor: 'bn', constantMetallic: 'bq', constantRoughness: 'br', enabledLights: 't', lights12: 'cp', lights34: 'c6', lights56: 'c7', lights78: 'c8', metallicTexture: 'bC', normalMapTexture: 'ai', normalMapType: 'aj', roughnessTexture: 'bN', sceneProperties: 'e', viewMatrix: 'f'}
};
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$bumpyPhysicalMesh = function (useTextureOrColor) {
	return function (roughnessData) {
		return function (constantRoughness) {
			return function (metallicData) {
				return function (constantMetallic) {
					return function (ambientOcclusionData) {
						return function (constantAmbientOcclusion) {
							return function (normalMapData) {
								return function (normalMapType) {
									return function (bounds) {
										return function (webGLMesh) {
											return function (backFaceSetting) {
												if (!useTextureOrColor.$) {
													var baseColorData = useTextureOrColor.a;
													return A2(
														$ianmackenzie$elm_3d_scene$Scene3d$Types$OpaqueMeshNode,
														bounds,
														F8(
															function (sceneProperties, modelScale, modelMatrix, isRightHanded, viewMatrix, projectionMatrix, _v1, settings) {
																var lights = _v1.a;
																var enabledLights = _v1.b;
																return A5(
																	$elm_explorations$webgl$WebGL$entityWith,
																	A3($ianmackenzie$elm_3d_scene$Scene3d$Entity$meshSettings, isRightHanded, backFaceSetting, settings),
																	$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$bumpyVertex,
																	$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$physicalTexturesFragment,
																	webGLMesh,
																	{ae: ambientOcclusionData, bm: baseColorData, af: constantAmbientOcclusion, bn: $ianmackenzie$elm_3d_scene$Scene3d$Entity$zeroVec4, bq: constantMetallic, br: constantRoughness, t: enabledLights, cp: lights.cp, c6: lights.c6, c7: lights.c7, c8: lights.c8, bC: metallicData, b: modelMatrix, c: modelScale, ai: normalMapData, aj: normalMapType, d: projectionMatrix, bN: roughnessData, e: sceneProperties, f: viewMatrix});
															}));
												} else {
													var constantBaseColor = useTextureOrColor.a;
													var dummyTexture = useTextureOrColor.b;
													return A3(
														$ianmackenzie$elm_3d_scene$Scene3d$Entity$meshNode,
														constantBaseColor,
														bounds,
														F8(
															function (sceneProperties, modelScale, modelMatrix, isRightHanded, viewMatrix, projectionMatrix, _v2, settings) {
																var lights = _v2.a;
																var enabledLights = _v2.b;
																return A5(
																	$elm_explorations$webgl$WebGL$entityWith,
																	A3($ianmackenzie$elm_3d_scene$Scene3d$Entity$meshSettings, isRightHanded, backFaceSetting, settings),
																	$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$bumpyVertex,
																	$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$physicalTexturesFragment,
																	webGLMesh,
																	{
																		ae: ambientOcclusionData,
																		bm: dummyTexture,
																		af: constantAmbientOcclusion,
																		bn: $ianmackenzie$elm_3d_scene$Scene3d$Entity$premultiplyColor(constantBaseColor),
																		bq: constantMetallic,
																		br: constantRoughness,
																		t: enabledLights,
																		cp: lights.cp,
																		c6: lights.c6,
																		c7: lights.c7,
																		c8: lights.c8,
																		bC: metallicData,
																		b: modelMatrix,
																		c: modelScale,
																		ai: normalMapData,
																		aj: normalMapType,
																		d: projectionMatrix,
																		bN: roughnessData,
																		e: sceneProperties,
																		f: viewMatrix
																	});
															}));
												}
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$colorTextureFragment = {
	src: '\n        precision mediump float;\n        \n        uniform mediump sampler2D colorTexture;\n        \n        varying mediump vec2 interpolatedUv;\n        \n        void main () {\n            gl_FragColor = texture2D(colorTexture, interpolatedUv);\n        }\n    ',
	attributes: {},
	uniforms: {colorTexture: 'cT'}
};
var $ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$unlitVertex = {
	src: '\n        precision highp float;\n        \n        attribute highp vec3 position;\n        attribute mediump vec2 uv;\n        \n        uniform highp vec4 modelScale;\n        uniform highp mat4 modelMatrix;\n        uniform highp mat4 viewMatrix;\n        uniform highp mat4 projectionMatrix;\n        uniform highp mat4 sceneProperties;\n        \n        varying mediump vec2 interpolatedUv;\n        \n        vec4 getWorldPosition(vec3 modelPosition, vec4 modelScale, mat4 modelMatrix) {\n            vec4 scaledPosition = vec4(modelScale.xyz * modelPosition, 1.0);\n            return modelMatrix * scaledPosition;\n        }\n        \n        void main() {\n            vec4 worldPosition = getWorldPosition(position, modelScale, modelMatrix);\n            gl_Position = projectionMatrix * (viewMatrix * worldPosition);\n            interpolatedUv = uv;\n        }\n    ',
	attributes: {position: 'f9', uv: 'bZ'},
	uniforms: {modelMatrix: 'b', modelScale: 'c', projectionMatrix: 'd', sceneProperties: 'e', viewMatrix: 'f'}
};
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$colorTextureMesh = F4(
	function (data, bounds, webGLMesh, backFaceSetting) {
		return A2(
			$ianmackenzie$elm_3d_scene$Scene3d$Types$OpaqueMeshNode,
			bounds,
			F8(
				function (sceneProperties, modelScale, modelMatrix, isRightHanded, viewMatrix, projectionMatrix, lights, settings) {
					return A5(
						$elm_explorations$webgl$WebGL$entityWith,
						A3($ianmackenzie$elm_3d_scene$Scene3d$Entity$meshSettings, isRightHanded, backFaceSetting, settings),
						$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$unlitVertex,
						$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$colorTextureFragment,
						webGLMesh,
						{cT: data, b: modelMatrix, c: modelScale, d: projectionMatrix, e: sceneProperties, f: viewMatrix});
				}));
	});
var $ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$constantFragment = {
	src: '\n        precision lowp float;\n        \n        uniform lowp vec4 constantColor;\n        \n        void main () {\n            gl_FragColor = constantColor;\n        }\n    ',
	attributes: {},
	uniforms: {constantColor: 'bo'}
};
var $ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$plainVertex = {
	src: '\n        precision highp float;\n        \n        attribute highp vec3 position;\n        \n        uniform highp vec4 modelScale;\n        uniform highp mat4 modelMatrix;\n        uniform highp mat4 viewMatrix;\n        uniform highp mat4 projectionMatrix;\n        uniform highp mat4 sceneProperties;\n        \n        vec4 getWorldPosition(vec3 modelPosition, vec4 modelScale, mat4 modelMatrix) {\n            vec4 scaledPosition = vec4(modelScale.xyz * modelPosition, 1.0);\n            return modelMatrix * scaledPosition;\n        }\n        \n        void main () {\n            vec4 worldPosition = getWorldPosition(position, modelScale, modelMatrix);\n            gl_Position = projectionMatrix * (viewMatrix * worldPosition);\n        }\n    ',
	attributes: {position: 'f9'},
	uniforms: {modelMatrix: 'b', modelScale: 'c', projectionMatrix: 'd', sceneProperties: 'e', viewMatrix: 'f'}
};
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$constantMesh = F4(
	function (color, bounds, webGLMesh, backFaceSetting) {
		return A3(
			$ianmackenzie$elm_3d_scene$Scene3d$Entity$meshNode,
			color,
			bounds,
			F8(
				function (sceneProperties, modelScale, modelMatrix, isRightHanded, viewMatrix, projectionMatrix, lights, settings) {
					return A5(
						$elm_explorations$webgl$WebGL$entityWith,
						A3($ianmackenzie$elm_3d_scene$Scene3d$Entity$meshSettings, isRightHanded, backFaceSetting, settings),
						$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$plainVertex,
						$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$constantFragment,
						webGLMesh,
						{
							bo: $ianmackenzie$elm_3d_scene$Scene3d$Entity$premultiplyColor(color),
							b: modelMatrix,
							c: modelScale,
							d: projectionMatrix,
							e: sceneProperties,
							f: viewMatrix
						});
				}));
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Types$PointNode = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$constantPointFragment = {
	src: '\n        precision lowp float;\n        \n        uniform lowp vec4 constantColor;\n        uniform lowp float pointRadius;\n        uniform highp mat4 sceneProperties;\n        \n        float pointAlpha(float pointRadius, vec2 pointCoord) {\n            float pointSize = 2.0 * pointRadius;\n            float x = (pointSize + 2.0) * (pointCoord.s - 0.5);\n            float y = (pointSize + 2.0) * (pointCoord.t - 0.5);\n            float r = sqrt(x * x + y * y);\n            float innerRadius = pointRadius;\n            float outerRadius = pointRadius + 1.0;\n            if (r > outerRadius) {\n                return 0.0;\n            } else if (r > innerRadius) {\n                return outerRadius - r;\n            } else {\n                return 1.0;\n            }\n        }\n        \n        void main () {\n            float supersampling = sceneProperties[3][0];\n            float alpha = pointAlpha(pointRadius * supersampling, gl_PointCoord);\n            gl_FragColor = constantColor * alpha;\n        }\n    ',
	attributes: {},
	uniforms: {constantColor: 'bo', pointRadius: 'dq', sceneProperties: 'e'}
};
var $ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$pointVertex = {
	src: '\n        precision highp float;\n        \n        attribute highp vec3 position;\n        \n        uniform highp vec4 modelScale;\n        uniform highp mat4 modelMatrix;\n        uniform lowp float pointRadius;\n        uniform highp mat4 viewMatrix;\n        uniform highp mat4 projectionMatrix;\n        uniform highp mat4 sceneProperties;\n        \n        vec4 getWorldPosition(vec3 modelPosition, vec4 modelScale, mat4 modelMatrix) {\n            vec4 scaledPosition = vec4(modelScale.xyz * modelPosition, 1.0);\n            return modelMatrix * scaledPosition;\n        }\n        \n        void main () {\n            vec4 worldPosition = getWorldPosition(position, modelScale, modelMatrix);\n            gl_Position = projectionMatrix * (viewMatrix * worldPosition);\n            float supersampling = sceneProperties[3][0];\n            gl_PointSize = 2.0 * pointRadius * supersampling + 2.0;\n        }\n    ',
	attributes: {position: 'f9'},
	uniforms: {modelMatrix: 'b', modelScale: 'c', pointRadius: 'dq', projectionMatrix: 'd', sceneProperties: 'e', viewMatrix: 'f'}
};
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$constantPointMesh = F4(
	function (color, radius, bounds, webGLMesh) {
		return A2(
			$ianmackenzie$elm_3d_scene$Scene3d$Types$PointNode,
			bounds,
			F8(
				function (sceneProperties, modelScale, modelMatrix, isRightHanded, viewMatrix, projectionMatrix, lights, settings) {
					return A5(
						$elm_explorations$webgl$WebGL$entityWith,
						settings,
						$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$pointVertex,
						$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$constantPointFragment,
						webGLMesh,
						{
							bo: $ianmackenzie$elm_3d_scene$Scene3d$Entity$premultiplyColor(color),
							b: modelMatrix,
							c: modelScale,
							dq: radius,
							d: projectionMatrix,
							e: sceneProperties,
							f: viewMatrix
						});
				}));
	});
var $ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$emissiveFragment = {
	src: '\n        precision mediump float;\n        \n        uniform mediump vec4 emissiveColor;\n        uniform highp mat4 sceneProperties;\n        \n        float gammaCorrect(float u) {\n            if (u <= 0.0031308) {\n                return 12.92 * u;\n            } else {\n                return 1.055 * pow(u, 1.0 / 2.4) - 0.055;\n            }\n        }\n        \n        vec3 gammaCorrectedColor(vec3 color) {\n            float red = gammaCorrect(color.r);\n            float green = gammaCorrect(color.g);\n            float blue = gammaCorrect(color.b);\n            return vec3(red, green, blue);\n        }\n        \n        vec3 reinhardLuminanceToneMap(vec3 color) {\n            float luminance = 0.2126 * color.r + 0.7152 * color.g + 0.0722 * color.b;\n            float scale = 1.0 / (1.0 + luminance);\n            return gammaCorrectedColor(color * scale);\n        }\n        \n        vec3 reinhardPerChannelToneMap(vec3 color) {\n            return gammaCorrectedColor(color / (color + 1.0));\n        }\n        \n        float extendedReinhardToneMap(float x, float xMax) {\n            return x * (1.0 + (x / (xMax * xMax))) / (1.0 + x);\n        }\n        \n        vec3 extendedReinhardLuminanceToneMap(vec3 color, float overexposureLimit) {\n            float luminance = 0.2126 * color.r + 0.7152 * color.g + 0.0722 * color.b;\n            float scaledLuminance = extendedReinhardToneMap(luminance, overexposureLimit);\n            float scale = scaledLuminance / luminance;\n            return gammaCorrectedColor(color * scale);\n        }\n        \n        vec3 extendedReinhardPerChannelToneMap(vec3 color, float overexposureLimit) {\n            float red = extendedReinhardToneMap(color.r, overexposureLimit);\n            float green = extendedReinhardToneMap(color.g, overexposureLimit);\n            float blue = extendedReinhardToneMap(color.b, overexposureLimit);\n            return gammaCorrectedColor(vec3(red, green, blue));\n        }\n        \n        vec3 hableFilmicHelper(vec3 color) {\n            float a = 0.15;\n            float b = 0.5;\n            float c = 0.1;\n            float d = 0.2;\n            float e = 0.02;\n            float f = 0.3;\n            return (color * (a * color + c * b) + d * e) / (color * (a * color + b) + d * f) - e / f;\n        }\n        \n        vec3 hableFilmicToneMap(vec3 color) {\n            float exposureBias = 2.0;\n            vec3 unscaled = hableFilmicHelper(exposureBias * color);\n            vec3 scale = 1.0 / hableFilmicHelper(vec3(11.2));\n            return gammaCorrectedColor(scale * unscaled);\n        }\n        \n        vec3 toneMap(vec3 color, float toneMapType, float toneMapParam) {\n            if (toneMapType == 0.0) {\n                return gammaCorrectedColor(color);\n            } else if (toneMapType == 1.0) {\n                return reinhardLuminanceToneMap(color);\n            } else if (toneMapType == 2.0) {\n                return reinhardPerChannelToneMap(color);\n            } else if (toneMapType == 3.0) {\n                return extendedReinhardLuminanceToneMap(color, toneMapParam);\n            } else if (toneMapType == 4.0) {\n                return extendedReinhardPerChannelToneMap(color, toneMapParam);\n            } else if (toneMapType == 5.0) {\n                return hableFilmicToneMap(color);\n            } else {\n                return vec3(0.0, 0.0, 0.0);\n            }\n        }\n        \n        float inverseAlpha(float value) {\n            // the value used for alpha cannot be less than zero\n            float signValue = float(sign(value));\n            return signValue / (value + (signValue - 1.0));\n        }\n        \n        vec4 toSrgb(vec4 linearColor, mat4 sceneProperties) {\n            vec3 referenceWhite = sceneProperties[2].rgb;\n            // linearColor has premultiplied alpha, but tone mapping works on\n            // non-premultiplied linear RGB so we need to temporarily \'undo\' the\n            // premultiplication before applying tone mapping\n            float invAlpha = inverseAlpha(linearColor.a);\n            float unitR = (linearColor.r * invAlpha) / referenceWhite.r;\n            float unitG = (linearColor.g * invAlpha) / referenceWhite.g;\n            float unitB = (linearColor.b * invAlpha) / referenceWhite.b;\n            float toneMapType = sceneProperties[3][2];\n            float toneMapParam = sceneProperties[3][3];\n            // Apply tone mapping\n            vec3 toneMapped = toneMap(vec3(unitR, unitG, unitB), toneMapType, toneMapParam);\n            // Re-apply premultiplied alpha after tone mapping\n            return vec4(toneMapped * linearColor.a, linearColor.a);\n        }\n        \n        void main () {\n            gl_FragColor = toSrgb(emissiveColor, sceneProperties);\n        }\n    ',
	attributes: {},
	uniforms: {emissiveColor: 'bt', sceneProperties: 'e'}
};
var $ianmackenzie$elm_units$Luminance$inNits = function (_v0) {
	var numNits = _v0;
	return numNits;
};
var $elm_explorations$linear_algebra$Math$Vector4$scale = _MJS_v4scale;
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$emissiveMesh = F5(
	function (color, backlight, bounds, webGLMesh, backFaceSetting) {
		return A2(
			$ianmackenzie$elm_3d_scene$Scene3d$Types$OpaqueMeshNode,
			bounds,
			F8(
				function (sceneProperties, modelScale, modelMatrix, isRightHanded, viewMatrix, projectionMatrix, lights, settings) {
					return A5(
						$elm_explorations$webgl$WebGL$entityWith,
						A3($ianmackenzie$elm_3d_scene$Scene3d$Entity$meshSettings, isRightHanded, backFaceSetting, settings),
						$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$plainVertex,
						$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$emissiveFragment,
						webGLMesh,
						{
							bt: A2(
								$elm_explorations$linear_algebra$Math$Vector4$scale,
								$ianmackenzie$elm_units$Luminance$inNits(backlight),
								color),
							b: modelMatrix,
							c: modelScale,
							d: projectionMatrix,
							e: sceneProperties,
							f: viewMatrix
						});
				}));
	});
var $ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$emissivePointFragment = {
	src: '\n        precision mediump float;\n        \n        uniform mediump vec4 emissiveColor;\n        uniform lowp float pointRadius;\n        uniform highp mat4 sceneProperties;\n        \n        float gammaCorrect(float u) {\n            if (u <= 0.0031308) {\n                return 12.92 * u;\n            } else {\n                return 1.055 * pow(u, 1.0 / 2.4) - 0.055;\n            }\n        }\n        \n        vec3 gammaCorrectedColor(vec3 color) {\n            float red = gammaCorrect(color.r);\n            float green = gammaCorrect(color.g);\n            float blue = gammaCorrect(color.b);\n            return vec3(red, green, blue);\n        }\n        \n        vec3 reinhardLuminanceToneMap(vec3 color) {\n            float luminance = 0.2126 * color.r + 0.7152 * color.g + 0.0722 * color.b;\n            float scale = 1.0 / (1.0 + luminance);\n            return gammaCorrectedColor(color * scale);\n        }\n        \n        vec3 reinhardPerChannelToneMap(vec3 color) {\n            return gammaCorrectedColor(color / (color + 1.0));\n        }\n        \n        float extendedReinhardToneMap(float x, float xMax) {\n            return x * (1.0 + (x / (xMax * xMax))) / (1.0 + x);\n        }\n        \n        vec3 extendedReinhardLuminanceToneMap(vec3 color, float overexposureLimit) {\n            float luminance = 0.2126 * color.r + 0.7152 * color.g + 0.0722 * color.b;\n            float scaledLuminance = extendedReinhardToneMap(luminance, overexposureLimit);\n            float scale = scaledLuminance / luminance;\n            return gammaCorrectedColor(color * scale);\n        }\n        \n        vec3 extendedReinhardPerChannelToneMap(vec3 color, float overexposureLimit) {\n            float red = extendedReinhardToneMap(color.r, overexposureLimit);\n            float green = extendedReinhardToneMap(color.g, overexposureLimit);\n            float blue = extendedReinhardToneMap(color.b, overexposureLimit);\n            return gammaCorrectedColor(vec3(red, green, blue));\n        }\n        \n        vec3 hableFilmicHelper(vec3 color) {\n            float a = 0.15;\n            float b = 0.5;\n            float c = 0.1;\n            float d = 0.2;\n            float e = 0.02;\n            float f = 0.3;\n            return (color * (a * color + c * b) + d * e) / (color * (a * color + b) + d * f) - e / f;\n        }\n        \n        vec3 hableFilmicToneMap(vec3 color) {\n            float exposureBias = 2.0;\n            vec3 unscaled = hableFilmicHelper(exposureBias * color);\n            vec3 scale = 1.0 / hableFilmicHelper(vec3(11.2));\n            return gammaCorrectedColor(scale * unscaled);\n        }\n        \n        vec3 toneMap(vec3 color, float toneMapType, float toneMapParam) {\n            if (toneMapType == 0.0) {\n                return gammaCorrectedColor(color);\n            } else if (toneMapType == 1.0) {\n                return reinhardLuminanceToneMap(color);\n            } else if (toneMapType == 2.0) {\n                return reinhardPerChannelToneMap(color);\n            } else if (toneMapType == 3.0) {\n                return extendedReinhardLuminanceToneMap(color, toneMapParam);\n            } else if (toneMapType == 4.0) {\n                return extendedReinhardPerChannelToneMap(color, toneMapParam);\n            } else if (toneMapType == 5.0) {\n                return hableFilmicToneMap(color);\n            } else {\n                return vec3(0.0, 0.0, 0.0);\n            }\n        }\n        \n        float inverseAlpha(float value) {\n            // the value used for alpha cannot be less than zero\n            float signValue = float(sign(value));\n            return signValue / (value + (signValue - 1.0));\n        }\n        \n        vec4 toSrgb(vec4 linearColor, mat4 sceneProperties) {\n            vec3 referenceWhite = sceneProperties[2].rgb;\n            // linearColor has premultiplied alpha, but tone mapping works on\n            // non-premultiplied linear RGB so we need to temporarily \'undo\' the\n            // premultiplication before applying tone mapping\n            float invAlpha = inverseAlpha(linearColor.a);\n            float unitR = (linearColor.r * invAlpha) / referenceWhite.r;\n            float unitG = (linearColor.g * invAlpha) / referenceWhite.g;\n            float unitB = (linearColor.b * invAlpha) / referenceWhite.b;\n            float toneMapType = sceneProperties[3][2];\n            float toneMapParam = sceneProperties[3][3];\n            // Apply tone mapping\n            vec3 toneMapped = toneMap(vec3(unitR, unitG, unitB), toneMapType, toneMapParam);\n            // Re-apply premultiplied alpha after tone mapping\n            return vec4(toneMapped * linearColor.a, linearColor.a);\n        }\n        \n        float pointAlpha(float pointRadius, vec2 pointCoord) {\n            float pointSize = 2.0 * pointRadius;\n            float x = (pointSize + 2.0) * (pointCoord.s - 0.5);\n            float y = (pointSize + 2.0) * (pointCoord.t - 0.5);\n            float r = sqrt(x * x + y * y);\n            float innerRadius = pointRadius;\n            float outerRadius = pointRadius + 1.0;\n            if (r > outerRadius) {\n                return 0.0;\n            } else if (r > innerRadius) {\n                return outerRadius - r;\n            } else {\n                return 1.0;\n            }\n        }\n        \n        void main () {\n            vec4 color = toSrgb(emissiveColor, sceneProperties);\n            float supersampling = sceneProperties[3][0];\n            float alpha = pointAlpha(pointRadius * supersampling, gl_PointCoord);\n            gl_FragColor = color * alpha;\n        }\n    ',
	attributes: {},
	uniforms: {emissiveColor: 'bt', pointRadius: 'dq', sceneProperties: 'e'}
};
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$emissivePointMesh = F5(
	function (color, backlight, radius, bounds, webGLMesh) {
		return A2(
			$ianmackenzie$elm_3d_scene$Scene3d$Types$PointNode,
			bounds,
			F8(
				function (sceneProperties, modelScale, modelMatrix, isRightHanded, viewMatrix, projectionMatrix, lights, settings) {
					return A5(
						$elm_explorations$webgl$WebGL$entityWith,
						settings,
						$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$pointVertex,
						$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$emissivePointFragment,
						webGLMesh,
						{
							bt: A2(
								$elm_explorations$linear_algebra$Math$Vector4$scale,
								$ianmackenzie$elm_units$Luminance$inNits(backlight),
								color),
							b: modelMatrix,
							c: modelScale,
							dq: radius,
							d: projectionMatrix,
							e: sceneProperties,
							f: viewMatrix
						});
				}));
	});
var $ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$lambertianFragment = {
	src: '\n        precision highp float;\n        \n        uniform highp mat4 sceneProperties;\n        uniform highp mat4 lights12;\n        uniform highp mat4 lights34;\n        uniform highp mat4 lights56;\n        uniform highp mat4 lights78;\n        uniform lowp vec4 enabledLights;\n        uniform lowp vec4 materialColor;\n        uniform lowp float ambientOcclusion;\n        uniform highp mat4 viewMatrix;\n        \n        varying highp vec3 interpolatedPosition;\n        varying highp vec3 interpolatedNormal;\n        \n        const lowp float kPerspectiveProjection = 0.0;\n        const lowp float kOrthographicProjection = 1.0;\n        const lowp float kDirectionalLight = 1.0;\n        const lowp float kPointLight = 2.0;\n        const highp float kPi = 3.14159265359;\n        const lowp float kDisabledLight = 0.0;\n        const lowp float kSoftLighting = 3.0;\n        \n        float getNormalSign() {\n            return 2.0 * float(gl_FrontFacing) - 1.0;\n        }\n        \n        vec3 getDirectionToCamera(vec3 surfacePosition, mat4 sceneProperties) {\n            float projectionType = sceneProperties[1].w;\n            if (projectionType == kPerspectiveProjection) {\n                vec3 cameraPoint = sceneProperties[1].xyz;\n                return normalize(cameraPoint - surfacePosition);\n            } else if (projectionType == kOrthographicProjection) {\n                return sceneProperties[1].xyz;\n            } else {\n                return vec3(0.0, 0.0, 0.0);\n            }\n        }\n        \n        void getDirectionToLightAndNormalIlluminance(\n            vec4 xyz_type,\n            vec4 rgb_parameter,\n            vec3 surfacePosition,\n            out vec3 directionToLight,\n            out vec3 normalIlluminance\n        ) {\n            float lightType = xyz_type.w;\n            if (lightType == kDirectionalLight) {\n                directionToLight = xyz_type.xyz;\n                normalIlluminance = rgb_parameter.rgb;\n            } else if (lightType == kPointLight) {\n                vec3 lightPosition = xyz_type.xyz;\n                vec3 displacement = lightPosition - surfacePosition;\n                float distance = length(displacement);\n                directionToLight = displacement / distance;\n                normalIlluminance = rgb_parameter.rgb / (4.0 * kPi * distance * distance);\n            }\n        }\n        \n        float positiveDotProduct(vec3 v1, vec3 v2) {\n            return clamp(dot(v1, v2), 0.0, 1.0);\n        }\n        \n        vec3 softLightingLuminance(\n            vec3 aboveLuminance,\n            vec3 belowLuminance,\n            vec3 localUpDirection,\n            vec3 localLightDirection\n        ) {\n            float sinElevation = dot(localLightDirection, localUpDirection);\n            float t = (sinElevation + 1.0) / 2.0;\n            return aboveLuminance * t + belowLuminance * (1.0 - t);\n        }\n        \n        vec3 lambertianLight(\n            vec3 surfacePosition,\n            vec3 surfaceNormal,\n            vec3 materialColor,\n            float ambientOcclusion,\n            vec4 xyz_type,\n            vec4 rgb_parameter\n        ) {\n            float lightType = xyz_type.w;\n            if (lightType == kDisabledLight) {\n                return vec3(0.0, 0.0, 0.0);\n            } else if (lightType == kSoftLighting) {\n                vec3 upDirection = xyz_type.xyz;\n                vec3 aboveLuminance = rgb_parameter.rgb;\n                vec3 belowLuminance = rgb_parameter.a * aboveLuminance;\n                vec3 luminance = softLightingLuminance(aboveLuminance, belowLuminance, upDirection, surfaceNormal);\n                return luminance * materialColor * ambientOcclusion;\n            }\n        \n            vec3 directionToLight = vec3(0.0, 0.0, 0.0);\n            vec3 normalIlluminance = vec3(0.0, 0.0, 0.0);\n            getDirectionToLightAndNormalIlluminance(\n                xyz_type,\n                rgb_parameter,\n                surfacePosition,\n                directionToLight,\n                normalIlluminance\n            );\n        \n            float dotNL = positiveDotProduct(directionToLight, surfaceNormal);\n            return (normalIlluminance * dotNL) * (materialColor / kPi);\n        }\n        \n        vec3 lambertianLighting(\n            vec3 surfacePosition,\n            vec3 surfaceNormal,\n            vec3 materialColor,\n            float ambientOcclusion,\n            mat4 lights12,\n            mat4 lights34,\n            mat4 lights56,\n            mat4 lights78,\n            vec4 enabledLights\n        ) {\n            vec3 litColor1 = enabledLights[0] == 1.0 ? lambertianLight(surfacePosition, surfaceNormal, materialColor, ambientOcclusion, lights12[0], lights12[1]) : vec3(0.0, 0.0, 0.0);\n            vec3 litColor2 = enabledLights[1] == 1.0 ? lambertianLight(surfacePosition, surfaceNormal, materialColor, ambientOcclusion, lights12[2], lights12[3]) : vec3(0.0, 0.0, 0.0);\n            vec3 litColor3 = enabledLights[2] == 1.0 ? lambertianLight(surfacePosition, surfaceNormal, materialColor, ambientOcclusion, lights34[0], lights34[1]) : vec3(0.0, 0.0, 0.0);\n            vec3 litColor4 = enabledLights[3] == 1.0 ? lambertianLight(surfacePosition, surfaceNormal, materialColor, ambientOcclusion, lights34[2], lights34[3]) : vec3(0.0, 0.0, 0.0);\n            vec3 litColor5 = lambertianLight(surfacePosition, surfaceNormal, materialColor, ambientOcclusion, lights56[0], lights56[1]);\n            vec3 litColor6 = lambertianLight(surfacePosition, surfaceNormal, materialColor, ambientOcclusion, lights56[2], lights56[3]);\n            vec3 litColor7 = lambertianLight(surfacePosition, surfaceNormal, materialColor, ambientOcclusion, lights78[0], lights78[1]);\n            vec3 litColor8 = lambertianLight(surfacePosition, surfaceNormal, materialColor, ambientOcclusion, lights78[2], lights78[3]);\n            return litColor1 + litColor2 + litColor3 + litColor4 + litColor5 + litColor6 + litColor7 + litColor8;\n        }\n        \n        float gammaCorrect(float u) {\n            if (u <= 0.0031308) {\n                return 12.92 * u;\n            } else {\n                return 1.055 * pow(u, 1.0 / 2.4) - 0.055;\n            }\n        }\n        \n        vec3 gammaCorrectedColor(vec3 color) {\n            float red = gammaCorrect(color.r);\n            float green = gammaCorrect(color.g);\n            float blue = gammaCorrect(color.b);\n            return vec3(red, green, blue);\n        }\n        \n        vec3 reinhardLuminanceToneMap(vec3 color) {\n            float luminance = 0.2126 * color.r + 0.7152 * color.g + 0.0722 * color.b;\n            float scale = 1.0 / (1.0 + luminance);\n            return gammaCorrectedColor(color * scale);\n        }\n        \n        vec3 reinhardPerChannelToneMap(vec3 color) {\n            return gammaCorrectedColor(color / (color + 1.0));\n        }\n        \n        float extendedReinhardToneMap(float x, float xMax) {\n            return x * (1.0 + (x / (xMax * xMax))) / (1.0 + x);\n        }\n        \n        vec3 extendedReinhardLuminanceToneMap(vec3 color, float overexposureLimit) {\n            float luminance = 0.2126 * color.r + 0.7152 * color.g + 0.0722 * color.b;\n            float scaledLuminance = extendedReinhardToneMap(luminance, overexposureLimit);\n            float scale = scaledLuminance / luminance;\n            return gammaCorrectedColor(color * scale);\n        }\n        \n        vec3 extendedReinhardPerChannelToneMap(vec3 color, float overexposureLimit) {\n            float red = extendedReinhardToneMap(color.r, overexposureLimit);\n            float green = extendedReinhardToneMap(color.g, overexposureLimit);\n            float blue = extendedReinhardToneMap(color.b, overexposureLimit);\n            return gammaCorrectedColor(vec3(red, green, blue));\n        }\n        \n        vec3 hableFilmicHelper(vec3 color) {\n            float a = 0.15;\n            float b = 0.5;\n            float c = 0.1;\n            float d = 0.2;\n            float e = 0.02;\n            float f = 0.3;\n            return (color * (a * color + c * b) + d * e) / (color * (a * color + b) + d * f) - e / f;\n        }\n        \n        vec3 hableFilmicToneMap(vec3 color) {\n            float exposureBias = 2.0;\n            vec3 unscaled = hableFilmicHelper(exposureBias * color);\n            vec3 scale = 1.0 / hableFilmicHelper(vec3(11.2));\n            return gammaCorrectedColor(scale * unscaled);\n        }\n        \n        vec3 toneMap(vec3 color, float toneMapType, float toneMapParam) {\n            if (toneMapType == 0.0) {\n                return gammaCorrectedColor(color);\n            } else if (toneMapType == 1.0) {\n                return reinhardLuminanceToneMap(color);\n            } else if (toneMapType == 2.0) {\n                return reinhardPerChannelToneMap(color);\n            } else if (toneMapType == 3.0) {\n                return extendedReinhardLuminanceToneMap(color, toneMapParam);\n            } else if (toneMapType == 4.0) {\n                return extendedReinhardPerChannelToneMap(color, toneMapParam);\n            } else if (toneMapType == 5.0) {\n                return hableFilmicToneMap(color);\n            } else {\n                return vec3(0.0, 0.0, 0.0);\n            }\n        }\n        \n        float inverseAlpha(float value) {\n            // the value used for alpha cannot be less than zero\n            float signValue = float(sign(value));\n            return signValue / (value + (signValue - 1.0));\n        }\n        \n        vec4 toSrgb(vec4 linearColor, mat4 sceneProperties) {\n            vec3 referenceWhite = sceneProperties[2].rgb;\n            // linearColor has premultiplied alpha, but tone mapping works on\n            // non-premultiplied linear RGB so we need to temporarily \'undo\' the\n            // premultiplication before applying tone mapping\n            float invAlpha = inverseAlpha(linearColor.a);\n            float unitR = (linearColor.r * invAlpha) / referenceWhite.r;\n            float unitG = (linearColor.g * invAlpha) / referenceWhite.g;\n            float unitB = (linearColor.b * invAlpha) / referenceWhite.b;\n            float toneMapType = sceneProperties[3][2];\n            float toneMapParam = sceneProperties[3][3];\n            // Apply tone mapping\n            vec3 toneMapped = toneMap(vec3(unitR, unitG, unitB), toneMapType, toneMapParam);\n            // Re-apply premultiplied alpha after tone mapping\n            return vec4(toneMapped * linearColor.a, linearColor.a);\n        }\n        \n        void main() {\n            vec3 normalDirection = normalize(interpolatedNormal) * getNormalSign();\n            vec3 directionToCamera = getDirectionToCamera(interpolatedPosition, sceneProperties);\n        \n            vec3 linearColor = lambertianLighting(\n                interpolatedPosition,\n                normalDirection,\n                materialColor.rgb,\n                ambientOcclusion,\n                lights12,\n                lights34,\n                lights56,\n                lights78,\n                enabledLights\n            );\n        \n            gl_FragColor = toSrgb(vec4(linearColor, materialColor.a), sceneProperties);\n        }\n    ',
	attributes: {},
	uniforms: {ambientOcclusion: 'gK', enabledLights: 't', lights12: 'cp', lights34: 'c6', lights56: 'c7', lights78: 'c8', materialColor: 'd2', sceneProperties: 'e', viewMatrix: 'f'}
};
var $ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$uniformVertex = {
	src: '\n        precision highp float;\n        \n        attribute highp vec3 position;\n        attribute highp vec3 normal;\n        \n        uniform highp vec4 modelScale;\n        uniform highp mat4 modelMatrix;\n        uniform highp mat4 viewMatrix;\n        uniform highp mat4 projectionMatrix;\n        uniform highp mat4 sceneProperties;\n        \n        varying highp vec3 interpolatedPosition;\n        varying highp vec3 interpolatedNormal;\n        \n        vec4 getWorldPosition(vec3 modelPosition, vec4 modelScale, mat4 modelMatrix) {\n            vec4 scaledPosition = vec4(modelScale.xyz * modelPosition, 1.0);\n            return modelMatrix * scaledPosition;\n        }\n        \n        vec3 safeNormalize(vec3 vector) {\n            if (vector == vec3(0.0, 0.0, 0.0)) {\n                return vector;\n            } else {\n                return normalize(vector);\n            }\n        }\n        \n        vec3 getWorldNormal(vec3 modelNormal, vec4 modelScale, mat4 modelMatrix) {\n            vec3 normalScale = vec3(modelScale.w / modelScale.x, modelScale.w / modelScale.y, modelScale.w / modelScale.z);\n            return (modelMatrix * vec4(safeNormalize(normalScale * modelNormal), 0.0)).xyz;\n        }\n        \n        void main () {\n            vec4 worldPosition = getWorldPosition(position, modelScale, modelMatrix);\n            gl_Position = projectionMatrix * (viewMatrix * worldPosition);\n            interpolatedPosition = worldPosition.xyz;\n            interpolatedNormal = getWorldNormal(normal, modelScale, modelMatrix);\n        }\n    ',
	attributes: {normal: 'aS', position: 'f9'},
	uniforms: {modelMatrix: 'b', modelScale: 'c', projectionMatrix: 'd', sceneProperties: 'e', viewMatrix: 'f'}
};
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$lambertianMesh = F5(
	function (color, ambientOcclusion, bounds, webGLMesh, backFaceSetting) {
		return A3(
			$ianmackenzie$elm_3d_scene$Scene3d$Entity$meshNode,
			color,
			bounds,
			F8(
				function (sceneProperties, modelScale, modelMatrix, isRightHanded, viewMatrix, projectionMatrix, _v0, settings) {
					var lights = _v0.a;
					var enabledLights = _v0.b;
					return A5(
						$elm_explorations$webgl$WebGL$entityWith,
						A3($ianmackenzie$elm_3d_scene$Scene3d$Entity$meshSettings, isRightHanded, backFaceSetting, settings),
						$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$uniformVertex,
						$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$lambertianFragment,
						webGLMesh,
						{
							gK: ambientOcclusion,
							t: enabledLights,
							cp: lights.cp,
							c6: lights.c6,
							c7: lights.c7,
							c8: lights.c8,
							d2: $ianmackenzie$elm_3d_scene$Scene3d$Entity$premultiplyColor(color),
							b: modelMatrix,
							c: modelScale,
							d: projectionMatrix,
							e: sceneProperties,
							f: viewMatrix
						});
				}));
	});
var $ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$physicalFragment = {
	src: '\n        precision highp float;\n        \n        uniform highp mat4 sceneProperties;\n        uniform highp mat4 viewMatrix;\n        uniform highp mat4 lights12;\n        uniform highp mat4 lights34;\n        uniform highp mat4 lights56;\n        uniform highp mat4 lights78;\n        uniform lowp vec4 enabledLights;\n        uniform lowp vec4 baseColor;\n        uniform lowp float roughness;\n        uniform lowp float metallic;\n        uniform lowp float ambientOcclusion;\n        \n        varying highp vec3 interpolatedPosition;\n        varying highp vec3 interpolatedNormal;\n        \n        const lowp float kPerspectiveProjection = 0.0;\n        const lowp float kOrthographicProjection = 1.0;\n        const lowp float kDirectionalLight = 1.0;\n        const lowp float kPointLight = 2.0;\n        const highp float kPi = 3.14159265359;\n        const mediump float kMediumpFloatMax = 65504.0;\n        const lowp float kDisabledLight = 0.0;\n        const lowp float kSoftLighting = 3.0;\n        \n        float getNormalSign() {\n            return 2.0 * float(gl_FrontFacing) - 1.0;\n        }\n        \n        vec3 getDirectionToCamera(vec3 surfacePosition, mat4 sceneProperties) {\n            float projectionType = sceneProperties[1].w;\n            if (projectionType == kPerspectiveProjection) {\n                vec3 cameraPoint = sceneProperties[1].xyz;\n                return normalize(cameraPoint - surfacePosition);\n            } else if (projectionType == kOrthographicProjection) {\n                return sceneProperties[1].xyz;\n            } else {\n                return vec3(0.0, 0.0, 0.0);\n            }\n        }\n        \n        void getDirectionToLightAndNormalIlluminance(\n            vec4 xyz_type,\n            vec4 rgb_parameter,\n            vec3 surfacePosition,\n            out vec3 directionToLight,\n            out vec3 normalIlluminance\n        ) {\n            float lightType = xyz_type.w;\n            if (lightType == kDirectionalLight) {\n                directionToLight = xyz_type.xyz;\n                normalIlluminance = rgb_parameter.rgb;\n            } else if (lightType == kPointLight) {\n                vec3 lightPosition = xyz_type.xyz;\n                vec3 displacement = lightPosition - surfacePosition;\n                float distance = length(displacement);\n                directionToLight = displacement / distance;\n                normalIlluminance = rgb_parameter.rgb / (4.0 * kPi * distance * distance);\n            }\n        }\n        \n        float positiveDotProduct(vec3 v1, vec3 v2) {\n            return clamp(dot(v1, v2), 0.0, 1.0);\n        }\n        \n        // Adapted from https://google.github.io/filament/Filament.md.html#materialsystem/specularbrdf/normaldistributionfunction(speculard)\n        float specularD(float alpha, float dotNH, vec3 normalDirection, vec3 halfDirection) {\n            vec3 crossNH = cross(normalDirection, halfDirection);\n            float a = dotNH * alpha;\n            float k = alpha / (dot(crossNH, crossNH) + a * a);\n            float d = k * k * (1.0 / kPi);\n            return min(d, kMediumpFloatMax);\n        }\n        \n        float safeQuotient(float numerator, float denominator) {\n            if (denominator == 0.0) {\n                return 0.0;\n            } else {\n                return numerator / denominator;\n            }\n        }\n        \n        float g1(float dotNV, float alphaSquared) {\n            return safeQuotient(2.0 * dotNV, dotNV + sqrt(alphaSquared + (1.0 - alphaSquared) * dotNV * dotNV));\n        }\n        \n        float specularG(float dotNL, float dotNV, float alphaSquared) {\n            return g1(dotNV, alphaSquared) * g1(dotNL, alphaSquared);\n        }\n        \n        vec3 fresnelColor(vec3 specularBaseColor, float dotVH) {\n            vec3 one = vec3(1.0, 1.0, 1.0);\n            float scale = exp2((-5.55473 * dotVH - 6.98316) * dotVH);\n            return specularBaseColor + (one - specularBaseColor) * scale;\n        }\n        \n        vec3 brdf(vec3 normalDirection, vec3 directionToCamera, vec3 directionToLight, float alpha, float dotNV, float dotNL, vec3 specularBaseColor, vec3 normalIlluminance) {\n            vec3 halfDirection = normalize(directionToCamera + directionToLight);\n            float dotVH = positiveDotProduct(directionToCamera, halfDirection);\n            float dotNH = positiveDotProduct(normalDirection, halfDirection);\n            float dotNHSquared = dotNH * dotNH;\n        \n            float d = specularD(alpha, dotNH, normalDirection, halfDirection);\n            float g = specularG(dotNL, dotNV, alpha * alpha);\n            vec3 f = fresnelColor(specularBaseColor, dotVH);\n            return safeQuotient(d * g, 4.0 * dotNL * dotNV) * f;\n        }\n        \n        vec3 sampleFacetNormal(vec3 vH, vec3 vT1, vec3 vT2, float s, float alpha) {\n            float t2 = (1.0 - s);\n            vec3 vNh = t2 * vT2 + sqrt(max(0.0, 1.0 - t2 * t2)) * vH;\n            return normalize(vec3(alpha * vNh.x, alpha * vNh.y, max(0.0, vNh.z)));\n        }\n        \n        vec3 softLightingLuminance(\n            vec3 aboveLuminance,\n            vec3 belowLuminance,\n            vec3 localUpDirection,\n            vec3 localLightDirection\n        ) {\n            float sinElevation = dot(localLightDirection, localUpDirection);\n            float t = (sinElevation + 1.0) / 2.0;\n            return aboveLuminance * t + belowLuminance * (1.0 - t);\n        }\n        \n        vec3 softLightingSpecularSample(\n            vec3 aboveLuminance,\n            vec3 belowLuminance,\n            vec3 localUpDirection,\n            vec3 localViewDirection,\n            vec3 localLightDirection,\n            vec3 localHalfDirection,\n            float alphaSquared,\n            vec3 specularBaseColor\n        ) {\n            vec3 luminance = softLightingLuminance(aboveLuminance, belowLuminance, localUpDirection, localLightDirection);\n            float dotVH = positiveDotProduct(localViewDirection, localHalfDirection);\n            float dotNL = localLightDirection.z;\n            return luminance * (fresnelColor(specularBaseColor, dotVH) * g1(dotNL, alphaSquared));\n        }\n        \n        vec3 softLighting(\n            vec3 normalDirection,\n            vec3 diffuseBaseColor,\n            vec3 specularBaseColor,\n            float alpha,\n            vec3 directionToCamera,\n            vec3 viewY,\n            vec4 xyz_type,\n            vec4 rgb_parameter\n        ) {\n            float alphaSquared = alpha * alpha;\n            vec3 upDirection = xyz_type.xyz;\n            vec3 luminanceAbove = rgb_parameter.rgb;\n            vec3 luminanceBelow = rgb_parameter.a * luminanceAbove;\n            vec3 crossProduct = cross(normalDirection, directionToCamera);\n            float crossMagnitude = length(crossProduct);\n            vec3 xDirection = vec3(0.0, 0.0, 0.0);\n            vec3 yDirection = vec3(0.0, 0.0, 0.0);\n            if (crossMagnitude > 1.0e-6) {\n                yDirection = (1.0 / crossMagnitude) * crossProduct;\n                xDirection = cross(yDirection, normalDirection);\n            } else {\n                vec3 viewY = vec3(viewMatrix[0][1], viewMatrix[1][1], viewMatrix[2][1]);\n                xDirection = normalize(cross(viewY, normalDirection));\n                yDirection = cross(normalDirection, xDirection);\n            }\n            float localViewX = dot(directionToCamera, xDirection);\n            float localViewZ = dot(directionToCamera, normalDirection);\n            vec3 localViewDirection = vec3(localViewX, 0, localViewZ);\n            float localUpX = dot(upDirection, xDirection);\n            float localUpY = dot(upDirection, yDirection);\n            float localUpZ = dot(upDirection, normalDirection);\n            vec3 localUpDirection = vec3(localUpX, localUpY, localUpZ);\n        \n            vec3 vH = normalize(vec3(alpha * localViewX, 0.0, localViewZ));\n            vec3 vT1 = vec3(0.0, 1.0, 0.0);\n            vec3 vT2 = cross(vH, vT1);\n            float s = 0.5 * (1.0 + vH.z);\n        \n            vec3 localHalfDirection = sampleFacetNormal(vH, vT1, vT2, s, alpha);\n            vec3 localLightDirection = vec3(0.0, 0.0, 0.0);\n        \n            localLightDirection = -reflect(localViewDirection, localHalfDirection);\n            vec3 specular = softLightingSpecularSample(luminanceAbove, luminanceBelow, localUpDirection, localViewDirection, localLightDirection, localHalfDirection, alphaSquared, specularBaseColor);\n        \n            localLightDirection = vec3(0.000000, 0.000000, 1.000000);\n            vec3 diffuse = softLightingLuminance(luminanceAbove, luminanceBelow, localUpDirection, localLightDirection) * localLightDirection.z;\n        \n            return specular + diffuse * diffuseBaseColor;\n        }\n        \n        vec3 physicalLight(\n            vec4 xyz_type,\n            vec4 rgb_parameter,\n            vec3 surfacePosition,\n            vec3 normalDirection,\n            vec3 directionToCamera,\n            vec3 viewY,\n            float dotNV,\n            vec3 diffuseBaseColor,\n            vec3 specularBaseColor,\n            float alpha,\n            float ambientOcclusion\n        ) {\n            float lightType = xyz_type.w;\n            if (lightType == kDisabledLight) {\n                return vec3(0.0, 0.0, 0.0);\n            } else if (lightType == kSoftLighting) {\n                return softLighting(normalDirection, diffuseBaseColor, specularBaseColor, alpha, directionToCamera, viewY, xyz_type, rgb_parameter) * ambientOcclusion;\n            }\n        \n            vec3 directionToLight = vec3(0.0, 0.0, 0.0);\n            vec3 normalIlluminance = vec3(0.0, 0.0, 0.0);\n            getDirectionToLightAndNormalIlluminance(xyz_type, rgb_parameter, surfacePosition, directionToLight, normalIlluminance);\n        \n            float dotNL = positiveDotProduct(normalDirection, directionToLight);\n            vec3 specularColor = brdf(normalDirection, directionToCamera, directionToLight, alpha, dotNV, dotNL, specularBaseColor, normalIlluminance);\n            return (normalIlluminance * dotNL) * ((diffuseBaseColor / kPi) + specularColor);\n        }\n        \n        vec3 physicalLighting(\n            vec3 surfacePosition,\n            vec3 surfaceNormal,\n            vec3 baseColor,\n            vec3 directionToCamera,\n            mat4 viewMatrix,\n            float roughness,\n            float metallic,\n            float ambientOcclusion,\n            mat4 lights12,\n            mat4 lights34,\n            mat4 lights56,\n            mat4 lights78,\n            vec4 enabledLights\n        ) {\n            float dotNV = positiveDotProduct(surfaceNormal, directionToCamera);\n            float alpha = roughness * roughness;\n            float nonmetallic = 1.0 - metallic;\n            vec3 diffuseBaseColor = nonmetallic * 0.96 * baseColor;\n            vec3 specularBaseColor = nonmetallic * 0.04 * vec3(1.0, 1.0, 1.0) + metallic * baseColor;\n            vec3 viewY = vec3(viewMatrix[0][1], viewMatrix[1][1], viewMatrix[2][1]);\n        \n            vec3 litColor1 = enabledLights[0] == 1.0 ? physicalLight(lights12[0], lights12[1], surfacePosition, surfaceNormal, directionToCamera, viewY, dotNV, diffuseBaseColor, specularBaseColor, alpha, ambientOcclusion) : vec3(0.0, 0.0, 0.0);\n            vec3 litColor2 = enabledLights[1] == 1.0 ? physicalLight(lights12[2], lights12[3], surfacePosition, surfaceNormal, directionToCamera, viewY, dotNV, diffuseBaseColor, specularBaseColor, alpha, ambientOcclusion) : vec3(0.0, 0.0, 0.0);\n            vec3 litColor3 = enabledLights[2] == 1.0 ? physicalLight(lights34[0], lights34[1], surfacePosition, surfaceNormal, directionToCamera, viewY, dotNV, diffuseBaseColor, specularBaseColor, alpha, ambientOcclusion) : vec3(0.0, 0.0, 0.0);\n            vec3 litColor4 = enabledLights[3] == 1.0 ? physicalLight(lights34[2], lights34[3], surfacePosition, surfaceNormal, directionToCamera, viewY, dotNV, diffuseBaseColor, specularBaseColor, alpha, ambientOcclusion) : vec3(0.0, 0.0, 0.0);\n            vec3 litColor5 = physicalLight(lights56[0], lights56[1], surfacePosition, surfaceNormal, directionToCamera, viewY, dotNV, diffuseBaseColor, specularBaseColor, alpha, ambientOcclusion);\n            vec3 litColor6 = physicalLight(lights56[2], lights56[3], surfacePosition, surfaceNormal, directionToCamera, viewY, dotNV, diffuseBaseColor, specularBaseColor, alpha, ambientOcclusion);\n            vec3 litColor7 = physicalLight(lights78[0], lights78[1], surfacePosition, surfaceNormal, directionToCamera, viewY, dotNV, diffuseBaseColor, specularBaseColor, alpha, ambientOcclusion);\n            vec3 litColor8 = physicalLight(lights78[2], lights78[3], surfacePosition, surfaceNormal, directionToCamera, viewY, dotNV, diffuseBaseColor, specularBaseColor, alpha, ambientOcclusion);\n            return litColor1 + litColor2 + litColor3 + litColor4 + litColor5 + litColor6 + litColor7 + litColor8;\n        }\n        \n        float gammaCorrect(float u) {\n            if (u <= 0.0031308) {\n                return 12.92 * u;\n            } else {\n                return 1.055 * pow(u, 1.0 / 2.4) - 0.055;\n            }\n        }\n        \n        vec3 gammaCorrectedColor(vec3 color) {\n            float red = gammaCorrect(color.r);\n            float green = gammaCorrect(color.g);\n            float blue = gammaCorrect(color.b);\n            return vec3(red, green, blue);\n        }\n        \n        vec3 reinhardLuminanceToneMap(vec3 color) {\n            float luminance = 0.2126 * color.r + 0.7152 * color.g + 0.0722 * color.b;\n            float scale = 1.0 / (1.0 + luminance);\n            return gammaCorrectedColor(color * scale);\n        }\n        \n        vec3 reinhardPerChannelToneMap(vec3 color) {\n            return gammaCorrectedColor(color / (color + 1.0));\n        }\n        \n        float extendedReinhardToneMap(float x, float xMax) {\n            return x * (1.0 + (x / (xMax * xMax))) / (1.0 + x);\n        }\n        \n        vec3 extendedReinhardLuminanceToneMap(vec3 color, float overexposureLimit) {\n            float luminance = 0.2126 * color.r + 0.7152 * color.g + 0.0722 * color.b;\n            float scaledLuminance = extendedReinhardToneMap(luminance, overexposureLimit);\n            float scale = scaledLuminance / luminance;\n            return gammaCorrectedColor(color * scale);\n        }\n        \n        vec3 extendedReinhardPerChannelToneMap(vec3 color, float overexposureLimit) {\n            float red = extendedReinhardToneMap(color.r, overexposureLimit);\n            float green = extendedReinhardToneMap(color.g, overexposureLimit);\n            float blue = extendedReinhardToneMap(color.b, overexposureLimit);\n            return gammaCorrectedColor(vec3(red, green, blue));\n        }\n        \n        vec3 hableFilmicHelper(vec3 color) {\n            float a = 0.15;\n            float b = 0.5;\n            float c = 0.1;\n            float d = 0.2;\n            float e = 0.02;\n            float f = 0.3;\n            return (color * (a * color + c * b) + d * e) / (color * (a * color + b) + d * f) - e / f;\n        }\n        \n        vec3 hableFilmicToneMap(vec3 color) {\n            float exposureBias = 2.0;\n            vec3 unscaled = hableFilmicHelper(exposureBias * color);\n            vec3 scale = 1.0 / hableFilmicHelper(vec3(11.2));\n            return gammaCorrectedColor(scale * unscaled);\n        }\n        \n        vec3 toneMap(vec3 color, float toneMapType, float toneMapParam) {\n            if (toneMapType == 0.0) {\n                return gammaCorrectedColor(color);\n            } else if (toneMapType == 1.0) {\n                return reinhardLuminanceToneMap(color);\n            } else if (toneMapType == 2.0) {\n                return reinhardPerChannelToneMap(color);\n            } else if (toneMapType == 3.0) {\n                return extendedReinhardLuminanceToneMap(color, toneMapParam);\n            } else if (toneMapType == 4.0) {\n                return extendedReinhardPerChannelToneMap(color, toneMapParam);\n            } else if (toneMapType == 5.0) {\n                return hableFilmicToneMap(color);\n            } else {\n                return vec3(0.0, 0.0, 0.0);\n            }\n        }\n        \n        float inverseAlpha(float value) {\n            // the value used for alpha cannot be less than zero\n            float signValue = float(sign(value));\n            return signValue / (value + (signValue - 1.0));\n        }\n        \n        vec4 toSrgb(vec4 linearColor, mat4 sceneProperties) {\n            vec3 referenceWhite = sceneProperties[2].rgb;\n            // linearColor has premultiplied alpha, but tone mapping works on\n            // non-premultiplied linear RGB so we need to temporarily \'undo\' the\n            // premultiplication before applying tone mapping\n            float invAlpha = inverseAlpha(linearColor.a);\n            float unitR = (linearColor.r * invAlpha) / referenceWhite.r;\n            float unitG = (linearColor.g * invAlpha) / referenceWhite.g;\n            float unitB = (linearColor.b * invAlpha) / referenceWhite.b;\n            float toneMapType = sceneProperties[3][2];\n            float toneMapParam = sceneProperties[3][3];\n            // Apply tone mapping\n            vec3 toneMapped = toneMap(vec3(unitR, unitG, unitB), toneMapType, toneMapParam);\n            // Re-apply premultiplied alpha after tone mapping\n            return vec4(toneMapped * linearColor.a, linearColor.a);\n        }\n        \n        void main() {\n            vec3 normalDirection = normalize(interpolatedNormal) * getNormalSign();\n            vec3 directionToCamera = getDirectionToCamera(interpolatedPosition, sceneProperties);\n        \n            vec3 linearColor = physicalLighting(\n                interpolatedPosition,\n                normalDirection,\n                baseColor.rgb,\n                directionToCamera,\n                viewMatrix,\n                roughness,\n                metallic,\n                ambientOcclusion,\n                lights12,\n                lights34,\n                lights56,\n                lights78,\n                enabledLights\n            );\n        \n            gl_FragColor = toSrgb(vec4(linearColor, baseColor.a), sceneProperties);\n        }\n    ',
	attributes: {},
	uniforms: {ambientOcclusion: 'gK', baseColor: 'ar', enabledLights: 't', lights12: 'cp', lights34: 'c6', lights56: 'c7', lights78: 'c8', metallic: 'd5', roughness: 'ax', sceneProperties: 'e', viewMatrix: 'f'}
};
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$physicalMesh = F7(
	function (color, roughness, metallic, ambientOcclusion, bounds, webGLMesh, backFaceSetting) {
		return A3(
			$ianmackenzie$elm_3d_scene$Scene3d$Entity$meshNode,
			color,
			bounds,
			F8(
				function (sceneProperties, modelScale, modelMatrix, isRightHanded, viewMatrix, projectionMatrix, _v0, settings) {
					var lights = _v0.a;
					var enabledLights = _v0.b;
					return A5(
						$elm_explorations$webgl$WebGL$entityWith,
						A3($ianmackenzie$elm_3d_scene$Scene3d$Entity$meshSettings, isRightHanded, backFaceSetting, settings),
						$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$uniformVertex,
						$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$physicalFragment,
						webGLMesh,
						{
							gK: ambientOcclusion,
							ar: $ianmackenzie$elm_3d_scene$Scene3d$Entity$premultiplyColor(color),
							t: enabledLights,
							cp: lights.cp,
							c6: lights.c6,
							c7: lights.c7,
							c8: lights.c8,
							d5: metallic,
							b: modelMatrix,
							c: modelScale,
							d: projectionMatrix,
							ax: roughness,
							e: sceneProperties,
							f: viewMatrix
						});
				}));
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$ConstantLambertianMaterial = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$TexturedLambertianMaterial = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$UseColor = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$UseTexture = function (a) {
	return {$: 0, a: a};
};
var $elm_explorations$linear_algebra$Math$Vector2$vec2 = _MJS_v2;
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$enabledFloat = function (value) {
	return A2($elm_explorations$linear_algebra$Math$Vector2$vec2, value, 1);
};
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$zeroVec2 = A2($elm_explorations$linear_algebra$Math$Vector2$vec2, 0, 0);
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$floatTuple = F2(
	function (fallbackData, texture) {
		if (!texture.$) {
			var value = texture.a;
			return _Utils_Tuple2(
				fallbackData,
				$ianmackenzie$elm_3d_scene$Scene3d$Entity$enabledFloat(value));
		} else {
			var data = texture.a.eS;
			return _Utils_Tuple2(data, $ianmackenzie$elm_3d_scene$Scene3d$Entity$zeroVec2);
		}
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$normalMapTuple = F2(
	function (fallbackData, channel) {
		if (!channel.$) {
			return _Utils_Tuple2(fallbackData, 0.0);
		} else {
			var data = channel.a.eS;
			var format = channel.a.hG;
			return _Utils_Tuple2(
				data,
				function () {
					if (!format) {
						return 1.0;
					} else {
						return -1.0;
					}
				}());
		}
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$resolveLambertian = F3(
	function (materialColorTexture, ambientOcclusionTexture, normalMapTexture) {
		var _v0 = _Utils_Tuple3(materialColorTexture, ambientOcclusionTexture, normalMapTexture);
		if (_v0.a.$ === 1) {
			var data = _v0.a.a.eS;
			return A3(
				$ianmackenzie$elm_3d_scene$Scene3d$Entity$TexturedLambertianMaterial,
				$ianmackenzie$elm_3d_scene$Scene3d$Entity$UseTexture(data),
				A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$floatTuple, data, ambientOcclusionTexture),
				A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$normalMapTuple, data, normalMapTexture));
		} else {
			if (!_v0.b.$) {
				if (!_v0.c.$) {
					var materialColor = _v0.a.a;
					var ambientOcclusion = _v0.b.a;
					var _v1 = _v0.c;
					return A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$ConstantLambertianMaterial, materialColor, ambientOcclusion);
				} else {
					var materialColor = _v0.a.a;
					var data = _v0.c.a.eS;
					return A3(
						$ianmackenzie$elm_3d_scene$Scene3d$Entity$TexturedLambertianMaterial,
						A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$UseColor, materialColor, data),
						A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$floatTuple, data, ambientOcclusionTexture),
						A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$normalMapTuple, data, normalMapTexture));
				}
			} else {
				var materialColor = _v0.a.a;
				var data = _v0.b.a.eS;
				return A3(
					$ianmackenzie$elm_3d_scene$Scene3d$Entity$TexturedLambertianMaterial,
					A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$UseColor, materialColor, data),
					A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$floatTuple, data, ambientOcclusionTexture),
					A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$normalMapTuple, data, normalMapTexture));
			}
		}
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$ConstantPbrMaterial = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$TexturedPbrMaterial = F5(
	function (a, b, c, d, e) {
		return {$: 1, a: a, b: b, c: c, d: d, e: e};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$Tuple5 = F5(
	function (a, b, c, d, e) {
		return {$: 0, a: a, b: b, c: c, d: d, e: e};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$resolvePbr = F5(
	function (baseColorTexture, roughnessTexture, metallicTexture, ambientOcclusionTexture, normalMapTexture) {
		var _v0 = A5($ianmackenzie$elm_3d_scene$Scene3d$Entity$Tuple5, baseColorTexture, roughnessTexture, metallicTexture, ambientOcclusionTexture, normalMapTexture);
		if (_v0.a.$ === 1) {
			var data = _v0.a.a.eS;
			return A5(
				$ianmackenzie$elm_3d_scene$Scene3d$Entity$TexturedPbrMaterial,
				$ianmackenzie$elm_3d_scene$Scene3d$Entity$UseTexture(data),
				A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$floatTuple, data, roughnessTexture),
				A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$floatTuple, data, metallicTexture),
				A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$floatTuple, data, ambientOcclusionTexture),
				A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$normalMapTuple, data, normalMapTexture));
		} else {
			if (!_v0.b.$) {
				if (!_v0.c.$) {
					if (!_v0.d.$) {
						if (!_v0.e.$) {
							var baseColor = _v0.a.a;
							var roughness = _v0.b.a;
							var metallic = _v0.c.a;
							var ambientOcclusion = _v0.d.a;
							var _v1 = _v0.e;
							return A4($ianmackenzie$elm_3d_scene$Scene3d$Entity$ConstantPbrMaterial, baseColor, roughness, metallic, ambientOcclusion);
						} else {
							var baseColor = _v0.a.a;
							var data = _v0.e.a.eS;
							return A5(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$TexturedPbrMaterial,
								A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$UseColor, baseColor, data),
								A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$floatTuple, data, roughnessTexture),
								A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$floatTuple, data, metallicTexture),
								A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$floatTuple, data, ambientOcclusionTexture),
								_Utils_Tuple2(data, 1.0));
						}
					} else {
						var baseColor = _v0.a.a;
						var data = _v0.d.a.eS;
						return A5(
							$ianmackenzie$elm_3d_scene$Scene3d$Entity$TexturedPbrMaterial,
							A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$UseColor, baseColor, data),
							A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$floatTuple, data, roughnessTexture),
							A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$floatTuple, data, metallicTexture),
							_Utils_Tuple2(data, $ianmackenzie$elm_3d_scene$Scene3d$Entity$zeroVec2),
							A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$normalMapTuple, data, normalMapTexture));
					}
				} else {
					var baseColor = _v0.a.a;
					var data = _v0.c.a.eS;
					return A5(
						$ianmackenzie$elm_3d_scene$Scene3d$Entity$TexturedPbrMaterial,
						A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$UseColor, baseColor, data),
						A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$floatTuple, data, roughnessTexture),
						_Utils_Tuple2(data, $ianmackenzie$elm_3d_scene$Scene3d$Entity$zeroVec2),
						A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$floatTuple, data, ambientOcclusionTexture),
						A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$normalMapTuple, data, normalMapTexture));
				}
			} else {
				var baseColor = _v0.a.a;
				var data = _v0.b.a.eS;
				return A5(
					$ianmackenzie$elm_3d_scene$Scene3d$Entity$TexturedPbrMaterial,
					A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$UseColor, baseColor, data),
					_Utils_Tuple2(data, $ianmackenzie$elm_3d_scene$Scene3d$Entity$zeroVec2),
					A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$floatTuple, data, metallicTexture),
					A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$floatTuple, data, ambientOcclusionTexture),
					A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$normalMapTuple, data, normalMapTexture));
			}
		}
	});
var $ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$emissiveTextureFragment = {
	src: '\n        precision mediump float;\n        \n        uniform mediump sampler2D colorTexture;\n        uniform mediump float backlight;\n        uniform highp mat4 sceneProperties;\n        \n        varying mediump vec2 interpolatedUv;\n        \n        float inverseGamma(float u) {\n            if (u <= 0.04045) {\n                return clamp(u / 12.92, 0.0, 1.0);\n            } else {\n                return clamp(pow((u + 0.055) / 1.055, 2.4), 0.0, 1.0);\n            }\n        }\n        \n        float inverseAlpha(float value) {\n            // the value used for alpha cannot be less than zero\n            float signValue = float(sign(value));\n            return signValue / (value + (signValue - 1.0));\n        }\n        \n        vec4 fromSrgb(vec4 srgbColor) {\n            float invAlpha = inverseAlpha(srgbColor.a);\n            return vec4(\n                inverseGamma(srgbColor.r * invAlpha) * srgbColor.a,\n                inverseGamma(srgbColor.g * invAlpha) * srgbColor.a,\n                inverseGamma(srgbColor.b * invAlpha) * srgbColor.a,\n                srgbColor.a\n            );\n        }\n        \n        float gammaCorrect(float u) {\n            if (u <= 0.0031308) {\n                return 12.92 * u;\n            } else {\n                return 1.055 * pow(u, 1.0 / 2.4) - 0.055;\n            }\n        }\n        \n        vec3 gammaCorrectedColor(vec3 color) {\n            float red = gammaCorrect(color.r);\n            float green = gammaCorrect(color.g);\n            float blue = gammaCorrect(color.b);\n            return vec3(red, green, blue);\n        }\n        \n        vec3 reinhardLuminanceToneMap(vec3 color) {\n            float luminance = 0.2126 * color.r + 0.7152 * color.g + 0.0722 * color.b;\n            float scale = 1.0 / (1.0 + luminance);\n            return gammaCorrectedColor(color * scale);\n        }\n        \n        vec3 reinhardPerChannelToneMap(vec3 color) {\n            return gammaCorrectedColor(color / (color + 1.0));\n        }\n        \n        float extendedReinhardToneMap(float x, float xMax) {\n            return x * (1.0 + (x / (xMax * xMax))) / (1.0 + x);\n        }\n        \n        vec3 extendedReinhardLuminanceToneMap(vec3 color, float overexposureLimit) {\n            float luminance = 0.2126 * color.r + 0.7152 * color.g + 0.0722 * color.b;\n            float scaledLuminance = extendedReinhardToneMap(luminance, overexposureLimit);\n            float scale = scaledLuminance / luminance;\n            return gammaCorrectedColor(color * scale);\n        }\n        \n        vec3 extendedReinhardPerChannelToneMap(vec3 color, float overexposureLimit) {\n            float red = extendedReinhardToneMap(color.r, overexposureLimit);\n            float green = extendedReinhardToneMap(color.g, overexposureLimit);\n            float blue = extendedReinhardToneMap(color.b, overexposureLimit);\n            return gammaCorrectedColor(vec3(red, green, blue));\n        }\n        \n        vec3 hableFilmicHelper(vec3 color) {\n            float a = 0.15;\n            float b = 0.5;\n            float c = 0.1;\n            float d = 0.2;\n            float e = 0.02;\n            float f = 0.3;\n            return (color * (a * color + c * b) + d * e) / (color * (a * color + b) + d * f) - e / f;\n        }\n        \n        vec3 hableFilmicToneMap(vec3 color) {\n            float exposureBias = 2.0;\n            vec3 unscaled = hableFilmicHelper(exposureBias * color);\n            vec3 scale = 1.0 / hableFilmicHelper(vec3(11.2));\n            return gammaCorrectedColor(scale * unscaled);\n        }\n        \n        vec3 toneMap(vec3 color, float toneMapType, float toneMapParam) {\n            if (toneMapType == 0.0) {\n                return gammaCorrectedColor(color);\n            } else if (toneMapType == 1.0) {\n                return reinhardLuminanceToneMap(color);\n            } else if (toneMapType == 2.0) {\n                return reinhardPerChannelToneMap(color);\n            } else if (toneMapType == 3.0) {\n                return extendedReinhardLuminanceToneMap(color, toneMapParam);\n            } else if (toneMapType == 4.0) {\n                return extendedReinhardPerChannelToneMap(color, toneMapParam);\n            } else if (toneMapType == 5.0) {\n                return hableFilmicToneMap(color);\n            } else {\n                return vec3(0.0, 0.0, 0.0);\n            }\n        }\n        \n        vec4 toSrgb(vec4 linearColor, mat4 sceneProperties) {\n            vec3 referenceWhite = sceneProperties[2].rgb;\n            // linearColor has premultiplied alpha, but tone mapping works on\n            // non-premultiplied linear RGB so we need to temporarily \'undo\' the\n            // premultiplication before applying tone mapping\n            float invAlpha = inverseAlpha(linearColor.a);\n            float unitR = (linearColor.r * invAlpha) / referenceWhite.r;\n            float unitG = (linearColor.g * invAlpha) / referenceWhite.g;\n            float unitB = (linearColor.b * invAlpha) / referenceWhite.b;\n            float toneMapType = sceneProperties[3][2];\n            float toneMapParam = sceneProperties[3][3];\n            // Apply tone mapping\n            vec3 toneMapped = toneMap(vec3(unitR, unitG, unitB), toneMapType, toneMapParam);\n            // Re-apply premultiplied alpha after tone mapping\n            return vec4(toneMapped * linearColor.a, linearColor.a);\n        }\n        \n        void main () {\n            vec4 linearTextureColor = fromSrgb(texture2D(colorTexture, interpolatedUv));\n            vec4 emissiveColor = vec4(linearTextureColor.rgb * backlight, linearTextureColor.a);\n            gl_FragColor = toSrgb(emissiveColor, sceneProperties);\n        }\n    ',
	attributes: {},
	uniforms: {backlight: 'dI', colorTexture: 'cT', sceneProperties: 'e'}
};
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$texturedEmissiveMesh = F5(
	function (colorData, backlight, bounds, webGLMesh, backFaceSetting) {
		return A2(
			$ianmackenzie$elm_3d_scene$Scene3d$Types$OpaqueMeshNode,
			bounds,
			F8(
				function (sceneProperties, modelScale, modelMatrix, isRightHanded, viewMatrix, projectionMatrix, lights, settings) {
					return A5(
						$elm_explorations$webgl$WebGL$entityWith,
						A3($ianmackenzie$elm_3d_scene$Scene3d$Entity$meshSettings, isRightHanded, backFaceSetting, settings),
						$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$unlitVertex,
						$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$emissiveTextureFragment,
						webGLMesh,
						{
							dI: $ianmackenzie$elm_units$Luminance$inNits(backlight),
							cT: colorData,
							b: modelMatrix,
							c: modelScale,
							d: projectionMatrix,
							e: sceneProperties,
							f: viewMatrix
						});
				}));
	});
var $ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$texturedVertex = {
	src: '\n        precision highp float;\n        \n        attribute highp vec3 position;\n        attribute highp vec3 normal;\n        attribute mediump vec2 uv;\n        \n        uniform highp vec4 modelScale;\n        uniform highp mat4 modelMatrix;\n        uniform highp mat4 viewMatrix;\n        uniform highp mat4 projectionMatrix;\n        uniform highp mat4 sceneProperties;\n        \n        varying highp vec3 interpolatedPosition;\n        varying highp vec3 interpolatedNormal;\n        varying mediump vec2 interpolatedUv;\n        varying highp vec4 interpolatedTangent;\n        \n        vec4 getWorldPosition(vec3 modelPosition, vec4 modelScale, mat4 modelMatrix) {\n            vec4 scaledPosition = vec4(modelScale.xyz * modelPosition, 1.0);\n            return modelMatrix * scaledPosition;\n        }\n        \n        vec3 safeNormalize(vec3 vector) {\n            if (vector == vec3(0.0, 0.0, 0.0)) {\n                return vector;\n            } else {\n                return normalize(vector);\n            }\n        }\n        \n        vec3 getWorldNormal(vec3 modelNormal, vec4 modelScale, mat4 modelMatrix) {\n            vec3 normalScale = vec3(modelScale.w / modelScale.x, modelScale.w / modelScale.y, modelScale.w / modelScale.z);\n            return (modelMatrix * vec4(safeNormalize(normalScale * modelNormal), 0.0)).xyz;\n        }\n        \n        void main () {\n            vec4 worldPosition = getWorldPosition(position, modelScale, modelMatrix);\n            gl_Position = projectionMatrix * (viewMatrix * worldPosition);\n            interpolatedPosition = worldPosition.xyz;\n            interpolatedNormal = getWorldNormal(normal, modelScale, modelMatrix);\n            interpolatedUv = uv;\n            interpolatedTangent = vec4(0.0, 0.0, 0.0, 0.0);\n        }\n    ',
	attributes: {normal: 'aS', position: 'f9', uv: 'bZ'},
	uniforms: {modelMatrix: 'b', modelScale: 'c', projectionMatrix: 'd', sceneProperties: 'e', viewMatrix: 'f'}
};
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$texturedLambertianMesh = F6(
	function (useTextureOrColor, ambientOcclusionData, constantAmbientOcclusion, bounds, webGLMesh, backFaceSetting) {
		if (!useTextureOrColor.$) {
			var materialColorData = useTextureOrColor.a;
			return A2(
				$ianmackenzie$elm_3d_scene$Scene3d$Types$OpaqueMeshNode,
				bounds,
				F8(
					function (sceneProperties, modelScale, modelMatrix, isRightHanded, viewMatrix, projectionMatrix, _v1, settings) {
						var lights = _v1.a;
						var enabledLights = _v1.b;
						return A5(
							$elm_explorations$webgl$WebGL$entityWith,
							A3($ianmackenzie$elm_3d_scene$Scene3d$Entity$meshSettings, isRightHanded, backFaceSetting, settings),
							$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$texturedVertex,
							$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$lambertianTextureFragment,
							webGLMesh,
							{ae: ambientOcclusionData, af: constantAmbientOcclusion, bp: $ianmackenzie$elm_3d_scene$Scene3d$Entity$zeroVec4, t: enabledLights, cp: lights.cp, c6: lights.c6, c7: lights.c7, c8: lights.c8, bB: materialColorData, b: modelMatrix, c: modelScale, ai: materialColorData, aj: 0.0, d: projectionMatrix, e: sceneProperties, f: viewMatrix});
					}));
		} else {
			var constantMaterialColor = useTextureOrColor.a;
			var dummyTexture = useTextureOrColor.b;
			return A3(
				$ianmackenzie$elm_3d_scene$Scene3d$Entity$meshNode,
				constantMaterialColor,
				bounds,
				F8(
					function (sceneProperties, modelScale, modelMatrix, isRightHanded, viewMatrix, projectionMatrix, _v2, settings) {
						var lights = _v2.a;
						var enabledLights = _v2.b;
						return A5(
							$elm_explorations$webgl$WebGL$entityWith,
							A3($ianmackenzie$elm_3d_scene$Scene3d$Entity$meshSettings, isRightHanded, backFaceSetting, settings),
							$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$texturedVertex,
							$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$lambertianTextureFragment,
							webGLMesh,
							{
								ae: ambientOcclusionData,
								af: constantAmbientOcclusion,
								bp: $ianmackenzie$elm_3d_scene$Scene3d$Entity$premultiplyColor(constantMaterialColor),
								t: enabledLights,
								cp: lights.cp,
								c6: lights.c6,
								c7: lights.c7,
								c8: lights.c8,
								bB: dummyTexture,
								b: modelMatrix,
								c: modelScale,
								ai: dummyTexture,
								aj: 0.0,
								d: projectionMatrix,
								e: sceneProperties,
								f: viewMatrix
							});
					}));
		}
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$texturedPhysicalMesh = F8(
	function (useTextureOrColor, roughnessData, constantRoughness, metallicData, constantMetallic, bounds, webGLMesh, backFaceSetting) {
		if (!useTextureOrColor.$) {
			var baseColorData = useTextureOrColor.a;
			return A2(
				$ianmackenzie$elm_3d_scene$Scene3d$Types$OpaqueMeshNode,
				bounds,
				F8(
					function (sceneProperties, modelScale, modelMatrix, isRightHanded, viewMatrix, projectionMatrix, _v1, settings) {
						var lights = _v1.a;
						var enabledLights = _v1.b;
						return A5(
							$elm_explorations$webgl$WebGL$entityWith,
							A3($ianmackenzie$elm_3d_scene$Scene3d$Entity$meshSettings, isRightHanded, backFaceSetting, settings),
							$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$texturedVertex,
							$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$physicalTexturesFragment,
							webGLMesh,
							{
								ae: baseColorData,
								bm: baseColorData,
								af: $ianmackenzie$elm_3d_scene$Scene3d$Entity$enabledFloat(1),
								bn: $ianmackenzie$elm_3d_scene$Scene3d$Entity$zeroVec4,
								bq: constantMetallic,
								br: constantRoughness,
								t: enabledLights,
								cp: lights.cp,
								c6: lights.c6,
								c7: lights.c7,
								c8: lights.c8,
								bC: metallicData,
								b: modelMatrix,
								c: modelScale,
								ai: baseColorData,
								aj: 0.0,
								d: projectionMatrix,
								bN: roughnessData,
								e: sceneProperties,
								f: viewMatrix
							});
					}));
		} else {
			var constantBaseColor = useTextureOrColor.a;
			var dummyTexture = useTextureOrColor.b;
			return A3(
				$ianmackenzie$elm_3d_scene$Scene3d$Entity$meshNode,
				constantBaseColor,
				bounds,
				F8(
					function (sceneProperties, modelScale, modelMatrix, isRightHanded, viewMatrix, projectionMatrix, _v2, settings) {
						var lights = _v2.a;
						var enabledLights = _v2.b;
						return A5(
							$elm_explorations$webgl$WebGL$entityWith,
							A3($ianmackenzie$elm_3d_scene$Scene3d$Entity$meshSettings, isRightHanded, backFaceSetting, settings),
							$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$texturedVertex,
							$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$physicalTexturesFragment,
							webGLMesh,
							{
								ae: dummyTexture,
								bm: dummyTexture,
								af: $ianmackenzie$elm_3d_scene$Scene3d$Entity$enabledFloat(1),
								bn: $ianmackenzie$elm_3d_scene$Scene3d$Entity$premultiplyColor(constantBaseColor),
								bq: constantMetallic,
								br: constantRoughness,
								t: enabledLights,
								cp: lights.cp,
								c6: lights.c6,
								c7: lights.c7,
								c8: lights.c8,
								bC: metallicData,
								b: modelMatrix,
								c: modelScale,
								ai: dummyTexture,
								aj: 0.0,
								d: projectionMatrix,
								bN: roughnessData,
								e: sceneProperties,
								f: viewMatrix
							});
					}));
		}
	});
var $ianmackenzie$elm_geometry$BoundingBox3d$centerPoint = function (boundingBox) {
	var _v0 = boundingBox;
	var b = _v0;
	var x1 = b.fN;
	var x2 = b.fK;
	var y1 = b.fO;
	var y2 = b.fL;
	var z1 = b.fP;
	var z2 = b.fM;
	return {cF: x1 + (0.5 * (x2 - x1)), cG: y1 + (0.5 * (y2 - y1)), cH: z1 + (0.5 * (z2 - z1))};
};
var $ianmackenzie$elm_geometry$BoundingBox3d$maxX = function (_v0) {
	var boundingBox = _v0;
	return boundingBox.fK;
};
var $ianmackenzie$elm_geometry$BoundingBox3d$maxY = function (_v0) {
	var boundingBox = _v0;
	return boundingBox.fL;
};
var $ianmackenzie$elm_geometry$BoundingBox3d$maxZ = function (_v0) {
	var boundingBox = _v0;
	return boundingBox.fM;
};
var $ianmackenzie$elm_geometry$BoundingBox3d$minX = function (_v0) {
	var boundingBox = _v0;
	return boundingBox.fN;
};
var $ianmackenzie$elm_geometry$BoundingBox3d$minY = function (_v0) {
	var boundingBox = _v0;
	return boundingBox.fO;
};
var $ianmackenzie$elm_geometry$BoundingBox3d$minZ = function (_v0) {
	var boundingBox = _v0;
	return boundingBox.fP;
};
var $ianmackenzie$elm_units$Quantity$minus = F2(
	function (_v0, _v1) {
		var y = _v0;
		var x = _v1;
		return x - y;
	});
var $ianmackenzie$elm_geometry$BoundingBox3d$dimensions = function (boundingBox) {
	return _Utils_Tuple3(
		A2(
			$ianmackenzie$elm_units$Quantity$minus,
			$ianmackenzie$elm_geometry$BoundingBox3d$minX(boundingBox),
			$ianmackenzie$elm_geometry$BoundingBox3d$maxX(boundingBox)),
		A2(
			$ianmackenzie$elm_units$Quantity$minus,
			$ianmackenzie$elm_geometry$BoundingBox3d$minY(boundingBox),
			$ianmackenzie$elm_geometry$BoundingBox3d$maxY(boundingBox)),
		A2(
			$ianmackenzie$elm_units$Quantity$minus,
			$ianmackenzie$elm_geometry$BoundingBox3d$minZ(boundingBox),
			$ianmackenzie$elm_geometry$BoundingBox3d$maxZ(boundingBox)));
};
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds = function (boundingBox) {
	var _v0 = $ianmackenzie$elm_geometry$BoundingBox3d$dimensions(boundingBox);
	var xDimension = _v0.a;
	var yDimension = _v0.b;
	var zDimension = _v0.c;
	return {
		g6: $ianmackenzie$elm_geometry$Point3d$unwrap(
			$ianmackenzie$elm_geometry$BoundingBox3d$centerPoint(boundingBox)),
		hM: xDimension / 2,
		hN: yDimension / 2,
		hO: zDimension / 2
	};
};
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$mesh = F2(
	function (givenMaterial, givenMesh) {
		switch (givenMaterial.$) {
			case 0:
				if (!givenMaterial.b.$) {
					var color = givenMaterial.b.a;
					switch (givenMesh.$) {
						case 0:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 1:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var backFaceSetting = givenMesh.d;
							return A4(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$constantMesh,
								color,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								backFaceSetting);
						case 2:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var backFaceSetting = givenMesh.d;
							return A4(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$constantMesh,
								color,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								backFaceSetting);
						case 3:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var backFaceSetting = givenMesh.d;
							return A4(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$constantMesh,
								color,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								backFaceSetting);
						case 4:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var backFaceSetting = givenMesh.d;
							return A4(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$constantMesh,
								color,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								backFaceSetting);
						case 5:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var backFaceSetting = givenMesh.d;
							return A4(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$constantMesh,
								color,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								backFaceSetting);
						case 6:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var backFaceSetting = givenMesh.d;
							return A4(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$constantMesh,
								color,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								backFaceSetting);
						case 7:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var backFaceSetting = givenMesh.d;
							return A4(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$constantMesh,
								color,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								backFaceSetting);
						case 8:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							return A4(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$constantMesh,
								color,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								0);
						case 9:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							return A4(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$constantMesh,
								color,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								0);
						default:
							var boundingBox = givenMesh.a;
							var radius = givenMesh.b;
							var webGLMesh = givenMesh.d;
							return A4(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$constantPointMesh,
								color,
								radius,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh);
					}
				} else {
					var _v2 = givenMaterial.a;
					var data = givenMaterial.b.a.eS;
					switch (givenMesh.$) {
						case 0:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 1:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 2:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 3:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 4:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 5:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var backFaceSetting = givenMesh.d;
							return A4(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$colorTextureMesh,
								data,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								backFaceSetting);
						case 6:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var backFaceSetting = givenMesh.d;
							return A4(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$colorTextureMesh,
								data,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								backFaceSetting);
						case 7:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var backFaceSetting = givenMesh.d;
							return A4(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$colorTextureMesh,
								data,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								backFaceSetting);
						case 8:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 9:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						default:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
					}
				}
			case 1:
				if (!givenMaterial.b.$) {
					var emissiveColor = givenMaterial.b.a;
					var backlight = givenMaterial.c;
					switch (givenMesh.$) {
						case 0:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 1:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var backFaceSetting = givenMesh.d;
							return A5(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$emissiveMesh,
								emissiveColor,
								backlight,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								backFaceSetting);
						case 2:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var backFaceSetting = givenMesh.d;
							return A5(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$emissiveMesh,
								emissiveColor,
								backlight,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								backFaceSetting);
						case 3:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var backFaceSetting = givenMesh.d;
							return A5(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$emissiveMesh,
								emissiveColor,
								backlight,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								backFaceSetting);
						case 4:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var backFaceSetting = givenMesh.d;
							return A5(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$emissiveMesh,
								emissiveColor,
								backlight,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								backFaceSetting);
						case 5:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var backFaceSetting = givenMesh.d;
							return A5(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$emissiveMesh,
								emissiveColor,
								backlight,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								backFaceSetting);
						case 6:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var backFaceSetting = givenMesh.d;
							return A5(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$emissiveMesh,
								emissiveColor,
								backlight,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								backFaceSetting);
						case 7:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var backFaceSetting = givenMesh.d;
							return A5(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$emissiveMesh,
								emissiveColor,
								backlight,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								backFaceSetting);
						case 8:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							return A5(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$emissiveMesh,
								emissiveColor,
								backlight,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								0);
						case 9:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							return A5(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$emissiveMesh,
								emissiveColor,
								backlight,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								0);
						default:
							var boundingBox = givenMesh.a;
							var radius = givenMesh.b;
							var webGLMesh = givenMesh.d;
							return A5(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$emissivePointMesh,
								emissiveColor,
								backlight,
								radius,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh);
					}
				} else {
					var _v5 = givenMaterial.a;
					var data = givenMaterial.b.a.eS;
					var backlight = givenMaterial.c;
					switch (givenMesh.$) {
						case 0:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 1:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 2:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 3:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 4:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 5:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var backFaceSetting = givenMesh.d;
							return A5(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$texturedEmissiveMesh,
								data,
								backlight,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								backFaceSetting);
						case 6:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var backFaceSetting = givenMesh.d;
							return A5(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$texturedEmissiveMesh,
								data,
								backlight,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								backFaceSetting);
						case 7:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var backFaceSetting = givenMesh.d;
							return A5(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$texturedEmissiveMesh,
								data,
								backlight,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								backFaceSetting);
						case 8:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 9:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						default:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
					}
				}
			case 2:
				var _v7 = givenMaterial.a;
				var materialColorTexture = givenMaterial.b;
				var ambientOcclusionTexture = givenMaterial.c;
				var normalMapTexture = givenMaterial.d;
				var _v8 = A3($ianmackenzie$elm_3d_scene$Scene3d$Entity$resolveLambertian, materialColorTexture, ambientOcclusionTexture, normalMapTexture);
				if (!_v8.$) {
					var materialColor = _v8.a;
					var ambientOcclusion = _v8.b;
					switch (givenMesh.$) {
						case 0:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 1:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 2:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var cullBackFaces = givenMesh.d;
							return A5(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$lambertianMesh,
								materialColor,
								ambientOcclusion,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								cullBackFaces);
						case 3:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 4:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var cullBackFaces = givenMesh.d;
							return A5(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$lambertianMesh,
								materialColor,
								ambientOcclusion,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								cullBackFaces);
						case 5:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 6:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var cullBackFaces = givenMesh.d;
							return A5(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$lambertianMesh,
								materialColor,
								ambientOcclusion,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								cullBackFaces);
						case 7:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var cullBackFaces = givenMesh.d;
							return A5(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$lambertianMesh,
								materialColor,
								ambientOcclusion,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								cullBackFaces);
						case 8:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 9:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						default:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
					}
				} else {
					var useColorOrTexture = _v8.a;
					var _v10 = _v8.b;
					var ambientOcclusionData = _v10.a;
					var constantAmbientOcclusion = _v10.b;
					var _v11 = _v8.c;
					var normalMapData = _v11.a;
					var normalMapType = _v11.b;
					switch (givenMesh.$) {
						case 0:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 1:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 2:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 3:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 4:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 5:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 6:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var cullBackFaces = givenMesh.d;
							return A6(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$texturedLambertianMesh,
								useColorOrTexture,
								ambientOcclusionData,
								constantAmbientOcclusion,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								cullBackFaces);
						case 7:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var cullBackFaces = givenMesh.d;
							return A8(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$bumpyLambertianMesh,
								useColorOrTexture,
								ambientOcclusionData,
								constantAmbientOcclusion,
								normalMapData,
								normalMapType,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								cullBackFaces);
						case 8:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 9:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						default:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
					}
				}
			default:
				var _v13 = givenMaterial.a;
				var baseColorTexture = givenMaterial.b;
				var roughnessTexture = givenMaterial.c;
				var metallicTexture = givenMaterial.d;
				var ambientOcclusionTexture = givenMaterial.e;
				var normalMapTexture = givenMaterial.f;
				var _v14 = A5($ianmackenzie$elm_3d_scene$Scene3d$Entity$resolvePbr, baseColorTexture, roughnessTexture, metallicTexture, ambientOcclusionTexture, normalMapTexture);
				if (!_v14.$) {
					var baseColor = _v14.a;
					var roughness = _v14.b;
					var metallic = _v14.c;
					var ambientOcclusion = _v14.d;
					switch (givenMesh.$) {
						case 0:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 1:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 2:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var backFaceSetting = givenMesh.d;
							return A7(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$physicalMesh,
								baseColor,
								roughness,
								metallic,
								ambientOcclusion,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								backFaceSetting);
						case 3:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 4:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var backFaceSetting = givenMesh.d;
							return A7(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$physicalMesh,
								baseColor,
								roughness,
								metallic,
								ambientOcclusion,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								backFaceSetting);
						case 5:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 6:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var backFaceSetting = givenMesh.d;
							return A7(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$physicalMesh,
								baseColor,
								roughness,
								metallic,
								ambientOcclusion,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								backFaceSetting);
						case 7:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var backFaceSetting = givenMesh.d;
							return A7(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$physicalMesh,
								baseColor,
								roughness,
								metallic,
								ambientOcclusion,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								backFaceSetting);
						case 8:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 9:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						default:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
					}
				} else {
					var useTextureOrColor = _v14.a;
					var _v16 = _v14.b;
					var roughnessData = _v16.a;
					var constantRoughness = _v16.b;
					var _v17 = _v14.c;
					var metallicData = _v17.a;
					var constantMetallic = _v17.b;
					var _v18 = _v14.d;
					var ambientOcclusionData = _v18.a;
					var constantAmbientOcclusion = _v18.b;
					var _v19 = _v14.e;
					var normalMapData = _v19.a;
					var normalMapType = _v19.b;
					switch (givenMesh.$) {
						case 0:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 1:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 2:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 3:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 4:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 5:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 6:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var backFaceSetting = givenMesh.d;
							return A8(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$texturedPhysicalMesh,
								useTextureOrColor,
								roughnessData,
								constantRoughness,
								metallicData,
								constantMetallic,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox),
								webGLMesh,
								backFaceSetting);
						case 7:
							var boundingBox = givenMesh.a;
							var webGLMesh = givenMesh.c;
							var backFaceSetting = givenMesh.d;
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$bumpyPhysicalMesh(useTextureOrColor)(roughnessData)(constantRoughness)(metallicData)(constantMetallic)(ambientOcclusionData)(constantAmbientOcclusion)(normalMapData)(normalMapType)(
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$toBounds(boundingBox))(webGLMesh)(backFaceSetting);
						case 8:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						case 9:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
						default:
							return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
					}
				}
		}
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Transformation$placeIn = function (frame) {
	var p0 = $ianmackenzie$elm_geometry$Point3d$unwrap(
		$ianmackenzie$elm_geometry$Frame3d$originPoint(frame));
	var k = $ianmackenzie$elm_geometry$Direction3d$unwrap(
		$ianmackenzie$elm_geometry$Frame3d$zDirection(frame));
	var j = $ianmackenzie$elm_geometry$Direction3d$unwrap(
		$ianmackenzie$elm_geometry$Frame3d$yDirection(frame));
	var i = $ianmackenzie$elm_geometry$Direction3d$unwrap(
		$ianmackenzie$elm_geometry$Frame3d$xDirection(frame));
	return {
		fn: $ianmackenzie$elm_geometry$Frame3d$isRightHanded(frame),
		x: i.cF,
		y: i.cG,
		z: i.cH,
		A: j.cF,
		B: j.cG,
		C: j.cH,
		D: k.cF,
		E: k.cG,
		F: k.cH,
		T: p0.cF,
		U: p0.cG,
		V: p0.cH,
		dx: 1
	};
};
var $ianmackenzie$elm_3d_scene$Scene3d$Types$Transformed = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Transformation$compose = F2(
	function (t1, t2) {
		return {
			fn: _Utils_eq(t1.fn, t2.fn),
			x: ((t1.x * t2.x) + (t1.y * t2.A)) + (t1.z * t2.D),
			y: ((t1.x * t2.y) + (t1.y * t2.B)) + (t1.z * t2.E),
			z: ((t1.x * t2.z) + (t1.y * t2.C)) + (t1.z * t2.F),
			A: ((t1.A * t2.x) + (t1.B * t2.A)) + (t1.C * t2.D),
			B: ((t1.A * t2.y) + (t1.B * t2.B)) + (t1.C * t2.E),
			C: ((t1.A * t2.z) + (t1.B * t2.C)) + (t1.C * t2.F),
			D: ((t1.D * t2.x) + (t1.E * t2.A)) + (t1.F * t2.D),
			E: ((t1.D * t2.y) + (t1.E * t2.B)) + (t1.F * t2.E),
			F: ((t1.D * t2.z) + (t1.E * t2.C)) + (t1.F * t2.F),
			T: t2.T + ((((t1.T * t2.x) + (t1.U * t2.A)) + (t1.V * t2.D)) * t2.dx),
			U: t2.U + ((((t1.T * t2.y) + (t1.U * t2.B)) + (t1.V * t2.E)) * t2.dx),
			V: t2.V + ((((t1.T * t2.z) + (t1.U * t2.C)) + (t1.V * t2.F)) * t2.dx),
			dx: t1.dx * t2.dx
		};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$transformBy = F2(
	function (transformation, _v0) {
		var node = _v0;
		switch (node.$) {
			case 0:
				return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
			case 6:
				var existingTransformation = node.a;
				var underlyingNode = node.b;
				var compositeTransformation = A2($ianmackenzie$elm_3d_scene$Scene3d$Transformation$compose, existingTransformation, transformation);
				return A2($ianmackenzie$elm_3d_scene$Scene3d$Types$Transformed, compositeTransformation, underlyingNode);
			case 1:
				return A2($ianmackenzie$elm_3d_scene$Scene3d$Types$Transformed, transformation, node);
			case 2:
				return A2($ianmackenzie$elm_3d_scene$Scene3d$Types$Transformed, transformation, node);
			case 4:
				return A2($ianmackenzie$elm_3d_scene$Scene3d$Types$Transformed, transformation, node);
			case 3:
				return A2($ianmackenzie$elm_3d_scene$Scene3d$Types$Transformed, transformation, node);
			default:
				return A2($ianmackenzie$elm_3d_scene$Scene3d$Types$Transformed, transformation, node);
		}
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$placeIn = F2(
	function (frame, givenDrawable) {
		return A2(
			$ianmackenzie$elm_3d_scene$Scene3d$Entity$transformBy,
			$ianmackenzie$elm_3d_scene$Scene3d$Transformation$placeIn(frame),
			givenDrawable);
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Types$ShadowNode = function (a) {
	return {$: 3, a: a};
};
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$preScaleBounds = F2(
	function (_v0, bounds) {
		var scaleX = _v0.a;
		var scaleY = _v0.b;
		var scaleZ = _v0.c;
		var originalCenterPoint = bounds.g6;
		return {
			g6: {cF: scaleX * originalCenterPoint.cF, cG: scaleY * originalCenterPoint.cG, cH: scaleZ * originalCenterPoint.cH},
			hM: scaleX * bounds.hM,
			hN: scaleY * bounds.hN,
			hO: scaleZ * bounds.hO
		};
	});
var $elm_explorations$linear_algebra$Math$Vector4$fromRecord = _MJS_v4fromRecord;
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$preScaleDrawFunction = function (_v0) {
	return function (originalDrawFunction) {
		return function (sceneProperties) {
			return function (modelScale) {
				return function (modelMatrix) {
					return function (isRightHanded) {
						return function (viewMatrix) {
							return function (projectionMatrix) {
								return function (lights) {
									return function (settings) {
										var scaleX = _v0.a;
										var scaleY = _v0.b;
										var scaleZ = _v0.c;
										var _v1 = $elm_explorations$linear_algebra$Math$Vector4$toRecord(modelScale);
										var x = _v1.cF;
										var y = _v1.cG;
										var z = _v1.cH;
										var w = _v1.gF;
										var updatedModelScale = $elm_explorations$linear_algebra$Math$Vector4$fromRecord(
											{gF: w, cF: x * scaleX, cG: y * scaleY, cH: z * scaleZ});
										return A8(originalDrawFunction, sceneProperties, updatedModelScale, modelMatrix, isRightHanded, viewMatrix, projectionMatrix, lights, settings);
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$preScaleNode = F2(
	function (scalingFactors, node) {
		switch (node.$) {
			case 0:
				return $ianmackenzie$elm_3d_scene$Scene3d$Types$EmptyNode;
			case 6:
				var transformation = node.a;
				var underlyingNode = node.b;
				return A2(
					$ianmackenzie$elm_3d_scene$Scene3d$Types$Transformed,
					transformation,
					A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$preScaleNode, scalingFactors, underlyingNode));
			case 1:
				var bounds = node.a;
				var drawFunction = node.b;
				return A2(
					$ianmackenzie$elm_3d_scene$Scene3d$Types$OpaqueMeshNode,
					A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$preScaleBounds, scalingFactors, bounds),
					A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$preScaleDrawFunction, scalingFactors, drawFunction));
			case 2:
				var bounds = node.a;
				var drawFunction = node.b;
				return A2(
					$ianmackenzie$elm_3d_scene$Scene3d$Types$TransparentMeshNode,
					A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$preScaleBounds, scalingFactors, bounds),
					A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$preScaleDrawFunction, scalingFactors, drawFunction));
			case 4:
				return node;
			case 3:
				var drawFunction = node.a;
				return $ianmackenzie$elm_3d_scene$Scene3d$Types$ShadowNode(
					A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$preScaleDrawFunction, scalingFactors, drawFunction));
			default:
				var childNodes = node.a;
				return $ianmackenzie$elm_3d_scene$Scene3d$Types$Group(
					A2(
						$elm$core$List$map,
						$ianmackenzie$elm_3d_scene$Scene3d$Entity$preScaleNode(scalingFactors),
						childNodes));
		}
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$preScale = F2(
	function (scalingFactors, _v0) {
		var node = _v0;
		return A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$preScaleNode, scalingFactors, node);
	});
var $ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$shadowFragment = {
	src: '\n        precision lowp float;\n        \n        void main () {\n            gl_FragColor = vec4(0.0, 0.0, 0.0, 1.0);\n        }\n    ',
	attributes: {},
	uniforms: {}
};
var $elm_explorations$webgl$WebGL$Settings$StencilTest$Test = $elm$core$Basics$identity;
var $elm_explorations$webgl$WebGL$Settings$StencilTest$always = 519;
var $elm_explorations$webgl$WebGL$Settings$StencilTest$Operation = $elm$core$Basics$identity;
var $elm_explorations$webgl$WebGL$Settings$StencilTest$decrement = 7683;
var $elm_explorations$webgl$WebGL$Settings$StencilTest$increment = 7682;
var $elm_explorations$webgl$WebGL$Settings$StencilTest$keep = 7680;
var $elm_explorations$webgl$WebGL$Internal$StencilTest = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return {$: 2, a: a, b: b, c: c, d: d, e: e, f: f, g: g, h: h, i: i, j: j, k: k};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm_explorations$webgl$WebGL$Settings$StencilTest$testSeparate = F3(
	function (_v0, options1, options2) {
		var ref = _v0.en;
		var mask = _v0.d0;
		var writeMask = _v0.eE;
		var expandTest = F2(
			function (_v2, fn) {
				var expandedTest = _v2;
				return fn(expandedTest);
			});
		var expandOp = F2(
			function (_v1, fn) {
				var op = _v1;
				return fn(op);
			});
		var expand = function (options) {
			return A2(
				$elm$core$Basics$composeR,
				expandTest(options.cx),
				A2(
					$elm$core$Basics$composeR,
					expandOp(options.cg),
					A2(
						$elm$core$Basics$composeR,
						expandOp(options.cI),
						expandOp(options.cJ))));
		};
		return A2(
			expand,
			options2,
			A2(
				expand,
				options1,
				A3($elm_explorations$webgl$WebGL$Internal$StencilTest, ref, mask, writeMask)));
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$leftHandedStencilTest = A3(
	$elm_explorations$webgl$WebGL$Settings$StencilTest$testSeparate,
	{d0: 0, en: 0, eE: 15},
	{cg: $elm_explorations$webgl$WebGL$Settings$StencilTest$keep, cx: $elm_explorations$webgl$WebGL$Settings$StencilTest$always, cI: $elm_explorations$webgl$WebGL$Settings$StencilTest$keep, cJ: $elm_explorations$webgl$WebGL$Settings$StencilTest$decrement},
	{cg: $elm_explorations$webgl$WebGL$Settings$StencilTest$keep, cx: $elm_explorations$webgl$WebGL$Settings$StencilTest$always, cI: $elm_explorations$webgl$WebGL$Settings$StencilTest$keep, cJ: $elm_explorations$webgl$WebGL$Settings$StencilTest$increment});
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$rightHandedStencilTest = A3(
	$elm_explorations$webgl$WebGL$Settings$StencilTest$testSeparate,
	{d0: 0, en: 0, eE: 15},
	{cg: $elm_explorations$webgl$WebGL$Settings$StencilTest$keep, cx: $elm_explorations$webgl$WebGL$Settings$StencilTest$always, cI: $elm_explorations$webgl$WebGL$Settings$StencilTest$keep, cJ: $elm_explorations$webgl$WebGL$Settings$StencilTest$increment},
	{cg: $elm_explorations$webgl$WebGL$Settings$StencilTest$keep, cx: $elm_explorations$webgl$WebGL$Settings$StencilTest$always, cI: $elm_explorations$webgl$WebGL$Settings$StencilTest$keep, cJ: $elm_explorations$webgl$WebGL$Settings$StencilTest$decrement});
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$shadowSettings = F2(
	function (isRightHanded, settings) {
		return isRightHanded ? A2($elm$core$List$cons, $ianmackenzie$elm_3d_scene$Scene3d$Entity$rightHandedStencilTest, settings) : A2($elm$core$List$cons, $ianmackenzie$elm_3d_scene$Scene3d$Entity$leftHandedStencilTest, settings);
	});
var $ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$shadowVertex = {
	src: '\n        precision highp float;\n        \n        attribute highp vec3 position;\n        attribute highp vec3 normal;\n        \n        uniform highp vec4 modelScale;\n        uniform highp mat4 modelMatrix;\n        uniform highp mat4 viewMatrix;\n        uniform highp mat4 projectionMatrix;\n        uniform highp mat4 sceneProperties;\n        uniform highp mat4 shadowLight;\n        \n        const lowp float kDirectionalLight = 1.0;\n        const lowp float kPointLight = 2.0;\n        \n        vec4 getWorldPosition(vec3 modelPosition, vec4 modelScale, mat4 modelMatrix) {\n            vec4 scaledPosition = vec4(modelScale.xyz * modelPosition, 1.0);\n            return modelMatrix * scaledPosition;\n        }\n        \n        vec3 safeNormalize(vec3 vector) {\n            if (vector == vec3(0.0, 0.0, 0.0)) {\n                return vector;\n            } else {\n                return normalize(vector);\n            }\n        }\n        \n        vec3 getWorldNormal(vec3 modelNormal, vec4 modelScale, mat4 modelMatrix) {\n            vec3 normalScale = vec3(modelScale.w / modelScale.x, modelScale.w / modelScale.y, modelScale.w / modelScale.z);\n            return (modelMatrix * vec4(safeNormalize(normalScale * modelNormal), 0.0)).xyz;\n        }\n        \n        vec3 getDirectionToLight(vec3 surfacePosition, vec4 xyz_type, vec4 rgb_parameter) {\n            float lightType = xyz_type.w;\n            if (lightType == kDirectionalLight) {\n                return xyz_type.xyz;\n            } else if (lightType == kPointLight) {\n                vec3 lightPosition = xyz_type.xyz;\n                return normalize(lightPosition - surfacePosition);\n            } else {\n                return vec3(0.0, 0.0, 0.0);\n            }\n        }\n        \n        vec4 shadowVertexPosition(vec3 position, vec3 normal, mat4 shadowLight, vec4 modelScale, mat4 modelMatrix, mat4 viewMatrix, mat4 projectionMatrix, mat4 sceneProperties) {\n            vec4 worldPosition = getWorldPosition(position, modelScale, modelMatrix);\n            vec3 worldNormal = getWorldNormal(normal, vec4(modelScale.xyz, 1.0), modelMatrix);\n            vec4 xyz_type = shadowLight[0];\n            vec4 rgb_parameter = shadowLight[1];\n            vec3 directionToLight = getDirectionToLight(worldPosition.xyz, xyz_type, rgb_parameter);\n            vec3 offset = vec3(0.0, 0.0, 0.0);\n            float sceneDiameter = sceneProperties[3][1];\n            if (dot(directionToLight, worldNormal) <= 0.0) {\n                offset = -sceneDiameter * directionToLight;\n            } else {\n                offset = -0.001 * sceneDiameter * directionToLight;\n            }\n            vec4 offsetPosition = worldPosition + vec4(offset, 0.0);\n            return projectionMatrix * (viewMatrix * offsetPosition);\n        }\n        \n        void main () {\n            gl_Position = shadowVertexPosition(\n                position,\n                normal,\n                shadowLight,\n                modelScale,\n                modelMatrix,\n                viewMatrix,\n                projectionMatrix,\n                sceneProperties\n            );\n        }\n    ',
	attributes: {normal: 'aS', position: 'f9'},
	uniforms: {modelMatrix: 'b', modelScale: 'c', projectionMatrix: 'd', sceneProperties: 'e', shadowLight: 'dz', viewMatrix: 'f'}
};
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$shadowDrawFunction = function (givenShadow) {
	if (!givenShadow.$) {
		return $elm$core$Maybe$Nothing;
	} else {
		var webGLMesh = givenShadow.c;
		return $elm$core$Maybe$Just(
			F8(
				function (sceneProperties, modelScale, modelMatrix, isRightHanded, viewMatrix, projectionMatrix, shadowLight, settings) {
					return A5(
						$elm_explorations$webgl$WebGL$entityWith,
						A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$shadowSettings, isRightHanded, settings),
						$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$shadowVertex,
						$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$shadowFragment,
						webGLMesh,
						{b: modelMatrix, c: modelScale, d: projectionMatrix, e: sceneProperties, dz: shadowLight, f: viewMatrix});
				}));
	}
};
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$shadow = function (givenShadow) {
	var _v0 = $ianmackenzie$elm_3d_scene$Scene3d$Entity$shadowDrawFunction(givenShadow);
	if (!_v0.$) {
		var drawFunction = _v0.a;
		return $ianmackenzie$elm_3d_scene$Scene3d$Types$ShadowNode(drawFunction);
	} else {
		return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
	}
};
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$block = F4(
	function (renderObject, renderShadow, givenMaterial, givenBlock) {
		var baseEntity = A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$mesh, givenMaterial, $ianmackenzie$elm_3d_scene$Scene3d$Primitives$block);
		var untransformedEntity = function () {
			var _v1 = _Utils_Tuple2(renderObject, renderShadow);
			if (_v1.a) {
				if (_v1.b) {
					return $ianmackenzie$elm_3d_scene$Scene3d$Entity$group(
						_List_fromArray(
							[
								baseEntity,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$shadow($ianmackenzie$elm_3d_scene$Scene3d$Primitives$blockShadow)
							]));
				} else {
					return baseEntity;
				}
			} else {
				if (_v1.b) {
					return $ianmackenzie$elm_3d_scene$Scene3d$Entity$shadow($ianmackenzie$elm_3d_scene$Scene3d$Primitives$blockShadow);
				} else {
					return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
				}
			}
		}();
		var _v0 = $ianmackenzie$elm_geometry$Block3d$dimensions(givenBlock);
		var scaleX = _v0.a;
		var scaleY = _v0.b;
		var scaleZ = _v0.c;
		return A2(
			$ianmackenzie$elm_3d_scene$Scene3d$Entity$placeIn,
			$ianmackenzie$elm_geometry$Block3d$axes(givenBlock),
			A2(
				$ianmackenzie$elm_3d_scene$Scene3d$Entity$preScale,
				_Utils_Tuple3(scaleX, scaleY, scaleZ),
				untransformedEntity));
	});
var $ianmackenzie$elm_3d_scene$Scene3d$blockWithShadow = F2(
	function (givenMaterial, givenBlock) {
		return A4($ianmackenzie$elm_3d_scene$Scene3d$Entity$block, true, true, givenMaterial, givenBlock);
	});
var $ianmackenzie$elm_3d_scene$Scene3d$group = function (entities) {
	return $ianmackenzie$elm_3d_scene$Scene3d$Entity$group(entities);
};
var $ianmackenzie$elm_3d_scene$Scene3d$Types$Constant = function (a) {
	return {$: 0, a: a};
};
var $ianmackenzie$elm_3d_scene$Scene3d$Types$NoNormalMap = {$: 0};
var $ianmackenzie$elm_3d_scene$Scene3d$Types$PbrMaterial = F6(
	function (a, b, c, d, e, f) {
		return {$: 3, a: a, b: b, c: c, d: d, e: e, f: f};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Types$UseMeshUvs = 0;
var $ianmackenzie$elm_3d_scene$Scene3d$Types$LinearRgb = $elm$core$Basics$identity;
var $ianmackenzie$elm_3d_scene$Scene3d$ColorConversions$inverseGamma = function (u) {
	return A3(
		$elm$core$Basics$clamp,
		0,
		1,
		(u <= 0.04045) ? (u / 12.92) : A2($elm$core$Basics$pow, (u + 0.055) / 1.055, 2.4));
};
var $avh4$elm_color$Color$toRgba = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	return {eH: a, gV: b, hK: g, iM: r};
};
var $ianmackenzie$elm_3d_scene$Scene3d$ColorConversions$colorToLinearRgb = function (color) {
	var _v0 = $avh4$elm_color$Color$toRgba(color);
	var red = _v0.iM;
	var green = _v0.hK;
	var blue = _v0.gV;
	var alpha = _v0.eH;
	return A4(
		$elm_explorations$linear_algebra$Math$Vector4$vec4,
		$ianmackenzie$elm_3d_scene$Scene3d$ColorConversions$inverseGamma(red),
		$ianmackenzie$elm_3d_scene$Scene3d$ColorConversions$inverseGamma(green),
		$ianmackenzie$elm_3d_scene$Scene3d$ColorConversions$inverseGamma(blue),
		alpha);
};
var $ianmackenzie$elm_3d_scene$Scene3d$Material$pbr = function (_v0) {
	var baseColor = _v0.ar;
	var roughness = _v0.ax;
	var metallic = _v0.d5;
	return A6(
		$ianmackenzie$elm_3d_scene$Scene3d$Types$PbrMaterial,
		0,
		$ianmackenzie$elm_3d_scene$Scene3d$Types$Constant(
			$ianmackenzie$elm_3d_scene$Scene3d$ColorConversions$colorToLinearRgb(baseColor)),
		$ianmackenzie$elm_3d_scene$Scene3d$Types$Constant(
			A3($elm$core$Basics$clamp, 0, 1, roughness)),
		$ianmackenzie$elm_3d_scene$Scene3d$Types$Constant(
			A3($elm$core$Basics$clamp, 0, 1, metallic)),
		$ianmackenzie$elm_3d_scene$Scene3d$Types$Constant(1),
		$ianmackenzie$elm_3d_scene$Scene3d$Types$NoNormalMap);
};
var $ianmackenzie$elm_3d_scene$Scene3d$Material$nonmetal = function (_v0) {
	var baseColor = _v0.ar;
	var roughness = _v0.ax;
	return $ianmackenzie$elm_3d_scene$Scene3d$Material$pbr(
		{ar: baseColor, d5: 0, ax: roughness});
};
var $ianmackenzie$elm_3d_scene$Scene3d$placeIn = F2(
	function (frame, entity) {
		return A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$placeIn, frame, entity);
	});
var $ianmackenzie$elm_geometry$Vector3d$toUnitless = function (_v0) {
	var vectorComponents = _v0;
	return vectorComponents;
};
var $ianmackenzie$elm_3d_scene$Scene3d$Mesh$collectBumpy = F2(
	function (_v0, accumulated) {
		var position = _v0.f9;
		var normal = _v0.aS;
		var uv = _v0.bZ;
		var tangent = _v0.bR;
		var tangentBasisIsRightHanded = _v0.bS;
		var t = $ianmackenzie$elm_geometry$Vector3d$toUnitless(tangent);
		var bitangentSign = tangentBasisIsRightHanded ? (-1) : 1;
		var _v1 = uv;
		var u = _v1.a;
		var v = _v1.b;
		var vertex = {
			aS: $ianmackenzie$elm_geometry_linear_algebra_interop$Geometry$Interop$LinearAlgebra$Vector3d$toVec3(normal),
			f9: $ianmackenzie$elm_geometry_linear_algebra_interop$Geometry$Interop$LinearAlgebra$Point3d$toVec3(position),
			bR: $elm_explorations$linear_algebra$Math$Vector4$fromRecord(
				{gF: bitangentSign, cF: t.cF, cG: t.cG, cH: t.cH}),
			bZ: A2($elm_explorations$linear_algebra$Math$Vector2$vec2, u, v)
		};
		return A2($elm$core$List$cons, vertex, accumulated);
	});
var $elm_explorations$linear_algebra$Math$Vector3$getX = _MJS_v3getX;
var $elm_explorations$linear_algebra$Math$Vector3$getY = _MJS_v3getY;
var $elm_explorations$linear_algebra$Math$Vector3$getZ = _MJS_v3getZ;
var $ianmackenzie$elm_3d_scene$Scene3d$Mesh$vertexBoundsHelp = F7(
	function (minX, maxX, minY, maxY, minZ, maxZ, remaining) {
		vertexBoundsHelp:
		while (true) {
			if (remaining.b) {
				var next = remaining.a;
				var rest = remaining.b;
				var z = $elm_explorations$linear_algebra$Math$Vector3$getZ(next.f9);
				var y = $elm_explorations$linear_algebra$Math$Vector3$getY(next.f9);
				var x = $elm_explorations$linear_algebra$Math$Vector3$getX(next.f9);
				var $temp$minX = A2($elm$core$Basics$min, minX, x),
					$temp$maxX = A2($elm$core$Basics$max, maxX, x),
					$temp$minY = A2($elm$core$Basics$min, minY, y),
					$temp$maxY = A2($elm$core$Basics$max, maxY, y),
					$temp$minZ = A2($elm$core$Basics$min, minZ, z),
					$temp$maxZ = A2($elm$core$Basics$max, maxZ, z),
					$temp$remaining = rest;
				minX = $temp$minX;
				maxX = $temp$maxX;
				minY = $temp$minY;
				maxY = $temp$maxY;
				minZ = $temp$minZ;
				maxZ = $temp$maxZ;
				remaining = $temp$remaining;
				continue vertexBoundsHelp;
			} else {
				return $ianmackenzie$elm_geometry$BoundingBox3d$fromExtrema(
					{fK: maxX, fL: maxY, fM: maxZ, fN: minX, fO: minY, fP: minZ});
			}
		}
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Mesh$vertexBounds = F2(
	function (first, rest) {
		var z = $elm_explorations$linear_algebra$Math$Vector3$getZ(first.f9);
		var y = $elm_explorations$linear_algebra$Math$Vector3$getY(first.f9);
		var x = $elm_explorations$linear_algebra$Math$Vector3$getX(first.f9);
		return A7($ianmackenzie$elm_3d_scene$Scene3d$Mesh$vertexBoundsHelp, x, x, y, y, z, z, rest);
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Mesh$bumpyFaces = function (givenMesh) {
	var collectedVertices = A3(
		$elm$core$Array$foldr,
		$ianmackenzie$elm_3d_scene$Scene3d$Mesh$collectBumpy,
		_List_Nil,
		$ianmackenzie$elm_triangular_mesh$TriangularMesh$vertices(givenMesh));
	if (!collectedVertices.b) {
		return $ianmackenzie$elm_3d_scene$Scene3d$Types$EmptyMesh;
	} else {
		var first = collectedVertices.a;
		var rest = collectedVertices.b;
		var webGLMesh = A2(
			$elm_explorations$webgl$WebGL$indexedTriangles,
			collectedVertices,
			$ianmackenzie$elm_triangular_mesh$TriangularMesh$faceIndices(givenMesh));
		var bounds = A2($ianmackenzie$elm_3d_scene$Scene3d$Mesh$vertexBounds, first, rest);
		return A4($ianmackenzie$elm_3d_scene$Scene3d$Types$MeshWithTangents, bounds, givenMesh, webGLMesh, 0);
	}
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $ianmackenzie$elm_3d_scene$Scene3d$meshWithShadow = F3(
	function (givenMaterial, givenMesh, givenShadow) {
		return $ianmackenzie$elm_3d_scene$Scene3d$group(
			_List_fromArray(
				[
					A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$mesh, givenMaterial, givenMesh),
					$ianmackenzie$elm_3d_scene$Scene3d$Entity$shadow(givenShadow)
				]));
	});
var $ianmackenzie$elm_geometry$Vector3d$unitless = F3(
	function (x, y, z) {
		return {cF: x, cG: y, cH: z};
	});
var $author$project$Scene3d$Entity$Arena$renderTiledBox = F5(
	function (bx, by, bz, tileM, mat) {
		var uz = bz / tileM;
		var uy = by / tileM;
		var ux = bx / tileM;
		var p = $ianmackenzie$elm_geometry$Point3d$meters;
		var n1 = $ianmackenzie$elm_geometry$Vector3d$unitless;
		var makeVert = F4(
			function (pos, norm, tang, uv) {
				return {aS: norm, f9: pos, bR: tang, bS: false, bZ: uv};
			});
		var makeFaceTris = function (faceIdx) {
			var b = faceIdx * 4;
			return _List_fromArray(
				[
					_Utils_Tuple3(b, b + 1, b + 2),
					_Utils_Tuple3(b, b + 2, b + 3)
				]);
		};
		var hz = bz / 2;
		var hy = by / 2;
		var hx = bx / 2;
		var facePoZ = _List_fromArray(
			[
				A4(
				makeVert,
				A3(p, -hx, -hy, hz),
				A3(n1, 0, 0, 1),
				A3(n1, 1, 0, 0),
				_Utils_Tuple2(0, 0)),
				A4(
				makeVert,
				A3(p, hx, -hy, hz),
				A3(n1, 0, 0, 1),
				A3(n1, 1, 0, 0),
				_Utils_Tuple2(ux, 0)),
				A4(
				makeVert,
				A3(p, hx, hy, hz),
				A3(n1, 0, 0, 1),
				A3(n1, 1, 0, 0),
				_Utils_Tuple2(ux, uy)),
				A4(
				makeVert,
				A3(p, -hx, hy, hz),
				A3(n1, 0, 0, 1),
				A3(n1, 1, 0, 0),
				_Utils_Tuple2(0, uy))
			]);
		var facePoY = _List_fromArray(
			[
				A4(
				makeVert,
				A3(p, hx, hy, -hz),
				A3(n1, 0, 1, 0),
				A3(n1, -1, 0, 0),
				_Utils_Tuple2(0, 0)),
				A4(
				makeVert,
				A3(p, -hx, hy, -hz),
				A3(n1, 0, 1, 0),
				A3(n1, -1, 0, 0),
				_Utils_Tuple2(ux, 0)),
				A4(
				makeVert,
				A3(p, -hx, hy, hz),
				A3(n1, 0, 1, 0),
				A3(n1, -1, 0, 0),
				_Utils_Tuple2(ux, uz)),
				A4(
				makeVert,
				A3(p, hx, hy, hz),
				A3(n1, 0, 1, 0),
				A3(n1, -1, 0, 0),
				_Utils_Tuple2(0, uz))
			]);
		var facePoX = _List_fromArray(
			[
				A4(
				makeVert,
				A3(p, hx, -hy, -hz),
				A3(n1, 1, 0, 0),
				A3(n1, 0, 1, 0),
				_Utils_Tuple2(0, 0)),
				A4(
				makeVert,
				A3(p, hx, hy, -hz),
				A3(n1, 1, 0, 0),
				A3(n1, 0, 1, 0),
				_Utils_Tuple2(uy, 0)),
				A4(
				makeVert,
				A3(p, hx, hy, hz),
				A3(n1, 1, 0, 0),
				A3(n1, 0, 1, 0),
				_Utils_Tuple2(uy, uz)),
				A4(
				makeVert,
				A3(p, hx, -hy, hz),
				A3(n1, 1, 0, 0),
				A3(n1, 0, 1, 0),
				_Utils_Tuple2(0, uz))
			]);
		var faceNeZ = _List_fromArray(
			[
				A4(
				makeVert,
				A3(p, -hx, hy, -hz),
				A3(n1, 0, 0, -1),
				A3(n1, 1, 0, 0),
				_Utils_Tuple2(0, 0)),
				A4(
				makeVert,
				A3(p, hx, hy, -hz),
				A3(n1, 0, 0, -1),
				A3(n1, 1, 0, 0),
				_Utils_Tuple2(ux, 0)),
				A4(
				makeVert,
				A3(p, hx, -hy, -hz),
				A3(n1, 0, 0, -1),
				A3(n1, 1, 0, 0),
				_Utils_Tuple2(ux, uy)),
				A4(
				makeVert,
				A3(p, -hx, -hy, -hz),
				A3(n1, 0, 0, -1),
				A3(n1, 1, 0, 0),
				_Utils_Tuple2(0, uy))
			]);
		var faceNeY = _List_fromArray(
			[
				A4(
				makeVert,
				A3(p, -hx, -hy, -hz),
				A3(n1, 0, -1, 0),
				A3(n1, 1, 0, 0),
				_Utils_Tuple2(0, 0)),
				A4(
				makeVert,
				A3(p, hx, -hy, -hz),
				A3(n1, 0, -1, 0),
				A3(n1, 1, 0, 0),
				_Utils_Tuple2(ux, 0)),
				A4(
				makeVert,
				A3(p, hx, -hy, hz),
				A3(n1, 0, -1, 0),
				A3(n1, 1, 0, 0),
				_Utils_Tuple2(ux, uz)),
				A4(
				makeVert,
				A3(p, -hx, -hy, hz),
				A3(n1, 0, -1, 0),
				A3(n1, 1, 0, 0),
				_Utils_Tuple2(0, uz))
			]);
		var faceNeX = _List_fromArray(
			[
				A4(
				makeVert,
				A3(p, -hx, hy, -hz),
				A3(n1, -1, 0, 0),
				A3(n1, 0, -1, 0),
				_Utils_Tuple2(0, 0)),
				A4(
				makeVert,
				A3(p, -hx, -hy, -hz),
				A3(n1, -1, 0, 0),
				A3(n1, 0, -1, 0),
				_Utils_Tuple2(uy, 0)),
				A4(
				makeVert,
				A3(p, -hx, -hy, hz),
				A3(n1, -1, 0, 0),
				A3(n1, 0, -1, 0),
				_Utils_Tuple2(uy, uz)),
				A4(
				makeVert,
				A3(p, -hx, hy, hz),
				A3(n1, -1, 0, 0),
				A3(n1, 0, -1, 0),
				_Utils_Tuple2(0, uz))
			]);
		var allVertices = $elm$core$Array$fromList(
			_Utils_ap(
				facePoX,
				_Utils_ap(
					faceNeX,
					_Utils_ap(
						facePoY,
						_Utils_ap(
							faceNeY,
							_Utils_ap(facePoZ, faceNeZ))))));
		var allFaces = A2(
			$elm$core$List$concatMap,
			makeFaceTris,
			A2($elm$core$List$range, 0, 5));
		var mesh = $ianmackenzie$elm_3d_scene$Scene3d$Mesh$bumpyFaces(
			A2($ianmackenzie$elm_triangular_mesh$TriangularMesh$indexed, allVertices, allFaces));
		var shadow = $ianmackenzie$elm_3d_scene$Scene3d$Mesh$shadow(mesh);
		return A3($ianmackenzie$elm_3d_scene$Scene3d$meshWithShadow, mat, mesh, shadow);
	});
var $avh4$elm_color$Color$rgb = F3(
	function (r, g, b) {
		return A4($avh4$elm_color$Color$RgbaSpace, r, g, b, 1.0);
	});
var $author$project$Scene3d$Entity$Arena$boundaryWalls = function (maybeWallMat) {
	var wallThickness = 1.0;
	var wallHeight = 7.5;
	var wallCenterZ = (wallHeight / 2) - 1.0;
	var makeWall = F4(
		function (cx, cy, sizeX, sizeY) {
			var center = A3($ianmackenzie$elm_geometry$Point3d$meters, cx, cy, wallCenterZ);
			var wallFrame = $ianmackenzie$elm_geometry$Frame3d$atPoint(center);
			if (!maybeWallMat.$) {
				var wallMat = maybeWallMat.a;
				return A2(
					$ianmackenzie$elm_3d_scene$Scene3d$placeIn,
					wallFrame,
					A5($author$project$Scene3d$Entity$Arena$renderTiledBox, sizeX, sizeY, wallHeight, 1.0, wallMat));
			} else {
				return A2(
					$ianmackenzie$elm_3d_scene$Scene3d$blockWithShadow,
					$ianmackenzie$elm_3d_scene$Scene3d$Material$nonmetal(
						{
							ar: A3($avh4$elm_color$Color$rgb, 0.35, 0.33, 0.3),
							ax: 0.93
						}),
					A2(
						$ianmackenzie$elm_geometry$Block3d$centeredOn,
						wallFrame,
						_Utils_Tuple3(
							$ianmackenzie$elm_units$Length$meters(sizeX),
							$ianmackenzie$elm_units$Length$meters(sizeY),
							$ianmackenzie$elm_units$Length$meters(wallHeight))));
			}
		});
	var longSide = $author$project$Config$arenaWidthMeters + (wallThickness * 2);
	var half = $author$project$Config$arenaWidthMeters / 2;
	var outerCenter = half + (wallThickness / 2);
	return $ianmackenzie$elm_3d_scene$Scene3d$group(
		_List_fromArray(
			[
				A4(makeWall, outerCenter, 0, wallThickness, longSide),
				A4(makeWall, -outerCenter, 0, wallThickness, longSide),
				A4(makeWall, 0, outerCenter, longSide, wallThickness),
				A4(makeWall, 0, -outerCenter, longSide, wallThickness)
			]));
};
var $author$project$Physics$Body$data = function (_v0) {
	var body = _v0;
	return body.eS;
};
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$browser$Browser$Dom$getViewport = _Browser_withWindow(_Browser_getViewport);
var $author$project$Game$Playing$Joystick$init = $elm$core$Maybe$Nothing;
var $elm$core$Basics$atan2 = _Basics_atan2;
var $ianmackenzie$elm_geometry$Direction3d$angleFrom = F2(
	function (_v0, _v1) {
		var d1 = _v0;
		var d2 = _v1;
		var relativeX = ((d1.cF * d2.cF) + (d1.cG * d2.cG)) + (d1.cH * d2.cH);
		var cz = (d1.cF * d2.cG) - (d1.cG * d2.cF);
		var cy = (d1.cH * d2.cF) - (d1.cF * d2.cH);
		var cx = (d1.cG * d2.cH) - (d1.cH * d2.cG);
		var relativeY = $elm$core$Basics$sqrt(((cx * cx) + (cy * cy)) + (cz * cz));
		return A2($elm$core$Basics$atan2, relativeY, relativeX);
	});
var $author$project$Physics$World$bodies = function (_v0) {
	var world = _v0;
	return A3(
		$elm$core$List$foldl,
		F2(
			function (body, result) {
				return A2($elm$core$List$cons, body, result);
			}),
		_List_Nil,
		world.eK);
};
var $author$project$Me$getInBodies = $elm_community$list_extra$List$Extra$find(
	A2(
		$elm$core$Basics$composeR,
		$author$project$Physics$Body$data,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.hb;
			},
			$elm$core$Basics$eq(0))));
var $author$project$Me$getInWorld = A2($elm$core$Basics$composeR, $author$project$Physics$World$bodies, $author$project$Me$getInBodies);
var $ianmackenzie$elm_units$Angle$inDegrees = function (angle) {
	return 180 * ($ianmackenzie$elm_units$Angle$inRadians(angle) / $elm$core$Basics$pi);
};
var $author$project$Game$Playing$initCameraZRotation = function (world) {
	var _v0 = $author$project$Me$getInWorld(world);
	if (!_v0.$) {
		var me = _v0.a;
		var myLookDirection = $ianmackenzie$elm_geometry$Frame3d$yDirection(
			$author$project$Physics$Body$frame(me));
		var myRotationAngle = $ianmackenzie$elm_units$Angle$inDegrees(
			A2(
				$ianmackenzie$elm_geometry$Direction3d$angleFrom,
				$ianmackenzie$elm_geometry$Frame3d$yDirection($ianmackenzie$elm_geometry$Frame3d$atOrigin),
				myLookDirection));
		return ($ianmackenzie$elm_geometry$Direction3d$xComponent(myLookDirection) > 0) ? (360.0 - myRotationAngle) : myRotationAngle;
	} else {
		return 0;
	}
};
var $author$project$Physics$World$empty = {eK: _List_Nil, hf: _List_Nil, hh: _List_Nil, hH: _List_Nil, ff: $author$project$Internal$Vector3$zero, io: 0, iY: $elm$core$Array$empty};
var $ianmackenzie$elm_units$Acceleration$metersPerSecondSquared = function (numMetersPerSecondSquared) {
	return numMetersPerSecondSquared;
};
var $ianmackenzie$elm_geometry$Direction3d$negativeZ = $ianmackenzie$elm_geometry$Direction3d$unsafe(
	{cF: 0, cG: 0, cH: -1});
var $ianmackenzie$elm_units$Acceleration$inMetersPerSecondSquared = function (_v0) {
	var numMetersPerSecondSquared = _v0;
	return numMetersPerSecondSquared;
};
var $author$project$Physics$World$withGravity = F3(
	function (acceleration, direction, _v0) {
		var world = _v0;
		return _Utils_update(
			world,
			{
				ff: A2(
					$author$project$Internal$Vector3$scale,
					$ianmackenzie$elm_units$Acceleration$inMetersPerSecondSquared(acceleration),
					$ianmackenzie$elm_geometry$Direction3d$unwrap(direction))
			});
	});
var $author$project$Game$Playing$initWorld = A3(
	$author$project$Physics$World$withGravity,
	$ianmackenzie$elm_units$Acceleration$metersPerSecondSquared(9.80665),
	$ianmackenzie$elm_geometry$Direction3d$negativeZ,
	$author$project$Physics$World$empty);
var $ianmackenzie$elm_3d_scene$Scene3d$nothing = $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
var $author$project$Scene3d$Entity$Arena$crateVariantMaterial = function (body) {
	var pos = $ianmackenzie$elm_geometry$Point3d$toMeters(
		$author$project$Physics$Body$originPoint(body));
	var hash = $elm$core$Basics$abs(
		$elm$core$Basics$floor((pos.cF * 7) + (pos.cG * 13)));
	var _v0 = A2($elm$core$Basics$modBy, 4, hash);
	switch (_v0) {
		case 0:
			return $ianmackenzie$elm_3d_scene$Scene3d$Material$nonmetal(
				{
					ar: A3($avh4$elm_color$Color$rgb, 0.52, 0.5, 0.46),
					ax: 0.92
				});
		case 1:
			return $ianmackenzie$elm_3d_scene$Scene3d$Material$nonmetal(
				{
					ar: A3($avh4$elm_color$Color$rgb, 0.3, 0.28, 0.26),
					ax: 0.95
				});
		case 2:
			return $ianmackenzie$elm_3d_scene$Scene3d$Material$nonmetal(
				{
					ar: A3($avh4$elm_color$Color$rgb, 0.42, 0.47, 0.36),
					ax: 0.68
				});
		default:
			return $ianmackenzie$elm_3d_scene$Scene3d$Material$nonmetal(
				{
					ar: A3($avh4$elm_color$Color$rgb, 0.62, 0.54, 0.42),
					ax: 0.88
				});
	}
};
var $ianmackenzie$elm_geometry$Geometry$Types$Cone3d = $elm$core$Basics$identity;
var $ianmackenzie$elm_geometry$Point3d$along = F2(
	function (_v0, _v1) {
		var axis = _v0;
		var distance = _v1;
		var _v2 = axis.iE;
		var p0 = _v2;
		var _v3 = axis.eW;
		var d = _v3;
		return {cF: p0.cF + (distance * d.cF), cG: p0.cG + (distance * d.cG), cH: p0.cH + (distance * d.cH)};
	});
var $ianmackenzie$elm_units$Quantity$greaterThanOrEqualTo = F2(
	function (_v0, _v1) {
		var y = _v0;
		var x = _v1;
		return _Utils_cmp(x, y) > -1;
	});
var $ianmackenzie$elm_geometry$Cone3d$along = F2(
	function (givenAxis, _arguments) {
		var givenAxisDirection = $ianmackenzie$elm_geometry$Axis3d$direction(givenAxis);
		var computedDirection = A2($ianmackenzie$elm_units$Quantity$greaterThanOrEqualTo, _arguments.gU, _arguments.ja) ? givenAxisDirection : $ianmackenzie$elm_geometry$Direction3d$reverse(givenAxisDirection);
		var computedBasePoint = A2($ianmackenzie$elm_geometry$Point3d$along, givenAxis, _arguments.gU);
		return {
			p: A2($ianmackenzie$elm_geometry$Axis3d$through, computedBasePoint, computedDirection),
			dU: $ianmackenzie$elm_units$Quantity$abs(
				A2($ianmackenzie$elm_units$Quantity$minus, _arguments.gU, _arguments.ja)),
			em: $ianmackenzie$elm_units$Quantity$abs(_arguments.em)
		};
	});
var $ianmackenzie$elm_geometry$Cone3d$axis = function (_v0) {
	var cone = _v0;
	return cone.p;
};
var $elm$core$Elm$JsArray$appendN = _JsArray_appendN;
var $elm$core$Elm$JsArray$slice = _JsArray_slice;
var $elm$core$Array$appendHelpBuilder = F2(
	function (tail, builder) {
		var tailLen = $elm$core$Elm$JsArray$length(tail);
		var notAppended = ($elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(builder.v)) - tailLen;
		var appended = A3($elm$core$Elm$JsArray$appendN, $elm$core$Array$branchFactor, builder.v, tail);
		return (notAppended < 0) ? {
			G: A2(
				$elm$core$List$cons,
				$elm$core$Array$Leaf(appended),
				builder.G),
			r: builder.r + 1,
			v: A3($elm$core$Elm$JsArray$slice, notAppended, tailLen, tail)
		} : ((!notAppended) ? {
			G: A2(
				$elm$core$List$cons,
				$elm$core$Array$Leaf(appended),
				builder.G),
			r: builder.r + 1,
			v: $elm$core$Elm$JsArray$empty
		} : {G: builder.G, r: builder.r, v: appended});
	});
var $elm$core$Elm$JsArray$push = _JsArray_push;
var $elm$core$Elm$JsArray$singleton = _JsArray_singleton;
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$insertTailInTree = F4(
	function (shift, index, tail, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		if (_Utils_cmp(
			pos,
			$elm$core$Elm$JsArray$length(tree)) > -1) {
			if (shift === 5) {
				return A2(
					$elm$core$Elm$JsArray$push,
					$elm$core$Array$Leaf(tail),
					tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, $elm$core$Elm$JsArray$empty));
				return A2($elm$core$Elm$JsArray$push, newSub, tree);
			}
		} else {
			var value = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!value.$) {
				var subTree = value.a;
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, subTree));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4(
						$elm$core$Array$insertTailInTree,
						shift - $elm$core$Array$shiftStep,
						index,
						tail,
						$elm$core$Elm$JsArray$singleton(value)));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			}
		}
	});
var $elm$core$Array$unsafeReplaceTail = F2(
	function (newTail, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var originalTailLen = $elm$core$Elm$JsArray$length(tail);
		var newTailLen = $elm$core$Elm$JsArray$length(newTail);
		var newArrayLen = len + (newTailLen - originalTailLen);
		if (_Utils_eq(newTailLen, $elm$core$Array$branchFactor)) {
			var overflow = _Utils_cmp(newArrayLen >>> $elm$core$Array$shiftStep, 1 << startShift) > 0;
			if (overflow) {
				var newShift = startShift + $elm$core$Array$shiftStep;
				var newTree = A4(
					$elm$core$Array$insertTailInTree,
					newShift,
					len,
					newTail,
					$elm$core$Elm$JsArray$singleton(
						$elm$core$Array$SubTree(tree)));
				return A4($elm$core$Array$Array_elm_builtin, newArrayLen, newShift, newTree, $elm$core$Elm$JsArray$empty);
			} else {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					newArrayLen,
					startShift,
					A4($elm$core$Array$insertTailInTree, startShift, len, newTail, tree),
					$elm$core$Elm$JsArray$empty);
			}
		} else {
			return A4($elm$core$Array$Array_elm_builtin, newArrayLen, startShift, tree, newTail);
		}
	});
var $elm$core$Array$appendHelpTree = F2(
	function (toAppend, array) {
		var len = array.a;
		var tree = array.c;
		var tail = array.d;
		var itemsToAppend = $elm$core$Elm$JsArray$length(toAppend);
		var notAppended = ($elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(tail)) - itemsToAppend;
		var appended = A3($elm$core$Elm$JsArray$appendN, $elm$core$Array$branchFactor, tail, toAppend);
		var newArray = A2($elm$core$Array$unsafeReplaceTail, appended, array);
		if (notAppended < 0) {
			var nextTail = A3($elm$core$Elm$JsArray$slice, notAppended, itemsToAppend, toAppend);
			return A2($elm$core$Array$unsafeReplaceTail, nextTail, newArray);
		} else {
			return newArray;
		}
	});
var $elm$core$Elm$JsArray$foldl = _JsArray_foldl;
var $elm$core$Array$builderFromArray = function (_v0) {
	var len = _v0.a;
	var tree = _v0.c;
	var tail = _v0.d;
	var helper = F2(
		function (node, acc) {
			if (!node.$) {
				var subTree = node.a;
				return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
			} else {
				return A2($elm$core$List$cons, node, acc);
			}
		});
	return {
		G: A3($elm$core$Elm$JsArray$foldl, helper, _List_Nil, tree),
		r: (len / $elm$core$Array$branchFactor) | 0,
		v: tail
	};
};
var $elm$core$Array$append = F2(
	function (a, _v0) {
		var aTail = a.d;
		var bLen = _v0.a;
		var bTree = _v0.c;
		var bTail = _v0.d;
		if (_Utils_cmp(bLen, $elm$core$Array$branchFactor * 4) < 1) {
			var foldHelper = F2(
				function (node, array) {
					if (!node.$) {
						var tree = node.a;
						return A3($elm$core$Elm$JsArray$foldl, foldHelper, array, tree);
					} else {
						var leaf = node.a;
						return A2($elm$core$Array$appendHelpTree, leaf, array);
					}
				});
			return A2(
				$elm$core$Array$appendHelpTree,
				bTail,
				A3($elm$core$Elm$JsArray$foldl, foldHelper, a, bTree));
		} else {
			var foldHelper = F2(
				function (node, builder) {
					if (!node.$) {
						var tree = node.a;
						return A3($elm$core$Elm$JsArray$foldl, foldHelper, builder, tree);
					} else {
						var leaf = node.a;
						return A2($elm$core$Array$appendHelpBuilder, leaf, builder);
					}
				});
			return A2(
				$elm$core$Array$builderToArray,
				true,
				A2(
					$elm$core$Array$appendHelpBuilder,
					bTail,
					A3(
						$elm$core$Elm$JsArray$foldl,
						foldHelper,
						$elm$core$Array$builderFromArray(a),
						bTree)));
		}
	});
var $ianmackenzie$elm_triangular_mesh$TriangularMesh$addMesh = F2(
	function (mesh, accumulated) {
		var meshVertices = $ianmackenzie$elm_triangular_mesh$TriangularMesh$vertices(mesh);
		var meshFaceIndices = $ianmackenzie$elm_triangular_mesh$TriangularMesh$faceIndices(mesh);
		var accumulatedVertices = $ianmackenzie$elm_triangular_mesh$TriangularMesh$vertices(accumulated);
		var offset = $elm$core$Array$length(accumulatedVertices);
		var prependFace = F2(
			function (_v0, accumulatedFaces) {
				var i = _v0.a;
				var j = _v0.b;
				var k = _v0.c;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple3(i + offset, j + offset, k + offset),
					accumulatedFaces);
			});
		var accumulatedFaceIndices = $ianmackenzie$elm_triangular_mesh$TriangularMesh$faceIndices(accumulated);
		var combinedFaceIndices = A3($elm$core$List$foldl, prependFace, accumulatedFaceIndices, meshFaceIndices);
		return {
			N: combinedFaceIndices,
			cE: A2($elm$core$Array$append, accumulatedVertices, meshVertices)
		};
	});
var $ianmackenzie$elm_triangular_mesh$TriangularMesh$empty = {N: _List_Nil, cE: $elm$core$Array$empty};
var $ianmackenzie$elm_triangular_mesh$TriangularMesh$reverseFaceIndices = function (_v0) {
	var mesh = _v0;
	return {
		N: $elm$core$List$reverse(mesh.N),
		cE: mesh.cE
	};
};
var $ianmackenzie$elm_triangular_mesh$TriangularMesh$combine = function (meshes) {
	if (meshes.b) {
		var first = meshes.a;
		var rest = meshes.b;
		return $ianmackenzie$elm_triangular_mesh$TriangularMesh$reverseFaceIndices(
			A3(
				$elm$core$List$foldl,
				$ianmackenzie$elm_triangular_mesh$TriangularMesh$addMesh,
				$ianmackenzie$elm_triangular_mesh$TriangularMesh$reverseFaceIndices(first),
				rest));
	} else {
		return $ianmackenzie$elm_triangular_mesh$TriangularMesh$empty;
	}
};
var $ianmackenzie$elm_3d_scene$Scene3d$Mesh$collectSmooth = F2(
	function (_v0, accumulated) {
		var position = _v0.f9;
		var normal = _v0.aS;
		return A2(
			$elm$core$List$cons,
			{
				aS: $ianmackenzie$elm_geometry_linear_algebra_interop$Geometry$Interop$LinearAlgebra$Vector3d$toVec3(normal),
				f9: $ianmackenzie$elm_geometry_linear_algebra_interop$Geometry$Interop$LinearAlgebra$Point3d$toVec3(position)
			},
			accumulated);
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Mesh$indexedFaces = function (givenMesh) {
	var collectedVertices = A3(
		$elm$core$Array$foldr,
		$ianmackenzie$elm_3d_scene$Scene3d$Mesh$collectSmooth,
		_List_Nil,
		$ianmackenzie$elm_triangular_mesh$TriangularMesh$vertices(givenMesh));
	if (!collectedVertices.b) {
		return $ianmackenzie$elm_3d_scene$Scene3d$Types$EmptyMesh;
	} else {
		var first = collectedVertices.a;
		var rest = collectedVertices.b;
		var webGLMesh = A2(
			$elm_explorations$webgl$WebGL$indexedTriangles,
			collectedVertices,
			$ianmackenzie$elm_triangular_mesh$TriangularMesh$faceIndices(givenMesh));
		var bounds = A2($ianmackenzie$elm_3d_scene$Scene3d$Mesh$vertexBounds, first, rest);
		return A4($ianmackenzie$elm_3d_scene$Scene3d$Types$MeshWithNormals, bounds, givenMesh, webGLMesh, 0);
	}
};
var $ianmackenzie$elm_1d_parameter$Parameter1d$range = F5(
	function (startIndex, index, divisor, _function, accumulated) {
		range:
		while (true) {
			var newValue = _function(index / divisor);
			var newAccumulated = A2($elm$core$List$cons, newValue, accumulated);
			if (_Utils_eq(index, startIndex)) {
				return newAccumulated;
			} else {
				var $temp$startIndex = startIndex,
					$temp$index = index - 1,
					$temp$divisor = divisor,
					$temp$function = _function,
					$temp$accumulated = newAccumulated;
				startIndex = $temp$startIndex;
				index = $temp$index;
				divisor = $temp$divisor;
				_function = $temp$function;
				accumulated = $temp$accumulated;
				continue range;
			}
		}
	});
var $ianmackenzie$elm_1d_parameter$Parameter1d$leading = F2(
	function (n, _function) {
		return (n < 1) ? _List_Nil : A5($ianmackenzie$elm_1d_parameter$Parameter1d$range, 0, n - 1, n, _function, _List_Nil);
	});
var $ianmackenzie$elm_triangular_mesh$TriangularMesh$radial = F2(
	function (tip, loop) {
		var n = $elm$core$List$length(loop);
		return (n >= 2) ? {
			N: A2(
				$elm$core$List$map,
				function (i) {
					return _Utils_eq(i, n - 1) ? _Utils_Tuple3(0, n, 1) : _Utils_Tuple3(0, 1 + i, 2 + i);
				},
				A2($elm$core$List$range, 0, n - 1)),
			cE: $elm$core$Array$fromList(
				A2($elm$core$List$cons, tip, loop))
		} : $ianmackenzie$elm_triangular_mesh$TriangularMesh$empty;
	});
var $ianmackenzie$elm_geometry$Point3d$unsafe = function (givenCoordinates) {
	return givenCoordinates;
};
var $ianmackenzie$elm_geometry$Vector3d$unsafe = function (givenComponents) {
	return givenComponents;
};
var $ianmackenzie$elm_3d_scene$Scene3d$Primitives$cone = function () {
	var tip = {
		aS: $ianmackenzie$elm_geometry$Vector3d$zero,
		f9: $ianmackenzie$elm_geometry$Point3d$unsafe(
			{cF: 0, cG: 0, cH: 1})
	};
	var negativeZVector = $ianmackenzie$elm_geometry$Vector3d$unsafe(
		{cF: 0, cG: 0, cH: -1});
	var halfRootTwo = 0.5 * $elm$core$Basics$sqrt(2);
	var sides = A2(
		$ianmackenzie$elm_triangular_mesh$TriangularMesh$radial,
		tip,
		A2(
			$ianmackenzie$elm_1d_parameter$Parameter1d$leading,
			72,
			function (u) {
				var theta = (2 * $elm$core$Basics$pi) * u;
				var sinTheta = $elm$core$Basics$sin(theta);
				var cosTheta = $elm$core$Basics$cos(theta);
				return {
					aS: $ianmackenzie$elm_geometry$Vector3d$unsafe(
						{cF: cosTheta * halfRootTwo, cG: sinTheta * halfRootTwo, cH: halfRootTwo}),
					f9: $ianmackenzie$elm_geometry$Point3d$unsafe(
						{cF: cosTheta, cG: sinTheta, cH: 0})
				};
			}));
	var bottomCenter = {aS: negativeZVector, f9: $ianmackenzie$elm_geometry$Point3d$origin};
	var bottom = A2(
		$ianmackenzie$elm_triangular_mesh$TriangularMesh$radial,
		bottomCenter,
		A2(
			$ianmackenzie$elm_1d_parameter$Parameter1d$leading,
			72,
			function (u) {
				var theta = (2 * $elm$core$Basics$pi) * u;
				var sinTheta = $elm$core$Basics$sin(theta);
				var cosTheta = $elm$core$Basics$cos(theta);
				return {
					aS: negativeZVector,
					f9: $ianmackenzie$elm_geometry$Point3d$unsafe(
						{cF: cosTheta, cG: -sinTheta, cH: 0})
				};
			}));
	return $ianmackenzie$elm_3d_scene$Scene3d$Mesh$cullBackFaces(
		$ianmackenzie$elm_3d_scene$Scene3d$Mesh$indexedFaces(
			$ianmackenzie$elm_triangular_mesh$TriangularMesh$combine(
				_List_fromArray(
					[bottom, sides]))));
}();
var $ianmackenzie$elm_3d_scene$Scene3d$Primitives$coneShadow = $ianmackenzie$elm_3d_scene$Scene3d$Mesh$shadow($ianmackenzie$elm_3d_scene$Scene3d$Primitives$cone);
var $ianmackenzie$elm_geometry$Frame3d$fromZAxis = function (givenZAxis) {
	var givenZDirection = $ianmackenzie$elm_geometry$Axis3d$direction(givenZAxis);
	var _v0 = $ianmackenzie$elm_geometry$Direction3d$perpendicularBasis(givenZDirection);
	var computedXDirection = _v0.a;
	var computedYDirection = _v0.b;
	return $ianmackenzie$elm_geometry$Frame3d$unsafe(
		{
			iE: $ianmackenzie$elm_geometry$Axis3d$originPoint(givenZAxis),
			jr: computedXDirection,
			jv: computedYDirection,
			jz: givenZDirection
		});
};
var $ianmackenzie$elm_geometry$Cone3d$length = function (_v0) {
	var cone = _v0;
	return cone.dU;
};
var $ianmackenzie$elm_geometry$Cone3d$radius = function (_v0) {
	var cone = _v0;
	return cone.em;
};
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$cone = F4(
	function (renderObject, renderShadow, givenMaterial, givenCone) {
		var baseFrame = $ianmackenzie$elm_geometry$Frame3d$fromZAxis(
			$ianmackenzie$elm_geometry$Cone3d$axis(givenCone));
		var baseEntity = A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$mesh, givenMaterial, $ianmackenzie$elm_3d_scene$Scene3d$Primitives$cone);
		var untransformedEntity = function () {
			var _v2 = _Utils_Tuple2(renderObject, renderShadow);
			if (_v2.a) {
				if (_v2.b) {
					return $ianmackenzie$elm_3d_scene$Scene3d$Entity$group(
						_List_fromArray(
							[
								baseEntity,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$shadow($ianmackenzie$elm_3d_scene$Scene3d$Primitives$coneShadow)
							]));
				} else {
					return baseEntity;
				}
			} else {
				if (_v2.b) {
					return $ianmackenzie$elm_3d_scene$Scene3d$Entity$shadow($ianmackenzie$elm_3d_scene$Scene3d$Primitives$coneShadow);
				} else {
					return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
				}
			}
		}();
		var _v0 = $ianmackenzie$elm_geometry$Cone3d$radius(givenCone);
		var radius = _v0;
		var _v1 = $ianmackenzie$elm_geometry$Cone3d$length(givenCone);
		var length = _v1;
		return A2(
			$ianmackenzie$elm_3d_scene$Scene3d$Entity$placeIn,
			baseFrame,
			A2(
				$ianmackenzie$elm_3d_scene$Scene3d$Entity$preScale,
				_Utils_Tuple3(radius, radius, length),
				untransformedEntity));
	});
var $ianmackenzie$elm_3d_scene$Scene3d$coneWithShadow = F2(
	function (givenMaterial, givenCone) {
		return A4($ianmackenzie$elm_3d_scene$Scene3d$Entity$cone, true, true, givenMaterial, givenCone);
	});
var $ianmackenzie$elm_triangular_mesh$TriangularMesh$gridFaceIndices = F6(
	function (uSteps, uVertices, vVertices, uIndex0, vIndex0, accumulatedIndices) {
		gridFaceIndices:
		while (true) {
			var uIndex1 = A2($elm$core$Basics$modBy, uVertices, uIndex0 + 1);
			var rowStart1 = uVertices * A2($elm$core$Basics$modBy, vVertices, vIndex0 + 1);
			var rowStart0 = uVertices * vIndex0;
			var index11 = rowStart1 + uIndex1;
			var index10 = rowStart0 + uIndex1;
			var index01 = rowStart1 + uIndex0;
			var index00 = rowStart0 + uIndex0;
			var lowerFaceIndices = _Utils_Tuple3(index00, index10, index11);
			var upperFaceIndices = _Utils_Tuple3(index00, index11, index01);
			var updatedIndices = A2(
				$elm$core$List$cons,
				lowerFaceIndices,
				A2($elm$core$List$cons, upperFaceIndices, accumulatedIndices));
			if (uIndex0 > 0) {
				var $temp$uSteps = uSteps,
					$temp$uVertices = uVertices,
					$temp$vVertices = vVertices,
					$temp$uIndex0 = uIndex0 - 1,
					$temp$vIndex0 = vIndex0,
					$temp$accumulatedIndices = updatedIndices;
				uSteps = $temp$uSteps;
				uVertices = $temp$uVertices;
				vVertices = $temp$vVertices;
				uIndex0 = $temp$uIndex0;
				vIndex0 = $temp$vIndex0;
				accumulatedIndices = $temp$accumulatedIndices;
				continue gridFaceIndices;
			} else {
				if (vIndex0 > 0) {
					var $temp$uSteps = uSteps,
						$temp$uVertices = uVertices,
						$temp$vVertices = vVertices,
						$temp$uIndex0 = uSteps - 1,
						$temp$vIndex0 = vIndex0 - 1,
						$temp$accumulatedIndices = updatedIndices;
					uSteps = $temp$uSteps;
					uVertices = $temp$uVertices;
					vVertices = $temp$vVertices;
					uIndex0 = $temp$uIndex0;
					vIndex0 = $temp$vIndex0;
					accumulatedIndices = $temp$accumulatedIndices;
					continue gridFaceIndices;
				} else {
					return updatedIndices;
				}
			}
		}
	});
var $ianmackenzie$elm_triangular_mesh$TriangularMesh$gridImpl = F5(
	function (uSteps, vSteps, uVertices, vVertices, _function) {
		return ((uVertices <= 1) || (vVertices <= 1)) ? $ianmackenzie$elm_triangular_mesh$TriangularMesh$empty : {
			N: A6($ianmackenzie$elm_triangular_mesh$TriangularMesh$gridFaceIndices, uSteps, uVertices, vVertices, uSteps - 1, vSteps - 1, _List_Nil),
			cE: A2(
				$elm$core$Array$initialize,
				uVertices * vVertices,
				function (index) {
					return A2(
						_function,
						A2($elm$core$Basics$modBy, uVertices, index),
						(index / uVertices) | 0);
				})
		};
	});
var $ianmackenzie$elm_triangular_mesh$TriangularMesh$indexedTube = F3(
	function (uSteps, vSteps, _function) {
		return A5($ianmackenzie$elm_triangular_mesh$TriangularMesh$gridImpl, uSteps, vSteps, uSteps + 1, vSteps, _function);
	});
var $ianmackenzie$elm_triangular_mesh$TriangularMesh$toIndexedFunction = F5(
	function (uSteps, vSteps, _function, uIndex, vIndex) {
		return A2(_function, uIndex / uSteps, vIndex / vSteps);
	});
var $ianmackenzie$elm_triangular_mesh$TriangularMesh$tube = F3(
	function (uSteps, vSteps, _function) {
		return A3(
			$ianmackenzie$elm_triangular_mesh$TriangularMesh$indexedTube,
			uSteps,
			vSteps,
			A3($ianmackenzie$elm_triangular_mesh$TriangularMesh$toIndexedFunction, uSteps, vSteps, _function));
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Primitives$cylinder = function () {
	var sides = A3(
		$ianmackenzie$elm_triangular_mesh$TriangularMesh$tube,
		1,
		72,
		F2(
			function (u, v) {
				var theta = (2 * $elm$core$Basics$pi) * v;
				var sinTheta = $elm$core$Basics$sin(theta);
				var cosTheta = $elm$core$Basics$cos(theta);
				return {
					aS: $ianmackenzie$elm_geometry$Vector3d$unsafe(
						{cF: cosTheta, cG: -sinTheta, cH: 0}),
					f9: $ianmackenzie$elm_geometry$Point3d$unsafe(
						{cF: cosTheta, cG: -sinTheta, cH: u - 0.5})
				};
			}));
	var positiveZVector = $ianmackenzie$elm_geometry$Vector3d$unsafe(
		{cF: 0, cG: 0, cH: 1});
	var topCenter = {
		aS: positiveZVector,
		f9: $ianmackenzie$elm_geometry$Point3d$unsafe(
			{cF: 0, cG: 0, cH: 0.5})
	};
	var top = A2(
		$ianmackenzie$elm_triangular_mesh$TriangularMesh$radial,
		topCenter,
		A2(
			$ianmackenzie$elm_1d_parameter$Parameter1d$leading,
			72,
			function (u) {
				var theta = (2 * $elm$core$Basics$pi) * u;
				return {
					aS: positiveZVector,
					f9: $ianmackenzie$elm_geometry$Point3d$unsafe(
						{
							cF: $elm$core$Basics$cos(theta),
							cG: $elm$core$Basics$sin(theta),
							cH: 0.5
						})
				};
			}));
	var negativeZVector = $ianmackenzie$elm_geometry$Vector3d$unsafe(
		{cF: 0, cG: 0, cH: -1});
	var bottomCenter = {
		aS: negativeZVector,
		f9: $ianmackenzie$elm_geometry$Point3d$unsafe(
			{cF: 0, cG: 0, cH: -0.5})
	};
	var bottom = A2(
		$ianmackenzie$elm_triangular_mesh$TriangularMesh$radial,
		bottomCenter,
		A2(
			$ianmackenzie$elm_1d_parameter$Parameter1d$leading,
			72,
			function (u) {
				var theta = (2 * $elm$core$Basics$pi) * u;
				return {
					aS: negativeZVector,
					f9: $ianmackenzie$elm_geometry$Point3d$unsafe(
						{
							cF: $elm$core$Basics$cos(theta),
							cG: -$elm$core$Basics$sin(theta),
							cH: -0.5
						})
				};
			}));
	return $ianmackenzie$elm_3d_scene$Scene3d$Mesh$cullBackFaces(
		$ianmackenzie$elm_3d_scene$Scene3d$Mesh$indexedFaces(
			$ianmackenzie$elm_triangular_mesh$TriangularMesh$combine(
				_List_fromArray(
					[top, bottom, sides]))));
}();
var $ianmackenzie$elm_3d_scene$Scene3d$Primitives$cylinderShadow = $ianmackenzie$elm_3d_scene$Scene3d$Mesh$shadow($ianmackenzie$elm_3d_scene$Scene3d$Primitives$cylinder);
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$cylinder = F4(
	function (renderObject, renderShadow, givenMaterial, givenCylinder) {
		var centerFrame = $ianmackenzie$elm_geometry$Frame3d$fromZAxis(
			$ianmackenzie$elm_geometry$Cylinder3d$axis(givenCylinder));
		var baseEntity = A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$mesh, givenMaterial, $ianmackenzie$elm_3d_scene$Scene3d$Primitives$cylinder);
		var untransformedEntity = function () {
			var _v2 = _Utils_Tuple2(renderObject, renderShadow);
			if (_v2.a) {
				if (_v2.b) {
					return $ianmackenzie$elm_3d_scene$Scene3d$Entity$group(
						_List_fromArray(
							[
								baseEntity,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$shadow($ianmackenzie$elm_3d_scene$Scene3d$Primitives$cylinderShadow)
							]));
				} else {
					return baseEntity;
				}
			} else {
				if (_v2.b) {
					return $ianmackenzie$elm_3d_scene$Scene3d$Entity$shadow($ianmackenzie$elm_3d_scene$Scene3d$Primitives$cylinderShadow);
				} else {
					return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
				}
			}
		}();
		var _v0 = $ianmackenzie$elm_geometry$Cylinder3d$radius(givenCylinder);
		var radius = _v0;
		var _v1 = $ianmackenzie$elm_geometry$Cylinder3d$length(givenCylinder);
		var length = _v1;
		return A2(
			$ianmackenzie$elm_3d_scene$Scene3d$Entity$placeIn,
			centerFrame,
			A2(
				$ianmackenzie$elm_3d_scene$Scene3d$Entity$preScale,
				_Utils_Tuple3(radius, radius, length),
				untransformedEntity));
	});
var $ianmackenzie$elm_3d_scene$Scene3d$cylinderWithShadow = F2(
	function (givenMaterial, givenCylinder) {
		return A4($ianmackenzie$elm_3d_scene$Scene3d$Entity$cylinder, true, true, givenMaterial, givenCylinder);
	});
var $author$project$Scene3d$Entity$Common$renderCylinderLateralWithTexture = F3(
	function (radius, height, mat) {
		var slices = 32;
		var pi = 3.14159265358979;
		var vertexAt = F2(
			function (i, isTop) {
				var z = isTop ? (height / 2) : (-(height / 2));
				var v = isTop ? 1 : 0;
				var angle = (i / slices) * (2 * pi);
				var cosA = $elm$core$Basics$cos(angle);
				var sinA = $elm$core$Basics$sin(angle);
				return {
					aS: A3($ianmackenzie$elm_geometry$Vector3d$unitless, cosA, sinA, 0),
					f9: A3($ianmackenzie$elm_geometry$Point3d$meters, radius * cosA, radius * sinA, z),
					bR: A3($ianmackenzie$elm_geometry$Vector3d$unitless, -sinA, cosA, 0),
					bS: false,
					bZ: _Utils_Tuple2(i / slices, v)
				};
			});
		var vertices = $elm$core$Array$fromList(
			A2(
				$elm$core$List$concatMap,
				function (i) {
					return _List_fromArray(
						[
							A2(vertexAt, i, false),
							A2(vertexAt, i, true)
						]);
				},
				A2($elm$core$List$range, 0, slices)));
		var faces = A2(
			$elm$core$List$concatMap,
			function (i) {
				var tr = ((i + 1) * 2) + 1;
				var tl = (i * 2) + 1;
				var br = (i + 1) * 2;
				var bl = i * 2;
				return _List_fromArray(
					[
						_Utils_Tuple3(bl, br, tr),
						_Utils_Tuple3(bl, tr, tl)
					]);
			},
			A2($elm$core$List$range, 0, slices - 1));
		var mesh = $ianmackenzie$elm_3d_scene$Scene3d$Mesh$bumpyFaces(
			A2($ianmackenzie$elm_triangular_mesh$TriangularMesh$indexed, vertices, faces));
		var shadow = $ianmackenzie$elm_3d_scene$Scene3d$Mesh$shadow(mesh);
		return A3($ianmackenzie$elm_3d_scene$Scene3d$meshWithShadow, mat, mesh, shadow);
	});
var $author$project$Scene3d$Entity$Tree$render = F4(
	function (trunkRadius, height, maybeBarkMat, maybeLeafMat) {
		var trunkLength = height / 3.0;
		var trunkCenterZ = -(height / 3.0);
		var trunk = function () {
			if (!maybeBarkMat.$) {
				var barkMat = maybeBarkMat.a;
				return A2(
					$ianmackenzie$elm_3d_scene$Scene3d$placeIn,
					$ianmackenzie$elm_geometry$Frame3d$atPoint(
						A3($ianmackenzie$elm_geometry$Point3d$meters, 0, 0, trunkCenterZ)),
					A3($author$project$Scene3d$Entity$Common$renderCylinderLateralWithTexture, trunkRadius, trunkLength, barkMat));
			} else {
				return A2(
					$ianmackenzie$elm_3d_scene$Scene3d$cylinderWithShadow,
					$ianmackenzie$elm_3d_scene$Scene3d$Material$nonmetal(
						{
							ar: A3($avh4$elm_color$Color$rgb, 0.36, 0.22, 0.11),
							ax: 0.95
						}),
					A3(
						$ianmackenzie$elm_geometry$Cylinder3d$centeredOn,
						A3($ianmackenzie$elm_geometry$Point3d$meters, 0, 0, trunkCenterZ),
						$ianmackenzie$elm_geometry$Direction3d$z,
						{
							dU: $ianmackenzie$elm_units$Length$meters(trunkLength),
							em: $ianmackenzie$elm_units$Length$meters(trunkRadius)
						}));
			}
		}();
		var canopyStartZ = -(height / 6.0);
		var canopyMaterial = $ianmackenzie$elm_3d_scene$Scene3d$Material$nonmetal(
			{
				ar: A3($avh4$elm_color$Color$rgb, 0.14, 0.42, 0.12),
				ax: 0.9
			});
		var canopyEndZ = height / 2.0;
		var canopyHeight = canopyEndZ - canopyStartZ;
		var maxRadius = A2($elm$core$Basics$max, trunkRadius * 3.5, canopyHeight * 0.45);
		var makeTier = F3(
			function (baseZ, tipZ, radiusFactor) {
				return A2(
					$ianmackenzie$elm_3d_scene$Scene3d$coneWithShadow,
					canopyMaterial,
					A2(
						$ianmackenzie$elm_geometry$Cone3d$along,
						A2(
							$ianmackenzie$elm_geometry$Axis3d$through,
							A3($ianmackenzie$elm_geometry$Point3d$meters, 0, 0, baseZ),
							$ianmackenzie$elm_geometry$Direction3d$z),
						{
							gU: $ianmackenzie$elm_units$Length$meters(0),
							em: $ianmackenzie$elm_units$Length$meters(maxRadius * radiusFactor),
							ja: $ianmackenzie$elm_units$Length$meters(tipZ - baseZ)
						}));
			});
		return $ianmackenzie$elm_3d_scene$Scene3d$group(
			_List_fromArray(
				[
					trunk,
					A3(makeTier, canopyStartZ, canopyStartZ + (canopyHeight * 0.5), 1.0),
					A3(makeTier, canopyStartZ + (canopyHeight * 0.28), canopyStartZ + (canopyHeight * 0.75), 0.65),
					A3(makeTier, canopyStartZ + (canopyHeight * 0.52), canopyEndZ, 0.38)
				]));
	});
var $author$project$Scene3d$Entity$Arena$renderDiscWithTexture = F2(
	function (radius, mat) {
		var slices = 24;
		var pi = 3.14159265358979;
		var rimVertex = function (i) {
			var phi = (i / slices) * (2 * pi);
			var sinP = $elm$core$Basics$sin(phi);
			var cosP = $elm$core$Basics$cos(phi);
			return {
				aS: A3($ianmackenzie$elm_geometry$Vector3d$unitless, 0, 0, 1),
				f9: A3($ianmackenzie$elm_geometry$Point3d$meters, radius * cosP, radius * sinP, 0),
				bR: A3($ianmackenzie$elm_geometry$Vector3d$unitless, -sinP, cosP, 0),
				bS: false,
				bZ: _Utils_Tuple2(0.5 + (0.5 * cosP), 0.5 + (0.5 * sinP))
			};
		};
		var faces = A2(
			$elm$core$List$map,
			function (i) {
				return _Utils_Tuple3(
					0,
					i + 1,
					_Utils_eq(i + 1, slices) ? 1 : (i + 2));
			},
			A2($elm$core$List$range, 0, slices - 1));
		var centerVertex = {
			aS: A3($ianmackenzie$elm_geometry$Vector3d$unitless, 0, 0, 1),
			f9: $ianmackenzie$elm_geometry$Point3d$origin,
			bR: A3($ianmackenzie$elm_geometry$Vector3d$unitless, 1, 0, 0),
			bS: false,
			bZ: _Utils_Tuple2(0.5, 0.5)
		};
		var vertices = $elm$core$Array$fromList(
			A2(
				$elm$core$List$cons,
				centerVertex,
				A2(
					$elm$core$List$map,
					rimVertex,
					A2($elm$core$List$range, 0, slices - 1))));
		var mesh = $ianmackenzie$elm_3d_scene$Scene3d$Mesh$bumpyFaces(
			A2($ianmackenzie$elm_triangular_mesh$TriangularMesh$indexed, vertices, faces));
		var shadow = $ianmackenzie$elm_3d_scene$Scene3d$Mesh$shadow(mesh);
		return A3($ianmackenzie$elm_3d_scene$Scene3d$meshWithShadow, mat, mesh, shadow);
	});
var $author$project$Scene3d$Entity$Arena$renderColumn = F3(
	function (radius, height, stoneMat) {
		var capThickness = 0.1;
		var shaft = function () {
			if (!stoneMat.$) {
				var mat = stoneMat.a;
				return A3($author$project$Scene3d$Entity$Common$renderCylinderLateralWithTexture, radius, height, mat);
			} else {
				return A2(
					$ianmackenzie$elm_3d_scene$Scene3d$cylinderWithShadow,
					$ianmackenzie$elm_3d_scene$Scene3d$Material$nonmetal(
						{
							ar: A3($avh4$elm_color$Color$rgb, 0.72, 0.68, 0.62),
							ax: 0.72
						}),
					A3(
						$ianmackenzie$elm_geometry$Cylinder3d$centeredOn,
						$ianmackenzie$elm_geometry$Point3d$origin,
						$ianmackenzie$elm_geometry$Direction3d$z,
						{
							dU: $ianmackenzie$elm_units$Length$meters(height - (capThickness * 2)),
							em: $ianmackenzie$elm_units$Length$meters(radius)
						}));
			}
		}();
		var capRadius = radius * 1.45;
		var capMaterial = $ianmackenzie$elm_3d_scene$Scene3d$Material$nonmetal(
			{
				ar: A3($avh4$elm_color$Color$rgb, 0.3, 0.27, 0.22),
				ax: 0.68
			});
		var topCap = A2(
			$ianmackenzie$elm_3d_scene$Scene3d$cylinderWithShadow,
			capMaterial,
			A3(
				$ianmackenzie$elm_geometry$Cylinder3d$centeredOn,
				A3($ianmackenzie$elm_geometry$Point3d$meters, 0, 0, (height / 2) - (capThickness / 2)),
				$ianmackenzie$elm_geometry$Direction3d$z,
				{
					dU: $ianmackenzie$elm_units$Length$meters(capThickness),
					em: $ianmackenzie$elm_units$Length$meters(capRadius)
				}));
		var topDiscEntity = A2(
			$ianmackenzie$elm_3d_scene$Scene3d$placeIn,
			$ianmackenzie$elm_geometry$Frame3d$atPoint(
				A3($ianmackenzie$elm_geometry$Point3d$meters, 0, 0, height / 2)),
			A2($author$project$Scene3d$Entity$Arena$renderDiscWithTexture, capRadius, capMaterial));
		var baseCap = A2(
			$ianmackenzie$elm_3d_scene$Scene3d$cylinderWithShadow,
			capMaterial,
			A3(
				$ianmackenzie$elm_geometry$Cylinder3d$centeredOn,
				A3($ianmackenzie$elm_geometry$Point3d$meters, 0, 0, ((-height) / 2) + (capThickness / 2)),
				$ianmackenzie$elm_geometry$Direction3d$z,
				{
					dU: $ianmackenzie$elm_units$Length$meters(capThickness),
					em: $ianmackenzie$elm_units$Length$meters(capRadius)
				}));
		return $ianmackenzie$elm_3d_scene$Scene3d$group(
			_List_fromArray(
				[baseCap, shaft, topCap, topDiscEntity]));
	});
var $author$project$Scene3d$Entity$Arena$renderCrateWithTexture = F4(
	function (bx, by, bz, mat) {
		var p = $ianmackenzie$elm_geometry$Point3d$meters;
		var n1 = $ianmackenzie$elm_geometry$Vector3d$unitless;
		var makeVert = F4(
			function (pos, norm, tang, uv) {
				return {aS: norm, f9: pos, bR: tang, bS: false, bZ: uv};
			});
		var makeFaceTris = function (faceIdx) {
			var b = faceIdx * 4;
			return _List_fromArray(
				[
					_Utils_Tuple3(b, b + 1, b + 2),
					_Utils_Tuple3(b, b + 2, b + 3)
				]);
		};
		var hz = bz / 2;
		var hy = by / 2;
		var hx = bx / 2;
		var facePoZ = _List_fromArray(
			[
				A4(
				makeVert,
				A3(p, -hx, -hy, hz),
				A3(n1, 0, 0, 1),
				A3(n1, 1, 0, 0),
				_Utils_Tuple2(0, 0)),
				A4(
				makeVert,
				A3(p, hx, -hy, hz),
				A3(n1, 0, 0, 1),
				A3(n1, 1, 0, 0),
				_Utils_Tuple2(1, 0)),
				A4(
				makeVert,
				A3(p, hx, hy, hz),
				A3(n1, 0, 0, 1),
				A3(n1, 1, 0, 0),
				_Utils_Tuple2(1, 1)),
				A4(
				makeVert,
				A3(p, -hx, hy, hz),
				A3(n1, 0, 0, 1),
				A3(n1, 1, 0, 0),
				_Utils_Tuple2(0, 1))
			]);
		var facePoY = _List_fromArray(
			[
				A4(
				makeVert,
				A3(p, hx, hy, -hz),
				A3(n1, 0, 1, 0),
				A3(n1, -1, 0, 0),
				_Utils_Tuple2(0, 0)),
				A4(
				makeVert,
				A3(p, -hx, hy, -hz),
				A3(n1, 0, 1, 0),
				A3(n1, -1, 0, 0),
				_Utils_Tuple2(1, 0)),
				A4(
				makeVert,
				A3(p, -hx, hy, hz),
				A3(n1, 0, 1, 0),
				A3(n1, -1, 0, 0),
				_Utils_Tuple2(1, 1)),
				A4(
				makeVert,
				A3(p, hx, hy, hz),
				A3(n1, 0, 1, 0),
				A3(n1, -1, 0, 0),
				_Utils_Tuple2(0, 1))
			]);
		var facePoX = _List_fromArray(
			[
				A4(
				makeVert,
				A3(p, hx, -hy, -hz),
				A3(n1, 1, 0, 0),
				A3(n1, 0, 1, 0),
				_Utils_Tuple2(0, 0)),
				A4(
				makeVert,
				A3(p, hx, hy, -hz),
				A3(n1, 1, 0, 0),
				A3(n1, 0, 1, 0),
				_Utils_Tuple2(1, 0)),
				A4(
				makeVert,
				A3(p, hx, hy, hz),
				A3(n1, 1, 0, 0),
				A3(n1, 0, 1, 0),
				_Utils_Tuple2(1, 1)),
				A4(
				makeVert,
				A3(p, hx, -hy, hz),
				A3(n1, 1, 0, 0),
				A3(n1, 0, 1, 0),
				_Utils_Tuple2(0, 1))
			]);
		var faceNeZ = _List_fromArray(
			[
				A4(
				makeVert,
				A3(p, -hx, hy, -hz),
				A3(n1, 0, 0, -1),
				A3(n1, 1, 0, 0),
				_Utils_Tuple2(0, 0)),
				A4(
				makeVert,
				A3(p, hx, hy, -hz),
				A3(n1, 0, 0, -1),
				A3(n1, 1, 0, 0),
				_Utils_Tuple2(1, 0)),
				A4(
				makeVert,
				A3(p, hx, -hy, -hz),
				A3(n1, 0, 0, -1),
				A3(n1, 1, 0, 0),
				_Utils_Tuple2(1, 1)),
				A4(
				makeVert,
				A3(p, -hx, -hy, -hz),
				A3(n1, 0, 0, -1),
				A3(n1, 1, 0, 0),
				_Utils_Tuple2(0, 1))
			]);
		var faceNeY = _List_fromArray(
			[
				A4(
				makeVert,
				A3(p, -hx, -hy, -hz),
				A3(n1, 0, -1, 0),
				A3(n1, 1, 0, 0),
				_Utils_Tuple2(0, 0)),
				A4(
				makeVert,
				A3(p, hx, -hy, -hz),
				A3(n1, 0, -1, 0),
				A3(n1, 1, 0, 0),
				_Utils_Tuple2(1, 0)),
				A4(
				makeVert,
				A3(p, hx, -hy, hz),
				A3(n1, 0, -1, 0),
				A3(n1, 1, 0, 0),
				_Utils_Tuple2(1, 1)),
				A4(
				makeVert,
				A3(p, -hx, -hy, hz),
				A3(n1, 0, -1, 0),
				A3(n1, 1, 0, 0),
				_Utils_Tuple2(0, 1))
			]);
		var faceNeX = _List_fromArray(
			[
				A4(
				makeVert,
				A3(p, -hx, hy, -hz),
				A3(n1, -1, 0, 0),
				A3(n1, 0, -1, 0),
				_Utils_Tuple2(0, 0)),
				A4(
				makeVert,
				A3(p, -hx, -hy, -hz),
				A3(n1, -1, 0, 0),
				A3(n1, 0, -1, 0),
				_Utils_Tuple2(1, 0)),
				A4(
				makeVert,
				A3(p, -hx, -hy, hz),
				A3(n1, -1, 0, 0),
				A3(n1, 0, -1, 0),
				_Utils_Tuple2(1, 1)),
				A4(
				makeVert,
				A3(p, -hx, hy, hz),
				A3(n1, -1, 0, 0),
				A3(n1, 0, -1, 0),
				_Utils_Tuple2(0, 1))
			]);
		var allVertices = $elm$core$Array$fromList(
			_Utils_ap(
				facePoX,
				_Utils_ap(
					faceNeX,
					_Utils_ap(
						facePoY,
						_Utils_ap(
							faceNeY,
							_Utils_ap(facePoZ, faceNeZ))))));
		var allFaces = A2(
			$elm$core$List$concatMap,
			makeFaceTris,
			A2($elm$core$List$range, 0, 5));
		var mesh = $ianmackenzie$elm_3d_scene$Scene3d$Mesh$bumpyFaces(
			A2($ianmackenzie$elm_triangular_mesh$TriangularMesh$indexed, allVertices, allFaces));
		var shadow = $ianmackenzie$elm_3d_scene$Scene3d$Mesh$shadow(mesh);
		return A3($ianmackenzie$elm_3d_scene$Scene3d$meshWithShadow, mat, mesh, shadow);
	});
var $author$project$Scene3d$Entity$Arena$boulderWithTexture = F2(
	function (radius, mat) {
		var stacks = 16;
		var slices = 32;
		var pi = 3.14159265358979;
		var idx = F2(
			function (i, j) {
				return (i * (slices + 1)) + j;
			});
		var faces = A2(
			$elm$core$List$concatMap,
			function (i) {
				return A2(
					$elm$core$List$concatMap,
					function (j) {
						return _List_fromArray(
							[
								_Utils_Tuple3(
								A2(idx, i, j),
								A2(idx, i + 1, j),
								A2(idx, i + 1, j + 1)),
								_Utils_Tuple3(
								A2(idx, i, j),
								A2(idx, i + 1, j + 1),
								A2(idx, i, j + 1))
							]);
					},
					A2($elm$core$List$range, 0, slices - 1));
			},
			A2($elm$core$List$range, 0, stacks - 1));
		var cz = 0.5 - radius;
		var vertex = F2(
			function (i, j) {
				var lon = (j / slices) * (2 * pi);
				var slon = $elm$core$Basics$sin(lon);
				var lat = ((-pi) / 2) + ((i / stacks) * pi);
				var slat = $elm$core$Basics$sin(lat);
				var clon = $elm$core$Basics$cos(lon);
				var clat = $elm$core$Basics$cos(lat);
				return {
					aS: A3($ianmackenzie$elm_geometry$Vector3d$unitless, clat * clon, clat * slon, slat),
					f9: A3($ianmackenzie$elm_geometry$Point3d$meters, (radius * clat) * clon, (radius * clat) * slon, cz + (radius * slat)),
					bR: A3($ianmackenzie$elm_geometry$Vector3d$unitless, -slon, clon, 0),
					bS: false,
					bZ: _Utils_Tuple2(j / slices, i / stacks)
				};
			});
		var vertices = $elm$core$Array$fromList(
			A2(
				$elm$core$List$concatMap,
				function (i) {
					return A2(
						$elm$core$List$map,
						vertex(i),
						A2($elm$core$List$range, 0, slices));
				},
				A2($elm$core$List$range, 0, stacks)));
		var mesh = $ianmackenzie$elm_3d_scene$Scene3d$Mesh$bumpyFaces(
			A2($ianmackenzie$elm_triangular_mesh$TriangularMesh$indexed, vertices, faces));
		var shadow = $ianmackenzie$elm_3d_scene$Scene3d$Mesh$shadow(mesh);
		return A3($ianmackenzie$elm_3d_scene$Scene3d$meshWithShadow, mat, mesh, shadow);
	});
var $ianmackenzie$elm_triangular_mesh$TriangularMesh$indexedGrid = F3(
	function (uSteps, vSteps, _function) {
		return A5($ianmackenzie$elm_triangular_mesh$TriangularMesh$gridImpl, uSteps, vSteps, uSteps + 1, vSteps + 1, _function);
	});
var $ianmackenzie$elm_triangular_mesh$TriangularMesh$grid = F3(
	function (uSteps, vSteps, _function) {
		return A3(
			$ianmackenzie$elm_triangular_mesh$TriangularMesh$indexedGrid,
			uSteps,
			vSteps,
			A3($ianmackenzie$elm_triangular_mesh$TriangularMesh$toIndexedFunction, uSteps, vSteps, _function));
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Primitives$sphere = $ianmackenzie$elm_3d_scene$Scene3d$Mesh$cullBackFaces(
	$ianmackenzie$elm_3d_scene$Scene3d$Mesh$bumpyFaces(
		A3(
			$ianmackenzie$elm_triangular_mesh$TriangularMesh$grid,
			72,
			72,
			F2(
				function (u, v) {
					var theta = (2 * $elm$core$Basics$pi) * u;
					var sinTheta = $elm$core$Basics$sin(theta);
					var phi = ((-$elm$core$Basics$pi) / 2) + ($elm$core$Basics$pi * v);
					var sinPhi = $elm$core$Basics$sin(phi);
					var cosTheta = $elm$core$Basics$cos(theta);
					var cosPhi = $elm$core$Basics$cos(phi);
					var xyz = {cF: cosPhi * cosTheta, cG: cosPhi * sinTheta, cH: sinPhi};
					return {
						aS: $ianmackenzie$elm_geometry$Vector3d$unsafe(xyz),
						f9: $ianmackenzie$elm_geometry$Point3d$unsafe(xyz),
						bR: $ianmackenzie$elm_geometry$Vector3d$unsafe(
							{cF: -sinTheta, cG: cosTheta, cH: 0}),
						bS: true,
						bZ: _Utils_Tuple2(u, v)
					};
				}))));
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$numStrips = 72;
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$numOutlineVertices = 2 * $ianmackenzie$elm_3d_scene$Scene3d$Entity$numStrips;
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$buildSphereShadowIndices = F2(
	function (stripIndex, accumulated) {
		buildSphereShadowIndices:
		while (true) {
			var f = $ianmackenzie$elm_3d_scene$Scene3d$Entity$numOutlineVertices + 1;
			var e = A2($elm$core$Basics$modBy, $ianmackenzie$elm_3d_scene$Scene3d$Entity$numOutlineVertices, (2 * stripIndex) + 3);
			var d = A2($elm$core$Basics$modBy, $ianmackenzie$elm_3d_scene$Scene3d$Entity$numOutlineVertices, (2 * stripIndex) + 2);
			var c = (2 * stripIndex) + 1;
			var b = 2 * stripIndex;
			var a = $ianmackenzie$elm_3d_scene$Scene3d$Entity$numOutlineVertices;
			var updated = A2(
				$elm$core$List$cons,
				_Utils_Tuple3(a, b, d),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple3(b, e, d),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple3(b, c, e),
						A2(
							$elm$core$List$cons,
							_Utils_Tuple3(c, f, e),
							accumulated))));
			if (!stripIndex) {
				return updated;
			} else {
				var $temp$stripIndex = stripIndex - 1,
					$temp$accumulated = updated;
				stripIndex = $temp$stripIndex;
				accumulated = $temp$accumulated;
				continue buildSphereShadowIndices;
			}
		}
	});
var $ianmackenzie$elm_float_extra$Float$Extra$interpolateFrom = F3(
	function (start, end, parameter) {
		return (parameter <= 0.5) ? (start + (parameter * (end - start))) : (end + ((1 - parameter) * (start - end)));
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$buildSphereShadowVertices = F2(
	function (stripIndex, accumulated) {
		buildSphereShadowVertices:
		while (true) {
			var angle = A3($ianmackenzie$elm_float_extra$Float$Extra$interpolateFrom, 0, 2 * $elm$core$Basics$pi, stripIndex / $ianmackenzie$elm_3d_scene$Scene3d$Entity$numStrips);
			var left = {dH: angle, dg: 0, dt: 1};
			var right = {dH: angle, dg: 1, dt: 1};
			var updated = A2(
				$elm$core$List$cons,
				left,
				A2($elm$core$List$cons, right, accumulated));
			if (!stripIndex) {
				return updated;
			} else {
				var $temp$stripIndex = stripIndex - 1,
					$temp$accumulated = updated;
				stripIndex = $temp$stripIndex;
				accumulated = $temp$accumulated;
				continue buildSphereShadowVertices;
			}
		}
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$sphereShadowMesh = function () {
	var sphereShadowVertices = A2(
		$ianmackenzie$elm_3d_scene$Scene3d$Entity$buildSphereShadowVertices,
		$ianmackenzie$elm_3d_scene$Scene3d$Entity$numStrips - 1,
		_List_fromArray(
			[
				{dH: 0, dg: 0, dt: 0},
				{dH: 0, dg: 1, dt: 0}
			]));
	var sphereShadowIndices = A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$buildSphereShadowIndices, $ianmackenzie$elm_3d_scene$Scene3d$Entity$numStrips - 1, _List_Nil);
	return A2($elm_explorations$webgl$WebGL$indexedTriangles, sphereShadowVertices, sphereShadowIndices);
}();
var $ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$sphereShadowVertex = {
	src: '\n        precision highp float;\n        \n        attribute highp float angle;\n        attribute highp float offsetScale;\n        attribute highp float radiusScale;\n        \n        uniform highp vec4 modelScale;\n        uniform highp mat4 modelMatrix;\n        uniform highp mat4 viewMatrix;\n        uniform highp mat4 projectionMatrix;\n        uniform highp mat4 sceneProperties;\n        uniform highp mat4 shadowLight;\n        \n        const lowp float kDirectionalLight = 1.0;\n        const lowp float kPointLight = 2.0;\n        const lowp float kPerspectiveProjection = 0.0;\n        \n        vec4 getWorldPosition(vec3 modelPosition, vec4 modelScale, mat4 modelMatrix) {\n            vec4 scaledPosition = vec4(modelScale.xyz * modelPosition, 1.0);\n            return modelMatrix * scaledPosition;\n        }\n        \n        vec3 getDirectionToLight(vec3 surfacePosition, vec4 xyz_type, vec4 rgb_parameter) {\n            float lightType = xyz_type.w;\n            if (lightType == kDirectionalLight) {\n                return xyz_type.xyz;\n            } else if (lightType == kPointLight) {\n                vec3 lightPosition = xyz_type.xyz;\n                return normalize(lightPosition - surfacePosition);\n            } else {\n                return vec3(0.0, 0.0, 0.0);\n            }\n        }\n        \n        vec3 perpendicularTo(vec3 d) {\n            float absX = abs(d.x);\n            float absY = abs(d.y);\n            float absZ = abs(d.z);\n            if (absX <= absY) {\n                if (absX <= absZ) {\n                    float scale = 1.0 / length(d.zy);\n                    return vec3(0.0, -d.z * scale, d.y * scale);\n                } else {\n                    float scale = 1.0 / length(d.xy);\n                    return vec3(-d.y * scale, d.x * scale, 0.0);\n                }\n            } else {\n                if (absY <= absZ) {\n                    float scale = 1.0 / length(d.xz);\n                    return vec3(d.z * scale, 0.0, -d.x * scale);\n                } else {\n                    float scale = 1.0 / length(d.xy);\n                    return vec3(-d.y * scale, d.x * scale, 0.0);\n                }\n            }\n        }\n        \n        void main () {\n            vec4 worldCenter = getWorldPosition(vec3(0.0, 0.0, 0.0), modelScale, modelMatrix);\n            vec4 xyz_type = shadowLight[0];\n            vec4 rgb_parameter = shadowLight[1];\n            vec3 zDirection = getDirectionToLight(worldCenter.xyz, xyz_type, rgb_parameter);\n            vec3 xDirection = perpendicularTo(zDirection);\n            vec3 yDirection = cross(zDirection, xDirection);\n            float r = modelScale.x;\n            float adjustedRadius = r;\n            float zOffset = 0.0;\n            if (xyz_type.w == kPointLight) {\n                float distanceToLight = length(xyz_type.xyz - worldCenter.xyz);\n                float rSquared = r * r;\n                zOffset = rSquared / distanceToLight;\n                float zSquared = zOffset * zOffset;\n                adjustedRadius = sqrt(rSquared - zSquared) * radiusScale;\n            }\n            vec3 worldPosition =\n                worldCenter.xyz\n                    + zDirection * zOffset\n                    + xDirection * adjustedRadius * cos(angle)\n                    + yDirection * adjustedRadius * sin(angle);\n            vec3 directionToLight = getDirectionToLight(worldPosition, xyz_type, rgb_parameter);\n            float sceneDiameter = sceneProperties[3][1];\n            vec3 offset = -sceneDiameter * offsetScale * directionToLight;\n            vec4 offsetPosition = vec4(worldPosition + offset, 1.0);\n            gl_Position = projectionMatrix * (viewMatrix * offsetPosition);\n        }\n    ',
	attributes: {angle: 'dH', offsetScale: 'dg', radiusScale: 'dt'},
	uniforms: {modelMatrix: 'b', modelScale: 'c', projectionMatrix: 'd', sceneProperties: 'e', shadowLight: 'dz', viewMatrix: 'f'}
};
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$sphereShadow = function (givenSphere) {
	return $ianmackenzie$elm_3d_scene$Scene3d$Types$ShadowNode(
		F8(
			function (sceneProperties, modelScale, modelMatrix, isRightHanded, viewMatrix, projectionMatrix, shadowLight, settings) {
				return A5(
					$elm_explorations$webgl$WebGL$entityWith,
					A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$shadowSettings, true, settings),
					$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$sphereShadowVertex,
					$ianmackenzie$elm_3d_scene$Scene3d$UnoptimizedShaders$shadowFragment,
					$ianmackenzie$elm_3d_scene$Scene3d$Entity$sphereShadowMesh,
					{b: modelMatrix, c: modelScale, d: projectionMatrix, e: sceneProperties, dz: shadowLight, f: viewMatrix});
			}));
};
var $ianmackenzie$elm_3d_scene$Scene3d$Transformation$translateBy = function (displacement) {
	var v = $ianmackenzie$elm_geometry$Vector3d$unwrap(displacement);
	return {fn: true, x: 1, y: 0, z: 0, A: 0, B: 1, C: 0, D: 0, E: 0, F: 1, T: v.cF, U: v.cG, V: v.cH, dx: 1};
};
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$translateBy = F2(
	function (displacement, givenDrawable) {
		return A2(
			$ianmackenzie$elm_3d_scene$Scene3d$Entity$transformBy,
			$ianmackenzie$elm_3d_scene$Scene3d$Transformation$translateBy(displacement),
			givenDrawable);
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Entity$sphere = F4(
	function (renderObject, renderShadow, givenMaterial, givenSphere) {
		var baseEntity = A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$mesh, givenMaterial, $ianmackenzie$elm_3d_scene$Scene3d$Primitives$sphere);
		var untransformedEntity = function () {
			var _v1 = _Utils_Tuple2(renderObject, renderShadow);
			if (_v1.a) {
				if (_v1.b) {
					return $ianmackenzie$elm_3d_scene$Scene3d$Entity$group(
						_List_fromArray(
							[
								baseEntity,
								$ianmackenzie$elm_3d_scene$Scene3d$Entity$sphereShadow(givenSphere)
							]));
				} else {
					return baseEntity;
				}
			} else {
				if (_v1.b) {
					return $ianmackenzie$elm_3d_scene$Scene3d$Entity$sphereShadow(givenSphere);
				} else {
					return $ianmackenzie$elm_3d_scene$Scene3d$Entity$empty;
				}
			}
		}();
		var _v0 = $ianmackenzie$elm_geometry$Sphere3d$radius(givenSphere);
		var r = _v0;
		return A2(
			$ianmackenzie$elm_3d_scene$Scene3d$Entity$translateBy,
			A2(
				$ianmackenzie$elm_geometry$Vector3d$from,
				$ianmackenzie$elm_geometry$Point3d$origin,
				$ianmackenzie$elm_geometry$Sphere3d$centerPoint(givenSphere)),
			A2(
				$ianmackenzie$elm_3d_scene$Scene3d$Entity$preScale,
				_Utils_Tuple3(r, r, r),
				untransformedEntity));
	});
var $ianmackenzie$elm_3d_scene$Scene3d$bumpySphereWithShadow = F2(
	function (givenMaterial, givenSphere) {
		return A4($ianmackenzie$elm_3d_scene$Scene3d$Entity$sphere, true, true, givenMaterial, givenSphere);
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Types$EmissiveMaterial = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Types$LambertianMaterial = F4(
	function (a, b, c, d) {
		return {$: 2, a: a, b: b, c: c, d: d};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Types$UnlitMaterial = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Material$coerce = function (material) {
	switch (material.$) {
		case 0:
			var textureMap = material.a;
			var colorTexture = material.b;
			return A2($ianmackenzie$elm_3d_scene$Scene3d$Types$UnlitMaterial, textureMap, colorTexture);
		case 1:
			var textureMap = material.a;
			var colorTexture = material.b;
			var brightness = material.c;
			return A3($ianmackenzie$elm_3d_scene$Scene3d$Types$EmissiveMaterial, textureMap, colorTexture, brightness);
		case 2:
			var textureMap = material.a;
			var colorTexture = material.b;
			var ambientOcclusionTexture = material.c;
			var normalMapTexture = material.d;
			return A4($ianmackenzie$elm_3d_scene$Scene3d$Types$LambertianMaterial, textureMap, colorTexture, ambientOcclusionTexture, normalMapTexture);
		default:
			var textureMap = material.a;
			var colorTexture = material.b;
			var roughnessTexture = material.c;
			var metallicTexture = material.d;
			var ambientOcclusionTexture = material.e;
			var normalMapTexture = material.f;
			return A6($ianmackenzie$elm_3d_scene$Scene3d$Types$PbrMaterial, textureMap, colorTexture, roughnessTexture, metallicTexture, ambientOcclusionTexture, normalMapTexture);
	}
};
var $ianmackenzie$elm_3d_scene$Scene3d$Material$textured = $ianmackenzie$elm_3d_scene$Scene3d$Material$coerce;
var $ianmackenzie$elm_3d_scene$Scene3d$sphereWithShadow = F2(
	function (givenMaterial, givenSphere) {
		return A2(
			$ianmackenzie$elm_3d_scene$Scene3d$bumpySphereWithShadow,
			$ianmackenzie$elm_3d_scene$Scene3d$Material$textured(givenMaterial),
			givenSphere);
	});
var $author$project$Scene3d$Entity$Arena$renderSphere = F3(
	function (bodyData, radius, mats) {
		var buriedCenter = A3($ianmackenzie$elm_geometry$Point3d$meters, 0, 0, 0.5 - radius);
		var _v0 = bodyData.iz;
		_v0$2:
		while (true) {
			if (!_v0.$) {
				switch (_v0.a) {
					case 1:
						var _v1 = _v0.a;
						var _v2 = mats.g$;
						if (!_v2.$) {
							var mat = _v2.a;
							return A2($author$project$Scene3d$Entity$Arena$boulderWithTexture, radius, mat);
						} else {
							return A2(
								$ianmackenzie$elm_3d_scene$Scene3d$sphereWithShadow,
								$ianmackenzie$elm_3d_scene$Scene3d$Material$nonmetal(
									{
										ar: A3($avh4$elm_color$Color$rgb, 0.5, 0.47, 0.44),
										ax: 0.9
									}),
								A2(
									$ianmackenzie$elm_geometry$Sphere3d$atPoint,
									buriedCenter,
									$ianmackenzie$elm_units$Length$meters(radius)));
						}
					case 0:
						var _v3 = _v0.a;
						var _v4 = mats.iS;
						if (!_v4.$) {
							var mat = _v4.a;
							return A2($author$project$Scene3d$Entity$Arena$boulderWithTexture, radius, mat);
						} else {
							return A2(
								$ianmackenzie$elm_3d_scene$Scene3d$sphereWithShadow,
								$ianmackenzie$elm_3d_scene$Scene3d$Material$nonmetal(
									{
										ar: A3($avh4$elm_color$Color$rgb, 0.28, 0.26, 0.24),
										ax: 0.95
									}),
								A2(
									$ianmackenzie$elm_geometry$Sphere3d$atPoint,
									buriedCenter,
									$ianmackenzie$elm_units$Length$meters(radius)));
						}
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return A2(
			$ianmackenzie$elm_3d_scene$Scene3d$sphereWithShadow,
			$ianmackenzie$elm_3d_scene$Scene3d$Material$nonmetal(
				{
					ar: A3($avh4$elm_color$Color$rgb, 0.28, 0.26, 0.24),
					ax: 0.95
				}),
			A2(
				$ianmackenzie$elm_geometry$Sphere3d$atPoint,
				buriedCenter,
				$ianmackenzie$elm_units$Length$meters(radius)));
	});
var $author$project$Scene3d$Entity$Arena$obstacle = F2(
	function (mats, body) {
		var bodyFrame = $author$project$Physics$Body$frame(body);
		var bodyData = $author$project$Physics$Body$data(body);
		return A2(
			$ianmackenzie$elm_3d_scene$Scene3d$placeIn,
			bodyFrame,
			function () {
				var _v0 = bodyData.hq;
				switch (_v0.$) {
					case 1:
						var radius = _v0.a;
						return A3($author$project$Scene3d$Entity$Arena$renderSphere, bodyData, radius, mats);
					case 2:
						var radius = _v0.a;
						var height = _v0.b;
						var _v1 = bodyData.iz;
						if ((!_v1.$) && (_v1.a === 2)) {
							var _v2 = _v1.a;
							return A4($author$project$Scene3d$Entity$Tree$render, radius, height, mats.gT, mats.h3);
						} else {
							return A3($author$project$Scene3d$Entity$Arena$renderColumn, radius, height, mats.i0);
						}
					case 0:
						var bx = _v0.a;
						var by = _v0.b;
						var bz = _v0.c;
						var _v3 = mats.jn;
						if (!_v3.$) {
							var woodMat = _v3.a;
							return A4($author$project$Scene3d$Entity$Arena$renderCrateWithTexture, bx, by, bz, woodMat);
						} else {
							return A2(
								$ianmackenzie$elm_3d_scene$Scene3d$blockWithShadow,
								$author$project$Scene3d$Entity$Arena$crateVariantMaterial(body),
								A2(
									$ianmackenzie$elm_geometry$Block3d$centeredOn,
									$ianmackenzie$elm_geometry$Frame3d$atOrigin,
									_Utils_Tuple3(
										$ianmackenzie$elm_units$Length$meters(bx),
										$ianmackenzie$elm_units$Length$meters(by),
										$ianmackenzie$elm_units$Length$meters(bz))));
						}
					default:
						return $ianmackenzie$elm_3d_scene$Scene3d$nothing;
				}
			}());
	});
var $elm$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _v0) {
				var trues = _v0.a;
				var falses = _v0.b;
				return pred(x) ? _Utils_Tuple2(
					A2($elm$core$List$cons, x, trues),
					falses) : _Utils_Tuple2(
					trues,
					A2($elm$core$List$cons, x, falses));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			list);
	});
var $author$project$Game$Playing$init = F2(
	function (playerId, _v0) {
		var bodies = _v0.eK;
		var lastUpdated = _v0.a6;
		var teams = _v0.bV;
		var players = _v0.an;
		var world = A2($author$project$Physics$World$Extra$addBodies, bodies, $author$project$Game$Playing$initWorld);
		var noMats = A6($author$project$Scene3d$Entity$Arena$ObstacleMaterials, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
		var arenaObstacles = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Physics$Body$data,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.hb;
					},
					$elm$core$Basics$eq(3))),
			bodies);
		var arena = A2($author$project$Physics$World$Extra$addBodies, arenaObstacles, $author$project$Game$Playing$initWorld);
		var _v1 = A2(
			$elm$core$List$partition,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Physics$Body$data,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.hT;
					},
					$elm$core$Basics$eq('floor'))),
			arenaObstacles);
		var floorBodies = _v1.a;
		var nonFloorObstacleBodies = _v1.b;
		var cachedFallbackFloorEntity = function () {
			if (floorBodies.b) {
				var floorBody = floorBodies.a;
				return A2($author$project$Scene3d$Entity$Arena$obstacle, noMats, floorBody);
			} else {
				return $ianmackenzie$elm_3d_scene$Scene3d$nothing;
			}
		}();
		var cachedObstacleEntities = A2(
			$elm$core$List$map,
			$author$project$Scene3d$Entity$Arena$obstacle(noMats),
			nonFloorObstacleBodies);
		return _Utils_Tuple2(
			{
				cM: arena,
				aE: 0.0,
				as: $author$project$Game$Playing$initCameraZRotation(world),
				dN: cachedFallbackFloorEntity,
				ci: $elm$core$Maybe$Nothing,
				cl: _List_Nil,
				a4: _List_Nil,
				a6: lastUpdated,
				bD: $author$project$Game$Playing$Joystick$init,
				bE: 0,
				dc: 0,
				bF: 0,
				bG: 0.0,
				ba: $elm$core$Maybe$Nothing,
				bH: $elm$core$Maybe$Nothing,
				de: A3(
					$elm$core$List$foldl,
					F2(
						function (b, d) {
							var data = $author$project$Physics$Body$data(b);
							return (data.hb === 1) ? A3($elm$core$Dict$insert, data.hT, data.hS, d) : d;
						}),
					$elm$core$Dict$empty,
					bodies),
				df: A2(
					$elm$core$List$cons,
					$author$project$Scene3d$Entity$Arena$boundaryWalls($elm$core$Maybe$Nothing),
					cachedObstacleEntities),
				bK: 0,
				iJ: playerId,
				dn: $elm$core$Maybe$Nothing,
				$7: $elm$core$Maybe$Nothing,
				ek: A3(
					$elm$core$List$foldl,
					F2(
						function (p, d) {
							return A3($elm$core$Dict$insert, p.hT, p.aH, d);
						}),
					$elm$core$Dict$empty,
					players),
				aV: $elm$core$Set$empty,
				bf: false,
				bg: false,
				bT: $author$project$Game$Playing$Joystick$init,
				bU: 0,
				bV: teams,
				cw: A3(
					$elm$core$List$foldl,
					F2(
						function (t, d) {
							return A3($elm$core$Dict$insert, t.hT, t.he, d);
						}),
					$elm$core$Dict$empty,
					teams),
				ex: $elm$core$Maybe$Nothing,
				bY: false,
				aA: 0,
				aB: 0,
				q: world
			},
			A2($elm$core$Task$perform, $author$project$Game$Playing$ViewportChanged, $elm$browser$Browser$Dom$getViewport));
	});
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Game$PostGame$init = F2(
	function (playerId, serverState) {
		var playersWithStats = A2(
			$elm$core$List$filterMap,
			function (body) {
				var _v0 = $author$project$Physics$Body$data(body);
				var id = _v0.hT;
				var hp = _v0.hS;
				var eliminations = _v0.hu;
				var shotsFired = _v0.iV;
				var shotsHit = _v0.iW;
				return A2(
					$elm$core$Maybe$map,
					function (player) {
						return _Utils_Tuple2(
							player,
							{hu: eliminations, hS: hp, iV: shotsFired, iW: shotsHit});
					},
					A2(
						$elm_community$list_extra$List$Extra$find,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.hT;
							},
							$elm$core$Basics$eq(id)),
						serverState.an));
			},
			serverState.eK);
		return _Utils_Tuple2(
			{
				hJ: $elm$core$String$isEmpty(serverState.eP) ? serverState.hT : serverState.eP,
				iF: serverState.iF,
				iJ: playerId,
				an: playersWithStats,
				bV: serverState.bV,
				jd: serverState.jd
			},
			$elm$core$Platform$Cmd$none);
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $elm$core$Tuple$mapBoth = F3(
	function (funcA, funcB, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			funcA(x),
			funcB(y));
	});
var $author$project$Main$requestPlayerMesh = _Platform_outgoingPort(
	'requestPlayerMesh',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Game$PreLobbyMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Game$PostGame$restartGame = _Platform_outgoingPort(
	'restartGame',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Game$Lobby$CodeCopyReset = {$: 9};
var $author$project$Game$Lobby$LinkFeedbackReset = {$: 12};
var $author$project$Game$Lobby$copyGameLink = _Platform_outgoingPort('copyGameLink', $elm$json$Json$Encode$string);
var $author$project$Game$Lobby$copyToClipboard = _Platform_outgoingPort('copyToClipboard', $elm$json$Json$Encode$string);
var $author$project$Game$Lobby$createTeam = _Platform_outgoingPort(
	'createTeam',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string($.aH)),
					_Utils_Tuple2(
					'playerId',
					$elm$json$Json$Encode$string($.iJ))
				]));
	});
var $author$project$Game$Lobby$deleteTeam = _Platform_outgoingPort('deleteTeam', $elm$json$Json$Encode$string);
var $author$project$Game$Lobby$joinTeam = _Platform_outgoingPort(
	'joinTeam',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'playerId',
					$elm$json$Json$Encode$string($.iJ)),
					_Utils_Tuple2(
					'teamId',
					$elm$json$Json$Encode$string($.i7))
				]));
	});
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Game$Lobby$resetAfter = F2(
	function (ms, msg) {
		return A2(
			$elm$core$Task$perform,
			function (_v0) {
				return msg;
			},
			$elm$core$Process$sleep(ms));
	});
var $author$project$Game$Lobby$startGame = _Platform_outgoingPort(
	'startGame',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Game$Lobby$update = F2(
	function (msg, lobbyState) {
		switch (msg.$) {
			case 0:
				var newTeamName = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						lobbyState,
						{aX: newTeamName}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						lobbyState,
						{aX: ''}),
					$author$project$Game$Lobby$createTeam(
						{aH: lobbyState.aX, iJ: lobbyState.iJ}));
			case 13:
				var nextGameData = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						lobbyState,
						{iF: nextGameData.iF, an: nextGameData.an, bV: nextGameData.bV}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						lobbyState,
						{cm: true}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var name = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						lobbyState,
						{aU: name}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						lobbyState,
						{cm: false, dd: true}),
					$author$project$Game$Lobby$updatePlayerName(
						{aH: lobbyState.aU, iJ: lobbyState.iJ}));
			case 5:
				var teamId = msg.a;
				return _Utils_Tuple2(
					lobbyState,
					$author$project$Game$Lobby$joinTeam(
						{iJ: lobbyState.iJ, i7: teamId}));
			case 6:
				var teamId = msg.a;
				return _Utils_Tuple2(
					lobbyState,
					$author$project$Game$Lobby$deleteTeam(teamId));
			case 7:
				return _Utils_Tuple2(
					lobbyState,
					$author$project$Game$Lobby$startGame(0));
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						lobbyState,
						{cb: true}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Game$Lobby$copyToClipboard(lobbyState.hJ),
								A2($author$project$Game$Lobby$resetAfter, 2000, $author$project$Game$Lobby$CodeCopyReset)
							])));
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						lobbyState,
						{cb: false}),
					$elm$core$Platform$Cmd$none);
			case 10:
				return _Utils_Tuple2(
					lobbyState,
					$author$project$Game$Lobby$copyGameLink(lobbyState.hJ));
			case 11:
				var action = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						lobbyState,
						{
							cr: $elm$core$Maybe$Just(action)
						}),
					A2($author$project$Game$Lobby$resetAfter, 2000, $author$project$Game$Lobby$LinkFeedbackReset));
			default:
				return _Utils_Tuple2(
					_Utils_update(
						lobbyState,
						{cr: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Game$Playing$TexturesLoaded = function (a) {
	return {$: 6, a: a};
};
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Game$Playing$isAlive = function (body) {
	var data = $author$project$Physics$Body$data(body);
	return data.hS > 0;
};
var $author$project$Game$Playing$amIAlive = function (maybeMe) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2($elm$core$Maybe$map, $author$project$Game$Playing$isAlive, maybeMe));
};
var $author$project$Game$Playing$requestJump = _Platform_outgoingPort('requestJump', $elm$json$Json$Encode$string);
var $author$project$Game$Playing$applyJump = function (gameState) {
	return _Utils_Tuple2(
		gameState,
		$author$project$Game$Playing$requestJump(gameState.iJ));
};
var $ianmackenzie$elm_units$Duration$milliseconds = function (numMilliseconds) {
	return $ianmackenzie$elm_units$Duration$seconds(0.001 * numMilliseconds);
};
var $author$project$Game$Playing$bulletImpulse = A2(
	$ianmackenzie$elm_units$Quantity$times,
	$ianmackenzie$elm_units$Duration$milliseconds(16.667),
	$ianmackenzie$elm_units$Force$newtons(200));
var $author$project$Game$Playing$bulletMass = $ianmackenzie$elm_units$Mass$grams(50);
var $ianmackenzie$elm_geometry$Vector3d$for = F2(
	function (_v0, _v1) {
		var a = _v0;
		var v = _v1;
		return {cF: v.cF * a, cG: v.cG * a, cH: v.cH * a};
	});
var $ianmackenzie$elm_geometry$Vector3d$xComponent = function (_v0) {
	var v = _v0;
	return v.cF;
};
var $ianmackenzie$elm_geometry$Vector3d$yComponent = function (_v0) {
	var v = _v0;
	return v.cG;
};
var $ianmackenzie$elm_geometry$Vector3d$zComponent = function (_v0) {
	var v = _v0;
	return v.cH;
};
var $ianmackenzie$elm_geometry$Vector3d$toRecord = F2(
	function (fromQuantity, vector) {
		return {
			cF: fromQuantity(
				$ianmackenzie$elm_geometry$Vector3d$xComponent(vector)),
			cG: fromQuantity(
				$ianmackenzie$elm_geometry$Vector3d$yComponent(vector)),
			cH: fromQuantity(
				$ianmackenzie$elm_geometry$Vector3d$zComponent(vector))
		};
	});
var $author$project$Physics$Body$velocity = function (_v0) {
	var body = _v0;
	return $ianmackenzie$elm_geometry$Vector3d$unsafe(body.dF);
};
var $author$project$Game$Playing$getLinvel = function (body) {
	return A2(
		$ianmackenzie$elm_geometry$Vector3d$toRecord,
		$ianmackenzie$elm_units$Length$inMeters,
		A2(
			$ianmackenzie$elm_geometry$Vector3d$for,
			$ianmackenzie$elm_units$Duration$seconds(1),
			$author$project$Physics$Body$velocity(body)));
};
var $ianmackenzie$elm_geometry$Point3d$translateBy = F2(
	function (_v0, _v1) {
		var v = _v0;
		var p = _v1;
		return {cF: p.cF + v.cF, cG: p.cG + v.cG, cH: p.cH + v.cH};
	});
var $author$project$Me$getEyePoint = function (me) {
	return A2(
		$ianmackenzie$elm_geometry$Point3d$translateBy,
		A3($ianmackenzie$elm_geometry$Vector3d$meters, 0, 0, 0.5),
		$author$project$Physics$Body$originPoint(me));
};
var $ianmackenzie$elm_geometry$Axis3d$moveTo = F2(
	function (newOrigin, _v0) {
		var axis = _v0;
		return A2($ianmackenzie$elm_geometry$Axis3d$through, newOrigin, axis.eW);
	});
var $ianmackenzie$elm_geometry$Direction3d$rotateAround = F3(
	function (_v0, _v1, _v2) {
		var a = _v0;
		var angle = _v1;
		var d = _v2;
		var halfAngle = 0.5 * angle;
		var qw = $elm$core$Basics$cos(halfAngle);
		var sinHalfAngle = $elm$core$Basics$sin(halfAngle);
		var qx = a.cF * sinHalfAngle;
		var qwx = qw * qx;
		var qxx = qx * qx;
		var qy = a.cG * sinHalfAngle;
		var qwy = qw * qy;
		var qxy = qx * qy;
		var qyy = qy * qy;
		var qz = a.cH * sinHalfAngle;
		var qwz = qw * qz;
		var qxz = qx * qz;
		var qyz = qy * qz;
		var qzz = qz * qz;
		var a22 = 1 - (2 * (qxx + qyy));
		var a21 = 2 * (qyz + qwx);
		var a20 = 2 * (qxz - qwy);
		var a12 = 2 * (qyz - qwx);
		var a11 = 1 - (2 * (qxx + qzz));
		var a10 = 2 * (qxy + qwz);
		var a02 = 2 * (qxz + qwy);
		var a01 = 2 * (qxy - qwz);
		var a00 = 1 - (2 * (qyy + qzz));
		return {cF: ((a00 * d.cF) + (a01 * d.cG)) + (a02 * d.cH), cG: ((a10 * d.cF) + (a11 * d.cG)) + (a12 * d.cH), cH: ((a20 * d.cF) + (a21 * d.cG)) + (a22 * d.cH)};
	});
var $ianmackenzie$elm_geometry$Frame3d$rotateAround = F3(
	function (axis, angle, frame) {
		var axisDirection = $ianmackenzie$elm_geometry$Axis3d$direction(axis);
		return $ianmackenzie$elm_geometry$Frame3d$unsafe(
			{
				iE: A3(
					$ianmackenzie$elm_geometry$Point3d$rotateAround,
					axis,
					angle,
					$ianmackenzie$elm_geometry$Frame3d$originPoint(frame)),
				jr: A3(
					$ianmackenzie$elm_geometry$Direction3d$rotateAround,
					axisDirection,
					angle,
					$ianmackenzie$elm_geometry$Frame3d$xDirection(frame)),
				jv: A3(
					$ianmackenzie$elm_geometry$Direction3d$rotateAround,
					axisDirection,
					angle,
					$ianmackenzie$elm_geometry$Frame3d$yDirection(frame)),
				jz: A3(
					$ianmackenzie$elm_geometry$Direction3d$rotateAround,
					axisDirection,
					angle,
					$ianmackenzie$elm_geometry$Frame3d$zDirection(frame))
			});
	});
var $ianmackenzie$elm_geometry$Frame3d$rotateAroundOwn = F3(
	function (axis, angle, frame) {
		return A3(
			$ianmackenzie$elm_geometry$Frame3d$rotateAround,
			axis(frame),
			angle,
			frame);
	});
var $ianmackenzie$elm_geometry$Frame3d$xAxis = function (_v0) {
	var frame = _v0;
	return A2($ianmackenzie$elm_geometry$Axis3d$through, frame.iE, frame.jr);
};
var $ianmackenzie$elm_geometry$Frame3d$yAxis = function (_v0) {
	var frame = _v0;
	return A2($ianmackenzie$elm_geometry$Axis3d$through, frame.iE, frame.jv);
};
var $author$project$Me$getLookAxis = F3(
	function (me, xRotationDeg, zRotationDeg) {
		return A2(
			$ianmackenzie$elm_geometry$Axis3d$moveTo,
			$author$project$Me$getEyePoint(me),
			$ianmackenzie$elm_geometry$Frame3d$yAxis(
				A3(
					$ianmackenzie$elm_geometry$Frame3d$rotateAroundOwn,
					$ianmackenzie$elm_geometry$Frame3d$xAxis,
					$ianmackenzie$elm_units$Angle$degrees(xRotationDeg),
					A3(
						$ianmackenzie$elm_geometry$Frame3d$rotateAroundOwn,
						$ianmackenzie$elm_geometry$Frame3d$zAxis,
						$ianmackenzie$elm_units$Angle$degrees(zRotationDeg),
						$ianmackenzie$elm_geometry$Frame3d$atOrigin))));
	});
var $author$project$Me$getLookAxisInWorld = F3(
	function (world, xRotationDeg, zRotationDeg) {
		var _v0 = $author$project$Me$getInWorld(world);
		if (!_v0.$) {
			var me = _v0.a;
			return A3($author$project$Me$getLookAxis, me, xRotationDeg, zRotationDeg);
		} else {
			return $ianmackenzie$elm_geometry$Frame3d$yAxis($ianmackenzie$elm_geometry$Frame3d$atOrigin);
		}
	});
var $author$project$Physics$Body$moveTo = F2(
	function (point3d, _v0) {
		var body = _v0;
		var bodyCoordinatesTransform3d = A2(
			$author$project$Internal$Transform3d$placeIn,
			body.cA,
			$author$project$Internal$Transform3d$inverse(body.cR));
		var newTransform3d = A2(
			$author$project$Internal$Transform3d$placeIn,
			A2(
				$author$project$Internal$Transform3d$moveTo,
				$ianmackenzie$elm_geometry$Point3d$toMeters(point3d),
				bodyCoordinatesTransform3d),
			body.cR);
		return _Utils_update(
			body,
			{
				cA: newTransform3d,
				eD: A2($author$project$Internal$Shape$shapesPlaceIn, newTransform3d, body.er)
			});
	});
var $author$project$Physics$Body$particle = $author$project$Physics$Body$compound(
	_List_fromArray(
		[
			$author$project$Internal$Shape$Particle($author$project$Internal$Vector3$zero)
		]));
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$Game$Playing$requestShoot = _Platform_outgoingPort(
	'requestShoot',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'linvel',
					function ($) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'x',
									$elm$json$Json$Encode$float($.cF)),
									_Utils_Tuple2(
									'y',
									$elm$json$Json$Encode$float($.cG)),
									_Utils_Tuple2(
									'z',
									$elm$json$Json$Encode$float($.cH))
								]));
					}($.fA)),
					_Utils_Tuple2(
					'playerId',
					$elm$json$Json$Encode$string($.iJ)),
					_Utils_Tuple2(
					'position',
					function ($) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'x',
									$elm$json$Json$Encode$float($.cF)),
									_Utils_Tuple2(
									'y',
									$elm$json$Json$Encode$float($.cG)),
									_Utils_Tuple2(
									'z',
									$elm$json$Json$Encode$float($.cH))
								]));
					}($.f9))
				]));
	});
var $ianmackenzie$elm_geometry$Point3d$toRecord = F2(
	function (fromQuantity, point) {
		return {
			cF: fromQuantity(
				$ianmackenzie$elm_geometry$Point3d$xCoordinate(point)),
			cG: fromQuantity(
				$ianmackenzie$elm_geometry$Point3d$yCoordinate(point)),
			cH: fromQuantity(
				$ianmackenzie$elm_geometry$Point3d$zCoordinate(point))
		};
	});
var $author$project$Game$Playing$applyShoot = function (gameState) {
	var projectileOrientation = A3($author$project$Me$getLookAxisInWorld, gameState.q, gameState.aE, gameState.as);
	var projectileStartPoint = A2(
		$ianmackenzie$elm_geometry$Point3d$along,
		projectileOrientation,
		$ianmackenzie$elm_units$Length$centimeters(30));
	var projectile = A4(
		$author$project$Physics$Body$applyImpulse,
		$author$project$Game$Playing$bulletImpulse,
		$ianmackenzie$elm_geometry$Axis3d$direction(projectileOrientation),
		projectileStartPoint,
		A2(
			$author$project$Physics$Body$moveTo,
			projectileStartPoint,
			A2(
				$author$project$Physics$Body$withBehavior,
				$author$project$Physics$Body$dynamic($author$project$Game$Playing$bulletMass),
				$author$project$Physics$Body$particle(
					{hb: 2, hS: 0}))));
	return _Utils_Tuple2(
		gameState,
		$author$project$Game$Playing$requestShoot(
			{
				fA: $author$project$Game$Playing$getLinvel(projectile),
				iJ: gameState.iJ,
				f9: A2($ianmackenzie$elm_geometry$Point3d$toRecord, $ianmackenzie$elm_units$Length$inMeters, projectileStartPoint)
			}));
};
var $ianmackenzie$elm_geometry$Frame3d$moveTo = F2(
	function (newOrigin, frame) {
		return $ianmackenzie$elm_geometry$Frame3d$unsafe(
			{
				iE: newOrigin,
				jr: $ianmackenzie$elm_geometry$Frame3d$xDirection(frame),
				jv: $ianmackenzie$elm_geometry$Frame3d$yDirection(frame),
				jz: $ianmackenzie$elm_geometry$Frame3d$zDirection(frame)
			});
	});
var $author$project$Config$movementSpeed = 0.16;
var $author$project$Game$Playing$requestMove = _Platform_outgoingPort(
	'requestMove',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'playerId',
					$elm$json$Json$Encode$string($.iJ)),
					_Utils_Tuple2(
					'x',
					$elm$json$Json$Encode$float($.cF)),
					_Utils_Tuple2(
					'y',
					$elm$json$Json$Encode$float($.cG))
				]));
	});
var $author$project$Game$Playing$effectivelyZero = function (fl) {
	return $elm$core$Basics$abs(fl) < 0.00001;
};
var $author$project$Game$Playing$resolveOneObstacleCollision = F3(
	function (playerRadius, obstacle, playerPos) {
		var _v0 = $author$project$Physics$Body$data(obstacle).hq;
		switch (_v0.$) {
			case 0:
				var bx = _v0.a;
				var by = _v0.b;
				var bz = _v0.c;
				var playerZ = $ianmackenzie$elm_units$Length$inMeters(
					$ianmackenzie$elm_geometry$Point3d$zCoordinate(playerPos));
				var obstacleFrame = $author$project$Physics$Body$frame(obstacle);
				var obstacleCenter = $ianmackenzie$elm_geometry$Frame3d$originPoint(obstacleFrame);
				var obstacleCenterZ = $ianmackenzie$elm_units$Length$inMeters(
					$ianmackenzie$elm_geometry$Point3d$zCoordinate(obstacleCenter));
				var zOverlaps = (_Utils_cmp(playerZ - 0.5, obstacleCenterZ + (bz / 2)) < 0) && (_Utils_cmp(playerZ + 0.5, obstacleCenterZ - (bz / 2)) > 0);
				if (!zOverlaps) {
					return playerPos;
				} else {
					var py = $ianmackenzie$elm_units$Length$inMeters(
						$ianmackenzie$elm_geometry$Point3d$yCoordinate(playerPos));
					var px = $ianmackenzie$elm_units$Length$inMeters(
						$ianmackenzie$elm_geometry$Point3d$xCoordinate(playerPos));
					var ocy = $ianmackenzie$elm_units$Length$inMeters(
						$ianmackenzie$elm_geometry$Point3d$yCoordinate(obstacleCenter));
					var ocx = $ianmackenzie$elm_units$Length$inMeters(
						$ianmackenzie$elm_geometry$Point3d$xCoordinate(obstacleCenter));
					var localYDir = $ianmackenzie$elm_geometry$Frame3d$yDirection(obstacleFrame);
					var lyx = $ianmackenzie$elm_geometry$Direction3d$xComponent(localYDir);
					var lyy = $ianmackenzie$elm_geometry$Direction3d$yComponent(localYDir);
					var localXDir = $ianmackenzie$elm_geometry$Frame3d$xDirection(obstacleFrame);
					var lxx = $ianmackenzie$elm_geometry$Direction3d$xComponent(localXDir);
					var lxy = $ianmackenzie$elm_geometry$Direction3d$yComponent(localXDir);
					var hy = by / 2;
					var hx = bx / 2;
					var dy = py - ocy;
					var dx = px - ocx;
					var projX = (dx * lxx) + (dy * lxy);
					var projY = (dx * lyx) + (dy * lyy);
					var closestY = A3($elm$core$Basics$clamp, -hy, hy, projY);
					var diffY = projY - closestY;
					var closestX = A3($elm$core$Basics$clamp, -hx, hx, projX);
					var diffX = projX - closestX;
					var dist = $elm$core$Basics$sqrt((diffX * diffX) + (diffY * diffY));
					if (_Utils_cmp(dist, playerRadius) > -1) {
						return playerPos;
					} else {
						var _v1 = function () {
							if ($author$project$Game$Playing$effectivelyZero(dist)) {
								var penY = hy - $elm$core$Basics$abs(projY);
								var penX = hx - $elm$core$Basics$abs(projX);
								return (_Utils_cmp(penX, penY) < 1) ? _Utils_Tuple2(
									(projX >= 0) ? (penX + playerRadius) : (-(penX + playerRadius)),
									0) : _Utils_Tuple2(
									0,
									(projY >= 0) ? (penY + playerRadius) : (-(penY + playerRadius)));
							} else {
								var pushDist = playerRadius - dist;
								return _Utils_Tuple2((diffX / dist) * pushDist, (diffY / dist) * pushDist);
							}
						}();
						var pushXLocal = _v1.a;
						var pushYLocal = _v1.b;
						var actualPushDist = $elm$core$Basics$sqrt((pushXLocal * pushXLocal) + (pushYLocal * pushYLocal));
						if (actualPushDist > 5.0) {
							return playerPos;
						} else {
							var pushYWorld = (pushXLocal * lxy) + (pushYLocal * lyy);
							var pushXWorld = (pushXLocal * lxx) + (pushYLocal * lyx);
							return $ianmackenzie$elm_geometry$Point3d$fromMeters(
								{cF: px + pushXWorld, cG: py + pushYWorld, cH: playerZ});
						}
					}
				}
			case 1:
				var radius = _v0.a;
				var playerZ = $ianmackenzie$elm_units$Length$inMeters(
					$ianmackenzie$elm_geometry$Point3d$zCoordinate(playerPos));
				var obstacleCenter = $ianmackenzie$elm_geometry$Frame3d$originPoint(
					$author$project$Physics$Body$frame(obstacle));
				var obstacleCenterZ = $ianmackenzie$elm_units$Length$inMeters(
					$ianmackenzie$elm_geometry$Point3d$zCoordinate(obstacleCenter));
				var dz = playerZ - obstacleCenterZ;
				var horizontalRadius = $elm$core$Basics$sqrt(
					A2($elm$core$Basics$max, 0, (radius * radius) - (dz * dz)));
				var zOverlaps = _Utils_cmp(
					$elm$core$Basics$abs(dz),
					radius + 0.5) < 0;
				if (!zOverlaps) {
					return playerPos;
				} else {
					var py = $ianmackenzie$elm_units$Length$inMeters(
						$ianmackenzie$elm_geometry$Point3d$yCoordinate(playerPos));
					var px = $ianmackenzie$elm_units$Length$inMeters(
						$ianmackenzie$elm_geometry$Point3d$xCoordinate(playerPos));
					var ocy = $ianmackenzie$elm_units$Length$inMeters(
						$ianmackenzie$elm_geometry$Point3d$yCoordinate(obstacleCenter));
					var ocx = $ianmackenzie$elm_units$Length$inMeters(
						$ianmackenzie$elm_geometry$Point3d$xCoordinate(obstacleCenter));
					var minDist = horizontalRadius + playerRadius;
					var dy = py - ocy;
					var dx = px - ocx;
					var dist = $elm$core$Basics$sqrt((dx * dx) + (dy * dy));
					if (_Utils_cmp(dist, minDist) > -1) {
						return playerPos;
					} else {
						if ($author$project$Game$Playing$effectivelyZero(dist)) {
							return $ianmackenzie$elm_geometry$Point3d$fromMeters(
								{cF: ocx + minDist, cG: ocy, cH: playerZ});
						} else {
							var pushDist = minDist - dist;
							return $ianmackenzie$elm_geometry$Point3d$fromMeters(
								{cF: px + ((dx / dist) * pushDist), cG: py + ((dy / dist) * pushDist), cH: playerZ});
						}
					}
				}
			case 2:
				var radius = _v0.a;
				var height = _v0.b;
				var playerZ = $ianmackenzie$elm_units$Length$inMeters(
					$ianmackenzie$elm_geometry$Point3d$zCoordinate(playerPos));
				var obstacleCenter = $ianmackenzie$elm_geometry$Frame3d$originPoint(
					$author$project$Physics$Body$frame(obstacle));
				var obstacleCenterZ = $ianmackenzie$elm_units$Length$inMeters(
					$ianmackenzie$elm_geometry$Point3d$zCoordinate(obstacleCenter));
				var zOverlaps = (_Utils_cmp(playerZ - 0.5, obstacleCenterZ + (height / 2)) < 0) && (_Utils_cmp(playerZ + 0.5, obstacleCenterZ - (height / 2)) > 0);
				if (!zOverlaps) {
					return playerPos;
				} else {
					var py = $ianmackenzie$elm_units$Length$inMeters(
						$ianmackenzie$elm_geometry$Point3d$yCoordinate(playerPos));
					var px = $ianmackenzie$elm_units$Length$inMeters(
						$ianmackenzie$elm_geometry$Point3d$xCoordinate(playerPos));
					var ocy = $ianmackenzie$elm_units$Length$inMeters(
						$ianmackenzie$elm_geometry$Point3d$yCoordinate(obstacleCenter));
					var ocx = $ianmackenzie$elm_units$Length$inMeters(
						$ianmackenzie$elm_geometry$Point3d$xCoordinate(obstacleCenter));
					var minDist = radius + playerRadius;
					var dy = py - ocy;
					var dx = px - ocx;
					var dist = $elm$core$Basics$sqrt((dx * dx) + (dy * dy));
					if (_Utils_cmp(dist, minDist) > -1) {
						return playerPos;
					} else {
						if ($author$project$Game$Playing$effectivelyZero(dist)) {
							return $ianmackenzie$elm_geometry$Point3d$fromMeters(
								{cF: ocx + minDist, cG: ocy, cH: playerZ});
						} else {
							var pushDist = minDist - dist;
							return $ianmackenzie$elm_geometry$Point3d$fromMeters(
								{cF: px + ((dx / dist) * pushDist), cG: py + ((dy / dist) * pushDist), cH: playerZ});
						}
					}
				}
			default:
				return playerPos;
		}
	});
var $author$project$Game$Playing$resolveObstacleCollisions = F2(
	function (bodies, playerPos) {
		return A3(
			$elm$core$List$foldl,
			$author$project$Game$Playing$resolveOneObstacleCollision($author$project$Config$playerRadiusMeters),
			playerPos,
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Physics$Body$data,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.hb;
						},
						$elm$core$Basics$eq(3))),
				bodies));
	});
var $ianmackenzie$elm_geometry$Frame3d$translateBy = F2(
	function (vector, frame) {
		return $ianmackenzie$elm_geometry$Frame3d$unsafe(
			{
				iE: A2(
					$ianmackenzie$elm_geometry$Point3d$translateBy,
					vector,
					$ianmackenzie$elm_geometry$Frame3d$originPoint(frame)),
				jr: $ianmackenzie$elm_geometry$Frame3d$xDirection(frame),
				jv: $ianmackenzie$elm_geometry$Frame3d$yDirection(frame),
				jz: $ianmackenzie$elm_geometry$Frame3d$zDirection(frame)
			});
	});
var $ianmackenzie$elm_geometry$Vector3d$withLength = F2(
	function (_v0, _v1) {
		var a = _v0;
		var d = _v1;
		return {cF: a * d.cF, cG: a * d.cG, cH: a * d.cH};
	});
var $ianmackenzie$elm_geometry$Frame3d$translateIn = F3(
	function (direction, distance, frame) {
		return A2(
			$ianmackenzie$elm_geometry$Frame3d$translateBy,
			A2($ianmackenzie$elm_geometry$Vector3d$withLength, distance, direction),
			frame);
	});
var $ianmackenzie$elm_geometry$Frame3d$translateAlongOwn = F3(
	function (axis, distance, frame) {
		return A3(
			$ianmackenzie$elm_geometry$Frame3d$translateIn,
			$ianmackenzie$elm_geometry$Axis3d$direction(
				axis(frame)),
			distance,
			frame);
	});
var $author$project$Physics$World$update = F2(
	function (fn, _v0) {
		var world = _v0;
		var internalUpdate = function (body) {
			var _v1 = fn(body);
			var updatedBody = _v1;
			return _Utils_update(
				updatedBody,
				{hT: body.hT});
		};
		return _Utils_update(
			world,
			{
				eK: A3(
					$elm$core$List$foldl,
					F2(
						function (body, result) {
							return A2(
								$elm$core$List$cons,
								internalUpdate(body),
								result);
						}),
					_List_Nil,
					world.eK)
			});
	});
var $author$project$Physics$World$Extra$updateClass = F3(
	function (_class, transformer, world) {
		var f = function (body) {
			var data = $author$project$Physics$Body$data(body);
			return _Utils_eq(data.hb, _class) ? transformer(body) : body;
		};
		return A2($author$project$Physics$World$update, f, world);
	});
var $author$project$Me$updateInWorld = $author$project$Physics$World$Extra$updateClass(0);
var $author$project$Game$Playing$applyDirectionalMove = F5(
	function (x, y, ms, gameState, me) {
		var speed = $author$project$Config$movementSpeed;
		var xMovement = x * speed;
		var yMovement = y * speed;
		var nextMsSinceLastMoveSent = gameState.dc + ms;
		var shouldSendMove = nextMsSinceLastMoveSent >= 50;
		var currentMe = A2(
			$elm$core$Maybe$withDefault,
			me,
			$author$project$Me$getInWorld(gameState.q));
		var currentZ = $ianmackenzie$elm_units$Length$inMeters(
			$ianmackenzie$elm_geometry$Point3d$zCoordinate(
				$author$project$Physics$Body$originPoint(currentMe)));
		var myFrame = A2(
			$ianmackenzie$elm_geometry$Frame3d$moveTo,
			$author$project$Physics$Body$originPoint(currentMe),
			A3(
				$ianmackenzie$elm_geometry$Frame3d$rotateAroundOwn,
				$ianmackenzie$elm_geometry$Frame3d$zAxis,
				$ianmackenzie$elm_units$Angle$degrees(gameState.as),
				$ianmackenzie$elm_geometry$Frame3d$atOrigin));
		var nextOriginCoords = $ianmackenzie$elm_geometry$Point3d$toMeters(
			$ianmackenzie$elm_geometry$Frame3d$originPoint(
				A3(
					$ianmackenzie$elm_geometry$Frame3d$translateAlongOwn,
					$ianmackenzie$elm_geometry$Frame3d$xAxis,
					$ianmackenzie$elm_units$Length$meters(xMovement),
					A3(
						$ianmackenzie$elm_geometry$Frame3d$translateAlongOwn,
						$ianmackenzie$elm_geometry$Frame3d$yAxis,
						$ianmackenzie$elm_units$Length$meters(yMovement),
						myFrame))));
		var nextOriginPoint = $ianmackenzie$elm_geometry$Point3d$fromMeters(
			{cF: nextOriginCoords.cF, cG: nextOriginCoords.cG, cH: currentZ});
		var resolvedOriginPoint = A2(
			$author$project$Game$Playing$resolveObstacleCollisions,
			$author$project$Physics$World$bodies(gameState.q),
			nextOriginPoint);
		var clampedOriginPoint = function () {
			var halfArena = ($author$project$Config$arenaWidthMeters / 2) - 1.5;
			var coords = $ianmackenzie$elm_geometry$Point3d$toMeters(resolvedOriginPoint);
			return $ianmackenzie$elm_geometry$Point3d$fromMeters(
				{
					cF: A3($elm$core$Basics$clamp, -halfArena, halfArena, coords.cF),
					cG: A3($elm$core$Basics$clamp, -halfArena, halfArena, coords.cG),
					cH: coords.cH
				});
		}();
		var nextWorld = A2(
			$author$project$Me$updateInWorld,
			$author$project$Physics$Body$moveTo(clampedOriginPoint),
			gameState.q);
		var nextX = $ianmackenzie$elm_units$Length$inMeters(
			$ianmackenzie$elm_geometry$Point3d$xCoordinate(clampedOriginPoint));
		var nextY = $ianmackenzie$elm_units$Length$inMeters(
			$ianmackenzie$elm_geometry$Point3d$yCoordinate(clampedOriginPoint));
		var moveCmd = shouldSendMove ? $author$project$Game$Playing$requestMove(
			{iJ: gameState.iJ, cF: nextX, cG: nextY}) : $elm$core$Platform$Cmd$none;
		return _Utils_Tuple2(
			_Utils_update(
				gameState,
				{
					dc: shouldSendMove ? 0 : nextMsSinceLastMoveSent,
					q: nextWorld
				}),
			moveCmd);
	});
var $author$project$Config$joystickSensitivityFactor = 0.6;
var $elm_explorations$linear_algebra$Math$Vector2$sub = _MJS_v2sub;
var $elm_explorations$linear_algebra$Math$Vector2$toRecord = _MJS_v2toRecord;
var $author$project$Game$Playing$Joystick$getDirection = function (sizePx) {
	return $elm$core$Maybe$map(
		function (m) {
			var maxRadius = (sizePx / 2) * $author$project$Config$joystickSensitivityFactor;
			var _v0 = $elm_explorations$linear_algebra$Math$Vector2$toRecord(
				A2($elm_explorations$linear_algebra$Math$Vector2$sub, m.cU, m.dQ));
			var x = _v0.cF;
			var y = _v0.cG;
			return {
				cF: A3($elm$core$Basics$clamp, -1, 1, x / maxRadius),
				cG: A3($elm$core$Basics$clamp, -1, 1, y / maxRadius)
			};
		});
};
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $author$project$Game$Playing$getKeyboardMoveDirection = function (keys) {
	var pressed = function (k) {
		return A2($elm$core$Set$member, k, keys);
	};
	var x = (pressed('d') ? 1.0 : 0.0) - (pressed('a') ? 1.0 : 0.0);
	var y = (pressed('w') ? 1.0 : 0.0) - (pressed('s') ? 1.0 : 0.0);
	return ((!x) && (!y)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		{cF: x, cG: y});
};
var $author$project$Game$Playing$joystickSizePx = function (model) {
	return (_Utils_cmp(model.aB, model.aA) > 0) ? (model.aA * 0.4) : (model.aB * 0.38);
};
var $author$project$Game$Playing$updateMovement = F3(
	function (ms, maybeMe, gameState) {
		var _v0 = A2(
			$author$project$Game$Playing$Joystick$getDirection,
			$author$project$Game$Playing$joystickSizePx(gameState),
			gameState.bD);
		if (!_v0.$) {
			var x = _v0.a.cF;
			var y = _v0.a.cG;
			var coordsAreInvalid = $elm$core$Basics$isNaN(x) || $elm$core$Basics$isNaN(y);
			var _v1 = function () {
				var _v2 = _Utils_Tuple2(maybeMe, coordsAreInvalid);
				if ((!_v2.a.$) && (!_v2.b)) {
					var me = _v2.a.a;
					return A5($author$project$Game$Playing$applyDirectionalMove, x, y, ms, gameState, me);
				} else {
					return _Utils_Tuple2(gameState, $elm$core$Platform$Cmd$none);
				}
			}();
			var gameStateWithUpdatedWorld = _v1.a;
			var cmds = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					gameStateWithUpdatedWorld,
					{bE: gameState.bE + ms}),
				cmds);
		} else {
			var _v3 = _Utils_Tuple2(
				maybeMe,
				$author$project$Game$Playing$getKeyboardMoveDirection(gameState.aV));
			if ((!_v3.a.$) && (!_v3.b.$)) {
				var me = _v3.a.a;
				var x = _v3.b.a.cF;
				var y = _v3.b.a.cG;
				return A5($author$project$Game$Playing$applyDirectionalMove, x, y, ms, gameState, me);
			} else {
				return _Utils_Tuple2(gameState, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Game$Playing$getKeyboardLook = function (keys) {
	var pressed = function (k) {
		return A2($elm$core$Set$member, k, keys);
	};
	return {
		eZ: (pressed('arrowdown') ? 2.0 : 0.0) - (pressed('arrowup') ? 2.0 : 0.0),
		e_: ((pressed('e') || pressed('arrowright')) ? 2.0 : 0.0) - ((pressed('q') || pressed('arrowleft')) ? 2.0 : 0.0)
	};
};
var $author$project$Game$Playing$normalizeZRotationAngle = function (rotationAngle) {
	return rotationAngle - (360.0 * $elm$core$Basics$floor(rotationAngle / 360.0));
};
var $author$project$Game$Playing$requestRotate = _Platform_outgoingPort(
	'requestRotate',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'angle',
					$elm$json$Json$Encode$float($.dH)),
					_Utils_Tuple2(
					'playerId',
					$elm$json$Json$Encode$string($.iJ))
				]));
	});
var $author$project$Config$rotationScale = 2.5;
var $author$project$Game$Playing$updateTarget = F2(
	function (ms, gameState) {
		var _v0 = A2(
			$author$project$Game$Playing$Joystick$getDirection,
			$author$project$Game$Playing$joystickSizePx(gameState),
			gameState.bT);
		if (!_v0.$) {
			var x = _v0.a.cF;
			var y = _v0.a.cG;
			var zRotationDeg = (-x) * $author$project$Config$rotationScale;
			var xRotationDeg = (-y) * $author$project$Config$rotationScale;
			var coordsAreInvalid = $elm$core$Basics$isNaN(x) || $elm$core$Basics$isNaN(y);
			if (coordsAreInvalid) {
				return _Utils_Tuple2(gameState, $elm$core$Platform$Cmd$none);
			} else {
				var nextMsSinceLastRotateSent = gameState.bF + ms;
				var shouldSendRotate = nextMsSinceLastRotateSent >= 50;
				var newZRotationAngle = $author$project$Game$Playing$normalizeZRotationAngle(gameState.as + zRotationDeg);
				var rotateCmd = shouldSendRotate ? $author$project$Game$Playing$requestRotate(
					{dH: newZRotationAngle, iJ: gameState.iJ}) : $elm$core$Platform$Cmd$none;
				return _Utils_Tuple2(
					_Utils_update(
						gameState,
						{
							aE: A3($elm$core$Basics$clamp, -89, 89, gameState.aE - xRotationDeg),
							as: newZRotationAngle,
							bF: shouldSendRotate ? 0 : nextMsSinceLastRotateSent,
							bU: gameState.bU + ms
						}),
					rotateCmd);
			}
		} else {
			var _v1 = $author$project$Game$Playing$getKeyboardLook(gameState.aV);
			var dz = _v1.e_;
			var dx = _v1.eZ;
			if ((!dz) && (!dx)) {
				return _Utils_Tuple2(gameState, $elm$core$Platform$Cmd$none);
			} else {
				var nextMsSinceLastRotateSent = gameState.bF + ms;
				var shouldSendRotate = nextMsSinceLastRotateSent >= 50;
				var newZRotationAngle = $author$project$Game$Playing$normalizeZRotationAngle(gameState.as - dz);
				var rotateCmd = shouldSendRotate ? $author$project$Game$Playing$requestRotate(
					{dH: newZRotationAngle, iJ: gameState.iJ}) : $elm$core$Platform$Cmd$none;
				var newXRotationAngle = A3($elm$core$Basics$clamp, -89, 89, gameState.aE - dx);
				return _Utils_Tuple2(
					_Utils_update(
						gameState,
						{
							aE: newXRotationAngle,
							as: newZRotationAngle,
							bF: shouldSendRotate ? 0 : nextMsSinceLastRotateSent
						}),
					rotateCmd);
			}
		}
	});
var $author$project$Game$Playing$applyActions = F3(
	function (previousMe, gameState, ms) {
		var playerIsAlive = $author$project$Game$Playing$amIAlive(previousMe);
		var applyIf = F3(
			function (cond, f, gs) {
				return cond ? f(gs) : _Utils_Tuple2(gs, $elm$core$Platform$Cmd$none);
			});
		var _v0 = A3(
			applyIf,
			playerIsAlive,
			A2($author$project$Game$Playing$updateMovement, ms, previousMe),
			gameState);
		var gameStateMovementApplied = _v0.a;
		var movementCmds = _v0.b;
		var _v1 = A2($author$project$Game$Playing$updateTarget, ms, gameStateMovementApplied);
		var gameStateRotationApplied = _v1.a;
		var rotationCmds = _v1.b;
		var _v2 = A3(applyIf, gameState.bf && playerIsAlive, $author$project$Game$Playing$applyJump, gameStateRotationApplied);
		var gameStateJumpApplied = _v2.a;
		var jumpCmd = _v2.b;
		var _v3 = A3(applyIf, gameState.bg && playerIsAlive, $author$project$Game$Playing$applyShoot, gameStateJumpApplied);
		var gameStateShootApplied = _v3.a;
		var shootCmd = _v3.b;
		return _Utils_Tuple2(
			_Utils_update(
				gameStateShootApplied,
				{bf: false, bg: false}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[movementCmds, rotationCmds, jumpCmd, shootCmd])));
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $author$project$Server$State$BodiesState = F2(
	function (bodies, lastUpdated) {
		return {eK: bodies, a6: lastUpdated};
	});
var $author$project$Server$State$bodiesStateDecoder = function (playerId) {
	return A3(
		$elm$json$Json$Decode$map2,
		$author$project$Server$State$BodiesState,
		A2(
			$elm$json$Json$Decode$field,
			'bodies',
			$author$project$Server$Body$physicsBodiesDecoder(playerId)),
		A2($elm$json$Json$Decode$field, 'last_updated', $elm$json$Json$Decode$int));
};
var $author$project$Config$clientPhysicsSimulationMinIntervalMs = 33;
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $ianmackenzie$elm_3d_scene$Scene3d$Mesh$Decode$decodePoint = A4(
	$elm$json$Json$Decode$map3,
	$ianmackenzie$elm_geometry$Point3d$meters,
	A2($elm$json$Json$Decode$field, 'x', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'y', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'z', $elm$json$Json$Decode$float));
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $ianmackenzie$elm_3d_scene$Scene3d$Mesh$Decode$decodeTriangle = A4(
	$elm$json$Json$Decode$map3,
	$ianmackenzie$elm_geometry$Triangle3d$from,
	A2($elm$json$Json$Decode$index, 0, $ianmackenzie$elm_3d_scene$Scene3d$Mesh$Decode$decodePoint),
	A2($elm$json$Json$Decode$index, 1, $ianmackenzie$elm_3d_scene$Scene3d$Mesh$Decode$decodePoint),
	A2($elm$json$Json$Decode$index, 2, $ianmackenzie$elm_3d_scene$Scene3d$Mesh$Decode$decodePoint));
var $ianmackenzie$elm_3d_scene$Scene3d$Mesh$Decode$facets = A2(
	$elm$json$Json$Decode$map,
	$ianmackenzie$elm_3d_scene$Scene3d$Mesh$facets,
	$elm$json$Json$Decode$list($ianmackenzie$elm_3d_scene$Scene3d$Mesh$Decode$decodeTriangle));
var $author$project$Mesh$Player$decoder = $ianmackenzie$elm_3d_scene$Scene3d$Mesh$Decode$facets;
var $author$project$Game$Playing$Elimination = 1;
var $author$project$Game$Playing$Hit = 0;
var $author$project$Game$Playing$detectHitMarker = F2(
	function (snapshot, body) {
		var data = $author$project$Physics$Body$data(body);
		var oldHp = A2(
			$elm$core$Maybe$withDefault,
			data.hS,
			A2($elm$core$Dict$get, data.hT, snapshot));
		return (_Utils_cmp(data.hS, oldHp) < 0) ? $elm$core$Maybe$Just(
			{
				aq: 0,
				dS: (data.hS <= 0) ? 1 : 0
			}) : $elm$core$Maybe$Nothing;
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$diff = F2(
	function (t1, t2) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, t) {
					return A2($elm$core$Dict$remove, k, t);
				}),
			t1,
			t2);
	});
var $elm$core$Set$diff = F2(
	function (_v0, _v1) {
		var dict1 = _v0;
		var dict2 = _v1;
		return A2($elm$core$Dict$diff, dict1, dict2);
	});
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$Internal$Vector3$distanceSquared = F2(
	function (a, b) {
		return $author$project$Internal$Vector3$lengthSquared(
			A2($author$project$Internal$Vector3$sub, a, b));
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $author$project$Internal$BroadPhase$bodiesMayContact = F2(
	function (body1, body2) {
		var distanceSquared = A2(
			$author$project$Internal$Vector3$distanceSquared,
			$author$project$Internal$Transform3d$originPoint(body1.cA),
			$author$project$Internal$Transform3d$originPoint(body2.cA));
		var boundingRadiuses = body1.eM + body2.eM;
		return (((boundingRadiuses * boundingRadiuses) - distanceSquared) > 0) && (!(!(body1.d1 + body2.d1)));
	});
var $author$project$Internal$Vector3$dot = F2(
	function (a, b) {
		return ((a.cF * b.cF) + (a.cG * b.cG)) + (a.cH * b.cH);
	});
var $author$project$Collision$ConvexConvex$bestFaceHelp = F4(
	function (separatingAxis, faces, currentBestFace, currentBestDistance) {
		bestFaceHelp:
		while (true) {
			if (faces.b) {
				var face = faces.a;
				var remainingFaces = faces.b;
				var faceDistance = A2($author$project$Internal$Vector3$dot, face.aS, separatingAxis);
				if ((currentBestDistance - faceDistance) > 0) {
					var $temp$separatingAxis = separatingAxis,
						$temp$faces = remainingFaces,
						$temp$currentBestFace = face,
						$temp$currentBestDistance = faceDistance;
					separatingAxis = $temp$separatingAxis;
					faces = $temp$faces;
					currentBestFace = $temp$currentBestFace;
					currentBestDistance = $temp$currentBestDistance;
					continue bestFaceHelp;
				} else {
					var $temp$separatingAxis = separatingAxis,
						$temp$faces = remainingFaces,
						$temp$currentBestFace = currentBestFace,
						$temp$currentBestDistance = currentBestDistance;
					separatingAxis = $temp$separatingAxis;
					faces = $temp$faces;
					currentBestFace = $temp$currentBestFace;
					currentBestDistance = $temp$currentBestDistance;
					continue bestFaceHelp;
				}
			} else {
				return currentBestFace;
			}
		}
	});
var $author$project$Collision$ConvexConvex$bestFace = F2(
	function (faces, separatingAxis) {
		if (faces.b) {
			var face = faces.a;
			var restFaces = faces.b;
			return $elm$core$Maybe$Just(
				A4(
					$author$project$Collision$ConvexConvex$bestFaceHelp,
					separatingAxis,
					restFaces,
					face,
					A2($author$project$Internal$Vector3$dot, face.aS, separatingAxis)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Internal$Vector3$lerp = F3(
	function (t, v1, v2) {
		return {cF: v1.cF + (t * (v2.cF - v1.cF)), cG: v1.cG + (t * (v2.cG - v1.cG)), cH: v1.cH + (t * (v2.cH - v1.cH))};
	});
var $author$project$Collision$ConvexConvex$clipFaceAgainstPlaneAdd = F5(
	function (planeNormal, planeConstant, prev, next, result) {
		var nDotPrev = A2($author$project$Internal$Vector3$dot, planeNormal, prev) + planeConstant;
		var nDotNext = A2($author$project$Internal$Vector3$dot, planeNormal, next) + planeConstant;
		return (nDotPrev < 0) ? ((nDotNext < 0) ? A2($elm$core$List$cons, next, result) : A2(
			$elm$core$List$cons,
			A3($author$project$Internal$Vector3$lerp, nDotPrev / (nDotPrev - nDotNext), prev, next),
			result)) : ((nDotNext < 0) ? A2(
			$elm$core$List$cons,
			next,
			A2(
				$elm$core$List$cons,
				A3($author$project$Internal$Vector3$lerp, nDotPrev / (nDotPrev - nDotNext), prev, next),
				result)) : result);
	});
var $author$project$Shapes$Convex$foldFaceEdgesHelp = F4(
	function (fn, seed, resultSeed, vertices) {
		foldFaceEdgesHelp:
		while (true) {
			if (vertices.b) {
				var el1 = vertices.a;
				var rest1 = vertices.b;
				if (!rest1.b) {
					return A3(fn, el1, seed, resultSeed);
				} else {
					var el2 = rest1.a;
					var $temp$fn = fn,
						$temp$seed = seed,
						$temp$resultSeed = A3(fn, el1, el2, resultSeed),
						$temp$vertices = rest1;
					fn = $temp$fn;
					seed = $temp$seed;
					resultSeed = $temp$resultSeed;
					vertices = $temp$vertices;
					continue foldFaceEdgesHelp;
				}
			} else {
				return resultSeed;
			}
		}
	});
var $author$project$Shapes$Convex$foldFaceEdges = F3(
	function (fn, resultSeed, vertices) {
		if (vertices.b && vertices.b.b) {
			var first = vertices.a;
			var _v1 = vertices.b;
			return A4($author$project$Shapes$Convex$foldFaceEdgesHelp, fn, first, resultSeed, vertices);
		} else {
			return resultSeed;
		}
	});
var $author$project$Collision$ConvexConvex$clipAgainstAdjacentFaces = F2(
	function (_v0, faceVertices) {
		var vertices = _v0.cE;
		var normal = _v0.aS;
		return A3(
			$author$project$Shapes$Convex$foldFaceEdges,
			F2(
				function (v1, v2) {
					var edge = $author$project$Internal$Vector3$normalize(
						A2($author$project$Internal$Vector3$sub, v1, v2));
					var planeNormal = A2($author$project$Internal$Vector3$cross, normal, edge);
					var planeConstant = -A2($author$project$Internal$Vector3$dot, v1, planeNormal);
					return A2(
						$author$project$Shapes$Convex$foldFaceEdges,
						A2($author$project$Collision$ConvexConvex$clipFaceAgainstPlaneAdd, planeNormal, planeConstant),
						_List_Nil);
				}),
			faceVertices,
			vertices);
	});
var $author$project$Collision$ConvexConvex$clipTwoFacesHelp = F5(
	function (separatingAxis, face, facePlaneConstant, vertices, result) {
		clipTwoFacesHelp:
		while (true) {
			if (vertices.b) {
				var vertex = vertices.a;
				var remainingVertices = vertices.b;
				var depth = A2($author$project$Internal$Vector3$dot, face.aS, vertex) + facePlaneConstant;
				if (depth <= 0) {
					var $temp$separatingAxis = separatingAxis,
						$temp$face = face,
						$temp$facePlaneConstant = facePlaneConstant,
						$temp$vertices = remainingVertices,
						$temp$result = A2(
						$elm$core$List$cons,
						{
							ip: separatingAxis,
							iH: {cF: vertex.cF - (depth * face.aS.cF), cG: vertex.cG - (depth * face.aS.cG), cH: vertex.cH - (depth * face.aS.cH)},
							iI: vertex
						},
						result);
					separatingAxis = $temp$separatingAxis;
					face = $temp$face;
					facePlaneConstant = $temp$facePlaneConstant;
					vertices = $temp$vertices;
					result = $temp$result;
					continue clipTwoFacesHelp;
				} else {
					var $temp$separatingAxis = separatingAxis,
						$temp$face = face,
						$temp$facePlaneConstant = facePlaneConstant,
						$temp$vertices = remainingVertices,
						$temp$result = result;
					separatingAxis = $temp$separatingAxis;
					face = $temp$face;
					facePlaneConstant = $temp$facePlaneConstant;
					vertices = $temp$vertices;
					result = $temp$result;
					continue clipTwoFacesHelp;
				}
			} else {
				return result;
			}
		}
	});
var $author$project$Collision$ConvexConvex$clipTwoFaces = F4(
	function (face, _v0, separatingAxis, contacts) {
		var vertices = _v0.cE;
		var point = function () {
			var _v1 = face.cE;
			if (_v1.b) {
				var first = _v1.a;
				return first;
			} else {
				return $author$project$Internal$Vector3$zero;
			}
		}();
		var facePlaneConstant = -A2($author$project$Internal$Vector3$dot, face.aS, point);
		return A5(
			$author$project$Collision$ConvexConvex$clipTwoFacesHelp,
			separatingAxis,
			face,
			facePlaneConstant,
			A2($author$project$Collision$ConvexConvex$clipAgainstAdjacentFaces, face, vertices),
			contacts);
	});
var $author$project$Collision$ConvexConvex$project = F4(
	function (localAxis, minVal, maxVal, currentVertices) {
		project:
		while (true) {
			if (!currentVertices.b) {
				return {d3: maxVal, d6: minVal};
			} else {
				var vec = currentVertices.a;
				var remainingVertices = currentVertices.b;
				var val = ((vec.cF * localAxis.cF) + (vec.cG * localAxis.cG)) + (vec.cH * localAxis.cH);
				var $temp$localAxis = localAxis,
					$temp$minVal = ((minVal - val) > 0) ? val : minVal,
					$temp$maxVal = ((maxVal - val) > 0) ? maxVal : val,
					$temp$currentVertices = remainingVertices;
				localAxis = $temp$localAxis;
				minVal = $temp$minVal;
				maxVal = $temp$maxVal;
				currentVertices = $temp$currentVertices;
				continue project;
			}
		}
	});
var $author$project$Collision$ConvexConvex$testSeparatingAxis = F3(
	function (convex1, convex2, separatingAxis) {
		var p2 = A4($author$project$Collision$ConvexConvex$project, separatingAxis, $author$project$Internal$Const$maxNumber, -$author$project$Internal$Const$maxNumber, convex2.cE);
		var p1 = A4($author$project$Collision$ConvexConvex$project, separatingAxis, $author$project$Internal$Const$maxNumber, -$author$project$Internal$Const$maxNumber, convex1.cE);
		var d2 = p2.d3 - p1.d6;
		var d1 = p1.d3 - p2.d6;
		return ((d1 < 0) || (d2 < 0)) ? $elm$core$Maybe$Nothing : (((d1 - d2) > 0) ? $elm$core$Maybe$Just(d2) : $elm$core$Maybe$Just(d1));
	});
var $author$project$Internal$Const$precision = 1.0e-6;
var $author$project$Internal$Vector3$almostZero = function (_v0) {
	var x = _v0.cF;
	var y = _v0.cG;
	var z = _v0.cH;
	return (($elm$core$Basics$abs(x) - $author$project$Internal$Const$precision) <= 0) && ((($elm$core$Basics$abs(y) - $author$project$Internal$Const$precision) <= 0) && (($elm$core$Basics$abs(z) - $author$project$Internal$Const$precision) <= 0));
};
var $author$project$Internal$Vector3$negate = function (v3) {
	return {cF: -v3.cF, cG: -v3.cG, cH: -v3.cH};
};
var $author$project$Collision$ConvexConvex$testUniqueEdges = F7(
	function (convex1, convex2, initEdges2, edges1, edges2, target, dmin) {
		testUniqueEdges:
		while (true) {
			if (!edges1.b) {
				return (A2(
					$author$project$Internal$Vector3$dot,
					A2($author$project$Internal$Vector3$sub, convex2.f9, convex1.f9),
					target) > 0) ? $elm$core$Maybe$Just(
					$author$project$Internal$Vector3$negate(target)) : $elm$core$Maybe$Just(target);
			} else {
				var edge1 = edges1.a;
				var remainingEdges1 = edges1.b;
				if (!edges2.b) {
					var $temp$convex1 = convex1,
						$temp$convex2 = convex2,
						$temp$initEdges2 = initEdges2,
						$temp$edges1 = remainingEdges1,
						$temp$edges2 = initEdges2,
						$temp$target = target,
						$temp$dmin = dmin;
					convex1 = $temp$convex1;
					convex2 = $temp$convex2;
					initEdges2 = $temp$initEdges2;
					edges1 = $temp$edges1;
					edges2 = $temp$edges2;
					target = $temp$target;
					dmin = $temp$dmin;
					continue testUniqueEdges;
				} else {
					var edge2 = edges2.a;
					var remainingEdges2 = edges2.b;
					var cross = A2($author$project$Internal$Vector3$cross, edge1, edge2);
					if ($author$project$Internal$Vector3$almostZero(cross)) {
						var $temp$convex1 = convex1,
							$temp$convex2 = convex2,
							$temp$initEdges2 = initEdges2,
							$temp$edges1 = edges1,
							$temp$edges2 = remainingEdges2,
							$temp$target = target,
							$temp$dmin = dmin;
						convex1 = $temp$convex1;
						convex2 = $temp$convex2;
						initEdges2 = $temp$initEdges2;
						edges1 = $temp$edges1;
						edges2 = $temp$edges2;
						target = $temp$target;
						dmin = $temp$dmin;
						continue testUniqueEdges;
					} else {
						var normalizedCross = $author$project$Internal$Vector3$normalize(cross);
						var _v2 = A3($author$project$Collision$ConvexConvex$testSeparatingAxis, convex1, convex2, normalizedCross);
						if (_v2.$ === 1) {
							return $elm$core$Maybe$Nothing;
						} else {
							var dist = _v2.a;
							if ((dist - dmin) < 0) {
								var $temp$convex1 = convex1,
									$temp$convex2 = convex2,
									$temp$initEdges2 = initEdges2,
									$temp$edges1 = edges1,
									$temp$edges2 = remainingEdges2,
									$temp$target = normalizedCross,
									$temp$dmin = dist;
								convex1 = $temp$convex1;
								convex2 = $temp$convex2;
								initEdges2 = $temp$initEdges2;
								edges1 = $temp$edges1;
								edges2 = $temp$edges2;
								target = $temp$target;
								dmin = $temp$dmin;
								continue testUniqueEdges;
							} else {
								var $temp$convex1 = convex1,
									$temp$convex2 = convex2,
									$temp$initEdges2 = initEdges2,
									$temp$edges1 = edges1,
									$temp$edges2 = remainingEdges2,
									$temp$target = target,
									$temp$dmin = dmin;
								convex1 = $temp$convex1;
								convex2 = $temp$convex2;
								initEdges2 = $temp$initEdges2;
								edges1 = $temp$edges1;
								edges2 = $temp$edges2;
								target = $temp$target;
								dmin = $temp$dmin;
								continue testUniqueEdges;
							}
						}
					}
				}
			}
		}
	});
var $author$project$Collision$ConvexConvex$testUniqueNormals = F5(
	function (convex1, convex2, normals, target, dmin) {
		testUniqueNormals:
		while (true) {
			if (!normals.b) {
				return A7($author$project$Collision$ConvexConvex$testUniqueEdges, convex1, convex2, convex2.eB, convex1.eB, convex2.eB, target, dmin);
			} else {
				var normal = normals.a;
				var restNormals = normals.b;
				var _v1 = A3($author$project$Collision$ConvexConvex$testSeparatingAxis, convex1, convex2, normal);
				if (_v1.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var dist = _v1.a;
					if ((dist - dmin) < 0) {
						var $temp$convex1 = convex1,
							$temp$convex2 = convex2,
							$temp$normals = restNormals,
							$temp$target = normal,
							$temp$dmin = dist;
						convex1 = $temp$convex1;
						convex2 = $temp$convex2;
						normals = $temp$normals;
						target = $temp$target;
						dmin = $temp$dmin;
						continue testUniqueNormals;
					} else {
						var $temp$convex1 = convex1,
							$temp$convex2 = convex2,
							$temp$normals = restNormals,
							$temp$target = target,
							$temp$dmin = dmin;
						convex1 = $temp$convex1;
						convex2 = $temp$convex2;
						normals = $temp$normals;
						target = $temp$target;
						dmin = $temp$dmin;
						continue testUniqueNormals;
					}
				}
			}
		}
	});
var $author$project$Collision$ConvexConvex$findSeparatingAxis = F2(
	function (convex1, convex2) {
		return A5(
			$author$project$Collision$ConvexConvex$testUniqueNormals,
			convex1,
			convex2,
			_Utils_ap(convex1.gx, convex2.gx),
			$author$project$Internal$Vector3$zero,
			$author$project$Internal$Const$maxNumber);
	});
var $author$project$Collision$ConvexConvex$addContacts = F3(
	function (convex1, convex2, contacts) {
		var _v0 = A2($author$project$Collision$ConvexConvex$findSeparatingAxis, convex1, convex2);
		if (!_v0.$) {
			var separatingAxis = _v0.a;
			var reversedSeparatingAxis = $author$project$Internal$Vector3$negate(separatingAxis);
			var _v1 = A2($author$project$Collision$ConvexConvex$bestFace, convex1.e5, separatingAxis);
			if (!_v1.$) {
				var face1 = _v1.a;
				var _v2 = A2($author$project$Collision$ConvexConvex$bestFace, convex2.e5, reversedSeparatingAxis);
				if (!_v2.$) {
					var face2 = _v2.a;
					return A4($author$project$Collision$ConvexConvex$clipTwoFaces, face1, face2, reversedSeparatingAxis, contacts);
				} else {
					return contacts;
				}
			} else {
				return contacts;
			}
		} else {
			return contacts;
		}
	});
var $author$project$Collision$ParticleConvex$convexContact = F4(
	function (particlePosition, faces, bestDepth, bestContact) {
		convexContact:
		while (true) {
			if (!faces.b) {
				return bestContact;
			} else {
				var vertices = faces.a.cE;
				var normal = faces.a.aS;
				var remainingFaces = faces.b;
				var point = function () {
					if (vertices.b) {
						var first = vertices.a;
						return first;
					} else {
						return $author$project$Internal$Vector3$zero;
					}
				}();
				var dot = A2(
					$author$project$Internal$Vector3$dot,
					normal,
					A2($author$project$Internal$Vector3$sub, point, particlePosition));
				if (dot >= 0) {
					if (_Utils_cmp(dot, bestDepth) < 0) {
						var $temp$particlePosition = particlePosition,
							$temp$faces = remainingFaces,
							$temp$bestDepth = dot,
							$temp$bestContact = $elm$core$Maybe$Just(
							{
								ip: $author$project$Internal$Vector3$negate(normal),
								iH: particlePosition,
								iI: A2(
									$author$project$Internal$Vector3$add,
									particlePosition,
									A2($author$project$Internal$Vector3$scale, dot, normal))
							});
						particlePosition = $temp$particlePosition;
						faces = $temp$faces;
						bestDepth = $temp$bestDepth;
						bestContact = $temp$bestContact;
						continue convexContact;
					} else {
						var $temp$particlePosition = particlePosition,
							$temp$faces = remainingFaces,
							$temp$bestDepth = bestDepth,
							$temp$bestContact = bestContact;
						particlePosition = $temp$particlePosition;
						faces = $temp$faces;
						bestDepth = $temp$bestDepth;
						bestContact = $temp$bestContact;
						continue convexContact;
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $author$project$Collision$ParticleConvex$addContacts = F4(
	function (orderContact, particlePosition, _v0, contacts) {
		var faces = _v0.e5;
		var _v1 = A4($author$project$Collision$ParticleConvex$convexContact, particlePosition, faces, $author$project$Internal$Const$maxNumber, $elm$core$Maybe$Nothing);
		if (!_v1.$) {
			var contact = _v1.a;
			return A2(
				$elm$core$List$cons,
				orderContact(contact),
				contacts);
		} else {
			return contacts;
		}
	});
var $author$project$Collision$PlaneConvex$addContactsHelp = F5(
	function (orderContact, planePosition, planeNormal, vertices, contacts) {
		addContactsHelp:
		while (true) {
			if (vertices.b) {
				var vertex = vertices.a;
				var remainingVertices = vertices.b;
				var dot = (((vertex.cF - planePosition.cF) * planeNormal.cF) + ((vertex.cG - planePosition.cG) * planeNormal.cG)) + ((vertex.cH - planePosition.cH) * planeNormal.cH);
				if (dot <= 0) {
					var $temp$orderContact = orderContact,
						$temp$planePosition = planePosition,
						$temp$planeNormal = planeNormal,
						$temp$vertices = remainingVertices,
						$temp$contacts = A2(
						$elm$core$List$cons,
						orderContact(
							{
								ip: planeNormal,
								iH: {cF: vertex.cF - (dot * planeNormal.cF), cG: vertex.cG - (dot * planeNormal.cG), cH: vertex.cH - (dot * planeNormal.cH)},
								iI: vertex
							}),
						contacts);
					orderContact = $temp$orderContact;
					planePosition = $temp$planePosition;
					planeNormal = $temp$planeNormal;
					vertices = $temp$vertices;
					contacts = $temp$contacts;
					continue addContactsHelp;
				} else {
					var $temp$orderContact = orderContact,
						$temp$planePosition = planePosition,
						$temp$planeNormal = planeNormal,
						$temp$vertices = remainingVertices,
						$temp$contacts = contacts;
					orderContact = $temp$orderContact;
					planePosition = $temp$planePosition;
					planeNormal = $temp$planeNormal;
					vertices = $temp$vertices;
					contacts = $temp$contacts;
					continue addContactsHelp;
				}
			} else {
				return contacts;
			}
		}
	});
var $author$project$Collision$PlaneConvex$addContacts = F4(
	function (orderContact, plane, _v0, contacts) {
		var vertices = _v0.cE;
		return A5($author$project$Collision$PlaneConvex$addContactsHelp, orderContact, plane.f9, plane.aS, vertices, contacts);
	});
var $author$project$Collision$PlaneParticle$addContacts = F4(
	function (orderContact, _v0, particlePosition, contacts) {
		var position = _v0.f9;
		var normal = _v0.aS;
		var dot = (((particlePosition.cF - position.cF) * normal.cF) + ((particlePosition.cG - position.cG) * normal.cG)) + ((particlePosition.cH - position.cH) * normal.cH);
		return (dot <= 0) ? A2(
			$elm$core$List$cons,
			orderContact(
				{
					ip: normal,
					iH: {cF: particlePosition.cF - (dot * normal.cF), cG: particlePosition.cG - (dot * normal.cG), cH: particlePosition.cH - (dot * normal.cH)},
					iI: particlePosition
				}),
			contacts) : contacts;
	});
var $author$project$Collision$PlaneSphere$addContacts = F4(
	function (orderContact, _v0, sphere, contacts) {
		var normal = _v0.aS;
		var position = _v0.f9;
		var _v1 = sphere.f9;
		var x = _v1.cF;
		var y = _v1.cG;
		var z = _v1.cH;
		var vertex = {cF: x - (sphere.em * normal.cF), cG: y - (sphere.em * normal.cG), cH: z - (sphere.em * normal.cH)};
		var dot = (((vertex.cF - position.cF) * normal.cF) + ((vertex.cG - position.cG) * normal.cG)) + ((vertex.cH - position.cH) * normal.cH);
		return (dot <= 0) ? A2(
			$elm$core$List$cons,
			orderContact(
				{
					ip: normal,
					iH: {cF: vertex.cF - (dot * normal.cF), cG: vertex.cG - (dot * normal.cG), cH: vertex.cH - (dot * normal.cH)},
					iI: vertex
				}),
			contacts) : contacts;
	});
var $author$project$Internal$Vector3$direction = F2(
	function (a, b) {
		var c = A2($author$project$Internal$Vector3$sub, a, b);
		var len = $author$project$Internal$Vector3$length(c);
		return {cF: c.cF / len, cG: c.cG / len, cH: c.cH / len};
	});
var $author$project$Collision$SphereConvex$QualifiedEdges = function (a) {
	return {$: 0, a: a};
};
var $author$project$Collision$SphereConvex$isAFaceContact = function (testFaceResult) {
	if (testFaceResult.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Collision$SphereConvex$listRecurseUntil = F4(
	function (test, fn, resultSoFar, list) {
		listRecurseUntil:
		while (true) {
			if (test(resultSoFar)) {
				return resultSoFar;
			} else {
				if (list.b) {
					var head = list.a;
					var tail = list.b;
					var acc = A2(fn, head, resultSoFar);
					var $temp$test = test,
						$temp$fn = fn,
						$temp$resultSoFar = acc,
						$temp$list = tail;
					test = $temp$test;
					fn = $temp$fn;
					resultSoFar = $temp$resultSoFar;
					list = $temp$list;
					continue listRecurseUntil;
				} else {
					return resultSoFar;
				}
			}
		}
	});
var $author$project$Collision$SphereConvex$PossibleVertexContact = function (a) {
	return {$: 0, a: a};
};
var $author$project$Collision$SphereConvex$isAnEdgeContact = function (testEdgeResult) {
	if (testEdgeResult.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Collision$SphereConvex$EdgeContact = function (a) {
	return {$: 1, a: a};
};
var $author$project$Collision$SphereConvex$sphereTestEdge = F3(
	function (prevVertex, vertex, statusQuo) {
		var minDistanceSq = statusQuo.b;
		var edge = A2($author$project$Internal$Vector3$sub, vertex, prevVertex);
		var edgeUnit = $author$project$Internal$Vector3$normalize(edge);
		var offset = -A2($author$project$Internal$Vector3$dot, prevVertex, edgeUnit);
		var betterVertexContact = function (candidate) {
			var vertexLengthSq = $author$project$Internal$Vector3$lengthSquared(candidate);
			return ((vertexLengthSq - minDistanceSq) < 0) ? _Utils_Tuple2(
				$elm$core$Maybe$Just(candidate),
				vertexLengthSq) : statusQuo;
		};
		if (offset < 0) {
			return $author$project$Collision$SphereConvex$PossibleVertexContact(
				betterVertexContact(prevVertex));
		} else {
			if (((offset * offset) - $author$project$Internal$Vector3$lengthSquared(edge)) > 0) {
				return $author$project$Collision$SphereConvex$PossibleVertexContact(
					betterVertexContact(vertex));
			} else {
				var edgeContact = A2(
					$author$project$Internal$Vector3$add,
					prevVertex,
					A2($author$project$Internal$Vector3$scale, offset, edgeUnit));
				var edgeDistanceSq = $author$project$Internal$Vector3$lengthSquared(edgeContact);
				return ((edgeDistanceSq - minDistanceSq) < 0) ? $author$project$Collision$SphereConvex$EdgeContact(
					_Utils_Tuple2(edgeContact, edgeDistanceSq)) : $author$project$Collision$SphereConvex$PossibleVertexContact(statusQuo);
			}
		}
	});
var $author$project$Collision$SphereConvex$sphereTestBoundary = F2(
	function (faceEdges, statusQuo) {
		return A4(
			$author$project$Collision$SphereConvex$listRecurseUntil,
			$author$project$Collision$SphereConvex$isAnEdgeContact,
			F2(
				function (_v0, statusQuo1) {
					var prevVertex = _v0.a;
					var vertex = _v0.b;
					if (!statusQuo1.$) {
						var soFar = statusQuo1.a;
						return A3($author$project$Collision$SphereConvex$sphereTestEdge, prevVertex, vertex, soFar);
					} else {
						return statusQuo1;
					}
				}),
			statusQuo,
			faceEdges);
	});
var $author$project$Collision$SphereConvex$sphereTestBoundaries = F2(
	function (radius, faceEdgeList) {
		return A3(
			$elm$core$List$foldl,
			$author$project$Collision$SphereConvex$sphereTestBoundary,
			$author$project$Collision$SphereConvex$PossibleVertexContact(
				_Utils_Tuple2($elm$core$Maybe$Nothing, radius * radius)),
			faceEdgeList);
	});
var $author$project$Collision$SphereConvex$FaceContact = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Collision$SphereConvex$originProjection = F2(
	function (vertices, normal) {
		return A3(
			$author$project$Shapes$Convex$foldFaceEdges,
			F3(
				function (prevVertex, vertex, acc) {
					var edge_x_normal = A2(
						$author$project$Internal$Vector3$cross,
						normal,
						A2($author$project$Internal$Vector3$sub, vertex, prevVertex));
					return (A2($author$project$Internal$Vector3$dot, edge_x_normal, prevVertex) < 0) ? A2(
						$elm$core$List$cons,
						_Utils_Tuple2(prevVertex, vertex),
						acc) : acc;
				}),
			_List_Nil,
			vertices);
	});
var $author$project$Collision$SphereConvex$sphereTestFace = F4(
	function (radius, normal, vertices, acc) {
		var faceDistance = function () {
			if (vertices.b) {
				var point = vertices.a;
				return -A2($author$project$Internal$Vector3$dot, normal, point);
			} else {
				return -1;
			}
		}();
		if (((faceDistance - radius) < 0) && (faceDistance > 0.0)) {
			var _v0 = A2($author$project$Collision$SphereConvex$originProjection, vertices, normal);
			if (!_v0.b) {
				return A2($author$project$Collision$SphereConvex$FaceContact, normal, faceDistance);
			} else {
				var separatingEdges = _v0;
				return $author$project$Collision$SphereConvex$QualifiedEdges(
					A2($elm$core$List$cons, separatingEdges, acc));
			}
		} else {
			return $author$project$Collision$SphereConvex$QualifiedEdges(acc);
		}
	});
var $author$project$Collision$SphereConvex$sphereContact = F3(
	function (center, radius, _v0) {
		var faces = _v0.e5;
		var sphereFaceContact = F2(
			function (normal, distance) {
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						A2(
							$author$project$Internal$Vector3$sub,
							center,
							A2($author$project$Internal$Vector3$scale, distance, normal))),
					radius - distance);
			});
		var sphereBoundaryContact = F2(
			function (localContact, distanceSq) {
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						A2($author$project$Internal$Vector3$add, localContact, center)),
					radius - $elm$core$Basics$sqrt(distanceSq));
			});
		var spherePossibleBoundaryContact = function (faceEdgeList) {
			var _v3 = A2($author$project$Collision$SphereConvex$sphereTestBoundaries, radius, faceEdgeList);
			if (!_v3.$) {
				if (!_v3.a.a.$) {
					var _v4 = _v3.a;
					var localContact = _v4.a.a;
					var distanceSq = _v4.b;
					return A2(sphereBoundaryContact, localContact, distanceSq);
				} else {
					var noContact = _v3.a;
					return noContact;
				}
			} else {
				var _v5 = _v3.a;
				var localContact = _v5.a;
				var distanceSq = _v5.b;
				return A2(sphereBoundaryContact, localContact, distanceSq);
			}
		};
		var reframedVertices = function (faceVertices) {
			return A3(
				$elm$core$List$foldl,
				F2(
					function (vertex, acc) {
						return A2(
							$elm$core$List$cons,
							A2($author$project$Internal$Vector3$sub, vertex, center),
							acc);
					}),
				_List_Nil,
				faceVertices);
		};
		var testFaceResult = A4(
			$author$project$Collision$SphereConvex$listRecurseUntil,
			$author$project$Collision$SphereConvex$isAFaceContact,
			F2(
				function (face, statusQuo) {
					if (!statusQuo.$) {
						var acc = statusQuo.a;
						return A4(
							$author$project$Collision$SphereConvex$sphereTestFace,
							radius,
							face.aS,
							reframedVertices(face.cE),
							acc);
					} else {
						return statusQuo;
					}
				}),
			$author$project$Collision$SphereConvex$QualifiedEdges(_List_Nil),
			faces);
		if (!testFaceResult.$) {
			var faceEdgeList = testFaceResult.a;
			return spherePossibleBoundaryContact(faceEdgeList);
		} else {
			var faceNormal = testFaceResult.a;
			var faceDistance = testFaceResult.b;
			return A2(sphereFaceContact, faceNormal, faceDistance);
		}
	});
var $author$project$Collision$SphereConvex$addContacts = F4(
	function (orderContact, _v0, hull2, contacts) {
		var radius = _v0.em;
		var position = _v0.f9;
		var _v1 = A3($author$project$Collision$SphereConvex$sphereContact, position, radius, hull2);
		var maybeContact = _v1.a;
		var penetration = _v1.b;
		if (!maybeContact.$) {
			var contact2 = maybeContact.a;
			var normal = A2($author$project$Internal$Vector3$direction, contact2, position);
			return A2(
				$elm$core$List$cons,
				orderContact(
					{
						ip: normal,
						iH: {cF: contact2.cF + (penetration * normal.cF), cG: contact2.cG + (penetration * normal.cG), cH: contact2.cH + (penetration * normal.cH)},
						iI: contact2
					}),
				contacts);
		} else {
			return contacts;
		}
	});
var $author$project$Internal$Vector3$distance = F2(
	function (a, b) {
		var z = b.cH - a.cH;
		var y = b.cG - a.cG;
		var x = b.cF - a.cF;
		return $elm$core$Basics$sqrt(((x * x) + (y * y)) + (z * z));
	});
var $author$project$Collision$SphereParticle$addContacts = F4(
	function (orderContact, _v0, particlePosition, contacts) {
		var radius = _v0.em;
		var position = _v0.f9;
		var normal = A2($author$project$Internal$Vector3$direction, particlePosition, position);
		var distance = A2($author$project$Internal$Vector3$distance, particlePosition, position) - radius;
		return (distance > 0) ? contacts : A2(
			$elm$core$List$cons,
			orderContact(
				{
					ip: normal,
					iH: A2(
						$author$project$Internal$Vector3$add,
						position,
						A2($author$project$Internal$Vector3$scale, radius - distance, normal)),
					iI: particlePosition
				}),
			contacts);
	});
var $author$project$Collision$SphereSphere$addContacts = F3(
	function (sphere1, sphere2, contacts) {
		var radius2 = sphere2.em;
		var radius1 = sphere1.em;
		var center2 = sphere2.f9;
		var center1 = sphere1.f9;
		var distance = (A2($author$project$Internal$Vector3$distance, center2, center1) - radius1) - radius2;
		var normal = A2($author$project$Internal$Vector3$direction, center2, center1);
		return (distance > 0) ? contacts : A2(
			$elm$core$List$cons,
			{
				ip: normal,
				iH: A2(
					$author$project$Internal$Vector3$add,
					center1,
					A2($author$project$Internal$Vector3$scale, radius1 - distance, normal)),
				iI: A2(
					$author$project$Internal$Vector3$add,
					center2,
					A2($author$project$Internal$Vector3$scale, -radius2, normal))
			},
			contacts);
	});
var $author$project$Internal$Contact$flip = function (contact) {
	return {
		ip: $author$project$Internal$Vector3$negate(contact.ip),
		iH: contact.iI,
		iI: contact.iH
	};
};
var $author$project$Internal$NarrowPhase$addShapeContacts = F3(
	function (shape1, shape2, contacts) {
		switch (shape1.$) {
			case 0:
				var convex1 = shape1.a;
				switch (shape2.$) {
					case 0:
						var convex2 = shape2.a;
						return A3($author$project$Collision$ConvexConvex$addContacts, convex1, convex2, contacts);
					case 1:
						var plane2 = shape2.a;
						return A4($author$project$Collision$PlaneConvex$addContacts, $author$project$Internal$Contact$flip, plane2, convex1, contacts);
					case 2:
						var sphere2 = shape2.a;
						return A4($author$project$Collision$SphereConvex$addContacts, $author$project$Internal$Contact$flip, sphere2, convex1, contacts);
					default:
						var particle2 = shape2.a;
						return A4($author$project$Collision$ParticleConvex$addContacts, $author$project$Internal$Contact$flip, particle2, convex1, contacts);
				}
			case 1:
				var plane1 = shape1.a;
				switch (shape2.$) {
					case 1:
						return contacts;
					case 0:
						var convex2 = shape2.a;
						return A4($author$project$Collision$PlaneConvex$addContacts, $elm$core$Basics$identity, plane1, convex2, contacts);
					case 2:
						var sphere2 = shape2.a;
						return A4($author$project$Collision$PlaneSphere$addContacts, $elm$core$Basics$identity, plane1, sphere2, contacts);
					default:
						var particle2 = shape2.a;
						return A4($author$project$Collision$PlaneParticle$addContacts, $elm$core$Basics$identity, plane1, particle2, contacts);
				}
			case 2:
				var sphere1 = shape1.a;
				switch (shape2.$) {
					case 1:
						var plane2 = shape2.a;
						return A4($author$project$Collision$PlaneSphere$addContacts, $author$project$Internal$Contact$flip, plane2, sphere1, contacts);
					case 0:
						var convex2 = shape2.a;
						return A4($author$project$Collision$SphereConvex$addContacts, $elm$core$Basics$identity, sphere1, convex2, contacts);
					case 2:
						var sphere2 = shape2.a;
						return A3($author$project$Collision$SphereSphere$addContacts, sphere1, sphere2, contacts);
					default:
						var particle2 = shape2.a;
						return A4($author$project$Collision$SphereParticle$addContacts, $elm$core$Basics$identity, sphere1, particle2, contacts);
				}
			default:
				var particle1 = shape1.a;
				switch (shape2.$) {
					case 1:
						var plane2 = shape2.a;
						return A4($author$project$Collision$PlaneParticle$addContacts, $author$project$Internal$Contact$flip, plane2, particle1, contacts);
					case 0:
						var convex2 = shape2.a;
						return A4($author$project$Collision$ParticleConvex$addContacts, $elm$core$Basics$identity, particle1, convex2, contacts);
					case 2:
						var sphere2 = shape2.a;
						return A4($author$project$Collision$SphereParticle$addContacts, $author$project$Internal$Contact$flip, sphere2, particle1, contacts);
					default:
						return contacts;
				}
		}
	});
var $author$project$Internal$NarrowPhase$getContactsHelp = F5(
	function (shape1, currentShapes1, currentShapes2, shapes2, result) {
		getContactsHelp:
		while (true) {
			if (currentShapes2.b) {
				var shape2 = currentShapes2.a;
				var remainingShapes2 = currentShapes2.b;
				var $temp$shape1 = shape1,
					$temp$currentShapes1 = currentShapes1,
					$temp$currentShapes2 = remainingShapes2,
					$temp$shapes2 = shapes2,
					$temp$result = A3($author$project$Internal$NarrowPhase$addShapeContacts, shape1, shape2, result);
				shape1 = $temp$shape1;
				currentShapes1 = $temp$currentShapes1;
				currentShapes2 = $temp$currentShapes2;
				shapes2 = $temp$shapes2;
				result = $temp$result;
				continue getContactsHelp;
			} else {
				if (currentShapes1.b) {
					var newShape1 = currentShapes1.a;
					var remainingShapes1 = currentShapes1.b;
					var $temp$shape1 = newShape1,
						$temp$currentShapes1 = remainingShapes1,
						$temp$currentShapes2 = shapes2,
						$temp$shapes2 = shapes2,
						$temp$result = result;
					shape1 = $temp$shape1;
					currentShapes1 = $temp$currentShapes1;
					currentShapes2 = $temp$currentShapes2;
					shapes2 = $temp$shapes2;
					result = $temp$result;
					continue getContactsHelp;
				} else {
					return result;
				}
			}
		}
	});
var $author$project$Internal$NarrowPhase$getContacts = F2(
	function (shapes1, shapes2) {
		if (shapes1.b) {
			var shape1 = shapes1.a;
			var remainingShapes1 = shapes1.b;
			return A5($author$project$Internal$NarrowPhase$getContactsHelp, shape1, remainingShapes1, shapes2, shapes2, _List_Nil);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Internal$BroadPhase$addContactsHelp = F4(
	function (body1, currentBodies, restBodies, result) {
		addContactsHelp:
		while (true) {
			if (restBodies.b) {
				var body2 = restBodies.a;
				var newRestBodies = restBodies.b;
				var $temp$body1 = body1,
					$temp$currentBodies = currentBodies,
					$temp$restBodies = newRestBodies,
					$temp$result = function () {
					if (A2($author$project$Internal$BroadPhase$bodiesMayContact, body1, body2)) {
						var _v1 = A2($author$project$Internal$NarrowPhase$getContacts, body1.eD, body2.eD);
						if (!_v1.b) {
							return result;
						} else {
							var contacts = _v1;
							return A2(
								$elm$core$List$cons,
								{gX: body1, gY: body2, hi: contacts},
								result);
						}
					} else {
						return result;
					}
				}();
				body1 = $temp$body1;
				currentBodies = $temp$currentBodies;
				restBodies = $temp$restBodies;
				result = $temp$result;
				continue addContactsHelp;
			} else {
				if (currentBodies.b) {
					var newBody1 = currentBodies.a;
					var newRestBodies = currentBodies.b;
					var $temp$body1 = newBody1,
						$temp$currentBodies = newRestBodies,
						$temp$restBodies = newRestBodies,
						$temp$result = result;
					body1 = $temp$body1;
					currentBodies = $temp$currentBodies;
					restBodies = $temp$restBodies;
					result = $temp$result;
					continue addContactsHelp;
				} else {
					return result;
				}
			}
		}
	});
var $author$project$Internal$BroadPhase$addContacts = function (world) {
	return _Utils_update(
		world,
		{
			hh: function () {
				var _v0 = world.eK;
				if (_v0.b) {
					var body = _v0.a;
					var restBodies = _v0.b;
					return A4($author$project$Internal$BroadPhase$addContactsHelp, body, restBodies, restBodies, _List_Nil);
				} else {
					return _List_Nil;
				}
			}()
		});
};
var $ianmackenzie$elm_units$Duration$inSeconds = function (_v0) {
	var numSeconds = _v0;
	return numSeconds;
};
var $author$project$Internal$Equation$computeContactB = F5(
	function (bounciness, _v0, bi, bj, _v1) {
		var pi = _v0.iH;
		var pj = _v0.iI;
		var ni = _v0.ip;
		var spookA = _v1.R;
		var spookB = _v1.L;
		var wA = _v1.I;
		var wB = _v1.J;
		var gW = (((bounciness + 1) * (A2($author$project$Internal$Vector3$dot, bj.dF, ni) - A2($author$project$Internal$Vector3$dot, bi.dF, ni))) + A2($author$project$Internal$Vector3$dot, bj.cL, wB)) + A2($author$project$Internal$Vector3$dot, bi.cL, wA);
		var g = (((pj.cF - pi.cF) * ni.cF) + ((pj.cG - pi.cG) * ni.cG)) + ((pj.cH - pi.cH) * ni.cH);
		return ((-g) * spookA) - (gW * spookB);
	});
var $author$project$Internal$Equation$defaultRelaxation = 3;
var $author$project$Internal$Equation$defaultStiffness = 10000000;
var $author$project$Internal$Equation$computeC = F3(
	function (bi, bj, _v0) {
		var wA = _v0.I;
		var wB = _v0.J;
		var spookEps = _v0.X;
		return (((((((bi.c3 + bj.c3) + (wA.cF * (((bi.c2.h8 * wA.cF) + (bi.c2.h9 * wA.cG)) + (bi.c2.ia * wA.cH)))) + (wA.cG * (((bi.c2.ib * wA.cF) + (bi.c2.ic * wA.cG)) + (bi.c2.id * wA.cH)))) + (wA.cH * (((bi.c2.ie * wA.cF) + (bi.c2.$8 * wA.cG)) + (bi.c2.ig * wA.cH)))) + (wB.cF * (((bj.c2.h8 * wB.cF) + (bj.c2.h9 * wB.cG)) + (bj.c2.ia * wB.cH)))) + (wB.cG * (((bj.c2.ib * wB.cF) + (bj.c2.ic * wB.cG)) + (bj.c2.id * wB.cH)))) + (wB.cH * (((bj.c2.ie * wB.cF) + (bj.c2.$8 * wB.cG)) + (bj.c2.ig * wB.cH)))) + spookEps;
	});
var $author$project$Internal$Equation$computeGiMf = F4(
	function (gravity, bi, bj, _v0) {
		var wA = _v0.I;
		var vB = _v0.S;
		var wB = _v0.J;
		var gravityj = (bj.d1 > 0) ? gravity : $author$project$Internal$Vector3$zero;
		var gravityi = (bi.d1 > 0) ? gravity : $author$project$Internal$Vector3$zero;
		return (((((((-(((vB.cF * ((bi.c3 * bi.cZ.cF) + gravityi.cF)) + (vB.cG * ((bi.c3 * bi.cZ.cG) + gravityi.cG))) + (vB.cH * ((bi.c3 * bi.cZ.cH) + gravityi.cH)))) + (((vB.cF * ((bj.c3 * bj.cZ.cF) + gravityj.cF)) + (vB.cG * ((bj.c3 * bj.cZ.cG) + gravityj.cG))) + (vB.cH * ((bj.c3 * bj.cZ.cH) + gravityj.cH)))) + (wA.cF * (((bi.c2.h8 * bi.dC.cF) + (bi.c2.h9 * bi.dC.cG)) + (bi.c2.ia * bi.dC.cH)))) + (wA.cG * (((bi.c2.ib * bi.dC.cF) + (bi.c2.ic * bi.dC.cG)) + (bi.c2.id * bi.dC.cH)))) + (wA.cH * (((bi.c2.ie * bi.dC.cF) + (bi.c2.$8 * bi.dC.cG)) + (bi.c2.ig * bi.dC.cH)))) + (wB.cF * (((bj.c2.h8 * bj.dC.cF) + (bj.c2.h9 * bj.dC.cG)) + (bj.c2.ia * bj.dC.cH)))) + (wB.cG * (((bj.c2.ib * bj.dC.cF) + (bj.c2.ic * bj.dC.cG)) + (bj.c2.id * bj.dC.cH)))) + (wB.cH * (((bj.c2.ie * bj.dC.cF) + (bj.c2.$8 * bj.dC.cG)) + (bj.c2.ig * bj.dC.cH)));
	});
var $author$project$Internal$Equation$initSolverParams = F5(
	function (computeB, ctx, bi, bj, solverEquation) {
		return {
			e2: {
				aa: solverEquation.aa,
				ab: solverEquation.ab,
				ak: A3(computeB, bi, bj, solverEquation) - (ctx.w * A4($author$project$Internal$Equation$computeGiMf, ctx.ff, bi, bj, solverEquation)),
				al: 1 / A3($author$project$Internal$Equation$computeC, bi, bj, solverEquation),
				R: solverEquation.R,
				L: solverEquation.L,
				X: solverEquation.X,
				S: solverEquation.S,
				I: solverEquation.I,
				J: solverEquation.J
			},
			gp: 0
		};
	});
var $author$project$Internal$Equation$addDistanceConstraintEquations = F4(
	function (ctx, body1, body2, distance) {
		var spookEps = 4.0 / (((ctx.w * ctx.w) * $author$project$Internal$Equation$defaultStiffness) * (1 + (4 * $author$project$Internal$Equation$defaultRelaxation)));
		var spookB = (4.0 * $author$project$Internal$Equation$defaultRelaxation) / (1 + (4 * $author$project$Internal$Equation$defaultRelaxation));
		var spookA = 4.0 / (ctx.w * (1 + (4 * $author$project$Internal$Equation$defaultRelaxation)));
		var ni = A2(
			$author$project$Internal$Vector3$direction,
			$author$project$Internal$Transform3d$originPoint(body2.cA),
			$author$project$Internal$Transform3d$originPoint(body1.cA));
		var halfDistance = distance / 2;
		var ri = A2($author$project$Internal$Vector3$scale, halfDistance, ni);
		var rj = A2($author$project$Internal$Vector3$scale, -halfDistance, ni);
		return $elm$core$List$cons(
			A5(
				$author$project$Internal$Equation$initSolverParams,
				A2(
					$author$project$Internal$Equation$computeContactB,
					0,
					{
						ip: ni,
						iH: A2(
							$author$project$Internal$Vector3$add,
							ri,
							$author$project$Internal$Transform3d$originPoint(body1.cA)),
						iI: A2(
							$author$project$Internal$Vector3$add,
							rj,
							$author$project$Internal$Transform3d$originPoint(body2.cA))
					}),
				ctx,
				body1,
				body2,
				{
					aa: 1000000,
					ab: -1000000,
					ak: 0,
					al: 0,
					R: spookA,
					L: spookB,
					X: spookEps,
					S: ni,
					I: A2($author$project$Internal$Vector3$cross, ni, ri),
					J: A2($author$project$Internal$Vector3$cross, rj, ni)
				}));
	});
var $author$project$Internal$Equation$computeGW = F3(
	function (bi, bj, _v0) {
		var wA = _v0.I;
		var vB = _v0.S;
		var wB = _v0.J;
		return (((-(((vB.cF * bi.dF.cF) + (vB.cG * bi.dF.cG)) + (vB.cH * bi.dF.cH))) + (((wA.cF * bi.cL.cF) + (wA.cG * bi.cL.cG)) + (wA.cH * bi.cL.cH))) + (((vB.cF * bj.dF.cF) + (vB.cG * bj.dF.cG)) + (vB.cH * bj.dF.cH))) + (((wB.cF * bj.cL.cF) + (wB.cG * bj.cL.cG)) + (wB.cH * bj.cL.cH));
	});
var $author$project$Internal$Equation$computeRotationalB = F4(
	function (_v0, bi, bj, solverEquation) {
		var ni = _v0.ip;
		var nj = _v0.bb;
		var maxAngleCos = _v0.a8;
		var spookA = solverEquation.R;
		var spookB = solverEquation.L;
		var gW = A3($author$project$Internal$Equation$computeGW, bi, bj, solverEquation);
		var g = maxAngleCos - A2($author$project$Internal$Vector3$dot, ni, nj);
		return ((-g) * spookA) - (gW * spookB);
	});
var $author$project$Internal$Vector3$tangents = function (vec) {
	if ($author$project$Internal$Vector3$lengthSquared(vec) > 0) {
		var normalized = $author$project$Internal$Vector3$normalize(vec);
		var v = ($elm$core$Basics$abs(normalized.cF) < 0.9) ? A2($author$project$Internal$Vector3$cross, normalized, $author$project$Internal$Vector3$xAxis) : A2($author$project$Internal$Vector3$cross, normalized, $author$project$Internal$Vector3$yAxis);
		return _Utils_Tuple2(
			v,
			A2($author$project$Internal$Vector3$cross, normalized, v));
	} else {
		return _Utils_Tuple2($author$project$Internal$Vector3$xAxis, $author$project$Internal$Vector3$yAxis);
	}
};
var $author$project$Internal$Equation$addHingeRotationalConstraintEquations = F6(
	function (ctx, body1, body2, axis1, axis2, equations) {
		var worldAxis2 = A2($author$project$Internal$Transform3d$directionPlaceIn, body2.cA, axis2);
		var worldAxis1 = A2($author$project$Internal$Transform3d$directionPlaceIn, body1.cA, axis1);
		var spookEps = 4.0 / (((ctx.w * ctx.w) * $author$project$Internal$Equation$defaultStiffness) * (1 + (4 * $author$project$Internal$Equation$defaultRelaxation)));
		var spookB = (4.0 * $author$project$Internal$Equation$defaultRelaxation) / (1 + (4 * $author$project$Internal$Equation$defaultRelaxation));
		var spookA = 4.0 / (ctx.w * (1 + (4 * $author$project$Internal$Equation$defaultRelaxation)));
		var nj2 = worldAxis2;
		var nj1 = worldAxis2;
		var _v0 = $author$project$Internal$Vector3$tangents(worldAxis1);
		var ni1 = _v0.a;
		var ni2 = _v0.b;
		return A2(
			$elm$core$List$cons,
			A5(
				$author$project$Internal$Equation$initSolverParams,
				$author$project$Internal$Equation$computeRotationalB(
					{a8: 0, ip: ni1, bb: nj1}),
				ctx,
				body1,
				body2,
				{
					aa: 1000000,
					ab: -1000000,
					ak: 0,
					al: 0,
					R: spookA,
					L: spookB,
					X: spookEps,
					S: $author$project$Internal$Vector3$zero,
					I: A2($author$project$Internal$Vector3$cross, nj1, ni1),
					J: A2($author$project$Internal$Vector3$cross, ni1, nj1)
				}),
			A2(
				$elm$core$List$cons,
				A5(
					$author$project$Internal$Equation$initSolverParams,
					$author$project$Internal$Equation$computeRotationalB(
						{a8: 0, ip: ni2, bb: nj2}),
					ctx,
					body1,
					body2,
					{
						aa: 1000000,
						ab: -1000000,
						ak: 0,
						al: 0,
						R: spookA,
						L: spookB,
						X: spookEps,
						S: $author$project$Internal$Vector3$zero,
						I: A2($author$project$Internal$Vector3$cross, nj2, ni2),
						J: A2($author$project$Internal$Vector3$cross, ni2, nj2)
					}),
				equations));
	});
var $author$project$Internal$Equation$addLockRotationalConstraintEquations = function (ctx) {
	return function (body1) {
		return function (body2) {
			return function (x1) {
				return function (x2) {
					return function (y1) {
						return function (y2) {
							return function (z1) {
								return function (z2) {
									return function (equations) {
										var spookEps = 4.0 / (((ctx.w * ctx.w) * $author$project$Internal$Equation$defaultStiffness) * (1 + (4 * $author$project$Internal$Equation$defaultRelaxation)));
										var spookB = (4.0 * $author$project$Internal$Equation$defaultRelaxation) / (1 + (4 * $author$project$Internal$Equation$defaultRelaxation));
										var spookA = 4.0 / (ctx.w * (1 + (4 * $author$project$Internal$Equation$defaultRelaxation)));
										var nj3 = A2($author$project$Internal$Transform3d$directionPlaceIn, body2.cA, x2);
										var nj2 = A2($author$project$Internal$Transform3d$directionPlaceIn, body2.cA, z2);
										var nj1 = A2($author$project$Internal$Transform3d$directionPlaceIn, body2.cA, y2);
										var ni3 = A2($author$project$Internal$Transform3d$directionPlaceIn, body1.cA, z1);
										var ni2 = A2($author$project$Internal$Transform3d$directionPlaceIn, body1.cA, y1);
										var ni1 = A2($author$project$Internal$Transform3d$directionPlaceIn, body1.cA, x1);
										return A2(
											$elm$core$List$cons,
											A5(
												$author$project$Internal$Equation$initSolverParams,
												$author$project$Internal$Equation$computeRotationalB(
													{a8: 0, ip: ni1, bb: nj1}),
												ctx,
												body1,
												body2,
												{
													aa: 1000000,
													ab: -1000000,
													ak: 0,
													al: 0,
													R: spookA,
													L: spookB,
													X: spookEps,
													S: $author$project$Internal$Vector3$zero,
													I: A2($author$project$Internal$Vector3$cross, nj1, ni1),
													J: A2($author$project$Internal$Vector3$cross, ni1, nj1)
												}),
											A2(
												$elm$core$List$cons,
												A5(
													$author$project$Internal$Equation$initSolverParams,
													$author$project$Internal$Equation$computeRotationalB(
														{a8: 0, ip: ni2, bb: nj2}),
													ctx,
													body1,
													body2,
													{
														aa: 1000000,
														ab: -1000000,
														ak: 0,
														al: 0,
														R: spookA,
														L: spookB,
														X: spookEps,
														S: $author$project$Internal$Vector3$zero,
														I: A2($author$project$Internal$Vector3$cross, nj2, ni2),
														J: A2($author$project$Internal$Vector3$cross, ni2, nj2)
													}),
												A2(
													$elm$core$List$cons,
													A5(
														$author$project$Internal$Equation$initSolverParams,
														$author$project$Internal$Equation$computeRotationalB(
															{a8: 0, ip: ni3, bb: nj3}),
														ctx,
														body1,
														body2,
														{
															aa: 1000000,
															ab: -1000000,
															ak: 0,
															al: 0,
															R: spookA,
															L: spookB,
															X: spookEps,
															S: $author$project$Internal$Vector3$zero,
															I: A2($author$project$Internal$Vector3$cross, nj3, ni3),
															J: A2($author$project$Internal$Vector3$cross, ni3, nj3)
														}),
													equations)));
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Internal$Equation$addPointToPointConstraintEquations = F6(
	function (ctx, body1, body2, pivot1, pivot2, equations) {
		var spookEps = 4.0 / (((ctx.w * ctx.w) * $author$project$Internal$Equation$defaultStiffness) * (1 + (4 * $author$project$Internal$Equation$defaultRelaxation)));
		var spookB = (4.0 * $author$project$Internal$Equation$defaultRelaxation) / (1 + (4 * $author$project$Internal$Equation$defaultRelaxation));
		var spookA = 4.0 / (ctx.w * (1 + (4 * $author$project$Internal$Equation$defaultRelaxation)));
		var rj = A2($author$project$Internal$Transform3d$directionPlaceIn, body2.cA, pivot2);
		var ri = A2($author$project$Internal$Transform3d$directionPlaceIn, body1.cA, pivot1);
		return A3(
			$elm$core$List$foldl,
			function (ni) {
				return $elm$core$List$cons(
					A5(
						$author$project$Internal$Equation$initSolverParams,
						A2(
							$author$project$Internal$Equation$computeContactB,
							0,
							{
								ip: ni,
								iH: A2(
									$author$project$Internal$Vector3$add,
									$author$project$Internal$Transform3d$originPoint(body1.cA),
									ri),
								iI: A2(
									$author$project$Internal$Vector3$add,
									$author$project$Internal$Transform3d$originPoint(body2.cA),
									rj)
							}),
						ctx,
						body1,
						body2,
						{
							aa: 1000000,
							ab: -1000000,
							ak: 0,
							al: 0,
							R: spookA,
							L: spookB,
							X: spookEps,
							S: ni,
							I: A2($author$project$Internal$Vector3$cross, ni, ri),
							J: A2($author$project$Internal$Vector3$cross, rj, ni)
						}));
			},
			equations,
			$author$project$Internal$Vector3$basis);
	});
var $author$project$Internal$Equation$addConstraintEquations = F4(
	function (ctx, body1, body2, constraint) {
		switch (constraint.$) {
			case 0:
				var pivot1 = constraint.a;
				var pivot2 = constraint.b;
				return A5($author$project$Internal$Equation$addPointToPointConstraintEquations, ctx, body1, body2, pivot1, pivot2);
			case 1:
				var pivot1 = constraint.a;
				var axis1 = constraint.b;
				var pivot2 = constraint.c;
				var axis2 = constraint.d;
				return A2(
					$elm$core$Basics$composeR,
					A5($author$project$Internal$Equation$addPointToPointConstraintEquations, ctx, body1, body2, pivot1, pivot2),
					A5($author$project$Internal$Equation$addHingeRotationalConstraintEquations, ctx, body1, body2, axis1, axis2));
			case 2:
				var pivot1 = constraint.a;
				var x1 = constraint.b;
				var y1 = constraint.c;
				var z1 = constraint.d;
				var pivot2 = constraint.e;
				var x2 = constraint.f;
				var y2 = constraint.g;
				var z2 = constraint.h;
				return A2(
					$elm$core$Basics$composeR,
					A5($author$project$Internal$Equation$addPointToPointConstraintEquations, ctx, body1, body2, pivot1, pivot2),
					A9($author$project$Internal$Equation$addLockRotationalConstraintEquations, ctx, body1, body2, x1, x2, y1, y2, z1, z2));
			default:
				var distance = constraint.a;
				return A4($author$project$Internal$Equation$addDistanceConstraintEquations, ctx, body1, body2, distance);
		}
	});
var $author$project$Internal$Equation$constraintEquationsGroup = F4(
	function (ctx, body1, body2, constraints) {
		return {
			gZ: body1.hT,
			g_: body2.hT,
			dM: A3(
				$elm$core$List$foldl,
				A3($author$project$Internal$Equation$addConstraintEquations, ctx, body1, body2),
				_List_Nil,
				constraints)
		};
	});
var $author$project$Internal$Equation$computeFrictionB = F3(
	function (bi, bj, solverEquation) {
		var spookB = solverEquation.L;
		var gW = A3($author$project$Internal$Equation$computeGW, bi, bj, solverEquation);
		return (-gW) * spookB;
	});
var $author$project$Internal$Equation$addContactEquations = F7(
	function (ctx, maxFrictionForce, bounciness, body1, body2, contact, equations) {
		var spookEps = 4.0 / (((ctx.w * ctx.w) * $author$project$Internal$Equation$defaultStiffness) * (1 + (4 * $author$project$Internal$Equation$defaultRelaxation)));
		var spookB = (4.0 * $author$project$Internal$Equation$defaultRelaxation) / (1 + (4 * $author$project$Internal$Equation$defaultRelaxation));
		var spookA = 4.0 / (ctx.w * (1 + (4 * $author$project$Internal$Equation$defaultRelaxation)));
		var rj = A2(
			$author$project$Internal$Vector3$sub,
			contact.iI,
			$author$project$Internal$Transform3d$originPoint(body2.cA));
		var ri = A2(
			$author$project$Internal$Vector3$sub,
			contact.iH,
			$author$project$Internal$Transform3d$originPoint(body1.cA));
		var _v0 = $author$project$Internal$Vector3$tangents(contact.ip);
		var t1 = _v0.a;
		var t2 = _v0.b;
		return A2(
			$elm$core$List$cons,
			A5(
				$author$project$Internal$Equation$initSolverParams,
				A2($author$project$Internal$Equation$computeContactB, bounciness, contact),
				ctx,
				body1,
				body2,
				{
					aa: 1000000,
					ab: 0,
					ak: 0,
					al: 0,
					R: spookA,
					L: spookB,
					X: spookEps,
					S: contact.ip,
					I: A2($author$project$Internal$Vector3$cross, contact.ip, ri),
					J: A2($author$project$Internal$Vector3$cross, rj, contact.ip)
				}),
			A2(
				$elm$core$List$cons,
				A5(
					$author$project$Internal$Equation$initSolverParams,
					$author$project$Internal$Equation$computeFrictionB,
					ctx,
					body1,
					body2,
					{
						aa: maxFrictionForce,
						ab: -maxFrictionForce,
						ak: 0,
						al: 0,
						R: spookA,
						L: spookB,
						X: spookEps,
						S: t1,
						I: A2($author$project$Internal$Vector3$cross, t1, ri),
						J: A2($author$project$Internal$Vector3$cross, rj, t1)
					}),
				A2(
					$elm$core$List$cons,
					A5(
						$author$project$Internal$Equation$initSolverParams,
						$author$project$Internal$Equation$computeFrictionB,
						ctx,
						body1,
						body2,
						{
							aa: maxFrictionForce,
							ab: -maxFrictionForce,
							ak: 0,
							al: 0,
							R: spookA,
							L: spookB,
							X: spookEps,
							S: t2,
							I: A2($author$project$Internal$Vector3$cross, t2, ri),
							J: A2($author$project$Internal$Vector3$cross, rj, t2)
						}),
					equations)));
	});
var $author$project$Internal$Material$combine = F2(
	function (v1, v2) {
		var avg = (v1 + v2) * 0.5;
		var temp = (1 + avg) - $elm$core$Basics$abs(1 - avg);
		return (temp + $elm$core$Basics$abs(temp)) * 0.25;
	});
var $author$project$Internal$Material$contactBounciness = F2(
	function (m1, m2) {
		return A2($author$project$Internal$Material$combine, m1.cP, m2.cP);
	});
var $author$project$Internal$Material$contactFriction = F2(
	function (m1, m2) {
		return A2($author$project$Internal$Material$combine, m1.c_, m2.c_);
	});
var $author$project$Internal$Equation$contactEquationsGroup = F2(
	function (ctx, _v0) {
		var body1 = _v0.gX;
		var body2 = _v0.gY;
		var contacts = _v0.hi;
		var maxFrictionForce = ((body1.c3 + body2.c3) > 0) ? ((A2($author$project$Internal$Material$contactFriction, body1.fI, body2.fI) * ctx.fg) / (body1.c3 + body2.c3)) : 0;
		var bounciness = A2($author$project$Internal$Material$contactBounciness, body1.fI, body2.fI);
		return {
			gZ: body1.hT,
			g_: body2.hT,
			dM: A3(
				$elm$core$List$foldl,
				A5($author$project$Internal$Equation$addContactEquations, ctx, maxFrictionForce, bounciness, body1, body2),
				_List_Nil,
				contacts)
		};
	});
var $author$project$Internal$SolverBody$fromBody = function (body) {
	return {gW: body, b_: 0, b$: 0, b0: 0, b2: 0, b3: 0, b4: 0};
};
var $elm$core$Array$repeat = F2(
	function (n, e) {
		return A2(
			$elm$core$Array$initialize,
			n,
			function (_v0) {
				return e;
			});
	});
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $author$project$Internal$Solver$makeSolverBodies = F2(
	function (nextBodyId, bodies) {
		if (!bodies.b) {
			return _Utils_Tuple2($elm$core$Array$empty, $elm$core$Maybe$Nothing);
		} else {
			var firstBody = bodies.a;
			var fillingBody = $author$project$Internal$SolverBody$fromBody(
				_Utils_update(
					firstBody,
					{hT: -1}));
			var allBodies = A2($elm$core$Array$repeat, nextBodyId, fillingBody);
			return _Utils_Tuple2(
				A3(
					$elm$core$List$foldl,
					function (body) {
						return A2(
							$elm$core$Array$set,
							body.hT,
							$author$project$Internal$SolverBody$fromBody(body));
					},
					allBodies,
					bodies),
				$elm$core$Maybe$Just(fillingBody));
		}
	});
var $author$project$Internal$Solver$maxIterations = 20;
var $author$project$Internal$Solver$solveEquationsGroup = F5(
	function (body1, body2, equations, deltalambdaTot, currentEquations) {
		solveEquationsGroup:
		while (true) {
			if (!currentEquations.b) {
				return {gX: body1, gY: body2, dJ: deltalambdaTot, dM: equations};
			} else {
				var solverLambda = currentEquations.a.gp;
				var equation = currentEquations.a.e2;
				var remainingEquations = currentEquations.b;
				var invI2 = body2.gW.c2;
				var invI1 = body1.gW.c2;
				var _v1 = equation;
				var wA = _v1.I;
				var vB = _v1.S;
				var wB = _v1.J;
				var minForce = _v1.ab;
				var maxForce = _v1.aa;
				var solverB = _v1.ak;
				var spookEps = _v1.X;
				var solverInvC = _v1.al;
				var gWlambda = (((-(((vB.cF * body1.b_) + (vB.cG * body1.b$)) + (vB.cH * body1.b0))) + (((wA.cF * body1.b2) + (wA.cG * body1.b3)) + (wA.cH * body1.b4))) + (((vB.cF * body2.b_) + (vB.cG * body2.b$)) + (vB.cH * body2.b0))) + (((wB.cF * body2.b2) + (wB.cG * body2.b3)) + (wB.cH * body2.b4));
				var deltalambdaPrev = solverInvC * ((solverB - gWlambda) - (spookEps * solverLambda));
				var deltalambda = (((solverLambda + deltalambdaPrev) - minForce) < 0) ? (minForce - solverLambda) : ((((solverLambda + deltalambdaPrev) - maxForce) > 0) ? (maxForce - solverLambda) : deltalambdaPrev);
				var k1 = deltalambda * body1.gW.c3;
				var k2 = deltalambda * body2.gW.c3;
				var newBody1 = (body1.gW.d1 > 0) ? {gW: body1.gW, b_: body1.b_ - (k1 * vB.cF), b$: body1.b$ - (k1 * vB.cG), b0: body1.b0 - (k1 * vB.cH), b2: body1.b2 + ((((invI1.h8 * wA.cF) + (invI1.h9 * wA.cG)) + (invI1.ia * wA.cH)) * deltalambda), b3: body1.b3 + ((((invI1.ib * wA.cF) + (invI1.ic * wA.cG)) + (invI1.id * wA.cH)) * deltalambda), b4: body1.b4 + ((((invI1.ie * wA.cF) + (invI1.$8 * wA.cG)) + (invI1.ig * wA.cH)) * deltalambda)} : body1;
				var newBody2 = (body2.gW.d1 > 0) ? {gW: body2.gW, b_: body2.b_ + (k2 * vB.cF), b$: body2.b$ + (k2 * vB.cG), b0: body2.b0 + (k2 * vB.cH), b2: body2.b2 + ((((invI2.h8 * wB.cF) + (invI2.h9 * wB.cG)) + (invI2.ia * wB.cH)) * deltalambda), b3: body2.b3 + ((((invI2.ib * wB.cF) + (invI2.ic * wB.cG)) + (invI2.id * wB.cH)) * deltalambda), b4: body2.b4 + ((((invI2.ie * wB.cF) + (invI2.$8 * wB.cG)) + (invI2.ig * wB.cH)) * deltalambda)} : body2;
				var $temp$body1 = newBody1,
					$temp$body2 = newBody2,
					$temp$equations = A2(
					$elm$core$List$cons,
					{e2: equation, gp: solverLambda + deltalambda},
					equations),
					$temp$deltalambdaTot = deltalambdaTot + $elm$core$Basics$abs(deltalambda),
					$temp$currentEquations = remainingEquations;
				body1 = $temp$body1;
				body2 = $temp$body2;
				equations = $temp$equations;
				deltalambdaTot = $temp$deltalambdaTot;
				currentEquations = $temp$currentEquations;
				continue solveEquationsGroup;
			}
		}
	});
var $author$project$Internal$Solver$step = F6(
	function (number, deltalambdaTot, equationsGroups, currentEquationsGroups, prevBody1, solverBodies) {
		step:
		while (true) {
			if (!currentEquationsGroups.b) {
				if ((!number) || ((deltalambdaTot - $author$project$Internal$Const$precision) < 0)) {
					return A3($elm$core$Array$set, prevBody1.gW.hT, prevBody1, solverBodies);
				} else {
					var $temp$number = number - 1,
						$temp$deltalambdaTot = 0,
						$temp$equationsGroups = _List_Nil,
						$temp$currentEquationsGroups = $elm$core$List$reverse(equationsGroups),
						$temp$prevBody1 = prevBody1,
						$temp$solverBodies = solverBodies;
					number = $temp$number;
					deltalambdaTot = $temp$deltalambdaTot;
					equationsGroups = $temp$equationsGroups;
					currentEquationsGroups = $temp$currentEquationsGroups;
					prevBody1 = $temp$prevBody1;
					solverBodies = $temp$solverBodies;
					continue step;
				}
			} else {
				var bodyId1 = currentEquationsGroups.a.gZ;
				var bodyId2 = currentEquationsGroups.a.g_;
				var equations = currentEquationsGroups.a.dM;
				var remainingEquationsGroups = currentEquationsGroups.b;
				var newSolverBodies = ((!(bodyId1 - prevBody1.gW.hT)) || (!prevBody1.gW.d1)) ? solverBodies : A3($elm$core$Array$set, prevBody1.gW.hT, prevBody1, solverBodies);
				var maybeBody1 = (!(bodyId1 - prevBody1.gW.hT)) ? $elm$core$Maybe$Just(prevBody1) : A2($elm$core$Array$get, bodyId1, solverBodies);
				if (!maybeBody1.$) {
					var body1 = maybeBody1.a;
					var _v2 = A2($elm$core$Array$get, bodyId2, newSolverBodies);
					if (!_v2.$) {
						var body2 = _v2.a;
						var groupContext = A5($author$project$Internal$Solver$solveEquationsGroup, body1, body2, _List_Nil, deltalambdaTot, equations);
						var $temp$number = number,
							$temp$deltalambdaTot = groupContext.dJ,
							$temp$equationsGroups = A2(
							$elm$core$List$cons,
							{gZ: bodyId1, g_: bodyId2, dM: groupContext.dM},
							equationsGroups),
							$temp$currentEquationsGroups = remainingEquationsGroups,
							$temp$prevBody1 = groupContext.gX,
							$temp$solverBodies = (groupContext.gY.gW.d1 > 0) ? A3($elm$core$Array$set, bodyId2, groupContext.gY, newSolverBodies) : newSolverBodies;
						number = $temp$number;
						deltalambdaTot = $temp$deltalambdaTot;
						equationsGroups = $temp$equationsGroups;
						currentEquationsGroups = $temp$currentEquationsGroups;
						prevBody1 = $temp$prevBody1;
						solverBodies = $temp$solverBodies;
						continue step;
					} else {
						var $temp$number = number,
							$temp$deltalambdaTot = deltalambdaTot,
							$temp$equationsGroups = equationsGroups,
							$temp$currentEquationsGroups = remainingEquationsGroups,
							$temp$prevBody1 = prevBody1,
							$temp$solverBodies = newSolverBodies;
						number = $temp$number;
						deltalambdaTot = $temp$deltalambdaTot;
						equationsGroups = $temp$equationsGroups;
						currentEquationsGroups = $temp$currentEquationsGroups;
						prevBody1 = $temp$prevBody1;
						solverBodies = $temp$solverBodies;
						continue step;
					}
				} else {
					var $temp$number = number,
						$temp$deltalambdaTot = deltalambdaTot,
						$temp$equationsGroups = equationsGroups,
						$temp$currentEquationsGroups = remainingEquationsGroups,
						$temp$prevBody1 = prevBody1,
						$temp$solverBodies = newSolverBodies;
					number = $temp$number;
					deltalambdaTot = $temp$deltalambdaTot;
					equationsGroups = $temp$equationsGroups;
					currentEquationsGroups = $temp$currentEquationsGroups;
					prevBody1 = $temp$prevBody1;
					solverBodies = $temp$solverBodies;
					continue step;
				}
			}
		}
	});
var $elm$core$Elm$JsArray$map = _JsArray_map;
var $elm$core$Array$map = F2(
	function (func, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = function (node) {
			if (!node.$) {
				var subTree = node.a;
				return $elm$core$Array$SubTree(
					A2($elm$core$Elm$JsArray$map, helper, subTree));
			} else {
				var values = node.a;
				return $elm$core$Array$Leaf(
					A2($elm$core$Elm$JsArray$map, func, values));
			}
		};
		return A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A2($elm$core$Elm$JsArray$map, helper, tree),
			A2($elm$core$Elm$JsArray$map, func, tail));
	});
var $author$project$Internal$Transform3d$normalize = function (_v0) {
	var localOrigin = _v0.a;
	var _v1 = _v0.b;
	var x = _v1.a;
	var y = _v1.b;
	var z = _v1.c;
	var w = _v1.d;
	var len = $elm$core$Basics$sqrt((((x * x) + (y * y)) + (z * z)) + (w * w));
	return A2(
		$author$project$Internal$Transform3d$Transform3d,
		localOrigin,
		A4($author$project$Internal$Transform3d$Orientation3d, x / len, y / len, z / len, w / len));
};
var $author$project$Internal$Transform3d$rotateBy = F2(
	function (_v0, _v1) {
		var x = _v0.cF;
		var y = _v0.cG;
		var z = _v0.cH;
		var localOrigin = _v1.a;
		var _v2 = _v1.b;
		var qx = _v2.a;
		var qy = _v2.b;
		var qz = _v2.c;
		var qw = _v2.d;
		return A2(
			$author$project$Internal$Transform3d$Transform3d,
			localOrigin,
			A4($author$project$Internal$Transform3d$Orientation3d, qx + ((((x * qw) + (y * qz)) - (z * qy)) * 0.5), qy + ((((y * qw) + (z * qx)) - (x * qz)) * 0.5), qz + ((((z * qw) + (x * qy)) - (y * qx)) * 0.5), qw + (((((-x) * qx) - (y * qy)) - (z * qz)) * 0.5)));
	});
var $author$project$Internal$SolverBody$toBody = F2(
	function (_v0, _v1) {
		var dt = _v0.w;
		var gravity = _v0.ff;
		var body = _v1.gW;
		var vX = _v1.b_;
		var vY = _v1.b$;
		var vZ = _v1.b0;
		var wX = _v1.b2;
		var wY = _v1.b3;
		var wZ = _v1.b4;
		var ld = A2($elm$core$Basics$pow, 1.0 - body.fx, dt);
		var newVelocity = {cF: (((gravity.cF + (body.cZ.cF * body.c3)) * dt) + (body.dF.cF * ld)) + vX, cG: (((gravity.cG + (body.cZ.cG * body.c3)) * dt) + (body.dF.cG * ld)) + vY, cH: (((gravity.cH + (body.cZ.cH * body.c3)) * dt) + (body.dF.cH * ld)) + vZ};
		var velocityLength = $author$project$Internal$Vector3$length(newVelocity);
		var cappedVelocity = ((!velocityLength) || ((!body.eM) || (((velocityLength * dt) - body.eM) < 0))) ? newVelocity : A2($author$project$Internal$Vector3$scale, body.eM / (velocityLength * dt), newVelocity);
		var ad = A2($elm$core$Basics$pow, 1.0 - body.eI, dt);
		var newAngularVelocity = {cF: (((((body.c2.h8 * body.dC.cF) + (body.c2.h9 * body.dC.cG)) + (body.c2.ia * body.dC.cH)) * dt) + (body.cL.cF * ad)) + wX, cG: (((((body.c2.ib * body.dC.cF) + (body.c2.ic * body.dC.cG)) + (body.c2.id * body.dC.cH)) * dt) + (body.cL.cG * ad)) + wY, cH: (((((body.c2.ie * body.dC.cF) + (body.c2.$8 * body.dC.cG)) + (body.c2.ig * body.dC.cH)) * dt) + (body.cL.cH * ad)) + wZ};
		var newTransform3d = $author$project$Internal$Transform3d$normalize(
			A2(
				$author$project$Internal$Transform3d$translateBy,
				{cF: cappedVelocity.cF * dt, cG: cappedVelocity.cG * dt, cH: cappedVelocity.cH * dt},
				A2(
					$author$project$Internal$Transform3d$rotateBy,
					{cF: newAngularVelocity.cF * dt, cG: newAngularVelocity.cG * dt, cH: newAngularVelocity.cH * dt},
					body.cA)));
		return {
			eI: body.eI,
			cL: newAngularVelocity,
			eM: body.eM,
			cR: body.cR,
			eS: body.eS,
			cZ: $author$project$Internal$Vector3$zero,
			hT: body.hT,
			dR: body.dR,
			c2: A2($author$project$Internal$Transform3d$invertedInertiaRotateIn, newTransform3d, body.dR),
			c3: body.c3,
			fx: body.fx,
			d1: body.d1,
			fI: body.fI,
			er: body.er,
			dC: $author$project$Internal$Vector3$zero,
			cA: newTransform3d,
			dF: newVelocity,
			eD: A2($author$project$Internal$Shape$shapesPlaceIn, newTransform3d, body.er)
		};
	});
var $author$project$Internal$Solver$updateBodies = F3(
	function (ctx, bodies, world) {
		var simulatedBodies = A2(
			$elm$core$Array$map,
			function (solverBody) {
				return ((solverBody.gW.hT + 1) > 0) ? ((solverBody.gW.d1 > 0) ? A2($author$project$Internal$SolverBody$toBody, ctx, solverBody) : solverBody.gW) : solverBody.gW;
			},
			bodies);
		return _Utils_update(
			world,
			{
				eK: A2(
					$elm$core$List$filter,
					function (_v0) {
						var id = _v0.hT;
						return (id + 1) > 0;
					},
					$elm$core$Array$toList(simulatedBodies)),
				iY: simulatedBodies
			});
	});
var $author$project$Internal$Solver$solve = F2(
	function (dt, world) {
		var ctx = {
			w: dt,
			ff: world.ff,
			fg: $author$project$Internal$Vector3$length(world.ff)
		};
		var contactEquationsGroups = A3(
			$elm$core$List$foldl,
			F2(
				function (contactGroup, groups) {
					return A2(
						$elm$core$List$cons,
						A2($author$project$Internal$Equation$contactEquationsGroup, ctx, contactGroup),
						groups);
				}),
			_List_Nil,
			world.hh);
		var _v0 = A2($author$project$Internal$Solver$makeSolverBodies, world.io, world.eK);
		var solverBodies = _v0.a;
		var maybeFillingBody = _v0.b;
		var equationsGroups = A3(
			$elm$core$List$foldl,
			F2(
				function (_v2, groups) {
					var bodyId1 = _v2.gZ;
					var bodyId2 = _v2.g_;
					var constraints = _v2.hf;
					var _v3 = A2($elm$core$Array$get, bodyId1, solverBodies);
					if (_v3.$ === 1) {
						return groups;
					} else {
						var body1 = _v3.a;
						var _v4 = A2($elm$core$Array$get, bodyId2, solverBodies);
						if (_v4.$ === 1) {
							return groups;
						} else {
							var body2 = _v4.a;
							return A2(
								$elm$core$List$cons,
								A4($author$project$Internal$Equation$constraintEquationsGroup, ctx, body1.gW, body2.gW, constraints),
								groups);
						}
					}
				}),
			contactEquationsGroups,
			world.hf);
		var solvedBodies = function () {
			if (!maybeFillingBody.$) {
				var fillingBody = maybeFillingBody.a;
				return A6($author$project$Internal$Solver$step, $author$project$Internal$Solver$maxIterations, 0, _List_Nil, equationsGroups, fillingBody, solverBodies);
			} else {
				return solverBodies;
			}
		}();
		return A3($author$project$Internal$Solver$updateBodies, ctx, solvedBodies, world);
	});
var $author$project$Physics$World$simulate = F2(
	function (dt, _v0) {
		var world = _v0;
		return A2(
			$author$project$Internal$Solver$solve,
			$ianmackenzie$elm_units$Duration$inSeconds(dt),
			$author$project$Internal$BroadPhase$addContacts(world));
	});
var $author$project$Config$useClientPhysics = true;
var $author$project$Game$Playing$simulatePhysics = F2(
	function (ms, world) {
		return ($author$project$Config$useClientPhysics && (ms > 0)) ? A2(
			$author$project$Physics$World$simulate,
			$ianmackenzie$elm_units$Duration$milliseconds(ms),
			world) : world;
	});
var $author$project$Game$Playing$getNextSimulatedPlayingState = F2(
	function (ms, gameState) {
		return _Utils_update(
			gameState,
			{
				bG: gameState.bG + ms,
				bH: $elm$core$Maybe$Nothing,
				bK: 0,
				q: A2($author$project$Game$Playing$simulatePhysics, ms, gameState.q)
			});
	});
var $author$project$Constants$Graphics$floorTileUvScale = 3.0;
var $ianmackenzie$elm_3d_scene$Scene3d$mesh = F2(
	function (givenMaterial, givenMesh) {
		return A2($ianmackenzie$elm_3d_scene$Scene3d$Entity$mesh, givenMaterial, givenMesh);
	});
var $elm$core$Basics$round = _Basics_round;
var $author$project$Scene3d$Entity$Arena$getTiledFloor = function (material) {
	var zPos = 0.5;
	var up = A3($ianmackenzie$elm_geometry$Vector3d$unitless, 0, 0, 1);
	var tileSize = 5;
	var size = tileSize;
	var s = $author$project$Constants$Graphics$floorTileUvScale;
	var numTiles = ($elm$core$Basics$round($author$project$Config$arenaWidthMeters) / tileSize) | 0;
	var baseline = -($author$project$Config$arenaWidthMeters / 2);
	var tileVerticesAndFaces = F2(
		function (x, y) {
			var uvCorners = _List_fromArray(
				[
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(s, 0),
					_Utils_Tuple2(s, s),
					_Utils_Tuple2(0, s)
				]);
			var oy = (y * size) + baseline;
			var ox = (x * size) + baseline;
			var vert = F2(
				function (_v0, uv) {
					var px = _v0.a;
					var py = _v0.b;
					return {
						aS: up,
						f9: A3($ianmackenzie$elm_geometry$Point3d$meters, ox + px, oy + py, zPos),
						bR: A3($ianmackenzie$elm_geometry$Vector3d$unitless, 1, 0, 0),
						bS: false,
						bZ: uv
					};
				});
			var localCorners = _List_fromArray(
				[
					_Utils_Tuple2(0, 0),
					_Utils_Tuple2(size, 0),
					_Utils_Tuple2(size, size),
					_Utils_Tuple2(0, size)
				]);
			var baseIdx = ((x * numTiles) + y) * 4;
			return {
				e5: _List_fromArray(
					[
						_Utils_Tuple3(baseIdx, baseIdx + 1, baseIdx + 2),
						_Utils_Tuple3(baseIdx, baseIdx + 2, baseIdx + 3)
					]),
				cE: A3($elm$core$List$map2, vert, localCorners, uvCorners)
			};
		});
	var allTiles = A2(
		$elm$core$List$concatMap,
		function (x) {
			return A2(
				$elm$core$List$map,
				tileVerticesAndFaces(x),
				A2($elm$core$List$range, 0, numTiles - 1));
		},
		A2($elm$core$List$range, 0, numTiles - 1));
	var allVertices = $elm$core$Array$fromList(
		A2(
			$elm$core$List$concatMap,
			function ($) {
				return $.cE;
			},
			allTiles));
	var allFaces = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.e5;
		},
		allTiles);
	var mesh = $ianmackenzie$elm_3d_scene$Scene3d$Mesh$bumpyFaces(
		A2($ianmackenzie$elm_triangular_mesh$TriangularMesh$indexed, allVertices, allFaces));
	return A2($ianmackenzie$elm_3d_scene$Scene3d$mesh, material, mesh);
};
var $author$project$Game$Playing$hitMarkerMaxAgeMs = 400;
var $ianmackenzie$elm_3d_scene$Scene3d$Types$Texture = function (a) {
	return {$: 1, a: a};
};
var $ianmackenzie$elm_3d_scene$Scene3d$Material$map = F2(
	function (_function, texture) {
		if (!texture.$) {
			var value = texture.a;
			return $ianmackenzie$elm_3d_scene$Scene3d$Types$Constant(
				_function(value));
		} else {
			var properties = texture.a;
			return $ianmackenzie$elm_3d_scene$Scene3d$Types$Texture(properties);
		}
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Material$bumpyPbr = function (_v0) {
	var baseColor = _v0.ar;
	var roughness = _v0.ax;
	var metallic = _v0.d5;
	var ambientOcclusion = _v0.gK;
	var normalMap = _v0.ix;
	return A6(
		$ianmackenzie$elm_3d_scene$Scene3d$Types$PbrMaterial,
		0,
		A2($ianmackenzie$elm_3d_scene$Scene3d$Material$map, $ianmackenzie$elm_3d_scene$Scene3d$ColorConversions$colorToLinearRgb, baseColor),
		A2(
			$ianmackenzie$elm_3d_scene$Scene3d$Material$map,
			A2($elm$core$Basics$clamp, 0, 1),
			roughness),
		A2(
			$ianmackenzie$elm_3d_scene$Scene3d$Material$map,
			A2($elm$core$Basics$clamp, 0, 1),
			metallic),
		A2(
			$ianmackenzie$elm_3d_scene$Scene3d$Material$map,
			A2($elm$core$Basics$clamp, 0, 1),
			ambientOcclusion),
		normalMap);
};
var $ianmackenzie$elm_3d_scene$Scene3d$Material$constant = function (givenValue) {
	return $ianmackenzie$elm_3d_scene$Scene3d$Types$Constant(givenValue);
};
var $ianmackenzie$elm_3d_scene$Scene3d$Material$bumpyNonmetal = function (_v0) {
	var baseColor = _v0.ar;
	var roughness = _v0.ax;
	var ambientOcclusion = _v0.gK;
	var normalMap = _v0.ix;
	return $ianmackenzie$elm_3d_scene$Scene3d$Material$bumpyPbr(
		{
			gK: ambientOcclusion,
			ar: baseColor,
			d5: $ianmackenzie$elm_3d_scene$Scene3d$Material$constant(0),
			ix: normalMap,
			ax: roughness
		});
};
var $ianmackenzie$elm_3d_scene$Scene3d$Types$NormalMap = function (a) {
	return {$: 1, a: a};
};
var $elm_explorations$webgl$WebGL$Texture$LoadError = {$: 0};
var $elm_explorations$webgl$WebGL$Texture$SizeError = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm_explorations$webgl$WebGL$Texture$loadWith = F2(
	function (_v0, url) {
		var magnify = _v0.c9;
		var minify = _v0.db;
		var horizontalWrap = _v0.c0;
		var verticalWrap = _v0.dG;
		var flipY = _v0.cY;
		var expand = F4(
			function (_v1, _v2, _v3, _v4) {
				var mag = _v1;
				var min = _v2;
				var hor = _v3;
				var vert = _v4;
				return A6(_Texture_load, mag, min, hor, vert, flipY, url);
			});
		return A4(expand, magnify, minify, horizontalWrap, verticalWrap);
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Material$loadNormalMapWith = F2(
	function (_v0, url) {
		var format = _v0.hG;
		var options = _v0.iD;
		return A2(
			$elm$core$Task$map,
			function (data) {
				return $ianmackenzie$elm_3d_scene$Scene3d$Types$NormalMap(
					{eS: data, hG: format, iD: options, gz: url});
			},
			A2($elm_explorations$webgl$WebGL$Texture$loadWith, options, url));
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Material$loadWith = F2(
	function (options, url) {
		return A2(
			$elm$core$Task$map,
			function (data) {
				return $ianmackenzie$elm_3d_scene$Scene3d$Types$Texture(
					{eS: data, iD: options, gz: url});
			},
			A2($elm_explorations$webgl$WebGL$Texture$loadWith, options, url));
	});
var $elm$core$Task$map4 = F5(
	function (func, taskA, taskB, taskC, taskD) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return A2(
							$elm$core$Task$andThen,
							function (c) {
								return A2(
									$elm$core$Task$andThen,
									function (d) {
										return $elm$core$Task$succeed(
											A4(func, a, b, c, d));
									},
									taskD);
							},
							taskC);
					},
					taskB);
			},
			taskA);
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Types$OpenglFormat = 0;
var $ianmackenzie$elm_3d_scene$Scene3d$Material$openglFormat = 0;
var $elm_explorations$webgl$WebGL$Texture$Resize = $elm$core$Basics$identity;
var $elm_explorations$webgl$WebGL$Texture$linear = 9729;
var $elm_explorations$webgl$WebGL$Texture$linearMipmapLinear = 9987;
var $elm_explorations$webgl$WebGL$Texture$Wrap = $elm$core$Basics$identity;
var $elm_explorations$webgl$WebGL$Texture$repeat = 10497;
var $ianmackenzie$elm_3d_scene$Scene3d$Material$trilinearFiltering = {cY: true, c0: $elm_explorations$webgl$WebGL$Texture$repeat, c9: $elm_explorations$webgl$WebGL$Texture$linear, db: $elm_explorations$webgl$WebGL$Texture$linearMipmapLinear, dG: $elm_explorations$webgl$WebGL$Texture$repeat};
var $author$project$Texture$extensions = _List_fromArray(
	['jpg', 'png', 'jpeg', 'webp']);
var $elm$core$Task$fail = _Scheduler_fail;
var $author$project$Texture$tryLoad = F2(
	function (loader, basePath) {
		var _v0 = $author$project$Texture$extensions;
		if (_v0.b) {
			var first = _v0.a;
			var rest = _v0.b;
			return A3(
				$elm$core$List$foldl,
				F2(
					function (ext, task) {
						return A2(
							$elm$core$Task$onError,
							function (_v1) {
								return loader(basePath + ('.' + ext));
							},
							task);
					}),
				loader(basePath + ('.' + first)),
				rest);
		} else {
			return $elm$core$Task$fail($elm_explorations$webgl$WebGL$Texture$LoadError);
		}
	});
var $author$project$Texture$loadBumpy = function (base) {
	var loadTex = $author$project$Texture$tryLoad(
		$ianmackenzie$elm_3d_scene$Scene3d$Material$loadWith($ianmackenzie$elm_3d_scene$Scene3d$Material$trilinearFiltering));
	var loadNormal = $author$project$Texture$tryLoad(
		$ianmackenzie$elm_3d_scene$Scene3d$Material$loadNormalMapWith(
			{hG: $ianmackenzie$elm_3d_scene$Scene3d$Material$openglFormat, iD: $ianmackenzie$elm_3d_scene$Scene3d$Material$trilinearFiltering}));
	return A5(
		$elm$core$Task$map4,
		F4(
			function (bc, roughness, normalMap, ao) {
				return $ianmackenzie$elm_3d_scene$Scene3d$Material$bumpyNonmetal(
					{gK: ao, ar: bc, ix: normalMap, ax: roughness});
			}),
		loadTex(base + 'basecolor'),
		loadTex(base + 'roughness'),
		loadNormal(base + 'normal'),
		loadTex(base + 'ambientocclusion'));
};
var $author$project$Texture$init = A3(
	$elm$core$Task$map2,
	F2(
		function (a, b) {
			return {gT: b.gT, g$: a.g$, hL: a.hL, h3: b.h3, iS: a.iS, i0: a.i0, jk: b.jk, jn: b.jn};
		}),
	A5(
		$elm$core$Task$map4,
		F4(
			function (ground, rock, boulder, stone) {
				return {g$: boulder, hL: ground, iS: rock, i0: stone};
			}),
		$author$project$Texture$loadBumpy('textures/grass2/'),
		$author$project$Texture$loadBumpy('textures/rock1/'),
		$author$project$Texture$loadBumpy('textures/rock2/'),
		$author$project$Texture$loadBumpy('textures/stone1/')),
	A5(
		$elm$core$Task$map4,
		F4(
			function (wood, bark, wall, leaf) {
				return {gT: bark, h3: leaf, jk: wall, jn: wood};
			}),
		$author$project$Texture$loadBumpy('textures/wood1/'),
		$author$project$Texture$loadBumpy('textures/bark1/'),
		$author$project$Texture$loadBumpy('textures/wall1/'),
		$author$project$Texture$loadBumpy('textures/leaves1/')));
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Set$isEmpty = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$isEmpty(dict);
};
var $author$project$Config$jumpThresholdMs = 300.0;
var $author$project$HitEffect$maxAgeMs = 350;
var $author$project$Game$Playing$myHitFlashMaxAgeMs = 500;
var $elm$core$Set$remove = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$remove, key, dict);
	});
var $author$project$Config$shootThresholdMs = 300.0;
var $elm$core$String$toLower = _String_toLower;
var $author$project$Game$Playing$Joystick$update = F2(
	function (maybeModel, msg) {
		var _v0 = _Utils_Tuple2(msg, maybeModel);
		switch (_v0.a.$) {
			case 0:
				var _v1 = _v0.a;
				var pointerId = _v1.a;
				var pos = _v1.b;
				return $elm$core$Maybe$Just(
					{cU: pos, dQ: pos, bd: pointerId});
			case 1:
				if (!_v0.b.$) {
					var _v2 = _v0.a;
					var pointerId = _v2.a;
					var pos = _v2.b;
					var model = _v0.b.a;
					return _Utils_eq(model.bd, pointerId) ? $elm$core$Maybe$Just(
						_Utils_update(
							model,
							{cU: pos})) : maybeModel;
				} else {
					var _v3 = _v0.a;
					var _v4 = _v0.b;
					return $elm$core$Maybe$Nothing;
				}
			default:
				if (!_v0.b.$) {
					var pointerId = _v0.a.a;
					var model = _v0.b.a;
					return _Utils_eq(model.bd, pointerId) ? $elm$core$Maybe$Nothing : maybeModel;
				} else {
					var _v5 = _v0.b;
					return $elm$core$Maybe$Nothing;
				}
		}
	});
var $avh4$elm_color$Color$white = A4($avh4$elm_color$Color$RgbaSpace, 255 / 255, 255 / 255, 255 / 255, 1.0);
var $author$project$Game$Playing$update = F2(
	function (msg, gameState) {
		switch (msg.$) {
			case 0:
				var ms = msg.a;
				var accumulated = gameState.bK + ms;
				if (_Utils_cmp(accumulated, $author$project$Config$clientPhysicsSimulationMinIntervalMs) < 0) {
					return _Utils_Tuple2(
						_Utils_update(
							gameState,
							{bK: accumulated}),
						$elm$core$Platform$Cmd$none);
				} else {
					var maybeMe = $author$project$Me$getInWorld(gameState.q);
					var nextModel = function () {
						var _v2 = A2(
							$elm$core$Maybe$map,
							$elm$json$Json$Decode$decodeValue(
								$author$project$Server$State$bodiesStateDecoder(gameState.iJ)),
							gameState.bH);
						if ((!_v2.$) && (!_v2.a.$)) {
							var bodies = _v2.a.a.eK;
							var lastUpdated = _v2.a.a.a6;
							var isNewServerState = _Utils_cmp(lastUpdated, gameState.a6) > 0;
							if (isNewServerState) {
								var wasIHit = function () {
									var _v4 = _Utils_Tuple2(
										maybeMe,
										$author$project$Me$getInBodies(bodies));
									if ((!_v4.a.$) && (!_v4.b.$)) {
										var oldMe = _v4.a.a;
										var newMe = _v4.b.a;
										return _Utils_cmp(
											$author$project$Physics$Body$data(newMe).hS,
											$author$project$Physics$Body$data(oldMe).hS) < 0;
									} else {
										return false;
									}
								}();
								var npcBodies = A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Physics$Body$data,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.hb;
											},
											$elm$core$Basics$eq(1))),
									bodies);
								var nextNpcHpSnapshot = A3(
									$elm$core$List$foldl,
									F2(
										function (b, d) {
											return A3(
												$elm$core$Dict$insert,
												$author$project$Physics$Body$data(b).hT,
												$author$project$Physics$Body$data(b).hS,
												d);
										}),
									$elm$core$Dict$empty,
									npcBodies);
								var myBulletIds = $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Physics$Body$data,
											function ($) {
												return $.hT;
											}),
										A2(
											$elm$core$List$filter,
											function (b) {
												var d = $author$project$Physics$Body$data(b);
												return (d.hb === 2) && _Utils_eq(
													d.iF,
													$elm$core$Maybe$Just(gameState.iJ));
											},
											$author$project$Physics$World$bodies(gameState.q))));
								var dynamicBodies = A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Physics$Body$data,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.hb;
											},
											$elm$core$Basics$neq(3))),
									bodies);
								var defaultNextWorld = A2($author$project$Physics$World$Extra$addBodies, dynamicBodies, gameState.cM);
								var nextWorld = function () {
									var _v3 = _Utils_Tuple2(
										maybeMe,
										$author$project$Me$getInBodies(bodies));
									if ((!_v3.a.$) && (!_v3.b.$)) {
										var oldMe = _v3.a.a;
										var newMe = _v3.b.a;
										var serverZ = $ianmackenzie$elm_units$Length$inMeters(
											$ianmackenzie$elm_geometry$Point3d$zCoordinate(
												$author$project$Physics$Body$originPoint(newMe)));
										var clientOrigin = A2(
											$ianmackenzie$elm_geometry$Point3d$toRecord,
											$ianmackenzie$elm_units$Length$inMeters,
											$author$project$Physics$Body$originPoint(oldMe));
										var correctedOrigin = $ianmackenzie$elm_geometry$Point3d$fromMeters(
											{cF: clientOrigin.cF, cG: clientOrigin.cG, cH: serverZ});
										var nextMe = A2($author$project$Physics$Body$moveTo, correctedOrigin, newMe);
										return A2(
											$author$project$Me$updateInWorld,
											$elm$core$Basics$always(nextMe),
											defaultNextWorld);
									} else {
										return defaultNextWorld;
									}
								}();
								var clientServerDiscrepancyMs = ((gameState.a6 + gameState.bG) + accumulated) - lastUpdated;
								var allServerBulletIds = $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Physics$Body$data,
											function ($) {
												return $.hT;
											}),
										A2(
											$elm$core$List$filter,
											A2(
												$elm$core$Basics$composeR,
												$author$project$Physics$Body$data,
												A2(
													$elm$core$Basics$composeR,
													function ($) {
														return $.hb;
													},
													$elm$core$Basics$eq(2))),
											bodies)));
								var myBulletWasHit = !$elm$core$Set$isEmpty(
									A2($elm$core$Set$diff, myBulletIds, allServerBulletIds));
								var spawnedHitMarkers = myBulletWasHit ? A2(
									$elm$core$List$filterMap,
									$author$project$Game$Playing$detectHitMarker(gameState.de),
									npcBodies) : _List_Nil;
								return _Utils_update(
									gameState,
									{
										a4: spawnedHitMarkers,
										a6: lastUpdated,
										bG: 0,
										ba: wasIHit ? $elm$core$Maybe$Just(0) : gameState.ba,
										bH: $elm$core$Maybe$Nothing,
										de: nextNpcHpSnapshot,
										bK: 0,
										q: A2($author$project$Game$Playing$simulatePhysics, clientServerDiscrepancyMs, nextWorld)
									});
							} else {
								return A2($author$project$Game$Playing$getNextSimulatedPlayingState, accumulated, gameState);
							}
						} else {
							return A2($author$project$Game$Playing$getNextSimulatedPlayingState, accumulated, gameState);
						}
					}();
					var nextBulletIds = $elm$core$Set$fromList(
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Physics$Body$data,
								function ($) {
									return $.hT;
								}),
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Physics$Body$data,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.hb;
										},
										$elm$core$Basics$eq(2))),
								$author$project$Physics$World$bodies(nextModel.q))));
					var incrAge = function (age) {
						return (_Utils_cmp(age, $author$project$Game$Playing$myHitFlashMaxAgeMs) > 0) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(age + accumulated);
					};
					var currentBulletBodies = A2(
						$elm$core$List$filter,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Physics$Body$data,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.hb;
								},
								$elm$core$Basics$eq(2))),
						$author$project$Physics$World$bodies(gameState.q));
					var spawnedEffects = A2(
						$elm$core$List$map,
						function (b) {
							return {
								aq: 0,
								he: A2(
									$elm$core$Maybe$withDefault,
									$avh4$elm_color$Color$white,
									A2(
										$elm$core$Maybe$andThen,
										function (tid) {
											return A2($elm$core$Dict$get, tid, gameState.cw);
										},
										$author$project$Physics$Body$data(b).i7)),
								f9: $author$project$Physics$Body$originPoint(b)
							};
						},
						A2(
							$elm$core$List$filter,
							function (b) {
								return !A2(
									$elm$core$Set$member,
									$author$project$Physics$Body$data(b).hT,
									nextBulletIds);
							},
							currentBulletBodies));
					var agedMyHpFlash = A2($elm$core$Maybe$andThen, incrAge, nextModel.ba);
					var agedHitMarkers = A2(
						$elm$core$List$filter,
						function (m) {
							return _Utils_cmp(m.aq, $author$project$Game$Playing$hitMarkerMaxAgeMs) < 0;
						},
						A2(
							$elm$core$List$map,
							function (m) {
								return _Utils_update(
									m,
									{aq: m.aq + accumulated});
							},
							gameState.a4));
					var agedEffects = A2(
						$elm$core$List$filter,
						function (e) {
							return _Utils_cmp(e.aq, $author$project$HitEffect$maxAgeMs) < 0;
						},
						A2(
							$elm$core$List$map,
							function (e) {
								return _Utils_update(
									e,
									{aq: e.aq + accumulated});
							},
							gameState.cl));
					var nextModelWithEffects = _Utils_update(
						nextModel,
						{
							cl: _Utils_ap(agedEffects, spawnedEffects),
							a4: _Utils_ap(agedHitMarkers, nextModel.a4),
							ba: agedMyHpFlash
						});
					var _v1 = A3($author$project$Game$Playing$applyActions, maybeMe, nextModelWithEffects, accumulated);
					var nextModelActionsApplied = _v1.a;
					var cmd = _v1.b;
					return _Utils_Tuple2(nextModelActionsApplied, cmd);
				}
			case 5:
				var bodiesUpdate = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						gameState,
						{
							bH: $elm$core$Maybe$Just(bodiesUpdate)
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					gameState,
					A2($elm$core$Task$perform, $author$project$Game$Playing$ViewportChanged, $elm$browser$Browser$Dom$getViewport));
			case 1:
				var viewport = msg.a.jj;
				var _v5 = viewport;
				var width = _v5.jm;
				var height = _v5.hP;
				return _Utils_Tuple2(
					_Utils_update(
						gameState,
						{aA: height, aB: width}),
					A2($elm$core$Task$attempt, $author$project$Game$Playing$TexturesLoaded, $author$project$Texture$init));
			case 3:
				var joystickUpdate = msg.a;
				var nextGameState = _Utils_update(
					gameState,
					{
						bD: A2($author$project$Game$Playing$Joystick$update, gameState.bD, joystickUpdate),
						bY: false
					});
				if (joystickUpdate.$ === 2) {
					var nextModel = _Utils_update(
						nextGameState,
						{bE: 0});
					return (_Utils_cmp(gameState.bE, $author$project$Config$jumpThresholdMs) < 0) ? _Utils_Tuple2(
						_Utils_update(
							nextModel,
							{bf: true}),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2(nextModel, $elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(nextGameState, $elm$core$Platform$Cmd$none);
				}
			case 4:
				var joystickUpdate = msg.a;
				var nextGameState = _Utils_update(
					gameState,
					{
						bT: A2($author$project$Game$Playing$Joystick$update, gameState.bT, joystickUpdate),
						bY: false
					});
				if (joystickUpdate.$ === 2) {
					var nextModel = _Utils_update(
						nextGameState,
						{bU: 0});
					return (_Utils_cmp(gameState.bU, $author$project$Config$shootThresholdMs) < 0) ? _Utils_Tuple2(
						_Utils_update(
							nextModel,
							{bg: true}),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2(nextModel, $elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(nextGameState, $elm$core$Platform$Cmd$none);
				}
			case 6:
				var result = msg.a;
				if (!result.$) {
					var textures = result.a;
					var mats = A6(
						$author$project$Scene3d$Entity$Arena$ObstacleMaterials,
						$elm$core$Maybe$Just(textures.iS),
						$elm$core$Maybe$Just(textures.g$),
						$elm$core$Maybe$Just(textures.i0),
						$elm$core$Maybe$Just(textures.jn),
						$elm$core$Maybe$Just(textures.gT),
						$elm$core$Maybe$Just(textures.h3));
					var texturedObstacles = A2(
						$elm$core$List$map,
						$author$project$Scene3d$Entity$Arena$obstacle(mats),
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Physics$Body$data,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.hT;
									},
									$elm$core$Basics$neq('floor'))),
							$author$project$Physics$World$bodies(gameState.cM)));
					return _Utils_Tuple2(
						_Utils_update(
							gameState,
							{
								ci: $elm$core$Maybe$Just(
									$author$project$Scene3d$Entity$Arena$getTiledFloor(textures.hL)),
								df: A2(
									$elm$core$List$cons,
									$author$project$Scene3d$Entity$Arena$boundaryWalls(
										$elm$core$Maybe$Just(textures.jk)),
									texturedObstacles),
								ex: $elm$core$Maybe$Just(textures)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(gameState, $elm$core$Platform$Cmd$none);
				}
			case 7:
				var jsonStr = msg.a;
				var _v9 = A2($elm$json$Json$Decode$decodeString, $author$project$Mesh$Player$decoder, jsonStr);
				if (!_v9.$) {
					var mesh = _v9.a;
					return _Utils_Tuple2(
						_Utils_update(
							gameState,
							{
								dn: $elm$core$Maybe$Just(mesh),
								$7: $elm$core$Maybe$Just(
									$ianmackenzie$elm_3d_scene$Scene3d$Mesh$shadow(mesh))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(gameState, $elm$core$Platform$Cmd$none);
				}
			case 8:
				var key = msg.a;
				var k = $elm$core$String$toLower(key);
				var nextPressedKeys = A2($elm$core$Set$insert, k, gameState.aV);
				var shouldJump = k === ' ';
				var shouldShoot = (k === 'f') || (k === 'enter');
				return _Utils_Tuple2(
					_Utils_update(
						gameState,
						{aV: nextPressedKeys, bf: gameState.bf || shouldJump, bg: gameState.bg || shouldShoot, bY: true}),
					$elm$core$Platform$Cmd$none);
			default:
				var key = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						gameState,
						{
							aV: A2(
								$elm$core$Set$remove,
								$elm$core$String$toLower(key),
								gameState.aV)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Game$PreLobby$update = F2(
	function (msg, preLobbyState) {
		switch (msg.$) {
			case 0:
				var newGameCode = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						preLobbyState,
						{
							hJ: $elm$core$String$toLower(newGameCode)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var newTopicName = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						preLobbyState,
						{jd: newTopicName}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						preLobbyState,
						{h_: true}),
					$author$project$Game$PreLobby$joinGame(
						{
							fb: $elm$core$Maybe$Just(preLobbyState.hJ),
							iJ: preLobbyState.iJ,
							jd: $elm$core$Maybe$Nothing
						}));
			default:
				return _Utils_Tuple2(
					_Utils_update(
						preLobbyState,
						{h_: true}),
					$author$project$Game$PreLobby$joinGame(
						{
							fb: $elm$core$Maybe$Nothing,
							iJ: preLobbyState.iJ,
							jd: $elm$core$Maybe$Just(preLobbyState.jd)
						}));
		}
	});
var $author$project$Game$update = F2(
	function (msg, model) {
		var _v0 = _Utils_Tuple2(msg, model);
		_v0$5:
		while (true) {
			switch (_v0.b.$) {
				case 0:
					if (!_v0.a.$) {
						var preLobbyMsg = _v0.a.a;
						var preLobbyState = _v0.b.a;
						var _v1 = A2($author$project$Game$PreLobby$update, preLobbyMsg, preLobbyState);
						var nextPreLobbyState = _v1.a;
						var cmds = _v1.b;
						return _Utils_Tuple2(
							$author$project$Game$PreLobby(nextPreLobbyState),
							A2($elm$core$Platform$Cmd$map, $author$project$Game$PreLobbyMsg, cmds));
					} else {
						break _v0$5;
					}
				case 1:
					if (_v0.a.$ === 1) {
						var lobbyMsg = _v0.a.a;
						var lobbyState = _v0.b.a;
						var _v2 = A2($author$project$Game$Lobby$update, lobbyMsg, lobbyState);
						var nextLobbyState = _v2.a;
						var cmds = _v2.b;
						return _Utils_Tuple2(
							$author$project$Game$Lobby(nextLobbyState),
							A2($elm$core$Platform$Cmd$map, $author$project$Game$LobbyMsg, cmds));
					} else {
						break _v0$5;
					}
				case 2:
					if (_v0.a.$ === 2) {
						var playingMsg = _v0.a.a;
						var playingState = _v0.b.a;
						var _v3 = A2($author$project$Game$Playing$update, playingMsg, playingState);
						var nextPlayingState = _v3.a;
						var cmds = _v3.b;
						return _Utils_Tuple2(
							$author$project$Game$Playing(nextPlayingState),
							A2($elm$core$Platform$Cmd$map, $author$project$Game$PlayingMsg, cmds));
					} else {
						break _v0$5;
					}
				default:
					if ((_v0.a.$ === 3) && (_v0.a.a === 1)) {
						var _v4 = _v0.a.a;
						var postGameState = _v0.b.a;
						return _Utils_Tuple2(
							$author$project$Game$PostGame(postGameState),
							$author$project$Game$PostGame$restartGame(0));
					} else {
						var postGameState = _v0.b.a;
						return _Utils_Tuple2(
							$author$project$Game$PostGame(postGameState),
							$elm$core$Platform$Cmd$none);
					}
			}
		}
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Main$update = F2(
	function (msg, model) {
		var _v0 = function () {
			if (!msg.$) {
				var gameUpdateData = msg.a;
				var _v2 = A2(
					$elm$json$Json$Decode$decodeValue,
					$author$project$Server$State$decoder(model.iJ),
					gameUpdateData);
				if (_v2.$ === 1) {
					return _Utils_Tuple2(model.aO, $elm$core$Platform$Cmd$none);
				} else {
					var serverState = _v2.a;
					var _v3 = _Utils_Tuple2(model.aO, serverState.i_);
					switch (_v3.a.$) {
						case 0:
							return A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Game$Lobby,
								$elm$core$Platform$Cmd$map($author$project$Game$LobbyMsg),
								A3($author$project$Game$Lobby$init, model.iJ, model.be, serverState));
						case 1:
							if (_v3.b === 1) {
								var _v4 = _v3.b;
								var _v5 = A2($author$project$Game$Playing$init, model.iJ, serverState);
								var playingState = _v5.a;
								var playingCmds = _v5.b;
								return _Utils_Tuple2(
									$author$project$Game$Playing(playingState),
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2($elm$core$Platform$Cmd$map, $author$project$Game$PlayingMsg, playingCmds),
												$author$project$Main$requestPlayerMesh(0)
											])));
							} else {
								var lobbyState = _v3.a.a;
								var _v6 = A2(
									$author$project$Game$Lobby$update,
									$author$project$Game$Lobby$LobbyUpdated(serverState),
									lobbyState);
								var nextLobbyState = _v6.a;
								var cmds = _v6.b;
								return _Utils_Tuple2(
									$author$project$Game$Lobby(nextLobbyState),
									A2($elm$core$Platform$Cmd$map, $author$project$Game$LobbyMsg, cmds));
							}
						case 2:
							if (_v3.b === 2) {
								var _v7 = _v3.b;
								return A3(
									$elm$core$Tuple$mapBoth,
									$author$project$Game$PostGame,
									$elm$core$Platform$Cmd$map($author$project$Game$PostGameMsg),
									A2($author$project$Game$PostGame$init, model.iJ, serverState));
							} else {
								var playingState = _v3.a.a;
								return _Utils_Tuple2(
									$author$project$Game$Playing(playingState),
									$elm$core$Platform$Cmd$none);
							}
						default:
							switch (_v3.b) {
								case 0:
									var _v8 = _v3.b;
									return A3(
										$elm$core$Tuple$mapBoth,
										$author$project$Game$Lobby,
										$elm$core$Platform$Cmd$map($author$project$Game$LobbyMsg),
										A3($author$project$Game$Lobby$init, model.iJ, model.be, serverState));
								case 1:
									var _v9 = _v3.b;
									var _v10 = A2($author$project$Game$Playing$init, model.iJ, serverState);
									var playingState = _v10.a;
									var playingCmds = _v10.b;
									return _Utils_Tuple2(
										$author$project$Game$Playing(playingState),
										$elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[
													A2($elm$core$Platform$Cmd$map, $author$project$Game$PlayingMsg, playingCmds),
													$author$project$Main$requestPlayerMesh(0)
												])));
								default:
									var postGameState = _v3.a.a;
									return _Utils_Tuple2(
										$author$project$Game$PostGame(postGameState),
										$elm$core$Platform$Cmd$none);
							}
					}
				}
			} else {
				var clientUpdateMsg = msg.a;
				return A2($author$project$Game$update, clientUpdateMsg, model.aO);
			}
		}();
		var nextGame = _v0.a;
		var nextCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{aO: nextGame}),
			A2($elm$core$Platform$Cmd$map, $author$project$Main$ClientUpdate, nextCmd));
	});
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$Game$Lobby$CopyGameCode = {$: 8};
var $author$project$Game$Lobby$CreateTeam = {$: 1};
var $author$project$Game$Lobby$DeleteTeam = function (a) {
	return {$: 6, a: a};
};
var $author$project$Game$Lobby$EditPlayerName = {$: 2};
var $author$project$Game$Lobby$JoinTeam = function (a) {
	return {$: 5, a: a};
};
var $author$project$Game$Lobby$PlayerNameInputUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Game$Lobby$SavePlayerName = {$: 3};
var $author$project$Game$Lobby$ShareLink = {$: 10};
var $author$project$Game$Lobby$StartGame = {$: 7};
var $author$project$Game$Lobby$TeamNameInputUpdated = function (a) {
	return {$: 0, a: a};
};
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $elm$html$Html$span = _VirtualDom_node('span');
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $elm$core$String$fromFloat = _String_fromNumber;
var $avh4$elm_color$Color$toCssString = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var roundTo = function (x) {
		return $elm$core$Basics$round(x * 1000) / 1000;
	};
	var pct = function (x) {
		return $elm$core$Basics$round(x * 10000) / 100;
	};
	return $elm$core$String$concat(
		_List_fromArray(
			[
				'rgba(',
				$elm$core$String$fromFloat(
				pct(r)),
				'%,',
				$elm$core$String$fromFloat(
				pct(g)),
				'%,',
				$elm$core$String$fromFloat(
				pct(b)),
				'%,',
				$elm$core$String$fromFloat(
				roundTo(a)),
				')'
			]));
};
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Game$Lobby$view = function (lobbyState) {
	var viewPlayer = function (player) {
		var displayName = function () {
			var _v3 = player.aH;
			if (_v3 === '') {
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'font-style', 'italic')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Anonymous Player')
						]));
			} else {
				var name = _v3;
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						]));
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'padding', '4px 0'),
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
					A2($elm$html$Html$Attributes$style, 'gap', '6px')
				]),
			_List_fromArray(
				[
					displayName,
					_Utils_eq(player.hT, lobbyState.iJ) ? A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'color', '#aaa'),
							A2($elm$html$Html$Attributes$style, 'font-size', '0.8rem')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('(you)')
						])) : $elm$html$Html$text('')
				]));
	};
	var unassignedPlayers = A2(
		$elm$core$List$filter,
		function (p) {
			return _Utils_eq(p.i7, $elm$core$Maybe$Nothing);
		},
		lobbyState.an);
	var unassignedCard = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'box-shadow', '0 2px 4px 0 rgba(0,0,0,0.15)'),
				A2($elm$html$Html$Attributes$style, 'margin', '5px'),
				A2($elm$html$Html$Attributes$style, 'padding', '16px'),
				A2($elm$html$Html$Attributes$style, 'border', '2px solid #e0e0e0'),
				A2($elm$html$Html$Attributes$style, 'border-radius', '8px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h4,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'margin-top', '0'),
						A2($elm$html$Html$Attributes$style, 'margin-bottom', '10px'),
						A2($elm$html$Html$Attributes$style, 'color', '#999')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						'Unassigned (' + ($elm$core$String$fromInt(
							$elm$core$List$length(unassignedPlayers)) + ')'))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				A2($elm$core$List$map, viewPlayer, unassignedPlayers))
			]));
	var startStatusHint = ($elm$core$List$length(lobbyState.an) < 2) ? $elm$core$Maybe$Just('Waiting for more players to join') : (($elm$core$List$length(unassignedPlayers) > 0) ? $elm$core$Maybe$Just(
		$elm$core$String$fromInt(
			$elm$core$List$length(unassignedPlayers)) + ' player(s) still need to join a team') : $elm$core$Maybe$Nothing);
	var shareLinkLabel = function () {
		var _v2 = lobbyState.cr;
		if (!_v2.$) {
			if (_v2.a === 'shared') {
				return 'Shared!';
			} else {
				return 'Link copied!';
			}
		} else {
			return 'Share link';
		}
	}();
	var playersForTeam = function (team) {
		return A2(
			$elm$core$List$filter,
			function (p) {
				return _Utils_eq(
					p.i7,
					$elm$core$Maybe$Just(team.hT));
			},
			lobbyState.an);
	};
	var onTeam = F2(
		function (team, currentPlayerId) {
			return A2(
				$elm$core$List$member,
				currentPlayerId,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.hT;
					},
					playersForTeam(team)));
		});
	var viewTeamCard = function (team) {
		var players = playersForTeam(team);
		var myTeam = A2(onTeam, team, lobbyState.iJ);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'box-shadow', '0 2px 4px 0 rgba(0,0,0,0.15)'),
					A2($elm$html$Html$Attributes$style, 'margin', '5px'),
					A2($elm$html$Html$Attributes$style, 'padding', '16px'),
					A2(
					$elm$html$Html$Attributes$style,
					'border',
					'2px solid ' + $avh4$elm_color$Color$toCssString(team.he)),
					A2($elm$html$Html$Attributes$style, 'border-radius', '8px')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-top', '0'),
							A2($elm$html$Html$Attributes$style, 'margin-bottom', '10px')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(team.g5)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2($elm$core$List$map, viewPlayer, players)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-top', '10px')
						]),
					_List_fromArray(
						[
							(!myTeam) ? A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Game$Lobby$JoinTeam(team.hT)),
									A2($elm$html$Html$Attributes$style, 'width', '100%'),
									A2($elm$html$Html$Attributes$style, 'margin', '0')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Join this team')
								])) : $elm$html$Html$text(''),
							($elm$core$List$isEmpty(players) && _Utils_eq(team.iF, lobbyState.iJ)) ? A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Game$Lobby$DeleteTeam(team.hT)),
									A2($elm$html$Html$Attributes$style, 'background', '#bbb'),
									A2($elm$html$Html$Attributes$style, 'font-size', '0.8rem'),
									A2($elm$html$Html$Attributes$style, 'padding', '4px 10px'),
									A2($elm$html$Html$Attributes$style, 'width', '100%'),
									A2($elm$html$Html$Attributes$style, 'margin', '4px 0 0 0')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Delete')
								])) : $elm$html$Html$text('')
						]))
				]));
	};
	var onEnterMsg = function (msg) {
		return A2(
			$elm$html$Html$Events$on,
			'keydown',
			A2(
				$elm$json$Json$Decode$andThen,
				function (key) {
					return (key === 'Enter') ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('not enter');
				},
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)));
	};
	var myCurrentName = function () {
		var _v1 = A2(
			$elm_community$list_extra$List$Extra$find,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.hT;
				},
				$elm$core$Basics$eq(lobbyState.iJ)),
			lobbyState.an);
		if (!_v1.$) {
			var player = _v1.a;
			return $elm$core$String$isEmpty(player.aH) ? 'Anonymous Player' : player.aH;
		} else {
			return 'Anonymous Player';
		}
	}();
	var isHost = _Utils_eq(
		lobbyState.iF,
		$elm$core$Maybe$Just(lobbyState.iJ));
	var copyButtonLabel = lobbyState.cb ? 'Copied!' : 'Copy code';
	var canStart = isHost && (($elm$core$List$length(lobbyState.an) >= 2) && (!$elm$core$List$length(unassignedPlayers)));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'padding', '16px 20px'),
				A2($elm$html$Html$Attributes$style, 'max-width', '680px'),
				A2($elm$html$Html$Attributes$style, 'margin', '0 auto')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'padding', '0px')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Debate topic:')
					])),
				A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'padding', '0px'),
						A2($elm$html$Html$Attributes$style, 'margin-bottom', '30px'),
						A2($elm$html$Html$Attributes$style, 'color', 'black'),
						A2($elm$html$Html$Attributes$style, 'font-style', 'italic')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(lobbyState.jd)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'display', 'flex'),
						A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
						A2($elm$html$Html$Attributes$style, 'gap', '8px'),
						A2($elm$html$Html$Attributes$style, 'margin-bottom', '20px'),
						A2($elm$html$Html$Attributes$style, 'flex-wrap', 'wrap')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'color', '#888'),
								A2($elm$html$Html$Attributes$style, 'font-size', '0.9rem')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Invite friends:')
							])),
						A2(
						$elm$html$Html$strong,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'font-size', '1.3rem'),
								A2($elm$html$Html$Attributes$style, 'letter-spacing', '0.15em')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(lobbyState.hJ)
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$Game$Lobby$CopyGameCode),
								A2($elm$html$Html$Attributes$style, 'font-size', '1rem'),
								A2($elm$html$Html$Attributes$style, 'padding', '4px 10px'),
								A2($elm$html$Html$Attributes$style, 'margin', '0')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(copyButtonLabel)
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$Game$Lobby$ShareLink),
								A2($elm$html$Html$Attributes$style, 'font-size', '1rem'),
								A2($elm$html$Html$Attributes$style, 'padding', '4px 10px'),
								A2($elm$html$Html$Attributes$style, 'margin', '0')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(shareLinkLabel)
							]))
					])),
				isHost ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'margin-bottom', '20px')
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$disabled(!canStart),
								$elm$html$Html$Events$onClick($author$project$Game$Lobby$StartGame),
								A2($elm$html$Html$Attributes$style, 'margin', '0'),
								A2($elm$html$Html$Attributes$style, 'width', '100%'),
								A2($elm$html$Html$Attributes$style, 'font-size', '1.1rem'),
								A2($elm$html$Html$Attributes$style, 'padding', '14px 20px')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Start Game')
							])),
					function () {
						if (!startStatusHint.$) {
							var hint = startStatusHint.a;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'color', '#888'),
											A2($elm$html$Html$Attributes$style, 'font-size', '0.85rem'),
											A2($elm$html$Html$Attributes$style, 'margin-top', '8px')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(hint)
										]))
								]);
						} else {
							return _List_Nil;
						}
					}())) : $elm$html$Html$text(''),
				lobbyState.dd ? A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'margin-bottom', '20px'),
								A2($elm$html$Html$Attributes$style, 'display', 'flex'),
								A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
								A2($elm$html$Html$Attributes$style, 'gap', '8px')
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'color', '#888'),
										A2($elm$html$Html$Attributes$style, 'font-size', '0.9rem'),
										A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Your name:')
									])),
							lobbyState.cm ? _List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(lobbyState.aU),
											$elm$html$Html$Events$onInput($author$project$Game$Lobby$PlayerNameInputUpdated),
											onEnterMsg($author$project$Game$Lobby$SavePlayerName),
											A2($elm$html$Html$Attributes$style, 'margin', '0'),
											A2($elm$html$Html$Attributes$style, 'padding', '4px 8px'),
											A2($elm$html$Html$Attributes$style, 'font-size', '0.9rem'),
											A2($elm$html$Html$Attributes$style, 'flex', '1')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick($author$project$Game$Lobby$SavePlayerName),
											A2($elm$html$Html$Attributes$style, 'margin', '0'),
											A2($elm$html$Html$Attributes$style, 'padding', '4px 10px'),
											A2($elm$html$Html$Attributes$style, 'font-size', '0.85rem'),
											A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Save')
										]))
								]) : _List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(myCurrentName)
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick($author$project$Game$Lobby$EditPlayerName),
											A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
											A2($elm$html$Html$Attributes$style, 'font-size', '1.5rem'),
											A2($elm$html$Html$Attributes$style, 'opacity', '0.8'),
											$elm$html$Html$Attributes$title('Edit name')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('✏')
										]))
								]))),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'display', 'flex'),
								A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
								A2($elm$html$Html$Attributes$style, 'margin-bottom', '16px')
							]),
						A2(
							$elm$core$List$cons,
							unassignedCard,
							A2($elm$core$List$map, viewTeamCard, lobbyState.bV))),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'border-top', '1px solid #eee'),
								A2($elm$html$Html$Attributes$style, 'padding-top', '16px')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'color', '#888'),
										A2($elm$html$Html$Attributes$style, 'font-size', '0.85rem'),
										A2($elm$html$Html$Attributes$style, 'margin-bottom', '8px')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Create a new team')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'display', 'flex'),
										A2($elm$html$Html$Attributes$style, 'gap', '8px'),
										A2($elm$html$Html$Attributes$style, 'align-items', 'center')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_Utils_ap(
											_List_fromArray(
												[
													$elm$html$Html$Attributes$placeholder('Team name'),
													$elm$html$Html$Attributes$value(lobbyState.aX),
													$elm$html$Html$Events$onInput($author$project$Game$Lobby$TeamNameInputUpdated),
													A2($elm$html$Html$Attributes$style, 'margin', '0'),
													A2($elm$html$Html$Attributes$style, 'flex', '1')
												]),
											($elm$core$String$length(lobbyState.aX) > 0) ? _List_fromArray(
												[
													onEnterMsg($author$project$Game$Lobby$CreateTeam)
												]) : _List_Nil),
										_List_Nil),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Events$onClick($author$project$Game$Lobby$CreateTeam),
												$elm$html$Html$Attributes$disabled(
												!$elm$core$String$length(lobbyState.aX)),
												A2($elm$html$Html$Attributes$style, 'margin', '0'),
												A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Create')
											]))
									]))
							]))
					])) : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'margin-top', '8px')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'color', '#555'),
								A2($elm$html$Html$Attributes$style, 'font-size', '1rem'),
								A2($elm$html$Html$Attributes$style, 'margin-bottom', '12px')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Enter your player name')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'display', 'flex'),
								A2($elm$html$Html$Attributes$style, 'gap', '8px'),
								A2($elm$html$Html$Attributes$style, 'align-items', 'center')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_Utils_ap(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(lobbyState.aU),
											$elm$html$Html$Events$onInput($author$project$Game$Lobby$PlayerNameInputUpdated),
											$elm$html$Html$Attributes$placeholder('Your name'),
											A2($elm$html$Html$Attributes$style, 'margin', '0'),
											A2($elm$html$Html$Attributes$style, 'flex', '1')
										]),
									($elm$core$String$length(lobbyState.aU) > 0) ? _List_fromArray(
										[
											onEnterMsg($author$project$Game$Lobby$SavePlayerName)
										]) : _List_Nil),
								_List_Nil),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick($author$project$Game$Lobby$SavePlayerName),
										$elm$html$Html$Attributes$disabled(
										!$elm$core$String$length(lobbyState.aU)),
										A2($elm$html$Html$Attributes$style, 'margin', '0'),
										A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Continue')
									]))
							]))
					]))
			]));
};
var $author$project$Constants$Graphics$skyGradientCss = 'linear-gradient(to bottom, #0d47a1 0%, #1976d2 25%, #42a5f5 55%, #90caf9 78%, #d6eaf8 92%, #dde8c8 100%)';
var $author$project$Game$Playing$MovementPadUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Game$Playing$TargetPadUpdated = function (a) {
	return {$: 4, a: a};
};
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$line = $elm$svg$Svg$trustedNode('line');
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$Attributes$strokeLinecap = _VirtualDom_attribute('stroke-linecap');
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');
var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');
var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');
var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');
var $author$project$Game$Playing$aimIcon = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$stroke('rgba(0,0,0,0.55)'),
			$elm$svg$Svg$Attributes$strokeWidth('2'),
			$elm$svg$Svg$Attributes$strokeLinecap('round'),
			A2($elm$html$Html$Attributes$style, 'width', '60%'),
			A2($elm$html$Html$Attributes$style, 'height', '60%'),
			A2($elm$html$Html$Attributes$style, 'pointer-events', 'none')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('12'),
					$elm$svg$Svg$Attributes$cy('12'),
					$elm$svg$Svg$Attributes$r('5')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('12'),
					$elm$svg$Svg$Attributes$y1('1'),
					$elm$svg$Svg$Attributes$x2('12'),
					$elm$svg$Svg$Attributes$y2('7')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('12'),
					$elm$svg$Svg$Attributes$y1('17'),
					$elm$svg$Svg$Attributes$x2('12'),
					$elm$svg$Svg$Attributes$y2('23')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('1'),
					$elm$svg$Svg$Attributes$y1('12'),
					$elm$svg$Svg$Attributes$x2('7'),
					$elm$svg$Svg$Attributes$y2('12')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('17'),
					$elm$svg$Svg$Attributes$y1('12'),
					$elm$svg$Svg$Attributes$x2('23'),
					$elm$svg$Svg$Attributes$y2('12')
				]),
			_List_Nil)
		]));
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$svg$Svg$Attributes$points = _VirtualDom_attribute('points');
var $elm$svg$Svg$polygon = $elm$svg$Svg$trustedNode('polygon');
var $author$project$Game$Playing$movementIcon = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$fill('rgba(0,0,0,0.55)'),
			A2($elm$html$Html$Attributes$style, 'width', '60%'),
			A2($elm$html$Html$Attributes$style, 'height', '60%'),
			A2($elm$html$Html$Attributes$style, 'pointer-events', 'none')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$polygon,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('12,3 9,8 15,8')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polygon,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('12,21 9,16 15,16')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polygon,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('3,12 8,9 8,15')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polygon,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('21,12 16,9 16,15')
				]),
			_List_Nil)
		]));
var $author$project$Game$Playing$Joystick$JoystickDown = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Game$Playing$Joystick$JoystickMove = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Game$Playing$Joystick$JoystickUp = function (a) {
	return {$: 2, a: a};
};
var $author$project$Game$Playing$Joystick$modelToNubPosition = F2(
	function (sizePx, maybeModel) {
		var renderPos = function (n) {
			return $elm$core$String$fromFloat(
				A3($elm$core$Basics$clamp, 0.0, 100.0, (n * 100) / sizePx)) + '%';
		};
		var center = sizePx / 2;
		if (!maybeModel.$) {
			var initialPos = maybeModel.a.dQ;
			var currentOffset = maybeModel.a.cU;
			var initialPosCoords = $elm_explorations$linear_algebra$Math$Vector2$toRecord(initialPos);
			var currentOffsetCoords = $elm_explorations$linear_algebra$Math$Vector2$toRecord(currentOffset);
			return {
				cF: renderPos((currentOffsetCoords.cF - initialPosCoords.cF) + center),
				cG: renderPos((-(currentOffsetCoords.cG - initialPosCoords.cG)) + center)
			};
		} else {
			return {
				cF: renderPos(center),
				cG: renderPos(center)
			};
		}
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$defaultOptions = {el: true, eu: false};
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$Event = F5(
	function (pointerType, pointer, pointerId, isPrimary, contactDetails) {
		return {hg: contactDetails, h$: isPrimary, f6: pointer, bd: pointerId, iK: pointerType};
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$ContactDetails = F5(
	function (width, height, pressure, tiltX, tiltY) {
		return {hP: height, iL: pressure, i8: tiltX, i9: tiltY, jm: width};
	});
var $elm$json$Json$Decode$map5 = _Json_map5;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$contactDetailsDecoder = A6(
	$elm$json$Json$Decode$map5,
	$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$ContactDetails,
	A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'pressure', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'tiltX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'tiltY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$Event = F6(
	function (keys, button, clientPos, offsetPos, pagePos, screenPos) {
		return {g1: button, hc: clientPos, h2: keys, f_: offsetPos, iG: pagePos, iT: screenPos};
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$BackButton = 4;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$ErrorButton = 0;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$ForwardButton = 5;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$MainButton = 1;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$MiddleButton = 2;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$SecondButton = 3;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$buttonFromId = function (id) {
	switch (id) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		default:
			return 0;
	}
};
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$buttonDecoder = A2(
	$elm$json$Json$Decode$map,
	$mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$buttonFromId,
	A2($elm$json$Json$Decode$field, 'button', $elm$json$Json$Decode$int));
var $mpizenberg$elm_pointer_events$Internal$Decode$clientPos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Internal$Decode$Keys = F3(
	function (alt, ctrl, shift) {
		return {gJ: alt, hk: ctrl, iU: shift};
	});
var $mpizenberg$elm_pointer_events$Internal$Decode$keys = A4(
	$elm$json$Json$Decode$map3,
	$mpizenberg$elm_pointer_events$Internal$Decode$Keys,
	A2($elm$json$Json$Decode$field, 'altKey', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'ctrlKey', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool));
var $elm$json$Json$Decode$map6 = _Json_map6;
var $mpizenberg$elm_pointer_events$Internal$Decode$offsetPos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'offsetX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'offsetY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Internal$Decode$pagePos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'pageX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'pageY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Internal$Decode$screenPos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'screenX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'screenY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$eventDecoder = A7($elm$json$Json$Decode$map6, $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$Event, $mpizenberg$elm_pointer_events$Internal$Decode$keys, $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$buttonDecoder, $mpizenberg$elm_pointer_events$Internal$Decode$clientPos, $mpizenberg$elm_pointer_events$Internal$Decode$offsetPos, $mpizenberg$elm_pointer_events$Internal$Decode$pagePos, $mpizenberg$elm_pointer_events$Internal$Decode$screenPos);
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$MouseType = 0;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$PenType = 2;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$TouchType = 1;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$stringToPointerType = function (str) {
	switch (str) {
		case 'pen':
			return 2;
		case 'touch':
			return 1;
		default:
			return 0;
	}
};
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$pointerTypeDecoder = A2($elm$json$Json$Decode$map, $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$stringToPointerType, $elm$json$Json$Decode$string);
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$eventDecoder = A6(
	$elm$json$Json$Decode$map5,
	$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$Event,
	A2($elm$json$Json$Decode$field, 'pointerType', $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$pointerTypeDecoder),
	$mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$eventDecoder,
	A2($elm$json$Json$Decode$field, 'pointerId', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'isPrimary', $elm$json$Json$Decode$bool),
	$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$contactDetailsDecoder);
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onWithOptions = F3(
	function (event, options, tag) {
		return A2(
			$elm$html$Html$Events$custom,
			event,
			A2(
				$elm$json$Json$Decode$map,
				function (ev) {
					return {
						aQ: tag(ev),
						el: options.el,
						eu: options.eu
					};
				},
				$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$eventDecoder));
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onCancel = A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onWithOptions, 'pointercancel', $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$defaultOptions);
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown = A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onWithOptions, 'pointerdown', $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$defaultOptions);
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onMove = A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onWithOptions, 'pointermove', $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$defaultOptions);
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onUp = A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onWithOptions, 'pointerup', $mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$defaultOptions);
var $author$project$Game$Playing$Joystick$tupleToVec2 = function (_v0) {
	var x = _v0.a;
	var y = _v0.b;
	return A2($elm_explorations$linear_algebra$Math$Vector2$vec2, x, -y);
};
var $author$project$Game$Playing$Joystick$view = F4(
	function (sizePx, icon, onAction, maybeModel) {
		var sizeStr = $elm$core$String$fromFloat(sizePx) + 'px';
		var _v0 = A2($author$project$Game$Playing$Joystick$modelToNubPosition, sizePx, maybeModel);
		var x = _v0.cF;
		var y = _v0.cG;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', sizeStr),
					A2($elm$html$Html$Attributes$style, 'height', sizeStr),
					A2($elm$html$Html$Attributes$style, 'flex', '0 0 auto'),
					A2($elm$html$Html$Attributes$style, 'margin', '5px'),
					$elm$html$Html$Attributes$class('joystick'),
					$elm$html$Html$Attributes$class('no-zoom'),
					$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onDown(
					function (event) {
						return onAction(
							A2(
								$author$project$Game$Playing$Joystick$JoystickDown,
								event.bd,
								$author$project$Game$Playing$Joystick$tupleToVec2(event.f6.f_)));
					}),
					$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onMove(
					function (event) {
						return onAction(
							A2(
								$author$project$Game$Playing$Joystick$JoystickMove,
								event.bd,
								$author$project$Game$Playing$Joystick$tupleToVec2(event.f6.f_)));
					}),
					$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onUp(
					function (event) {
						return onAction(
							$author$project$Game$Playing$Joystick$JoystickUp(event.bd));
					}),
					$mpizenberg$elm_pointer_events$Html$Events$Extra$Pointer$onCancel(
					function (event) {
						return onAction(
							$author$project$Game$Playing$Joystick$JoystickUp(event.bd));
					})
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('joystick-nub'),
							$elm$html$Html$Attributes$class('no-zoom'),
							A2($elm$html$Html$Attributes$style, 'left', x),
							A2($elm$html$Html$Attributes$style, 'top', y),
							A2($elm$html$Html$Attributes$style, 'pointer-events', 'none')
						]),
					_List_fromArray(
						[icon]))
				]));
	});
var $author$project$Game$Playing$viewControlPad = function (model) {
	var sizePx = $author$project$Game$Playing$joystickSizePx(model);
	var landscape = _Utils_cmp(model.aB, model.aA) > 0;
	var padding = landscape ? '0 12px' : '0 20px';
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
				A2($elm$html$Html$Attributes$style, 'bottom', '16px'),
				A2($elm$html$Html$Attributes$style, 'left', '0'),
				A2($elm$html$Html$Attributes$style, 'right', '0'),
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'flex-direction', 'row'),
				A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
				A2($elm$html$Html$Attributes$style, 'justify-content', 'space-between'),
				A2($elm$html$Html$Attributes$style, 'padding', padding),
				$elm$html$Html$Attributes$class('no-zoom')
			]),
		_List_fromArray(
			[
				A4($author$project$Game$Playing$Joystick$view, sizePx, $author$project$Game$Playing$movementIcon, $author$project$Game$Playing$MovementPadUpdated, model.bD),
				A4($author$project$Game$Playing$Joystick$view, sizePx, $author$project$Game$Playing$aimIcon, $author$project$Game$Playing$TargetPadUpdated, model.bT)
			]));
};
var $author$project$Game$Playing$viewDamageFlash = function (maybeAge) {
	if (maybeAge.$ === 1) {
		return $elm$html$Html$text('');
	} else {
		var age = maybeAge.a;
		var opacity = (1 - (age / $author$project$Game$Playing$myHitFlashMaxAgeMs)) * 0.55;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
					A2($elm$html$Html$Attributes$style, 'inset', '0'),
					A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
					A2($elm$html$Html$Attributes$style, 'z-index', '5'),
					A2(
					$elm$html$Html$Attributes$style,
					'background',
					'rgba(220, 20, 20, ' + ($elm$core$String$fromFloat(opacity) + ')'))
				]),
			_List_Nil);
	}
};
var $author$project$Game$Playing$viewDeathOverlay = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
			A2($elm$html$Html$Attributes$style, 'inset', '0'),
			A2($elm$html$Html$Attributes$style, 'background', 'rgba(0,0,0,0.35)'),
			A2($elm$html$Html$Attributes$style, 'display', 'flex'),
			A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
			A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
			A2($elm$html$Html$Attributes$style, 'justify-content', 'center'),
			A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
			A2($elm$html$Html$Attributes$style, 'user-select', 'none'),
			A2($elm$html$Html$Attributes$style, '-webkit-user-select', 'none'),
			A2($elm$html$Html$Attributes$style, 'z-index', '10')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'font-size', '1.6rem'),
					A2($elm$html$Html$Attributes$style, 'font-weight', 'bold'),
					A2($elm$html$Html$Attributes$style, 'color', '#ff6f61'),
					A2($elm$html$Html$Attributes$style, 'text-shadow', '0 2px 8px rgba(0,0,0,0.8)')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('You were eliminated!')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'margin-top', '8px'),
					A2($elm$html$Html$Attributes$style, 'font-size', '0.9rem'),
					A2($elm$html$Html$Attributes$style, 'color', 'rgba(255,255,255,0.75)')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Waiting for the round to end…')
				]))
		]));
var $author$project$Config$cameraClipDepthMeters = 0.5;
var $ianmackenzie$elm_3d_scene$Scene3d$Light$CastsShadows = $elm$core$Basics$identity;
var $ianmackenzie$elm_3d_scene$Scene3d$Light$castsShadows = function (flag) {
	return flag;
};
var $ianmackenzie$elm_3d_scene$Scene3d$Types$Chromaticity = $elm$core$Basics$identity;
var $ianmackenzie$elm_3d_scene$Scene3d$Light$chromaticity = function (xy) {
	return xy;
};
var $elm_explorations$webgl$WebGL$Internal$Alpha = function (a) {
	return {$: 0, a: a};
};
var $elm_explorations$webgl$WebGL$alpha = $elm_explorations$webgl$WebGL$Internal$Alpha;
var $elm_explorations$webgl$WebGL$Internal$Antialias = {$: 3};
var $elm_explorations$webgl$WebGL$antialias = $elm_explorations$webgl$WebGL$Internal$Antialias;
var $elm_explorations$webgl$WebGL$Internal$ClearColor = F4(
	function (a, b, c, d) {
		return {$: 4, a: a, b: b, c: c, d: d};
	});
var $elm_explorations$webgl$WebGL$clearColor = $elm_explorations$webgl$WebGL$Internal$ClearColor;
var $elm_explorations$webgl$WebGL$Internal$Depth = function (a) {
	return {$: 1, a: a};
};
var $elm_explorations$webgl$WebGL$depth = $elm_explorations$webgl$WebGL$Internal$Depth;
var $elm$html$Html$Attributes$height = function (n) {
	return A2(
		_VirtualDom_attribute,
		'height',
		$elm$core$String$fromInt(n));
};
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $elm_explorations$webgl$WebGL$Internal$Stencil = function (a) {
	return {$: 2, a: a};
};
var $elm_explorations$webgl$WebGL$stencil = $elm_explorations$webgl$WebGL$Internal$Stencil;
var $elm_explorations$webgl$WebGL$toHtmlWith = F3(
	function (options, attributes, entities) {
		return A3(_WebGL_toHtml, options, attributes, entities);
	});
var $ianmackenzie$elm_units$Pixels$toInt = function (_v0) {
	var numPixels = _v0;
	return numPixels;
};
var $ianmackenzie$elm_3d_scene$Scene3d$allLightsEnabled = A4($elm_explorations$linear_algebra$Math$Vector4$vec4, 1, 1, 1, 1);
var $ianmackenzie$elm_3d_scene$Scene3d$call = F3(
	function (renderPasses, lights, settings) {
		return A2(
			$elm$core$List$map,
			function (renderPass) {
				return A2(renderPass, lights, settings);
			},
			renderPasses);
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Types$CieXyz = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$ColorConversions$chromaticityToCieXyz = F2(
	function (_v0, _v1) {
		var intensity = _v0;
		var x = _v1.cF;
		var y = _v1.cG;
		return A4($ianmackenzie$elm_3d_scene$Scene3d$Types$CieXyz, (intensity * x) / y, intensity, (intensity * ((1 - x) - y)) / y, 1);
	});
var $ianmackenzie$elm_3d_scene$Scene3d$ColorConversions$cieXyzToLinearRgb = function (_v0) {
	var bigX = _v0.a;
	var bigY = _v0.b;
	var bigZ = _v0.c;
	var a = _v0.d;
	return A4($elm_explorations$linear_algebra$Math$Vector4$vec4, ((3.2406 * bigX) - (1.5372 * bigY)) - (0.4986 * bigZ), (((-0.9689) * bigX) + (1.8758 * bigY)) + (0.0415 * bigZ), ((0.0557 * bigX) - (0.204 * bigY)) + (1.057 * bigZ), a);
};
var $ianmackenzie$elm_3d_scene$Scene3d$ColorConversions$chromaticityToLinearRgb = F2(
	function (intensity, chromaticity) {
		return $ianmackenzie$elm_3d_scene$Scene3d$ColorConversions$cieXyzToLinearRgb(
			A2($ianmackenzie$elm_3d_scene$Scene3d$ColorConversions$chromaticityToCieXyz, intensity, chromaticity));
	});
var $elm_explorations$linear_algebra$Math$Matrix4$fromRecord = _MJS_m4x4fromRecord;
var $ianmackenzie$elm_3d_scene$Scene3d$Transformation$modelMatrix = function (transformation) {
	return $elm_explorations$linear_algebra$Math$Matrix4$fromRecord(
		{h8: transformation.x, h9: transformation.A, ia: transformation.D, fB: transformation.T, ib: transformation.y, ic: transformation.B, id: transformation.E, fC: transformation.U, ie: transformation.z, $8: transformation.C, ig: transformation.F, fD: transformation.V, fE: 0, fF: 0, fG: 0, fH: 1});
};
var $ianmackenzie$elm_3d_scene$Scene3d$createRenderPass = F5(
	function (sceneProperties, viewMatrix, projectionMatrix, transformation, drawFunction) {
		var normalSign = transformation.fn ? 1 : (-1);
		var modelScale = A4($elm_explorations$linear_algebra$Math$Vector4$vec4, transformation.dx, transformation.dx, transformation.dx, normalSign);
		return A6(
			drawFunction,
			sceneProperties,
			modelScale,
			$ianmackenzie$elm_3d_scene$Scene3d$Transformation$modelMatrix(transformation),
			transformation.fn,
			viewMatrix,
			projectionMatrix);
	});
var $ianmackenzie$elm_3d_scene$Scene3d$collectRenderPasses = F6(
	function (sceneProperties, viewMatrix, projectionMatrix, currentTransformation, node, accumulated) {
		collectRenderPasses:
		while (true) {
			switch (node.$) {
				case 0:
					return accumulated;
				case 6:
					var transformation = node.a;
					var childNode = node.b;
					var $temp$sceneProperties = sceneProperties,
						$temp$viewMatrix = viewMatrix,
						$temp$projectionMatrix = projectionMatrix,
						$temp$currentTransformation = A2($ianmackenzie$elm_3d_scene$Scene3d$Transformation$compose, transformation, currentTransformation),
						$temp$node = childNode,
						$temp$accumulated = accumulated;
					sceneProperties = $temp$sceneProperties;
					viewMatrix = $temp$viewMatrix;
					projectionMatrix = $temp$projectionMatrix;
					currentTransformation = $temp$currentTransformation;
					node = $temp$node;
					accumulated = $temp$accumulated;
					continue collectRenderPasses;
				case 1:
					var meshDrawFunction = node.b;
					var updatedMeshes = A2(
						$elm$core$List$cons,
						A5($ianmackenzie$elm_3d_scene$Scene3d$createRenderPass, sceneProperties, viewMatrix, projectionMatrix, currentTransformation, meshDrawFunction),
						accumulated.Q);
					return {Q: updatedMeshes, f7: accumulated.f7, ac: accumulated.ac, o: accumulated.o};
				case 2:
					var meshDrawFunction = node.b;
					var updatedMeshes = A2(
						$elm$core$List$cons,
						A5($ianmackenzie$elm_3d_scene$Scene3d$createRenderPass, sceneProperties, viewMatrix, projectionMatrix, currentTransformation, meshDrawFunction),
						accumulated.o);
					return {Q: accumulated.Q, f7: accumulated.f7, ac: accumulated.ac, o: updatedMeshes};
				case 4:
					var pointDrawFunction = node.b;
					var updatedPoints = A2(
						$elm$core$List$cons,
						A5($ianmackenzie$elm_3d_scene$Scene3d$createRenderPass, sceneProperties, viewMatrix, projectionMatrix, currentTransformation, pointDrawFunction),
						accumulated.f7);
					return {Q: accumulated.Q, f7: updatedPoints, ac: accumulated.ac, o: accumulated.o};
				case 3:
					var shadowDrawFunction = node.a;
					var updatedShadows = A2(
						$elm$core$List$cons,
						A5($ianmackenzie$elm_3d_scene$Scene3d$createRenderPass, sceneProperties, viewMatrix, projectionMatrix, currentTransformation, shadowDrawFunction),
						accumulated.ac);
					return {Q: accumulated.Q, f7: accumulated.f7, ac: updatedShadows, o: accumulated.o};
				default:
					var childNodes = node.a;
					return A3(
						$elm$core$List$foldl,
						A4($ianmackenzie$elm_3d_scene$Scene3d$collectRenderPasses, sceneProperties, viewMatrix, projectionMatrix, currentTransformation),
						accumulated,
						childNodes);
			}
		}
	});
var $ianmackenzie$elm_units$Quantity$negate = function (_v0) {
	var value = _v0;
	return -value;
};
var $ianmackenzie$elm_units$Quantity$plus = F2(
	function (_v0, _v1) {
		var y = _v0;
		var x = _v1;
		return x + y;
	});
var $ianmackenzie$elm_geometry$Vector3d$xyz = F3(
	function (_v0, _v1, _v2) {
		var x = _v0;
		var y = _v1;
		var z = _v2;
		return {cF: x, cG: y, cH: z};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$sceneDiameter = function (viewBounds) {
	var _v0 = $ianmackenzie$elm_geometry$BoundingBox3d$dimensions(viewBounds);
	var xDimension = _v0.a;
	var yDimension = _v0.b;
	var zDimension = _v0.c;
	return $ianmackenzie$elm_geometry$Vector3d$length(
		A3($ianmackenzie$elm_geometry$Vector3d$xyz, xDimension, yDimension, zDimension));
};
var $ianmackenzie$elm_3d_scene$Scene3d$computeClipDepths = F2(
	function (givenClipDepth, viewBounds) {
		var nearClipDepth = A2(
			$ianmackenzie$elm_units$Quantity$multiplyBy,
			0.99,
			A2(
				$ianmackenzie$elm_units$Quantity$max,
				$ianmackenzie$elm_units$Quantity$abs(givenClipDepth),
				$ianmackenzie$elm_units$Quantity$negate(
					$ianmackenzie$elm_geometry$BoundingBox3d$maxZ(viewBounds))));
		var farClipDepth = A2(
			$ianmackenzie$elm_units$Quantity$multiplyBy,
			1.01,
			A2(
				$ianmackenzie$elm_units$Quantity$plus,
				$ianmackenzie$elm_3d_scene$Scene3d$sceneDiameter(viewBounds),
				$ianmackenzie$elm_units$Quantity$negate(
					$ianmackenzie$elm_geometry$BoundingBox3d$minZ(viewBounds))));
		return _Utils_Tuple2(nearClipDepth, farClipDepth);
	});
var $elm_explorations$webgl$WebGL$Internal$ColorMask = F4(
	function (a, b, c, d) {
		return {$: 4, a: a, b: b, c: c, d: d};
	});
var $elm_explorations$webgl$WebGL$Settings$colorMask = $elm_explorations$webgl$WebGL$Internal$ColorMask;
var $elm_explorations$webgl$WebGL$Internal$DepthTest = F4(
	function (a, b, c, d) {
		return {$: 1, a: a, b: b, c: c, d: d};
	});
var $elm_explorations$webgl$WebGL$Settings$DepthTest$greaterOrEqual = function (_v0) {
	var write = _v0.aC;
	var near = _v0.au;
	var far = _v0.at;
	return A4($elm_explorations$webgl$WebGL$Internal$DepthTest, 518, write, near, far);
};
var $elm_explorations$webgl$WebGL$Internal$PolygonOffset = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $elm_explorations$webgl$WebGL$Settings$polygonOffset = $elm_explorations$webgl$WebGL$Internal$PolygonOffset;
var $ianmackenzie$elm_3d_scene$Scene3d$createShadowStencil = _List_fromArray(
	[
		$elm_explorations$webgl$WebGL$Settings$DepthTest$greaterOrEqual(
		{at: 1, au: 0, aC: false}),
		A4($elm_explorations$webgl$WebGL$Settings$colorMask, false, false, false, false),
		A2($elm_explorations$webgl$WebGL$Settings$polygonOffset, 0.0, 1.0)
	]);
var $ianmackenzie$elm_3d_scene$Scene3d$initialStencilCount = 8;
var $ianmackenzie$elm_3d_scene$Scene3d$lowerFourBits = 15;
var $elm_explorations$webgl$WebGL$Settings$StencilTest$replace = 7681;
var $ianmackenzie$elm_3d_scene$Scene3d$dummyFragmentShader = {
	src: '\n        precision lowp float;\n\n        void main() {\n            gl_FragColor = vec4(0.0, 0.0, 0.0, 0.0);\n        }\n    ',
	attributes: {},
	uniforms: {}
};
var $elm_explorations$webgl$WebGL$Mesh1 = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm_explorations$webgl$WebGL$triangleStrip = $elm_explorations$webgl$WebGL$Mesh1(
	{e$: 1, fk: 0, fR: 5});
var $ianmackenzie$elm_3d_scene$Scene3d$fullScreenQuadMesh = $elm_explorations$webgl$WebGL$triangleStrip(
	_List_fromArray(
		[
			{
			f9: A2($elm_explorations$linear_algebra$Math$Vector2$vec2, -1, -1)
		},
			{
			f9: A2($elm_explorations$linear_algebra$Math$Vector2$vec2, 1, -1)
		},
			{
			f9: A2($elm_explorations$linear_algebra$Math$Vector2$vec2, -1, 1)
		},
			{
			f9: A2($elm_explorations$linear_algebra$Math$Vector2$vec2, 1, 1)
		}
		]));
var $ianmackenzie$elm_3d_scene$Scene3d$fullScreenQuadVertexShader = {
	src: '\n        precision lowp float;\n\n        attribute vec2 position;\n\n        void main() {\n            gl_Position = vec4(position, 0.0, 1.0);\n        }\n    ',
	attributes: {position: 'f9'},
	uniforms: {}
};
var $elm_explorations$webgl$WebGL$Settings$StencilTest$test = function (stencilTest) {
	return A3(
		$elm_explorations$webgl$WebGL$Settings$StencilTest$testSeparate,
		{d0: stencilTest.d0, en: stencilTest.en, eE: stencilTest.eE},
		{cg: stencilTest.cg, cx: stencilTest.cx, cI: stencilTest.cI, cJ: stencilTest.cJ},
		{cg: stencilTest.cg, cx: stencilTest.cx, cI: stencilTest.cI, cJ: stencilTest.cJ});
};
var $ianmackenzie$elm_3d_scene$Scene3d$updateStencil = function (test) {
	return A5(
		$elm_explorations$webgl$WebGL$entityWith,
		_List_fromArray(
			[
				$elm_explorations$webgl$WebGL$Settings$StencilTest$test(test),
				A4($elm_explorations$webgl$WebGL$Settings$colorMask, false, false, false, false)
			]),
		$ianmackenzie$elm_3d_scene$Scene3d$fullScreenQuadVertexShader,
		$ianmackenzie$elm_3d_scene$Scene3d$dummyFragmentShader,
		$ianmackenzie$elm_3d_scene$Scene3d$fullScreenQuadMesh,
		{});
};
var $ianmackenzie$elm_3d_scene$Scene3d$resetStencil = $ianmackenzie$elm_3d_scene$Scene3d$updateStencil(
	{cg: $elm_explorations$webgl$WebGL$Settings$StencilTest$replace, d0: 0, en: $ianmackenzie$elm_3d_scene$Scene3d$initialStencilCount, cx: $elm_explorations$webgl$WebGL$Settings$StencilTest$always, eE: $ianmackenzie$elm_3d_scene$Scene3d$lowerFourBits, cI: $elm_explorations$webgl$WebGL$Settings$StencilTest$replace, cJ: $elm_explorations$webgl$WebGL$Settings$StencilTest$replace});
var $elm_explorations$webgl$WebGL$Settings$StencilTest$greater = 516;
var $elm_explorations$webgl$WebGL$Settings$StencilTest$invert = 5386;
var $ianmackenzie$elm_3d_scene$Scene3d$singleLightMask = function (index) {
	return A2($elm$core$Basics$pow, 2, index + 4);
};
var $ianmackenzie$elm_3d_scene$Scene3d$storeStencilValue = function (lightIndex) {
	return $ianmackenzie$elm_3d_scene$Scene3d$updateStencil(
		{
			cg: $elm_explorations$webgl$WebGL$Settings$StencilTest$keep,
			d0: $ianmackenzie$elm_3d_scene$Scene3d$lowerFourBits,
			en: $ianmackenzie$elm_3d_scene$Scene3d$initialStencilCount,
			cx: $elm_explorations$webgl$WebGL$Settings$StencilTest$greater,
			eE: $ianmackenzie$elm_3d_scene$Scene3d$singleLightMask(lightIndex),
			cI: $elm_explorations$webgl$WebGL$Settings$StencilTest$invert,
			cJ: $elm_explorations$webgl$WebGL$Settings$StencilTest$invert
		});
};
var $ianmackenzie$elm_3d_scene$Scene3d$createShadow = F3(
	function (shadowRenderPasses, lightIndex, lightMatrix) {
		return $elm$core$List$concat(
			_List_fromArray(
				[
					A3($ianmackenzie$elm_3d_scene$Scene3d$call, shadowRenderPasses, lightMatrix, $ianmackenzie$elm_3d_scene$Scene3d$createShadowStencil),
					_List_fromArray(
					[
						$ianmackenzie$elm_3d_scene$Scene3d$storeStencilValue(lightIndex),
						$ianmackenzie$elm_3d_scene$Scene3d$resetStencil
					])
				]));
	});
var $ianmackenzie$elm_3d_scene$Scene3d$createShadows = F2(
	function (shadowRenderPasses, shadowCasters) {
		return $elm$core$List$concat(
			A2(
				$elm$core$List$indexedMap,
				$ianmackenzie$elm_3d_scene$Scene3d$createShadow(shadowRenderPasses),
				shadowCasters));
	});
var $elm_explorations$webgl$WebGL$Internal$Blend = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return {$: 0, a: a, b: b, c: c, d: d, e: e, f: f, g: g, h: h, i: i, j: j};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm_explorations$webgl$WebGL$Settings$Blend$custom = function (_v0) {
	var r = _v0.ds;
	var g = _v0.c$;
	var b = _v0.cO;
	var a = _v0.cK;
	var color = _v0.he;
	var alpha = _v0.eH;
	var expand = F2(
		function (_v1, _v2) {
			var eq1 = _v1.a;
			var f11 = _v1.b;
			var f12 = _v1.c;
			var eq2 = _v2.a;
			var f21 = _v2.b;
			var f22 = _v2.c;
			return $elm_explorations$webgl$WebGL$Internal$Blend(eq1)(f11)(f12)(eq2)(f21)(f22)(r)(g)(b)(a);
		});
	return A2(expand, color, alpha);
};
var $elm_explorations$webgl$WebGL$Settings$Blend$Blender = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm_explorations$webgl$WebGL$Settings$Blend$customAdd = F2(
	function (_v0, _v1) {
		var factor1 = _v0;
		var factor2 = _v1;
		return A3($elm_explorations$webgl$WebGL$Settings$Blend$Blender, 32774, factor1, factor2);
	});
var $elm_explorations$webgl$WebGL$Settings$Blend$add = F2(
	function (factor1, factor2) {
		return $elm_explorations$webgl$WebGL$Settings$Blend$custom(
			{
				cK: 0,
				eH: A2($elm_explorations$webgl$WebGL$Settings$Blend$customAdd, factor1, factor2),
				cO: 0,
				he: A2($elm_explorations$webgl$WebGL$Settings$Blend$customAdd, factor1, factor2),
				c$: 0,
				ds: 0
			});
	});
var $elm_explorations$webgl$WebGL$Settings$Blend$Factor = $elm$core$Basics$identity;
var $elm_explorations$webgl$WebGL$Settings$Blend$one = 1;
var $elm_explorations$webgl$WebGL$Settings$Blend$oneMinusSrcAlpha = 771;
var $elm_explorations$webgl$WebGL$Internal$SampleAlphaToCoverage = {$: 8};
var $elm_explorations$webgl$WebGL$Settings$sampleAlphaToCoverage = $elm_explorations$webgl$WebGL$Internal$SampleAlphaToCoverage;
var $ianmackenzie$elm_3d_scene$Scene3d$blendSettings = _List_fromArray(
	[
		A2($elm_explorations$webgl$WebGL$Settings$Blend$add, $elm_explorations$webgl$WebGL$Settings$Blend$one, $elm_explorations$webgl$WebGL$Settings$Blend$oneMinusSrcAlpha),
		$elm_explorations$webgl$WebGL$Settings$sampleAlphaToCoverage
	]);
var $elm_explorations$webgl$WebGL$Settings$DepthTest$less = function (_v0) {
	var write = _v0.aC;
	var near = _v0.au;
	var far = _v0.at;
	return A4($elm_explorations$webgl$WebGL$Internal$DepthTest, 513, write, near, far);
};
var $elm_explorations$webgl$WebGL$Settings$DepthTest$default = $elm_explorations$webgl$WebGL$Settings$DepthTest$less(
	{at: 1, au: 0, aC: true});
var $ianmackenzie$elm_3d_scene$Scene3d$drawNormally = A2($elm$core$List$cons, $elm_explorations$webgl$WebGL$Settings$DepthTest$default, $ianmackenzie$elm_3d_scene$Scene3d$blendSettings);
var $elm_explorations$webgl$WebGL$Settings$StencilTest$equal = 514;
var $elm_explorations$webgl$WebGL$Settings$DepthTest$lessOrEqual = function (_v0) {
	var write = _v0.aC;
	var near = _v0.au;
	var far = _v0.at;
	return A4($elm_explorations$webgl$WebGL$Internal$DepthTest, 515, write, near, far);
};
var $ianmackenzie$elm_3d_scene$Scene3d$upperFourBits = 240;
var $ianmackenzie$elm_3d_scene$Scene3d$drawOutsideStencil = A2(
	$elm$core$List$cons,
	$elm_explorations$webgl$WebGL$Settings$DepthTest$lessOrEqual(
		{at: 1, au: 0, aC: true}),
	A2(
		$elm$core$List$cons,
		$elm_explorations$webgl$WebGL$Settings$StencilTest$test(
			{cg: $elm_explorations$webgl$WebGL$Settings$StencilTest$keep, d0: $ianmackenzie$elm_3d_scene$Scene3d$upperFourBits, en: 0, cx: $elm_explorations$webgl$WebGL$Settings$StencilTest$equal, eE: 0, cI: $elm_explorations$webgl$WebGL$Settings$StencilTest$keep, cJ: $elm_explorations$webgl$WebGL$Settings$StencilTest$keep}),
		$ianmackenzie$elm_3d_scene$Scene3d$blendSettings));
var $elm_explorations$webgl$WebGL$Settings$DepthTest$equal = function (_v0) {
	var write = _v0.aC;
	var near = _v0.au;
	var far = _v0.at;
	return A4($elm_explorations$webgl$WebGL$Internal$DepthTest, 514, write, near, far);
};
var $ianmackenzie$elm_3d_scene$Scene3d$drawWhereDepthTestEqual = A2(
	$elm$core$List$cons,
	$elm_explorations$webgl$WebGL$Settings$DepthTest$equal(
		{at: 1, au: 0, aC: true}),
	$ianmackenzie$elm_3d_scene$Scene3d$blendSettings);
var $ianmackenzie$elm_3d_camera$Camera3d$frame = function (_v0) {
	var camera = _v0;
	return $ianmackenzie$elm_geometry$Frame3d$copy(camera.fa);
};
var $ianmackenzie$elm_3d_camera$Camera3d$eyePoint = function (camera) {
	return $ianmackenzie$elm_geometry$Frame3d$originPoint(
		$ianmackenzie$elm_3d_camera$Camera3d$frame(camera));
};
var $ianmackenzie$elm_3d_scene$Scene3d$Transformation$placementFrame = function (transformation) {
	return $ianmackenzie$elm_geometry$Frame3d$unsafe(
		{
			iE: $ianmackenzie$elm_geometry$Point3d$unsafe(
				{cF: transformation.T, cG: transformation.U, cH: transformation.V}),
			jr: $ianmackenzie$elm_geometry$Direction3d$unsafe(
				{cF: transformation.x, cG: transformation.y, cH: transformation.z}),
			jv: $ianmackenzie$elm_geometry$Direction3d$unsafe(
				{cF: transformation.A, cG: transformation.B, cH: transformation.C}),
			jz: $ianmackenzie$elm_geometry$Direction3d$unsafe(
				{cF: transformation.D, cG: transformation.E, cH: transformation.F})
		});
};
var $ianmackenzie$elm_geometry$Direction3d$relativeTo = F2(
	function (_v0, _v1) {
		var frame = _v0;
		var d = _v1;
		var _v2 = frame.jz;
		var k = _v2;
		var _v3 = frame.jv;
		var j = _v3;
		var _v4 = frame.jr;
		var i = _v4;
		return {cF: ((d.cF * i.cF) + (d.cG * i.cG)) + (d.cH * i.cH), cG: ((d.cF * j.cF) + (d.cG * j.cG)) + (d.cH * j.cH), cH: ((d.cF * k.cF) + (d.cG * k.cG)) + (d.cH * k.cH)};
	});
var $ianmackenzie$elm_geometry$Point3d$relativeTo = F2(
	function (_v0, _v1) {
		var frame = _v0;
		var p = _v1;
		var _v2 = frame.iE;
		var p0 = _v2;
		var deltaX = p.cF - p0.cF;
		var deltaY = p.cG - p0.cG;
		var deltaZ = p.cH - p0.cH;
		var _v3 = frame.jz;
		var k = _v3;
		var _v4 = frame.jv;
		var j = _v4;
		var _v5 = frame.jr;
		var i = _v5;
		return {cF: ((deltaX * i.cF) + (deltaY * i.cG)) + (deltaZ * i.cH), cG: ((deltaX * j.cF) + (deltaY * j.cG)) + (deltaZ * j.cH), cH: ((deltaX * k.cF) + (deltaY * k.cG)) + (deltaZ * k.cH)};
	});
var $ianmackenzie$elm_geometry$Frame3d$relativeTo = F2(
	function (otherFrame, frame) {
		return {
			iE: A2(
				$ianmackenzie$elm_geometry$Point3d$relativeTo,
				otherFrame,
				$ianmackenzie$elm_geometry$Frame3d$originPoint(frame)),
			jr: A2(
				$ianmackenzie$elm_geometry$Direction3d$relativeTo,
				otherFrame,
				$ianmackenzie$elm_geometry$Frame3d$xDirection(frame)),
			jv: A2(
				$ianmackenzie$elm_geometry$Direction3d$relativeTo,
				otherFrame,
				$ianmackenzie$elm_geometry$Frame3d$yDirection(frame)),
			jz: A2(
				$ianmackenzie$elm_geometry$Direction3d$relativeTo,
				otherFrame,
				$ianmackenzie$elm_geometry$Frame3d$zDirection(frame))
		};
	});
var $ianmackenzie$elm_geometry$BoundingBox3d$union = F2(
	function (firstBox, secondBox) {
		var _v0 = secondBox;
		var b2 = _v0;
		var _v1 = firstBox;
		var b1 = _v1;
		return {
			fK: A2($elm$core$Basics$max, b1.fK, b2.fK),
			fL: A2($elm$core$Basics$max, b1.fL, b2.fL),
			fM: A2($elm$core$Basics$max, b1.fM, b2.fM),
			fN: A2($elm$core$Basics$min, b1.fN, b2.fN),
			fO: A2($elm$core$Basics$min, b1.fO, b2.fO),
			fP: A2($elm$core$Basics$min, b1.fP, b2.fP)
		};
	});
var $ianmackenzie$elm_geometry$BoundingBox3d$withDimensions = F2(
	function (givenDimensions, givenCenterPoint) {
		var _v0 = givenCenterPoint;
		var x = _v0.cF;
		var y = _v0.cG;
		var z = _v0.cH;
		var _v1 = givenDimensions;
		var dx = _v1.a;
		var dy = _v1.b;
		var dz = _v1.c;
		var halfDx = $elm$core$Basics$abs(dx) / 2;
		var halfDy = $elm$core$Basics$abs(dy) / 2;
		var halfDz = $elm$core$Basics$abs(dz) / 2;
		return {fK: x + halfDx, fL: y + halfDy, fM: z + halfDz, fN: x - halfDx, fO: y - halfDy, fP: z - halfDz};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$updateViewBounds = F4(
	function (viewFrame, scale, modelBounds, current) {
		var originalCenter = modelBounds.g6;
		var modelZDimension = (2 * modelBounds.hO) * scale;
		var modelYDimension = (2 * modelBounds.hN) * scale;
		var modelXDimension = (2 * modelBounds.hM) * scale;
		var modelCenterZ = originalCenter.cH * scale;
		var modelCenterY = originalCenter.cG * scale;
		var modelCenterX = originalCenter.cF * scale;
		var k = $ianmackenzie$elm_geometry$Direction3d$unwrap(
			$ianmackenzie$elm_geometry$Frame3d$zDirection(viewFrame));
		var zDimension = ($elm$core$Basics$abs(modelXDimension * k.cF) + $elm$core$Basics$abs(modelYDimension * k.cG)) + $elm$core$Basics$abs(modelZDimension * k.cH);
		var j = $ianmackenzie$elm_geometry$Direction3d$unwrap(
			$ianmackenzie$elm_geometry$Frame3d$yDirection(viewFrame));
		var yDimension = ($elm$core$Basics$abs(modelXDimension * j.cF) + $elm$core$Basics$abs(modelYDimension * j.cG)) + $elm$core$Basics$abs(modelZDimension * j.cH);
		var i = $ianmackenzie$elm_geometry$Direction3d$unwrap(
			$ianmackenzie$elm_geometry$Frame3d$xDirection(viewFrame));
		var xDimension = ($elm$core$Basics$abs(modelXDimension * i.cF) + $elm$core$Basics$abs(modelYDimension * i.cG)) + $elm$core$Basics$abs(modelZDimension * i.cH);
		var nodeBounds = A2(
			$ianmackenzie$elm_geometry$BoundingBox3d$withDimensions,
			_Utils_Tuple3(xDimension, yDimension, zDimension),
			A2(
				$ianmackenzie$elm_geometry$Point3d$relativeTo,
				viewFrame,
				A3($ianmackenzie$elm_geometry$Point3d$meters, modelCenterX, modelCenterY, modelCenterZ)));
		if (!current.$) {
			var currentBounds = current.a;
			return $elm$core$Maybe$Just(
				A2($ianmackenzie$elm_geometry$BoundingBox3d$union, currentBounds, nodeBounds));
		} else {
			return $elm$core$Maybe$Just(nodeBounds);
		}
	});
var $ianmackenzie$elm_3d_scene$Scene3d$getViewBounds = F4(
	function (viewFrame, scale, current, nodes) {
		getViewBounds:
		while (true) {
			if (nodes.b) {
				var first = nodes.a;
				var rest = nodes.b;
				switch (first.$) {
					case 0:
						var $temp$viewFrame = viewFrame,
							$temp$scale = scale,
							$temp$current = current,
							$temp$nodes = rest;
						viewFrame = $temp$viewFrame;
						scale = $temp$scale;
						current = $temp$current;
						nodes = $temp$nodes;
						continue getViewBounds;
					case 1:
						var modelBounds = first.a;
						var updated = A4($ianmackenzie$elm_3d_scene$Scene3d$updateViewBounds, viewFrame, scale, modelBounds, current);
						var $temp$viewFrame = viewFrame,
							$temp$scale = scale,
							$temp$current = updated,
							$temp$nodes = rest;
						viewFrame = $temp$viewFrame;
						scale = $temp$scale;
						current = $temp$current;
						nodes = $temp$nodes;
						continue getViewBounds;
					case 2:
						var modelBounds = first.a;
						var updated = A4($ianmackenzie$elm_3d_scene$Scene3d$updateViewBounds, viewFrame, scale, modelBounds, current);
						var $temp$viewFrame = viewFrame,
							$temp$scale = scale,
							$temp$current = updated,
							$temp$nodes = rest;
						viewFrame = $temp$viewFrame;
						scale = $temp$scale;
						current = $temp$current;
						nodes = $temp$nodes;
						continue getViewBounds;
					case 3:
						var $temp$viewFrame = viewFrame,
							$temp$scale = scale,
							$temp$current = current,
							$temp$nodes = rest;
						viewFrame = $temp$viewFrame;
						scale = $temp$scale;
						current = $temp$current;
						nodes = $temp$nodes;
						continue getViewBounds;
					case 4:
						var modelBounds = first.a;
						var updated = A4($ianmackenzie$elm_3d_scene$Scene3d$updateViewBounds, viewFrame, scale, modelBounds, current);
						var $temp$viewFrame = viewFrame,
							$temp$scale = scale,
							$temp$current = updated,
							$temp$nodes = rest;
						viewFrame = $temp$viewFrame;
						scale = $temp$scale;
						current = $temp$current;
						nodes = $temp$nodes;
						continue getViewBounds;
					case 5:
						var childNodes = first.a;
						var $temp$viewFrame = viewFrame,
							$temp$scale = scale,
							$temp$current = A4($ianmackenzie$elm_3d_scene$Scene3d$getViewBounds, viewFrame, scale, current, childNodes),
							$temp$nodes = rest;
						viewFrame = $temp$viewFrame;
						scale = $temp$scale;
						current = $temp$current;
						nodes = $temp$nodes;
						continue getViewBounds;
					default:
						var transformation = first.a;
						var childNode = first.b;
						var localViewFrame = A2(
							$ianmackenzie$elm_geometry$Frame3d$relativeTo,
							$ianmackenzie$elm_3d_scene$Scene3d$Transformation$placementFrame(transformation),
							viewFrame);
						var localScale = scale * transformation.dx;
						var $temp$viewFrame = viewFrame,
							$temp$scale = scale,
							$temp$current = A4(
							$ianmackenzie$elm_3d_scene$Scene3d$getViewBounds,
							localViewFrame,
							localScale,
							current,
							_List_fromArray(
								[childNode])),
							$temp$nodes = rest;
						viewFrame = $temp$viewFrame;
						scale = $temp$scale;
						current = $temp$current;
						nodes = $temp$nodes;
						continue getViewBounds;
				}
			} else {
				return current;
			}
		}
	});
var $elm_explorations$linear_algebra$Math$Vector4$getX = _MJS_v4getX;
var $elm_explorations$linear_algebra$Math$Vector4$getY = _MJS_v4getY;
var $elm_explorations$linear_algebra$Math$Vector4$getZ = _MJS_v4getZ;
var $ianmackenzie$elm_3d_scene$Scene3d$Transformation$identity = {fn: true, x: 1, y: 0, z: 0, A: 0, B: 1, C: 0, D: 0, E: 0, F: 1, T: 0, U: 0, V: 0, dx: 1};
var $ianmackenzie$elm_3d_scene$Scene3d$initStencil = $ianmackenzie$elm_3d_scene$Scene3d$updateStencil(
	{cg: $elm_explorations$webgl$WebGL$Settings$StencilTest$replace, d0: 0, en: $ianmackenzie$elm_3d_scene$Scene3d$initialStencilCount, cx: $elm_explorations$webgl$WebGL$Settings$StencilTest$always, eE: 255, cI: $elm_explorations$webgl$WebGL$Settings$StencilTest$replace, cJ: $elm_explorations$webgl$WebGL$Settings$StencilTest$replace});
var $ianmackenzie$elm_3d_scene$Scene3d$Types$Light = $elm$core$Basics$identity;
var $ianmackenzie$elm_3d_scene$Scene3d$Light$disabled = {cO: 0, g4: false, c$: 0, ej: 0, ds: 0, jf: 0, cF: 0, cG: 0, cH: 0};
var $ianmackenzie$elm_3d_scene$Scene3d$lightPair = F2(
	function (_v0, _v1) {
		var first = _v0;
		var second = _v1;
		return $elm_explorations$linear_algebra$Math$Matrix4$fromRecord(
			{h8: first.cF, h9: first.ds, ia: second.cF, fB: second.ds, ib: first.cG, ic: first.c$, id: second.cG, fC: second.c$, ie: first.cH, $8: first.cO, ig: second.cH, fD: second.cO, fE: first.jf, fF: first.ej, fG: second.jf, fH: second.ej});
	});
var $ianmackenzie$elm_3d_scene$Scene3d$lightingDisabled = _Utils_Tuple2(
	{
		cp: A2($ianmackenzie$elm_3d_scene$Scene3d$lightPair, $ianmackenzie$elm_3d_scene$Scene3d$Light$disabled, $ianmackenzie$elm_3d_scene$Scene3d$Light$disabled),
		c6: A2($ianmackenzie$elm_3d_scene$Scene3d$lightPair, $ianmackenzie$elm_3d_scene$Scene3d$Light$disabled, $ianmackenzie$elm_3d_scene$Scene3d$Light$disabled),
		c7: A2($ianmackenzie$elm_3d_scene$Scene3d$lightPair, $ianmackenzie$elm_3d_scene$Scene3d$Light$disabled, $ianmackenzie$elm_3d_scene$Scene3d$Light$disabled),
		c8: A2($ianmackenzie$elm_3d_scene$Scene3d$lightPair, $ianmackenzie$elm_3d_scene$Scene3d$Light$disabled, $ianmackenzie$elm_3d_scene$Scene3d$Light$disabled)
	},
	A4($elm_explorations$linear_algebra$Math$Vector4$vec4, 0, 0, 0, 0));
var $ianmackenzie$elm_3d_camera$Camera3d$focalDistance = function (_v0) {
	var camera = _v0;
	return camera.bx;
};
var $ianmackenzie$elm_3d_camera$Camera3d$fovAngle = function (_v0) {
	var camera = _v0;
	return camera.e8;
};
var $ianmackenzie$elm_units$Quantity$half = function (_v0) {
	var value = _v0;
	return 0.5 * value;
};
var $elm$core$Basics$tan = _Basics_tan;
var $ianmackenzie$elm_units$Angle$tan = function (_v0) {
	var angle = _v0;
	return $elm$core$Basics$tan(angle);
};
var $ianmackenzie$elm_3d_camera$Camera3d$frustumSlope = function (camera) {
	return $ianmackenzie$elm_units$Angle$tan(
		$ianmackenzie$elm_units$Quantity$half(
			$ianmackenzie$elm_3d_camera$Camera3d$fovAngle(camera)));
};
var $ianmackenzie$elm_units$Quantity$twice = function (_v0) {
	var value = _v0;
	return 2 * value;
};
var $ianmackenzie$elm_3d_camera$Camera3d$fovHeight = function (camera) {
	return $ianmackenzie$elm_units$Quantity$twice(
		A2(
			$ianmackenzie$elm_units$Quantity$multiplyBy,
			$ianmackenzie$elm_3d_camera$Camera3d$frustumSlope(camera),
			$ianmackenzie$elm_3d_camera$Camera3d$focalDistance(camera)));
};
var $ianmackenzie$elm_3d_camera$Camera3d$projection = function (_v0) {
	var camera = _v0;
	return camera.gc;
};
var $ianmackenzie$elm_3d_camera$WebGL$Matrices$projectionMatrix = F2(
	function (camera, _v0) {
		var nearClipDepth = _v0.$9;
		var farClipDepth = _v0.hE;
		var aspectRatio = _v0.gO;
		var frustumSlope = $ianmackenzie$elm_3d_camera$Camera3d$frustumSlope(camera);
		var _v1 = $ianmackenzie$elm_units$Quantity$abs(nearClipDepth);
		var n = _v1;
		var _v2 = $ianmackenzie$elm_units$Quantity$abs(farClipDepth);
		var f = _v2;
		var _v3 = $ianmackenzie$elm_3d_camera$Camera3d$projection(camera);
		if (!_v3) {
			return $elm$core$Basics$isInfinite(f) ? $elm_explorations$linear_algebra$Math$Matrix4$fromRecord(
				{h8: 1 / (aspectRatio * frustumSlope), h9: 0, ia: 0, fB: 0, ib: 0, ic: 1 / frustumSlope, id: 0, fC: 0, ie: 0, $8: 0, ig: -1, fD: (-2) * n, fE: 0, fF: 0, fG: -1, fH: 0}) : $elm_explorations$linear_algebra$Math$Matrix4$fromRecord(
				{h8: 1 / (aspectRatio * frustumSlope), h9: 0, ia: 0, fB: 0, ib: 0, ic: 1 / frustumSlope, id: 0, fC: 0, ie: 0, $8: 0, ig: (-(f + n)) / (f - n), fD: (((-2) * f) * n) / (f - n), fE: 0, fF: 0, fG: -1, fH: 0});
		} else {
			var _v4 = $ianmackenzie$elm_3d_camera$Camera3d$fovHeight(camera);
			var h = _v4;
			return $elm$core$Basics$isInfinite(f) ? $elm_explorations$linear_algebra$Math$Matrix4$fromRecord(
				{h8: 2 / (aspectRatio * h), h9: 0, ia: 0, fB: 0, ib: 0, ic: 2 / h, id: 0, fC: 0, ie: 0, $8: 0, ig: 0, fD: -1, fE: 0, fF: 0, fG: 0, fH: 1}) : $elm_explorations$linear_algebra$Math$Matrix4$fromRecord(
				{h8: 2 / (aspectRatio * h), h9: 0, ia: 0, fB: 0, ib: 0, ic: 2 / h, id: 0, fC: 0, ie: 0, $8: 0, ig: (-2) / (f - n), fD: (-(f + n)) / (f - n), fE: 0, fF: 0, fG: 0, fH: 1});
		}
	});
var $ianmackenzie$elm_3d_scene$Scene3d$drawInsideStencil = function (lightMask) {
	return A2(
		$elm$core$List$cons,
		$elm_explorations$webgl$WebGL$Settings$DepthTest$lessOrEqual(
			{at: 1, au: 0, aC: true}),
		A2(
			$elm$core$List$cons,
			$elm_explorations$webgl$WebGL$Settings$StencilTest$test(
				{cg: $elm_explorations$webgl$WebGL$Settings$StencilTest$keep, d0: $ianmackenzie$elm_3d_scene$Scene3d$upperFourBits, en: lightMask, cx: $elm_explorations$webgl$WebGL$Settings$StencilTest$equal, eE: 0, cI: $elm_explorations$webgl$WebGL$Settings$StencilTest$keep, cJ: $elm_explorations$webgl$WebGL$Settings$StencilTest$keep}),
			$ianmackenzie$elm_3d_scene$Scene3d$blendSettings));
};
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $ianmackenzie$elm_3d_scene$Scene3d$enabledFlag = F2(
	function (lightMask, lightIndex) {
		return ((1 & (lightMask >> lightIndex)) === 1) ? 0 : 1;
	});
var $ianmackenzie$elm_3d_scene$Scene3d$renderWithinShadows = F3(
	function (meshRenderPasses, lightMatrices, numShadowingLights) {
		return $elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (lightMask) {
					var stencilMask = lightMask << 4;
					var enabledLights = A4(
						$elm_explorations$linear_algebra$Math$Vector4$vec4,
						A2($ianmackenzie$elm_3d_scene$Scene3d$enabledFlag, lightMask, 0),
						A2($ianmackenzie$elm_3d_scene$Scene3d$enabledFlag, lightMask, 1),
						A2($ianmackenzie$elm_3d_scene$Scene3d$enabledFlag, lightMask, 2),
						A2($ianmackenzie$elm_3d_scene$Scene3d$enabledFlag, lightMask, 3));
					return A3(
						$ianmackenzie$elm_3d_scene$Scene3d$call,
						meshRenderPasses,
						_Utils_Tuple2(lightMatrices, enabledLights),
						$ianmackenzie$elm_3d_scene$Scene3d$drawInsideStencil(stencilMask));
				},
				A2(
					$elm$core$List$range,
					1,
					A2($elm$core$Basics$pow, 2, numShadowingLights) - 1)));
	});
var $elm_explorations$linear_algebra$Math$Matrix4$toRecord = _MJS_m4x4toRecord;
var $ianmackenzie$elm_geometry_linear_algebra_interop$Geometry$Interop$LinearAlgebra$Frame3d$toMat4 = function (frame) {
	var p = $ianmackenzie$elm_geometry$Point3d$unwrap(
		$ianmackenzie$elm_geometry$Frame3d$originPoint(frame));
	var k = $ianmackenzie$elm_geometry$Direction3d$unwrap(
		$ianmackenzie$elm_geometry$Frame3d$zDirection(frame));
	var j = $ianmackenzie$elm_geometry$Direction3d$unwrap(
		$ianmackenzie$elm_geometry$Frame3d$yDirection(frame));
	var i = $ianmackenzie$elm_geometry$Direction3d$unwrap(
		$ianmackenzie$elm_geometry$Frame3d$xDirection(frame));
	return $elm_explorations$linear_algebra$Math$Matrix4$fromRecord(
		{h8: i.cF, h9: j.cF, ia: k.cF, fB: p.cF, ib: i.cG, ic: j.cG, id: k.cG, fC: p.cG, ie: i.cH, $8: j.cH, ig: k.cH, fD: p.cH, fE: 0, fF: 0, fG: 0, fH: 1});
};
var $ianmackenzie$elm_3d_camera$WebGL$Matrices$modelViewMatrix = F2(
	function (modelFrame, camera) {
		return $ianmackenzie$elm_geometry_linear_algebra_interop$Geometry$Interop$LinearAlgebra$Frame3d$toMat4(
			A2(
				$ianmackenzie$elm_geometry$Frame3d$relativeTo,
				$ianmackenzie$elm_3d_camera$Camera3d$frame(camera),
				modelFrame));
	});
var $ianmackenzie$elm_3d_camera$WebGL$Matrices$viewMatrix = function (camera) {
	return A2($ianmackenzie$elm_3d_camera$WebGL$Matrices$modelViewMatrix, $ianmackenzie$elm_geometry$Frame3d$atOrigin, camera);
};
var $ianmackenzie$elm_3d_scene$Scene3d$writeDepth = _List_fromArray(
	[
		$elm_explorations$webgl$WebGL$Settings$DepthTest$default,
		A4($elm_explorations$webgl$WebGL$Settings$colorMask, false, false, false, false)
	]);
var $ianmackenzie$elm_3d_scene$Scene3d$toWebGLEntities = function (_arguments) {
	var cameraFrame = $ianmackenzie$elm_3d_camera$Camera3d$frame(_arguments.g3);
	var _v0 = $ianmackenzie$elm_3d_scene$Scene3d$Entity$group(_arguments.hw);
	var rootNode = _v0;
	var _v1 = A4(
		$ianmackenzie$elm_3d_scene$Scene3d$getViewBounds,
		cameraFrame,
		1,
		$elm$core$Maybe$Nothing,
		_List_fromArray(
			[rootNode]));
	if (_v1.$ === 1) {
		return _List_Nil;
	} else {
		var viewBounds = _v1.a;
		var viewMatrix = $ianmackenzie$elm_3d_camera$WebGL$Matrices$viewMatrix(_arguments.g3);
		var _v2 = function () {
			var _v3 = _arguments.jc;
			switch (_v3.$) {
				case 0:
					return _Utils_Tuple2(0, 0);
				case 1:
					return _Utils_Tuple2(1, 0);
				case 2:
					return _Utils_Tuple2(2, 0);
				case 3:
					var overexposureLimit = _v3.a;
					return _Utils_Tuple2(3, overexposureLimit);
				case 4:
					var overexposureLimit = _v3.a;
					return _Utils_Tuple2(4, overexposureLimit);
				default:
					return _Utils_Tuple2(5, 0);
			}
		}();
		var toneMapType = _v2.a;
		var toneMapParam = _v2.b;
		var _v4 = A2($ianmackenzie$elm_3d_scene$Scene3d$computeClipDepths, _arguments.hd, viewBounds);
		var nearClipDepth = _v4.a;
		var farClipDepth = _v4.b;
		var projectionMatrix = A2(
			$ianmackenzie$elm_3d_camera$WebGL$Matrices$projectionMatrix,
			_arguments.g3,
			{gO: _arguments.gO, hE: farClipDepth, $9: nearClipDepth});
		var projectionType = $elm_explorations$linear_algebra$Math$Matrix4$toRecord(projectionMatrix).fH;
		var eyePointOrDirectionToCamera = (!projectionType) ? $ianmackenzie$elm_geometry$Point3d$toMeters(
			$ianmackenzie$elm_3d_camera$Camera3d$eyePoint(_arguments.g3)) : $ianmackenzie$elm_geometry$Direction3d$unwrap(
			$ianmackenzie$elm_geometry$Frame3d$zDirection(cameraFrame));
		var _v5 = _arguments.hA;
		var exposureLuminance = _v5;
		var _v6 = A2($ianmackenzie$elm_3d_scene$Scene3d$ColorConversions$chromaticityToLinearRgb, exposureLuminance, _arguments.jl);
		var referenceWhite = _v6;
		var sceneProperties = $elm_explorations$linear_algebra$Math$Matrix4$fromRecord(
			{
				h8: 0,
				h9: eyePointOrDirectionToCamera.cF,
				ia: $elm_explorations$linear_algebra$Math$Vector4$getX(referenceWhite),
				fB: _arguments.gt,
				ib: 0,
				ic: eyePointOrDirectionToCamera.cG,
				id: $elm_explorations$linear_algebra$Math$Vector4$getY(referenceWhite),
				fC: $ianmackenzie$elm_units$Length$inMeters(
					$ianmackenzie$elm_3d_scene$Scene3d$sceneDiameter(viewBounds)),
				ie: 0,
				$8: eyePointOrDirectionToCamera.cH,
				ig: $elm_explorations$linear_algebra$Math$Vector4$getZ(referenceWhite),
				fD: toneMapType,
				fE: 0,
				fF: projectionType,
				fG: 0,
				fH: toneMapParam
			});
		var renderPasses = A6(
			$ianmackenzie$elm_3d_scene$Scene3d$collectRenderPasses,
			sceneProperties,
			viewMatrix,
			projectionMatrix,
			$ianmackenzie$elm_3d_scene$Scene3d$Transformation$identity,
			rootNode,
			{Q: _List_Nil, f7: _List_Nil, ac: _List_Nil, o: _List_Nil});
		var _v7 = _arguments.h6;
		switch (_v7.$) {
			case 0:
				var lightMatrices = _v7.a;
				return $elm$core$List$concat(
					_List_fromArray(
						[
							A3(
							$ianmackenzie$elm_3d_scene$Scene3d$call,
							renderPasses.Q,
							_Utils_Tuple2(lightMatrices, $ianmackenzie$elm_3d_scene$Scene3d$allLightsEnabled),
							$ianmackenzie$elm_3d_scene$Scene3d$drawNormally),
							A3(
							$ianmackenzie$elm_3d_scene$Scene3d$call,
							renderPasses.o,
							_Utils_Tuple2(lightMatrices, $ianmackenzie$elm_3d_scene$Scene3d$allLightsEnabled),
							A2($elm$core$List$cons, $ianmackenzie$elm_3d_scene$Scene3d$Entity$cullFrontFaceSetting, $ianmackenzie$elm_3d_scene$Scene3d$writeDepth)),
							A3(
							$ianmackenzie$elm_3d_scene$Scene3d$call,
							renderPasses.o,
							_Utils_Tuple2(lightMatrices, $ianmackenzie$elm_3d_scene$Scene3d$allLightsEnabled),
							A2($elm$core$List$cons, $ianmackenzie$elm_3d_scene$Scene3d$Entity$cullFrontFaceSetting, $ianmackenzie$elm_3d_scene$Scene3d$drawWhereDepthTestEqual)),
							A3(
							$ianmackenzie$elm_3d_scene$Scene3d$call,
							renderPasses.o,
							_Utils_Tuple2(lightMatrices, $ianmackenzie$elm_3d_scene$Scene3d$allLightsEnabled),
							A2($elm$core$List$cons, $ianmackenzie$elm_3d_scene$Scene3d$Entity$cullBackFaceSetting, $ianmackenzie$elm_3d_scene$Scene3d$writeDepth)),
							A3(
							$ianmackenzie$elm_3d_scene$Scene3d$call,
							renderPasses.o,
							_Utils_Tuple2(lightMatrices, $ianmackenzie$elm_3d_scene$Scene3d$allLightsEnabled),
							A2($elm$core$List$cons, $ianmackenzie$elm_3d_scene$Scene3d$Entity$cullBackFaceSetting, $ianmackenzie$elm_3d_scene$Scene3d$drawWhereDepthTestEqual)),
							A3($ianmackenzie$elm_3d_scene$Scene3d$call, renderPasses.f7, $ianmackenzie$elm_3d_scene$Scene3d$lightingDisabled, $ianmackenzie$elm_3d_scene$Scene3d$drawNormally)
						]));
			case 1:
				var lightMatrices = _v7.a;
				return $elm$core$List$concat(
					_List_fromArray(
						[
							A3($ianmackenzie$elm_3d_scene$Scene3d$call, renderPasses.Q, $ianmackenzie$elm_3d_scene$Scene3d$lightingDisabled, $ianmackenzie$elm_3d_scene$Scene3d$drawNormally),
							_List_fromArray(
							[$ianmackenzie$elm_3d_scene$Scene3d$initStencil]),
							A3($ianmackenzie$elm_3d_scene$Scene3d$call, renderPasses.ac, lightMatrices.cp, $ianmackenzie$elm_3d_scene$Scene3d$createShadowStencil),
							_List_fromArray(
							[
								$ianmackenzie$elm_3d_scene$Scene3d$storeStencilValue(0)
							]),
							A3(
							$ianmackenzie$elm_3d_scene$Scene3d$call,
							renderPasses.Q,
							_Utils_Tuple2(lightMatrices, $ianmackenzie$elm_3d_scene$Scene3d$allLightsEnabled),
							$ianmackenzie$elm_3d_scene$Scene3d$drawOutsideStencil),
							A3(
							$ianmackenzie$elm_3d_scene$Scene3d$call,
							renderPasses.o,
							_Utils_Tuple2(lightMatrices, $ianmackenzie$elm_3d_scene$Scene3d$allLightsEnabled),
							A2($elm$core$List$cons, $ianmackenzie$elm_3d_scene$Scene3d$Entity$cullFrontFaceSetting, $ianmackenzie$elm_3d_scene$Scene3d$writeDepth)),
							A3(
							$ianmackenzie$elm_3d_scene$Scene3d$call,
							renderPasses.o,
							_Utils_Tuple2(lightMatrices, $ianmackenzie$elm_3d_scene$Scene3d$allLightsEnabled),
							A2($elm$core$List$cons, $ianmackenzie$elm_3d_scene$Scene3d$Entity$cullFrontFaceSetting, $ianmackenzie$elm_3d_scene$Scene3d$drawWhereDepthTestEqual)),
							A3(
							$ianmackenzie$elm_3d_scene$Scene3d$call,
							renderPasses.o,
							_Utils_Tuple2(lightMatrices, $ianmackenzie$elm_3d_scene$Scene3d$allLightsEnabled),
							A2($elm$core$List$cons, $ianmackenzie$elm_3d_scene$Scene3d$Entity$cullBackFaceSetting, $ianmackenzie$elm_3d_scene$Scene3d$writeDepth)),
							A3(
							$ianmackenzie$elm_3d_scene$Scene3d$call,
							renderPasses.o,
							_Utils_Tuple2(lightMatrices, $ianmackenzie$elm_3d_scene$Scene3d$allLightsEnabled),
							A2($elm$core$List$cons, $ianmackenzie$elm_3d_scene$Scene3d$Entity$cullBackFaceSetting, $ianmackenzie$elm_3d_scene$Scene3d$drawWhereDepthTestEqual)),
							A3($ianmackenzie$elm_3d_scene$Scene3d$call, renderPasses.f7, $ianmackenzie$elm_3d_scene$Scene3d$lightingDisabled, $ianmackenzie$elm_3d_scene$Scene3d$drawNormally)
						]));
			default:
				var shadowCasters = _v7.a;
				var allLightMatrices = _v7.b;
				return $elm$core$List$concat(
					_List_fromArray(
						[
							A3(
							$ianmackenzie$elm_3d_scene$Scene3d$call,
							renderPasses.Q,
							_Utils_Tuple2(allLightMatrices, $ianmackenzie$elm_3d_scene$Scene3d$allLightsEnabled),
							$ianmackenzie$elm_3d_scene$Scene3d$drawNormally),
							_List_fromArray(
							[$ianmackenzie$elm_3d_scene$Scene3d$initStencil]),
							A2($ianmackenzie$elm_3d_scene$Scene3d$createShadows, renderPasses.ac, shadowCasters),
							A3(
							$ianmackenzie$elm_3d_scene$Scene3d$renderWithinShadows,
							renderPasses.Q,
							allLightMatrices,
							$elm$core$List$length(shadowCasters)),
							A3(
							$ianmackenzie$elm_3d_scene$Scene3d$call,
							renderPasses.o,
							_Utils_Tuple2(allLightMatrices, $ianmackenzie$elm_3d_scene$Scene3d$allLightsEnabled),
							A2($elm$core$List$cons, $ianmackenzie$elm_3d_scene$Scene3d$Entity$cullFrontFaceSetting, $ianmackenzie$elm_3d_scene$Scene3d$writeDepth)),
							A3(
							$ianmackenzie$elm_3d_scene$Scene3d$call,
							renderPasses.o,
							_Utils_Tuple2(allLightMatrices, $ianmackenzie$elm_3d_scene$Scene3d$allLightsEnabled),
							A2($elm$core$List$cons, $ianmackenzie$elm_3d_scene$Scene3d$Entity$cullFrontFaceSetting, $ianmackenzie$elm_3d_scene$Scene3d$drawWhereDepthTestEqual)),
							A3(
							$ianmackenzie$elm_3d_scene$Scene3d$call,
							renderPasses.o,
							_Utils_Tuple2(allLightMatrices, $ianmackenzie$elm_3d_scene$Scene3d$allLightsEnabled),
							A2($elm$core$List$cons, $ianmackenzie$elm_3d_scene$Scene3d$Entity$cullBackFaceSetting, $ianmackenzie$elm_3d_scene$Scene3d$writeDepth)),
							A3(
							$ianmackenzie$elm_3d_scene$Scene3d$call,
							renderPasses.o,
							_Utils_Tuple2(allLightMatrices, $ianmackenzie$elm_3d_scene$Scene3d$allLightsEnabled),
							A2($elm$core$List$cons, $ianmackenzie$elm_3d_scene$Scene3d$Entity$cullBackFaceSetting, $ianmackenzie$elm_3d_scene$Scene3d$drawWhereDepthTestEqual)),
							A3($ianmackenzie$elm_3d_scene$Scene3d$call, renderPasses.f7, $ianmackenzie$elm_3d_scene$Scene3d$lightingDisabled, $ianmackenzie$elm_3d_scene$Scene3d$drawNormally)
						]));
		}
	}
};
var $elm$html$Html$Attributes$width = function (n) {
	return A2(
		_VirtualDom_attribute,
		'width',
		$elm$core$String$fromInt(n));
};
var $ianmackenzie$elm_3d_scene$Scene3d$composite = F2(
	function (_arguments, scenes) {
		var commonWebGLOptions = _List_fromArray(
			[
				$elm_explorations$webgl$WebGL$depth(1),
				$elm_explorations$webgl$WebGL$stencil(0),
				$elm_explorations$webgl$WebGL$alpha(true),
				A4($elm_explorations$webgl$WebGL$clearColor, 0, 0, 0, 0)
			]);
		var _v0 = function () {
			var _v1 = _arguments.gM;
			switch (_v1.$) {
				case 0:
					return _Utils_Tuple3(commonWebGLOptions, '0', 1);
				case 1:
					return _Utils_Tuple3(
						A2($elm$core$List$cons, $elm_explorations$webgl$WebGL$antialias, commonWebGLOptions),
						'1',
						1);
				default:
					var value = _v1.a;
					return _Utils_Tuple3(commonWebGLOptions, '0', value);
			}
		}();
		var webGLOptions = _v0.a;
		var key = _v0.b;
		var scalingFactor = _v0.c;
		var _v2 = _arguments.hq;
		var width = _v2.a;
		var height = _v2.b;
		var heightInPixels = $ianmackenzie$elm_units$Pixels$toInt(height);
		var heightCss = A2(
			$elm$html$Html$Attributes$style,
			'height',
			$elm$core$String$fromInt(heightInPixels) + 'px');
		var widthInPixels = $ianmackenzie$elm_units$Pixels$toInt(width);
		var aspectRatio = widthInPixels / heightInPixels;
		var webGLEntities = A2(
			$elm$core$List$concatMap,
			function (scene) {
				return $ianmackenzie$elm_3d_scene$Scene3d$toWebGLEntities(
					{gO: aspectRatio, g3: _arguments.g3, hd: _arguments.hd, hw: scene.hw, hA: scene.hA, h6: scene.h6, gt: scalingFactor, jc: scene.jc, jl: scene.jl});
			},
			scenes);
		var widthCss = A2(
			$elm$html$Html$Attributes$style,
			'width',
			$elm$core$String$fromInt(widthInPixels) + 'px');
		var _v3 = _arguments.gQ;
		var givenBackgroundColor = _v3;
		var backgroundColorString = $avh4$elm_color$Color$toCssString(givenBackgroundColor);
		return A3(
			$elm$html$Html$Keyed$node,
			'div',
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'padding', '0px'),
					widthCss,
					heightCss
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					key,
					A3(
						$elm_explorations$webgl$WebGL$toHtmlWith,
						webGLOptions,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$width(
								$elm$core$Basics$round(widthInPixels * scalingFactor)),
								$elm$html$Html$Attributes$height(
								$elm$core$Basics$round(heightInPixels * scalingFactor)),
								widthCss,
								heightCss,
								A2($elm$html$Html$Attributes$style, 'display', 'block'),
								A2($elm$html$Html$Attributes$style, 'background-color', backgroundColorString)
							]),
						webGLEntities))
				]));
	});
var $ianmackenzie$elm_3d_scene$Scene3d$custom = function (_arguments) {
	return A2(
		$ianmackenzie$elm_3d_scene$Scene3d$composite,
		{gM: _arguments.gM, gQ: _arguments.gQ, g3: _arguments.g3, hd: _arguments.hd, hq: _arguments.hq},
		_List_fromArray(
			[
				{hw: _arguments.hw, hA: _arguments.hA, h6: _arguments.h6, jc: _arguments.jc, jl: _arguments.jl}
			]));
};
var $ianmackenzie$elm_3d_scene$Scene3d$Light$daylight = $ianmackenzie$elm_3d_scene$Scene3d$Light$chromaticity(
	{cF: 0.31271, cG: 0.32902});
var $ianmackenzie$elm_3d_scene$Scene3d$Light$directional = F2(
	function (_v0, light) {
		var shadowFlag = _v0;
		var _v1 = $ianmackenzie$elm_geometry$Direction3d$unwrap(light.eW);
		var x = _v1.cF;
		var y = _v1.cG;
		var z = _v1.cH;
		var _v2 = A2($ianmackenzie$elm_3d_scene$Scene3d$ColorConversions$chromaticityToLinearRgb, light.c1, light.cS);
		var rgb = _v2;
		return {
			cO: $elm_explorations$linear_algebra$Math$Vector4$getZ(rgb),
			g4: shadowFlag,
			c$: $elm_explorations$linear_algebra$Math$Vector4$getY(rgb),
			ej: 0,
			ds: $elm_explorations$linear_algebra$Math$Vector4$getX(rgb),
			jf: 1,
			cF: -x,
			cG: -y,
			cH: -z
		};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$Exposure = $elm$core$Basics$identity;
var $ianmackenzie$elm_units$Luminance$nits = function (numNits) {
	return numNits;
};
var $ianmackenzie$elm_3d_scene$Scene3d$exposureValue = function (ev100) {
	return $ianmackenzie$elm_units$Luminance$nits(
		1.2 * A2($elm$core$Basics$pow, 2, ev100));
};
var $ianmackenzie$elm_3d_scene$Scene3d$MultiplePasses = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $ianmackenzie$elm_3d_scene$Scene3d$SingleUnshadowedPass = function (a) {
	return {$: 0, a: a};
};
var $ianmackenzie$elm_3d_scene$Scene3d$eraseLight = function (_v0) {
	var light = _v0;
	return light;
};
var $ianmackenzie$elm_3d_scene$Scene3d$lightCastsShadows = function (_v0) {
	var properties = _v0;
	return properties.g4;
};
var $ianmackenzie$elm_3d_scene$Scene3d$noLights = $ianmackenzie$elm_3d_scene$Scene3d$SingleUnshadowedPass($ianmackenzie$elm_3d_scene$Scene3d$lightingDisabled.a);
var $ianmackenzie$elm_3d_scene$Scene3d$singleLight = function (_v0) {
	var light = _v0;
	return $elm_explorations$linear_algebra$Math$Matrix4$fromRecord(
		{h8: light.cF, h9: light.ds, ia: 0, fB: 0, ib: light.cG, ic: light.c$, id: 0, fC: 0, ie: light.cH, $8: light.cO, ig: 0, fD: 0, fE: light.jf, fF: light.ej, fG: 0, fH: 0});
};
var $ianmackenzie$elm_3d_scene$Scene3d$eightLights = F8(
	function (first, second, third, fourth, fifth, sixth, seventh, eigth) {
		var _v0 = A2(
			$elm$core$List$partition,
			$ianmackenzie$elm_3d_scene$Scene3d$lightCastsShadows,
			_List_fromArray(
				[
					$ianmackenzie$elm_3d_scene$Scene3d$eraseLight(first),
					$ianmackenzie$elm_3d_scene$Scene3d$eraseLight(second),
					$ianmackenzie$elm_3d_scene$Scene3d$eraseLight(third),
					$ianmackenzie$elm_3d_scene$Scene3d$eraseLight(fourth)
				]));
		var enabledShadowCasters = _v0.a;
		var disabledShadowCasters = _v0.b;
		if (!enabledShadowCasters.b) {
			return $ianmackenzie$elm_3d_scene$Scene3d$SingleUnshadowedPass(
				{
					cp: A2($ianmackenzie$elm_3d_scene$Scene3d$lightPair, first, second),
					c6: A2($ianmackenzie$elm_3d_scene$Scene3d$lightPair, third, fourth),
					c7: A2($ianmackenzie$elm_3d_scene$Scene3d$lightPair, fifth, sixth),
					c8: A2($ianmackenzie$elm_3d_scene$Scene3d$lightPair, seventh, eigth)
				});
		} else {
			var sortedLights = _Utils_ap(enabledShadowCasters, disabledShadowCasters);
			if ((((sortedLights.b && sortedLights.b.b) && sortedLights.b.b.b) && sortedLights.b.b.b.b) && (!sortedLights.b.b.b.b.b)) {
				var light0 = sortedLights.a;
				var _v3 = sortedLights.b;
				var light1 = _v3.a;
				var _v4 = _v3.b;
				var light2 = _v4.a;
				var _v5 = _v4.b;
				var light3 = _v5.a;
				return A2(
					$ianmackenzie$elm_3d_scene$Scene3d$MultiplePasses,
					A2($elm$core$List$map, $ianmackenzie$elm_3d_scene$Scene3d$singleLight, enabledShadowCasters),
					{
						cp: A2($ianmackenzie$elm_3d_scene$Scene3d$lightPair, light0, light1),
						c6: A2($ianmackenzie$elm_3d_scene$Scene3d$lightPair, light2, light3),
						c7: A2($ianmackenzie$elm_3d_scene$Scene3d$lightPair, fifth, sixth),
						c8: A2($ianmackenzie$elm_3d_scene$Scene3d$lightPair, seventh, eigth)
					});
			} else {
				return $ianmackenzie$elm_3d_scene$Scene3d$noLights;
			}
		}
	});
var $ianmackenzie$elm_3d_scene$Scene3d$fourLights = F4(
	function (first, second, third, fourth) {
		return A8($ianmackenzie$elm_3d_scene$Scene3d$eightLights, first, second, third, fourth, $ianmackenzie$elm_3d_scene$Scene3d$Light$disabled, $ianmackenzie$elm_3d_scene$Scene3d$Light$disabled, $ianmackenzie$elm_3d_scene$Scene3d$Light$disabled, $ianmackenzie$elm_3d_scene$Scene3d$Light$disabled);
	});
var $elm$core$Basics$atan = _Basics_atan;
var $author$project$Game$Playing$targetHFovRadians = $elm$core$Basics$pi / 2;
var $author$project$Game$Playing$fovAngle = F2(
	function (viewWidth, viewHeight) {
		var aspectRatio = viewWidth / viewHeight;
		var vFovRad = 2 * $elm$core$Basics$atan(
			$elm$core$Basics$tan($author$project$Game$Playing$targetHFovRadians / 2) / aspectRatio);
		return $ianmackenzie$elm_units$Angle$radians(
			A3($elm$core$Basics$clamp, $elm$core$Basics$pi / 4, $elm$core$Basics$pi / 2, vFovRad));
	});
var $ianmackenzie$elm_3d_camera$Camera3d$Perspective = 0;
var $ianmackenzie$elm_3d_camera$Camera3d$Angle = function (a) {
	return {$: 0, a: a};
};
var $ianmackenzie$elm_3d_camera$Camera3d$angle = function (givenAngle) {
	return $ianmackenzie$elm_3d_camera$Camera3d$Angle(givenAngle);
};
var $ianmackenzie$elm_geometry$Point3d$distanceFrom = F2(
	function (_v0, _v1) {
		var p1 = _v0;
		var p2 = _v1;
		var deltaZ = p2.cH - p1.cH;
		var deltaY = p2.cG - p1.cG;
		var deltaX = p2.cF - p1.cF;
		var largestComponent = A2(
			$elm$core$Basics$max,
			$elm$core$Basics$abs(deltaX),
			A2(
				$elm$core$Basics$max,
				$elm$core$Basics$abs(deltaY),
				$elm$core$Basics$abs(deltaZ)));
		if (!largestComponent) {
			return $ianmackenzie$elm_units$Quantity$zero;
		} else {
			var scaledZ = deltaZ / largestComponent;
			var scaledY = deltaY / largestComponent;
			var scaledX = deltaX / largestComponent;
			var scaledLength = $elm$core$Basics$sqrt(((scaledX * scaledX) + (scaledY * scaledY)) + (scaledZ * scaledZ));
			return scaledLength * largestComponent;
		}
	});
var $ianmackenzie$elm_geometry$Vector3d$dot = F2(
	function (_v0, _v1) {
		var v2 = _v0;
		var v1 = _v1;
		return ((v1.cF * v2.cF) + (v1.cG * v2.cG)) + (v1.cH * v2.cH);
	});
var $ianmackenzie$elm_units$Quantity$greaterThan = F2(
	function (_v0, _v1) {
		var y = _v0;
		var x = _v1;
		return _Utils_cmp(x, y) > 0;
	});
var $ianmackenzie$elm_units$Quantity$lessThan = F2(
	function (_v0, _v1) {
		var y = _v0;
		var x = _v1;
		return _Utils_cmp(x, y) < 0;
	});
var $ianmackenzie$elm_geometry$Vector3d$minus = F2(
	function (_v0, _v1) {
		var v2 = _v0;
		var v1 = _v1;
		return {cF: v1.cF - v2.cF, cG: v1.cG - v2.cG, cH: v1.cH - v2.cH};
	});
var $ianmackenzie$elm_geometry$Vector3d$projectionIn = F2(
	function (_v0, _v1) {
		var d = _v0;
		var v = _v1;
		var projectedLength = ((v.cF * d.cF) + (v.cG * d.cG)) + (v.cH * d.cH);
		return {cF: d.cF * projectedLength, cG: d.cG * projectedLength, cH: d.cH * projectedLength};
	});
var $ianmackenzie$elm_geometry$Vector3d$reverse = function (_v0) {
	var v = _v0;
	return {cF: -v.cF, cG: -v.cG, cH: -v.cH};
};
var $ianmackenzie$elm_geometry$Direction3d$orthonormalize = F3(
	function (xVector, xyVector, xyzVector) {
		return A2(
			$elm$core$Maybe$andThen,
			function (xDirection) {
				var yVector = A2(
					$ianmackenzie$elm_geometry$Vector3d$minus,
					A2($ianmackenzie$elm_geometry$Vector3d$projectionIn, xDirection, xyVector),
					xyVector);
				return A2(
					$elm$core$Maybe$andThen,
					function (yDirection) {
						var rightHandedZVector = A2($ianmackenzie$elm_geometry$Vector3d$cross, xyVector, xVector);
						var tripleProduct = A2($ianmackenzie$elm_geometry$Vector3d$dot, xyzVector, rightHandedZVector);
						var zVector = A2($ianmackenzie$elm_units$Quantity$greaterThan, $ianmackenzie$elm_units$Quantity$zero, tripleProduct) ? rightHandedZVector : (A2($ianmackenzie$elm_units$Quantity$lessThan, $ianmackenzie$elm_units$Quantity$zero, tripleProduct) ? $ianmackenzie$elm_geometry$Vector3d$reverse(rightHandedZVector) : $ianmackenzie$elm_geometry$Vector3d$zero);
						return A2(
							$elm$core$Maybe$map,
							function (zDirection) {
								return _Utils_Tuple3(xDirection, yDirection, zDirection);
							},
							$ianmackenzie$elm_geometry$Vector3d$direction(zVector));
					},
					$ianmackenzie$elm_geometry$Vector3d$direction(yVector));
			},
			$ianmackenzie$elm_geometry$Vector3d$direction(xVector));
	});
var $ianmackenzie$elm_geometry$Direction3d$toVector = function (_v0) {
	var directionComponents = _v0;
	return directionComponents;
};
var $ianmackenzie$elm_geometry$Geometry$Types$SketchPlane3d = $elm$core$Basics$identity;
var $ianmackenzie$elm_geometry$SketchPlane3d$unsafe = $elm$core$Basics$identity;
var $ianmackenzie$elm_3d_camera$Camera3d$Camera3d = $elm$core$Basics$identity;
var $ianmackenzie$elm_units$Angle$atan2 = F2(
	function (_v0, _v1) {
		var y = _v0;
		var x = _v1;
		return A2($elm$core$Basics$atan2, y, x);
	});
var $ianmackenzie$elm_geometry$Unsafe$Direction3d$unsafeCrossProduct = F2(
	function (_v0, _v1) {
		var d1 = _v0;
		var d2 = _v1;
		return {cF: (d1.cG * d2.cH) - (d1.cH * d2.cG), cG: (d1.cH * d2.cF) - (d1.cF * d2.cH), cH: (d1.cF * d2.cG) - (d1.cG * d2.cF)};
	});
var $ianmackenzie$elm_geometry$SketchPlane3d$xDirection = function (_v0) {
	var properties = _v0;
	return properties.jr;
};
var $ianmackenzie$elm_geometry$SketchPlane3d$yDirection = function (_v0) {
	var properties = _v0;
	return properties.jv;
};
var $ianmackenzie$elm_geometry$SketchPlane3d$normalDirection = function (sketchPlane) {
	return A2(
		$ianmackenzie$elm_geometry$Unsafe$Direction3d$unsafeCrossProduct,
		$ianmackenzie$elm_geometry$SketchPlane3d$xDirection(sketchPlane),
		$ianmackenzie$elm_geometry$SketchPlane3d$yDirection(sketchPlane));
};
var $ianmackenzie$elm_geometry$SketchPlane3d$originPoint = function (_v0) {
	var properties = _v0;
	return properties.iE;
};
var $ianmackenzie$elm_geometry$SketchPlane3d$toFrame = function (sketchPlane) {
	return {
		iE: $ianmackenzie$elm_geometry$SketchPlane3d$originPoint(sketchPlane),
		jr: $ianmackenzie$elm_geometry$SketchPlane3d$xDirection(sketchPlane),
		jv: $ianmackenzie$elm_geometry$SketchPlane3d$yDirection(sketchPlane),
		jz: $ianmackenzie$elm_geometry$SketchPlane3d$normalDirection(sketchPlane)
	};
};
var $ianmackenzie$elm_3d_camera$Camera3d$with = function (given) {
	return {
		bx: given.bx,
		e8: function () {
			var _v0 = given.e7;
			if (!_v0.$) {
				var givenAngle = _v0.a;
				return givenAngle;
			} else {
				var givenHeight = _v0.a;
				return $ianmackenzie$elm_units$Quantity$twice(
					A2(
						$ianmackenzie$elm_units$Angle$atan2,
						$ianmackenzie$elm_units$Quantity$half(givenHeight),
						given.bx));
			}
		}(),
		fa: $ianmackenzie$elm_geometry$SketchPlane3d$toFrame(given.eC),
		gc: given.gc
	};
};
var $ianmackenzie$elm_geometry$SketchPlane3d$through = F2(
	function (givenOrigin, givenNormalDirection) {
		var _v0 = $ianmackenzie$elm_geometry$Direction3d$perpendicularBasis(givenNormalDirection);
		var computedXDirection = _v0.a;
		var computedYDirection = _v0.b;
		return $ianmackenzie$elm_geometry$SketchPlane3d$unsafe(
			{iE: givenOrigin, jr: computedXDirection, jv: computedYDirection});
	});
var $ianmackenzie$elm_geometry$SketchPlane3d$withNormalDirection = F2(
	function (givenNormalDirection, givenOrigin) {
		return A2($ianmackenzie$elm_geometry$SketchPlane3d$through, givenOrigin, givenNormalDirection);
	});
var $ianmackenzie$elm_3d_camera$Camera3d$lookAt = function (given) {
	var zVector = A2($ianmackenzie$elm_geometry$Vector3d$from, given.e6, given.e4);
	var yVector = $ianmackenzie$elm_geometry$Direction3d$toVector(given.gy);
	var xVector = A2($ianmackenzie$elm_geometry$Vector3d$cross, zVector, yVector);
	var computedViewPlane = function () {
		var _v0 = A3($ianmackenzie$elm_geometry$Direction3d$orthonormalize, zVector, yVector, xVector);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var normalizedZDirection = _v1.a;
			var normalizedYDirection = _v1.b;
			var normalizedXDirection = _v1.c;
			return $ianmackenzie$elm_geometry$SketchPlane3d$unsafe(
				{iE: given.e4, jr: normalizedXDirection, jv: normalizedYDirection});
		} else {
			var _v2 = $ianmackenzie$elm_geometry$Vector3d$direction(zVector);
			if (!_v2.$) {
				var zDirection = _v2.a;
				return A2($ianmackenzie$elm_geometry$SketchPlane3d$withNormalDirection, zDirection, given.e4);
			} else {
				var _v3 = $ianmackenzie$elm_geometry$Direction3d$perpendicularBasis(given.gy);
				var arbitraryZDirection = _v3.a;
				var arbitraryXDirection = _v3.b;
				return $ianmackenzie$elm_geometry$SketchPlane3d$unsafe(
					{iE: given.e4, jr: arbitraryXDirection, jv: given.gy});
			}
		}
	}();
	return $ianmackenzie$elm_3d_camera$Camera3d$with(
		{
			bx: A2($ianmackenzie$elm_geometry$Point3d$distanceFrom, given.e4, given.e6),
			e7: given.e7,
			gc: given.gc,
			eC: computedViewPlane
		});
};
var $author$project$Me$getCamera = F4(
	function (world, cameraXRotationAngle, cameraZRotationAngle, fov) {
		var _v0 = $author$project$Me$getInWorld(world);
		if (!_v0.$) {
			var me = _v0.a;
			var eyePoint = $author$project$Me$getEyePoint(me);
			var cameraAxis = A3($author$project$Me$getLookAxis, me, cameraXRotationAngle, cameraZRotationAngle);
			var focalPoint = A2(
				$ianmackenzie$elm_geometry$Point3d$along,
				cameraAxis,
				$ianmackenzie$elm_units$Length$meters(1));
			return $ianmackenzie$elm_3d_camera$Camera3d$lookAt(
				{
					e4: eyePoint,
					e6: focalPoint,
					e7: $ianmackenzie$elm_3d_camera$Camera3d$angle(fov),
					gc: 0,
					gy: $ianmackenzie$elm_geometry$Direction3d$positiveZ
				});
		} else {
			return $ianmackenzie$elm_3d_camera$Camera3d$lookAt(
				{
					e4: $ianmackenzie$elm_geometry$Point3d$origin,
					e6: A3($ianmackenzie$elm_geometry$Point3d$meters, 0, 1, 0),
					e7: $ianmackenzie$elm_3d_camera$Camera3d$angle(fov),
					gc: 0,
					gy: $ianmackenzie$elm_geometry$Direction3d$positiveZ
				});
		}
	});
var $ianmackenzie$elm_3d_scene$Scene3d$HableFilmicToneMapping = {$: 5};
var $ianmackenzie$elm_3d_scene$Scene3d$hableFilmicToneMapping = $ianmackenzie$elm_3d_scene$Scene3d$HableFilmicToneMapping;
var $author$project$Constants$Graphics$bulletRadiusCm = 5.0;
var $ianmackenzie$elm_3d_scene$Scene3d$Material$toVec4 = function (givenColor) {
	var _v0 = $avh4$elm_color$Color$toRgba(givenColor);
	var red = _v0.iM;
	var green = _v0.hK;
	var blue = _v0.gV;
	var alpha = _v0.eH;
	return A4($elm_explorations$linear_algebra$Math$Vector4$vec4, red, green, blue, alpha);
};
var $ianmackenzie$elm_3d_scene$Scene3d$Material$color = function (givenColor) {
	return A2(
		$ianmackenzie$elm_3d_scene$Scene3d$Types$UnlitMaterial,
		0,
		$ianmackenzie$elm_3d_scene$Scene3d$Types$Constant(
			$ianmackenzie$elm_3d_scene$Scene3d$Material$toVec4(givenColor)));
};
var $avh4$elm_color$Color$fromRgba = function (components) {
	return A4($avh4$elm_color$Color$RgbaSpace, components.iM, components.hK, components.gV, components.eH);
};
var $ianmackenzie$elm_3d_scene$Scene3d$bumpySphere = F2(
	function (givenMaterial, givenSphere) {
		return A4($ianmackenzie$elm_3d_scene$Scene3d$Entity$sphere, true, false, givenMaterial, givenSphere);
	});
var $ianmackenzie$elm_3d_scene$Scene3d$sphere = F2(
	function (givenMaterial, givenSphere) {
		return A2(
			$ianmackenzie$elm_3d_scene$Scene3d$bumpySphere,
			$ianmackenzie$elm_3d_scene$Scene3d$Material$textured(givenMaterial),
			givenSphere);
	});
var $author$project$Scene3d$Entity$Player$hitEffect = function (effect) {
	var ringAngles = _List_fromArray(
		[0, 60, 120, 180, 240, 300]);
	var progress = effect.aq / $author$project$HitEffect$maxAgeMs;
	var particleRadius = $ianmackenzie$elm_units$Length$centimeters($author$project$Constants$Graphics$bulletRadiusCm * (1 - (progress * 0.8)));
	var expandM = 0.6 * progress;
	var center = $ianmackenzie$elm_geometry$Point3d$toMeters(effect.f9);
	var _v0 = $avh4$elm_color$Color$toRgba(effect.he);
	var red = _v0.iM;
	var green = _v0.hK;
	var blue = _v0.gV;
	var material = $ianmackenzie$elm_3d_scene$Scene3d$Material$color(
		$avh4$elm_color$Color$fromRgba(
			{eH: 1 - progress, gV: blue, hK: green, iM: red}));
	var particle = function (angleDeg) {
		var radians = (angleDeg * $elm$core$Basics$pi) / 180;
		var pos = $ianmackenzie$elm_geometry$Point3d$fromMeters(
			{
				cF: center.cF + (expandM * $elm$core$Basics$cos(radians)),
				cG: center.cG + (expandM * $elm$core$Basics$sin(radians)),
				cH: center.cH + ((expandM * 0.3) * progress)
			});
		return A2(
			$ianmackenzie$elm_3d_scene$Scene3d$sphere,
			material,
			A2($ianmackenzie$elm_geometry$Sphere3d$atPoint, pos, particleRadius));
	};
	return $ianmackenzie$elm_3d_scene$Scene3d$group(
		A2($elm$core$List$map, particle, ringAngles));
};
var $ianmackenzie$elm_units$Pixels$int = function (numPixels) {
	return numPixels;
};
var $ianmackenzie$elm_units$Illuminance$lux = function (numLux) {
	return numLux;
};
var $ianmackenzie$elm_3d_scene$Scene3d$Multisampling = {$: 1};
var $ianmackenzie$elm_3d_scene$Scene3d$multisampling = $ianmackenzie$elm_3d_scene$Scene3d$Multisampling;
var $ianmackenzie$elm_3d_scene$Scene3d$Light$neverCastsShadows = false;
var $ianmackenzie$elm_units$Illuminance$inLux = function (_v0) {
	var numLux = _v0;
	return numLux;
};
var $ianmackenzie$elm_3d_scene$Scene3d$Light$soft = function (light) {
	soft:
	while (true) {
		if (_Utils_eq(light.hY, $ianmackenzie$elm_units$Quantity$zero) && _Utils_eq(light.hZ, $ianmackenzie$elm_units$Quantity$zero)) {
			return $ianmackenzie$elm_3d_scene$Scene3d$Light$disabled;
		} else {
			if (A2(
				$ianmackenzie$elm_units$Quantity$greaterThan,
				$ianmackenzie$elm_units$Quantity$abs(light.hY),
				$ianmackenzie$elm_units$Quantity$abs(light.hZ))) {
				var $temp$light = {
					cS: light.cS,
					hY: light.hZ,
					hZ: light.hY,
					gy: $ianmackenzie$elm_geometry$Direction3d$reverse(light.gy)
				};
				light = $temp$light;
				continue soft;
			} else {
				var nitsBelow = $elm$core$Basics$abs(
					$ianmackenzie$elm_units$Illuminance$inLux(light.hZ) / $elm$core$Basics$pi);
				var nitsAbove = $elm$core$Basics$abs(
					$ianmackenzie$elm_units$Illuminance$inLux(light.hY) / $elm$core$Basics$pi);
				var _v0 = $ianmackenzie$elm_geometry$Direction3d$unwrap(light.gy);
				var x = _v0.cF;
				var y = _v0.cG;
				var z = _v0.cH;
				var _v1 = A2(
					$ianmackenzie$elm_3d_scene$Scene3d$ColorConversions$chromaticityToLinearRgb,
					$ianmackenzie$elm_units$Quantity$float(1),
					light.cS);
				var rgb = _v1;
				return {
					cO: nitsAbove * $elm_explorations$linear_algebra$Math$Vector4$getZ(rgb),
					g4: false,
					c$: nitsAbove * $elm_explorations$linear_algebra$Math$Vector4$getY(rgb),
					ej: nitsBelow / nitsAbove,
					ds: nitsAbove * $elm_explorations$linear_algebra$Math$Vector4$getX(rgb),
					jf: 3,
					cF: x,
					cG: y,
					cH: z
				};
			}
		}
	}
};
var $ianmackenzie$elm_3d_scene$Scene3d$Light$overhead = function (_arguments) {
	return $ianmackenzie$elm_3d_scene$Scene3d$Light$soft(
		{cS: _arguments.cS, hY: _arguments.c1, hZ: $ianmackenzie$elm_units$Quantity$zero, gy: _arguments.gy});
};
var $author$project$Config$renderSizeScaleFactor = 1.0;
var $ianmackenzie$elm_units$Temperature$inKelvins = function (_v0) {
	var numKelvins = _v0;
	return numKelvins;
};
var $ianmackenzie$elm_3d_scene$Scene3d$Light$colorTemperature = function (temperature) {
	var t = A3(
		$elm$core$Basics$clamp,
		1667,
		25000,
		$ianmackenzie$elm_units$Temperature$inKelvins(temperature));
	var x = (t <= 4000) ? ((((((-0.2661239) * 1.0e9) / ((t * t) * t)) - ((0.2343589 * 1.0e6) / (t * t))) + ((0.8776956 * 1.0e3) / t)) + 0.17991) : ((((((-3.0258469) * 1.0e9) / ((t * t) * t)) + ((2.1070379 * 1.0e6) / (t * t))) + ((0.2226347 * 1.0e3) / t)) + 0.24039);
	var y = (t <= 2222) ? (((((-1.1063814) * ((x * x) * x)) - (1.3481102 * (x * x))) + (2.18555832 * x)) - 0.20219683) : ((t <= 4000) ? (((((-0.9549476) * ((x * x) * x)) - (1.37418593 * (x * x))) + (2.09137015 * x)) - 0.16748867) : ((((3.081758 * ((x * x) * x)) - (5.8733867 * (x * x))) + (3.75112997 * x)) - 0.37001483));
	return $ianmackenzie$elm_3d_scene$Scene3d$Light$chromaticity(
		{cF: x, cG: y});
};
var $ianmackenzie$elm_units$Temperature$Temperature = $elm$core$Basics$identity;
var $ianmackenzie$elm_units$Temperature$kelvins = function (numKelvins) {
	return numKelvins;
};
var $ianmackenzie$elm_3d_scene$Scene3d$Light$skylight = $ianmackenzie$elm_3d_scene$Scene3d$Light$colorTemperature(
	$ianmackenzie$elm_units$Temperature$kelvins(12000));
var $ianmackenzie$elm_3d_scene$Scene3d$Light$sunlight = $ianmackenzie$elm_3d_scene$Scene3d$Light$colorTemperature(
	$ianmackenzie$elm_units$Temperature$kelvins(5600));
var $author$project$Constants$Graphics$bulletEmissiveNits = 1500.0;
var $ianmackenzie$elm_3d_scene$Scene3d$ColorConversions$linearRgbToCieXyz = function (_v0) {
	var linearRgb = _v0;
	var linearR = $elm_explorations$linear_algebra$Math$Vector4$getX(linearRgb);
	var linearG = $elm_explorations$linear_algebra$Math$Vector4$getY(linearRgb);
	var linearB = $elm_explorations$linear_algebra$Math$Vector4$getZ(linearRgb);
	return A4(
		$ianmackenzie$elm_3d_scene$Scene3d$Types$CieXyz,
		((0.4124 * linearR) + (0.3576 * linearG)) + (0.1805 * linearB),
		((0.2126 * linearR) + (0.7152 * linearG)) + (0.0722 * linearB),
		((0.0193 * linearR) + (0.1192 * linearG)) + (0.9505 * linearB),
		$elm_explorations$linear_algebra$Math$Vector4$getW(linearRgb));
};
var $ianmackenzie$elm_3d_scene$Scene3d$ColorConversions$colorToCieXyz = function (color) {
	return $ianmackenzie$elm_3d_scene$Scene3d$ColorConversions$linearRgbToCieXyz(
		$ianmackenzie$elm_3d_scene$Scene3d$ColorConversions$colorToLinearRgb(color));
};
var $ianmackenzie$elm_3d_scene$Scene3d$Light$color = function (givenColor) {
	var _v0 = $ianmackenzie$elm_3d_scene$Scene3d$ColorConversions$colorToCieXyz(givenColor);
	var bigX = _v0.a;
	var bigY = _v0.b;
	var bigZ = _v0.c;
	var sum = (bigX + bigY) + bigZ;
	return $ianmackenzie$elm_3d_scene$Scene3d$Light$chromaticity(
		{cF: bigX / sum, cG: bigY / sum});
};
var $ianmackenzie$elm_3d_scene$Scene3d$Material$emissive = F2(
	function (givenChromaticity, brightness) {
		var baseColor = A2(
			$ianmackenzie$elm_3d_scene$Scene3d$ColorConversions$chromaticityToLinearRgb,
			$ianmackenzie$elm_units$Quantity$float(1),
			givenChromaticity);
		return A3(
			$ianmackenzie$elm_3d_scene$Scene3d$Types$EmissiveMaterial,
			0,
			$ianmackenzie$elm_3d_scene$Scene3d$Types$Constant(baseColor),
			brightness);
	});
var $author$project$Scene3d$Entity$Player$getTeamColorForBody = F2(
	function (teamsDict, body) {
		var bodyData = $author$project$Physics$Body$data(body);
		return A2(
			$elm$core$Maybe$withDefault,
			$avh4$elm_color$Color$black,
			A2(
				$elm$core$Maybe$andThen,
				function (teamId) {
					return A2($elm$core$Dict$get, teamId, teamsDict);
				},
				bodyData.i7));
	});
var $author$project$Scene3d$Entity$Player$bullet = F2(
	function (teamsDict, body) {
		var color = A2($author$project$Scene3d$Entity$Player$getTeamColorForBody, teamsDict, body);
		var material = A2(
			$ianmackenzie$elm_3d_scene$Scene3d$Material$emissive,
			$ianmackenzie$elm_3d_scene$Scene3d$Light$color(color),
			$ianmackenzie$elm_units$Luminance$nits($author$project$Constants$Graphics$bulletEmissiveNits));
		return A2(
			$ianmackenzie$elm_3d_scene$Scene3d$placeIn,
			$author$project$Physics$Body$frame(body),
			A2(
				$ianmackenzie$elm_3d_scene$Scene3d$sphereWithShadow,
				material,
				$ianmackenzie$elm_geometry$Sphere3d$atOrigin(
					$ianmackenzie$elm_units$Length$centimeters($author$project$Constants$Graphics$bulletRadiusCm))));
	});
var $ianmackenzie$elm_geometry$Point3d$translateIn = F3(
	function (_v0, _v1, _v2) {
		var d = _v0;
		var distance = _v1;
		var p = _v2;
		return {cF: p.cF + (distance * d.cF), cG: p.cG + (distance * d.cG), cH: p.cH + (distance * d.cH)};
	});
var $author$project$Scene3d$Entity$Player$bulletTrail = F2(
	function (teamsDict, body) {
		var vel = $author$project$Physics$Body$velocity(body);
		var origin = $author$project$Physics$Body$originPoint(body);
		var color = A2($author$project$Scene3d$Entity$Player$getTeamColorForBody, teamsDict, body);
		var _v0 = $avh4$elm_color$Color$toRgba(color);
		var red = _v0.iM;
		var green = _v0.hK;
		var blue = _v0.gV;
		var _v1 = $ianmackenzie$elm_geometry$Vector3d$direction(vel);
		if (_v1.$ === 1) {
			return $ianmackenzie$elm_3d_scene$Scene3d$nothing;
		} else {
			var velDir = _v1.a;
			var trailLengthM = 0.8;
			var trailSphere = function (_v2) {
				var frac = _v2.a;
				var alpha = _v2.b;
				var pos = A3(
					$ianmackenzie$elm_geometry$Point3d$translateIn,
					$ianmackenzie$elm_geometry$Direction3d$reverse(velDir),
					$ianmackenzie$elm_units$Length$meters(frac * trailLengthM),
					origin);
				var mat = $ianmackenzie$elm_3d_scene$Scene3d$Material$color(
					$avh4$elm_color$Color$fromRgba(
						{eH: alpha, gV: blue, hK: green, iM: red}));
				return A2(
					$ianmackenzie$elm_3d_scene$Scene3d$sphere,
					mat,
					A2(
						$ianmackenzie$elm_geometry$Sphere3d$atPoint,
						pos,
						$ianmackenzie$elm_units$Length$centimeters($author$project$Constants$Graphics$bulletRadiusCm * 0.65)));
			};
			var steps = _List_fromArray(
				[
					_Utils_Tuple2(0.15, 0.7),
					_Utils_Tuple2(0.38, 0.45),
					_Utils_Tuple2(0.62, 0.22),
					_Utils_Tuple2(0.85, 0.08)
				]);
			return $ianmackenzie$elm_3d_scene$Scene3d$group(
				A2($elm$core$List$map, trailSphere, steps));
		}
	});
var $ianmackenzie$elm_3d_scene$Scene3d$cylinder = F2(
	function (givenMaterial, givenCylinder) {
		return A4($ianmackenzie$elm_3d_scene$Scene3d$Entity$cylinder, true, false, givenMaterial, givenCylinder);
	});
var $ianmackenzie$elm_3d_scene$Scene3d$dummyMaterial = $ianmackenzie$elm_3d_scene$Scene3d$Material$color($avh4$elm_color$Color$black);
var $ianmackenzie$elm_3d_scene$Scene3d$cylinderShadow = function (givenCylinder) {
	return A4($ianmackenzie$elm_3d_scene$Scene3d$Entity$cylinder, false, true, $ianmackenzie$elm_3d_scene$Scene3d$dummyMaterial, givenCylinder);
};
var $ianmackenzie$elm_3d_scene$Scene3d$Material$matte = function (materialColor) {
	return A4(
		$ianmackenzie$elm_3d_scene$Scene3d$Types$LambertianMaterial,
		0,
		$ianmackenzie$elm_3d_scene$Scene3d$Types$Constant(
			$ianmackenzie$elm_3d_scene$Scene3d$ColorConversions$colorToLinearRgb(materialColor)),
		$ianmackenzie$elm_3d_scene$Scene3d$Material$constant(1),
		$ianmackenzie$elm_3d_scene$Scene3d$Types$NoNormalMap);
};
var $ianmackenzie$elm_3d_scene$Scene3d$Material$metal = function (_v0) {
	var baseColor = _v0.ar;
	var roughness = _v0.ax;
	return $ianmackenzie$elm_3d_scene$Scene3d$Material$pbr(
		{ar: baseColor, d5: 1, ax: roughness});
};
var $author$project$Constants$Graphics$teamDiscRadiusM = 0.62;
var $author$project$Constants$Graphics$teamDiscThicknessM = 0.03;
var $author$project$Constants$Graphics$teamDiscZOffsetM = -0.9;
var $author$project$Scene3d$Entity$Player$npc = F5(
	function (teamsDict, maybePlayerMesh, _v0, viewpoint, body) {
		var color = A2($author$project$Scene3d$Entity$Player$getTeamColorForBody, teamsDict, body);
		var bodyFrame = $author$project$Physics$Body$frame(body);
		var renderFrame = A3(
			$ianmackenzie$elm_geometry$Frame3d$translateAlongOwn,
			$ianmackenzie$elm_geometry$Frame3d$zAxis,
			$ianmackenzie$elm_units$Length$meters(0.5),
			bodyFrame);
		var bodyData = $author$project$Physics$Body$data(body);
		if (!bodyData.hS) {
			return A2(
				$ianmackenzie$elm_3d_scene$Scene3d$placeIn,
				renderFrame,
				A2(
					$ianmackenzie$elm_3d_scene$Scene3d$sphere,
					A2(
						$ianmackenzie$elm_3d_scene$Scene3d$Material$emissive,
						$ianmackenzie$elm_3d_scene$Scene3d$Light$color(color),
						$ianmackenzie$elm_units$Luminance$nits(2500)),
					$ianmackenzie$elm_geometry$Sphere3d$atOrigin(
						$ianmackenzie$elm_units$Length$meters(0.5))));
		} else {
			var playerEntity = function () {
				if (!maybePlayerMesh.$) {
					var playerMesh = maybePlayerMesh.a;
					return $ianmackenzie$elm_3d_scene$Scene3d$group(
						_List_fromArray(
							[
								A2(
								$ianmackenzie$elm_3d_scene$Scene3d$mesh,
								$ianmackenzie$elm_3d_scene$Scene3d$Material$metal(
									{ar: color, ax: 0}),
								playerMesh),
								$ianmackenzie$elm_3d_scene$Scene3d$cylinderShadow(
								A3(
									$ianmackenzie$elm_geometry$Cylinder3d$centeredOn,
									$ianmackenzie$elm_geometry$Point3d$origin,
									$ianmackenzie$elm_geometry$Direction3d$z,
									{
										dU: $ianmackenzie$elm_units$Length$meters(1.8),
										em: $ianmackenzie$elm_units$Length$meters(0.4)
									}))
							]));
				} else {
					return A2(
						$ianmackenzie$elm_3d_scene$Scene3d$cylinderWithShadow,
						$ianmackenzie$elm_3d_scene$Scene3d$Material$metal(
							{ar: color, ax: 0.1}),
						A3(
							$ianmackenzie$elm_geometry$Cylinder3d$centeredOn,
							$ianmackenzie$elm_geometry$Point3d$origin,
							$ianmackenzie$elm_geometry$Direction3d$z,
							{
								dU: $ianmackenzie$elm_units$Length$meters(2.0),
								em: $ianmackenzie$elm_units$Length$meters($author$project$Config$playerRadiusMeters)
							}));
				}
			}();
			var disc = A2(
				$ianmackenzie$elm_3d_scene$Scene3d$cylinder,
				$ianmackenzie$elm_3d_scene$Scene3d$Material$matte(color),
				A3(
					$ianmackenzie$elm_geometry$Cylinder3d$centeredOn,
					A3($ianmackenzie$elm_geometry$Point3d$meters, 0, 0, $author$project$Constants$Graphics$teamDiscZOffsetM),
					$ianmackenzie$elm_geometry$Direction3d$z,
					{
						dU: $ianmackenzie$elm_units$Length$meters($author$project$Constants$Graphics$teamDiscThicknessM),
						em: $ianmackenzie$elm_units$Length$meters($author$project$Constants$Graphics$teamDiscRadiusM)
					}));
			return A2(
				$ianmackenzie$elm_3d_scene$Scene3d$placeIn,
				renderFrame,
				$ianmackenzie$elm_3d_scene$Scene3d$group(
					_List_fromArray(
						[playerEntity, disc])));
		}
	});
var $author$project$Physics$Body$Extra$toSceneEntity = F5(
	function (teamsDict, playerMesh, playerMeshShadow, viewpoint, body) {
		var bodyData = $author$project$Physics$Body$data(body);
		var _v0 = bodyData.hb;
		switch (_v0) {
			case 2:
				return $elm$core$Maybe$Just(
					$ianmackenzie$elm_3d_scene$Scene3d$group(
						_List_fromArray(
							[
								A2($author$project$Scene3d$Entity$Player$bullet, teamsDict, body),
								A2($author$project$Scene3d$Entity$Player$bulletTrail, teamsDict, body)
							])));
			case 1:
				return $elm$core$Maybe$Just(
					A5($author$project$Scene3d$Entity$Player$npc, teamsDict, playerMesh, playerMeshShadow, viewpoint, body));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $ianmackenzie$elm_3d_scene$Scene3d$BackgroundColor = $elm$core$Basics$identity;
var $ianmackenzie$elm_3d_scene$Scene3d$backgroundColor = function (color) {
	return color;
};
var $avh4$elm_color$Color$rgba = F4(
	function (r, g, b, a) {
		return A4($avh4$elm_color$Color$RgbaSpace, r, g, b, a);
	});
var $ianmackenzie$elm_3d_scene$Scene3d$transparentBackground = $ianmackenzie$elm_3d_scene$Scene3d$backgroundColor(
	A4($avh4$elm_color$Color$rgba, 0, 0, 0, 0));
var $ianmackenzie$elm_geometry$Direction3d$yz = function (_v0) {
	var theta = _v0;
	return {
		cF: 0,
		cG: $elm$core$Basics$cos(theta),
		cH: $elm$core$Basics$sin(theta)
	};
};
var $author$project$Game$Playing$viewGameScene = function (world) {
	return function (floorEntity) {
		return function (fallbackFloorEntity) {
			return function (obstacleEntities) {
				return function (teamsDict) {
					return function (playerMesh) {
						return function (playerMeshShadow) {
							return function (cameraXRotationAngle) {
								return function (cameraZRotationAngle) {
									return function (viewWidth) {
										return function (viewHeight) {
											return function (hitEffects) {
												var renderWidth = viewWidth * $author$project$Config$renderSizeScaleFactor;
												var scaleFactor = viewWidth / renderWidth;
												var renderHeight = viewHeight * $author$project$Config$renderSizeScaleFactor;
												var hitEffectEntities = A2($elm$core$List$map, $author$project$Scene3d$Entity$Player$hitEffect, hitEffects);
												var camera = A4(
													$author$project$Me$getCamera,
													world,
													cameraXRotationAngle,
													cameraZRotationAngle,
													A2($author$project$Game$Playing$fovAngle, viewWidth, viewHeight));
												var dynamicEntities = A2(
													$elm$core$List$filterMap,
													A4($author$project$Physics$Body$Extra$toSceneEntity, teamsDict, playerMesh, playerMeshShadow, camera),
													$author$project$Physics$World$bodies(world));
												var activeFloorEntity = A2($elm$core$Maybe$withDefault, fallbackFloorEntity, floorEntity);
												var entities = A2(
													$elm$core$List$cons,
													activeFloorEntity,
													_Utils_ap(
														obstacleEntities,
														_Utils_ap(dynamicEntities, hitEffectEntities)));
												return A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('no-zoom'),
															A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
															A2($elm$html$Html$Attributes$style, 'top', '0'),
															A2($elm$html$Html$Attributes$style, 'left', '0'),
															A2(
															$elm$html$Html$Attributes$style,
															'width',
															$elm$core$String$fromFloat(viewWidth) + 'px'),
															A2(
															$elm$html$Html$Attributes$style,
															'height',
															$elm$core$String$fromFloat(viewHeight) + 'px'),
															A2($elm$html$Html$Attributes$style, 'overflow', 'hidden')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$Attributes$style,
																	'transform',
																	'scale(' + ($elm$core$String$fromFloat(scaleFactor) + ')')),
																	A2($elm$html$Html$Attributes$style, 'transform-origin', '0 0'),
																	A2(
																	$elm$html$Html$Attributes$style,
																	'width',
																	$elm$core$String$fromFloat(renderWidth) + 'px'),
																	A2(
																	$elm$html$Html$Attributes$style,
																	'height',
																	$elm$core$String$fromFloat(renderHeight) + 'px')
																]),
															_List_fromArray(
																[
																	$ianmackenzie$elm_3d_scene$Scene3d$custom(
																	{
																		gM: $ianmackenzie$elm_3d_scene$Scene3d$multisampling,
																		gQ: $ianmackenzie$elm_3d_scene$Scene3d$transparentBackground,
																		g3: camera,
																		hd: $ianmackenzie$elm_units$Length$meters($author$project$Config$cameraClipDepthMeters),
																		hq: _Utils_Tuple2(
																			$ianmackenzie$elm_units$Pixels$int(
																				$elm$core$Basics$round(renderWidth)),
																			$ianmackenzie$elm_units$Pixels$int(
																				$elm$core$Basics$round(renderHeight))),
																		hw: entities,
																		hA: $ianmackenzie$elm_3d_scene$Scene3d$exposureValue(15),
																		h6: A4(
																			$ianmackenzie$elm_3d_scene$Scene3d$fourLights,
																			A2(
																				$ianmackenzie$elm_3d_scene$Scene3d$Light$directional,
																				$ianmackenzie$elm_3d_scene$Scene3d$Light$castsShadows(true),
																				{
																					cS: $ianmackenzie$elm_3d_scene$Scene3d$Light$sunlight,
																					eW: $ianmackenzie$elm_geometry$Direction3d$yz(
																						$ianmackenzie$elm_units$Angle$degrees(-135)),
																					c1: $ianmackenzie$elm_units$Illuminance$lux(80000)
																				}),
																			$ianmackenzie$elm_3d_scene$Scene3d$Light$overhead(
																				{
																					cS: $ianmackenzie$elm_3d_scene$Scene3d$Light$skylight,
																					c1: $ianmackenzie$elm_units$Illuminance$lux(20000),
																					gy: $ianmackenzie$elm_geometry$Direction3d$positiveZ
																				}),
																			$ianmackenzie$elm_3d_scene$Scene3d$Light$overhead(
																				{
																					cS: $ianmackenzie$elm_3d_scene$Scene3d$Light$daylight,
																					c1: $ianmackenzie$elm_units$Illuminance$lux(15000),
																					gy: $ianmackenzie$elm_geometry$Direction3d$negativeZ
																				}),
																			A2(
																				$ianmackenzie$elm_3d_scene$Scene3d$Light$directional,
																				$ianmackenzie$elm_3d_scene$Scene3d$Light$neverCastsShadows,
																				{
																					cS: $ianmackenzie$elm_3d_scene$Scene3d$Light$chromaticity(
																						{cF: 0.34, cG: 0.35}),
																					eW: $ianmackenzie$elm_geometry$Direction3d$yz(
																						$ianmackenzie$elm_units$Angle$degrees(50)),
																					c1: $ianmackenzie$elm_units$Illuminance$lux(12000)
																				})),
																		jc: $ianmackenzie$elm_3d_scene$Scene3d$hableFilmicToneMapping,
																		jl: $ianmackenzie$elm_3d_scene$Scene3d$Light$daylight
																	})
																]))
														]));
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Constants$Graphics$healthBarSegments = 10;
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');
var $elm$svg$Svg$Attributes$rx = _VirtualDom_attribute('rx');
var $elm$svg$Svg$Attributes$ry = _VirtualDom_attribute('ry');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $author$project$Game$Playing$viewHealthBar = function (hp) {
	var total = $author$project$Constants$Graphics$healthBarSegments;
	var segW = 20;
	var segH = 10;
	var gap = 2;
	var totalW = (total * segW) + ((total - 1) * gap);
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromInt(totalW)),
				$elm$svg$Svg$Attributes$height(
				$elm$core$String$fromInt(segH))
			]),
		A2(
			$elm$core$List$map,
			function (i) {
				return A2(
					$elm$svg$Svg$rect,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$x(
							$elm$core$String$fromInt(i * (segW + gap))),
							$elm$svg$Svg$Attributes$y('0'),
							$elm$svg$Svg$Attributes$width(
							$elm$core$String$fromInt(segW)),
							$elm$svg$Svg$Attributes$height(
							$elm$core$String$fromInt(segH)),
							$elm$svg$Svg$Attributes$rx('2'),
							$elm$svg$Svg$Attributes$ry('2'),
							$elm$svg$Svg$Attributes$fill(
							(_Utils_cmp(i, hp) < 0) ? '#44dd44' : 'rgba(255,255,255,0.15)')
						]),
					_List_Nil);
			},
			A2($elm$core$List$range, 0, total - 1)));
};
var $elm$core$List$sortBy = _List_sortBy;
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $elm$svg$Svg$ellipse = $elm$svg$Svg$trustedNode('ellipse');
var $author$project$Game$Playing$viewSodaCan = F2(
	function (teamColor, hp) {
		var alive = hp > 0;
		var fillColor = alive ? $avh4$elm_color$Color$toCssString(teamColor) : 'rgba(255,255,255,0.1)';
		var highlightColor = alive ? 'rgba(255,255,255,0.35)' : 'rgba(255,255,255,0.06)';
		var strokeColor = alive ? 'rgba(0,0,0,0.2)' : 'rgba(255,255,255,0.2)';
		var tabColor = alive ? 'rgba(255,255,255,0.4)' : 'rgba(255,255,255,0.08)';
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width('14'),
					$elm$svg$Svg$Attributes$height('24'),
					$elm$svg$Svg$Attributes$viewBox('0 0 14 24')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$rect,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$x('0'),
								$elm$svg$Svg$Attributes$y('4'),
								$elm$svg$Svg$Attributes$width('14'),
								$elm$svg$Svg$Attributes$height('17'),
								$elm$svg$Svg$Attributes$fill(fillColor)
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$ellipse,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$cx('7'),
								$elm$svg$Svg$Attributes$cy('21'),
								$elm$svg$Svg$Attributes$rx('7'),
								$elm$svg$Svg$Attributes$ry('2.5'),
								$elm$svg$Svg$Attributes$fill(fillColor),
								$elm$svg$Svg$Attributes$stroke(strokeColor),
								$elm$svg$Svg$Attributes$strokeWidth('0.5')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$ellipse,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$cx('7'),
								$elm$svg$Svg$Attributes$cy('4'),
								$elm$svg$Svg$Attributes$rx('7'),
								$elm$svg$Svg$Attributes$ry('2.5'),
								$elm$svg$Svg$Attributes$fill(fillColor),
								$elm$svg$Svg$Attributes$stroke(strokeColor),
								$elm$svg$Svg$Attributes$strokeWidth('0.5')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$ellipse,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$cx('7'),
								$elm$svg$Svg$Attributes$cy('4'),
								$elm$svg$Svg$Attributes$rx('4'),
								$elm$svg$Svg$Attributes$ry('1.2'),
								$elm$svg$Svg$Attributes$fill(highlightColor)
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$rect,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$x('5'),
								$elm$svg$Svg$Attributes$y('1'),
								$elm$svg$Svg$Attributes$width('4'),
								$elm$svg$Svg$Attributes$height('3.5'),
								$elm$svg$Svg$Attributes$rx('1'),
								$elm$svg$Svg$Attributes$fill(tabColor)
							]),
						_List_Nil)
					]),
				(!alive) ? _List_fromArray(
					[
						A2(
						$elm$svg$Svg$line,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$x1('3'),
								$elm$svg$Svg$Attributes$y1('6'),
								$elm$svg$Svg$Attributes$x2('11'),
								$elm$svg$Svg$Attributes$y2('20'),
								$elm$svg$Svg$Attributes$stroke('rgba(255,255,255,0.5)'),
								$elm$svg$Svg$Attributes$strokeWidth('2'),
								$elm$svg$Svg$Attributes$strokeLinecap('round')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$line,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$x1('11'),
								$elm$svg$Svg$Attributes$y1('6'),
								$elm$svg$Svg$Attributes$x2('3'),
								$elm$svg$Svg$Attributes$y2('20'),
								$elm$svg$Svg$Attributes$stroke('rgba(255,255,255,0.5)'),
								$elm$svg$Svg$Attributes$strokeWidth('2'),
								$elm$svg$Svg$Attributes$strokeLinecap('round')
							]),
						_List_Nil)
					]) : _List_Nil));
	});
var $author$project$Game$Playing$viewTeamMembers = F2(
	function (teamColor, hps) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'gap', '4px'),
					A2($elm$html$Html$Attributes$style, 'align-items', 'flex-end')
				]),
			A2(
				$elm$core$List$map,
				$author$project$Game$Playing$viewSodaCan(teamColor),
				$elm$core$List$reverse(
					$elm$core$List$sort(hps))));
	});
var $author$project$Game$Playing$viewHud = F2(
	function (model, maybeMe) {
		if (maybeMe.$ === 1) {
			return $elm$html$Html$text('');
		} else {
			var me = maybeMe.a;
			var data = $author$project$Physics$Body$data(me);
			var teamColor = A2(
				$elm$core$Maybe$withDefault,
				A3($avh4$elm_color$Color$rgb, 0.5, 0.5, 0.5),
				A2(
					$elm$core$Maybe$andThen,
					function (tid) {
						return A2($elm$core$Dict$get, tid, model.cw);
					},
					data.i7));
			var teammateHps = A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Physics$Body$data,
					function ($) {
						return $.hS;
					}),
				A2(
					$elm$core$List$filter,
					function (b) {
						var bData = $author$project$Physics$Body$data(b);
						return (bData.hb === 1) && _Utils_eq(bData.i7, data.i7);
					},
					$author$project$Physics$World$bodies(model.q)));
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
						A2($elm$html$Html$Attributes$style, 'top', '8px'),
						A2($elm$html$Html$Attributes$style, 'left', '8px'),
						A2($elm$html$Html$Attributes$style, 'background', 'rgba(0,0,0,0.5)'),
						A2($elm$html$Html$Attributes$style, 'border-radius', '8px'),
						A2($elm$html$Html$Attributes$style, 'padding', '6px 10px'),
						A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
						A2($elm$html$Html$Attributes$style, 'user-select', 'none'),
						A2($elm$html$Html$Attributes$style, '-webkit-user-select', 'none'),
						A2($elm$html$Html$Attributes$style, 'z-index', '10'),
						A2($elm$html$Html$Attributes$style, 'display', 'flex'),
						A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
						A2($elm$html$Html$Attributes$style, 'gap', '5px')
					]),
				_List_fromArray(
					[
						$author$project$Game$Playing$viewHealthBar(data.hS),
						$elm$core$List$isEmpty(teammateHps) ? $elm$html$Html$text('') : A2($author$project$Game$Playing$viewTeamMembers, teamColor, teammateHps)
					]));
		}
	});
var $ianmackenzie$elm_geometry$Direction3d$from = F2(
	function (_v0, _v1) {
		var p1 = _v0;
		var p2 = _v1;
		var deltaZ = p2.cH - p1.cH;
		var deltaY = p2.cG - p1.cG;
		var deltaX = p2.cF - p1.cF;
		var largestComponent = A2(
			$elm$core$Basics$max,
			$elm$core$Basics$abs(deltaX),
			A2(
				$elm$core$Basics$max,
				$elm$core$Basics$abs(deltaY),
				$elm$core$Basics$abs(deltaZ)));
		if (!largestComponent) {
			return $elm$core$Maybe$Nothing;
		} else {
			var scaledZ = deltaZ / largestComponent;
			var scaledY = deltaY / largestComponent;
			var scaledX = deltaX / largestComponent;
			var scaledLength = $elm$core$Basics$sqrt(((scaledX * scaledX) + (scaledY * scaledY)) + (scaledZ * scaledZ));
			return $elm$core$Maybe$Just(
				{cF: scaledX / scaledLength, cG: scaledY / scaledLength, cH: scaledZ / scaledLength});
		}
	});
var $author$project$Constants$Graphics$healthBarElevationM = 1.3;
var $author$project$Constants$Graphics$healthBarMaxDistanceM = 35.0;
var $author$project$Scene3d$Entity$Player$projectToScreen = F4(
	function (camera, screenW, screenH, worldPoint) {
		var slope = $ianmackenzie$elm_3d_camera$Camera3d$frustumSlope(camera);
		var p = $ianmackenzie$elm_geometry$Point3d$toMeters(worldPoint);
		var eye = $ianmackenzie$elm_geometry$Point3d$toMeters(
			$ianmackenzie$elm_3d_camera$Camera3d$eyePoint(camera));
		var dz = p.cH - eye.cH;
		var dy = p.cG - eye.cG;
		var dx = p.cF - eye.cF;
		var camFrame = $ianmackenzie$elm_3d_camera$Camera3d$frame(camera);
		var fwd = $ianmackenzie$elm_geometry$Direction3d$reverse(
			$ianmackenzie$elm_geometry$Frame3d$zDirection(camFrame));
		var fwdDist = (($ianmackenzie$elm_geometry$Direction3d$xComponent(fwd) * dx) + ($ianmackenzie$elm_geometry$Direction3d$yComponent(fwd) * dy)) + ($ianmackenzie$elm_geometry$Direction3d$zComponent(fwd) * dz);
		var rgt = $ianmackenzie$elm_geometry$Direction3d$reverse(
			$ianmackenzie$elm_geometry$Frame3d$xDirection(camFrame));
		var rgtDist = (($ianmackenzie$elm_geometry$Direction3d$xComponent(rgt) * dx) + ($ianmackenzie$elm_geometry$Direction3d$yComponent(rgt) * dy)) + ($ianmackenzie$elm_geometry$Direction3d$zComponent(rgt) * dz);
		var up_ = $ianmackenzie$elm_geometry$Frame3d$yDirection(camFrame);
		var upDist = (($ianmackenzie$elm_geometry$Direction3d$xComponent(up_) * dx) + ($ianmackenzie$elm_geometry$Direction3d$yComponent(up_) * dy)) + ($ianmackenzie$elm_geometry$Direction3d$zComponent(up_) * dz);
		var yNdc = upDist / (fwdDist * slope);
		var aspectRatio = screenW / screenH;
		var xNdc = (-rgtDist) / ((fwdDist * slope) * aspectRatio);
		return ((fwdDist <= 0) || ((_Utils_cmp(xNdc, -1) < 0) || ((xNdc > 1) || ((_Utils_cmp(yNdc, -1) < 0) || (yNdc > 1))))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			_Utils_Tuple2(((xNdc + 1) / 2) * screenW, ((1 - yNdc) / 2) * screenH));
	});
var $author$project$Scene3d$Entity$Player$healthBarLabel = F5(
	function (body, hp, camera, screenW, screenH) {
		var labelCenter = A3(
			$ianmackenzie$elm_geometry$Point3d$translateIn,
			$ianmackenzie$elm_geometry$Direction3d$z,
			$ianmackenzie$elm_units$Length$meters($author$project$Constants$Graphics$healthBarElevationM),
			$author$project$Me$getEyePoint(body));
		var distanceM = A2(
			$elm$core$Basics$max,
			0.1,
			$ianmackenzie$elm_units$Length$inMeters(
				A2(
					$ianmackenzie$elm_geometry$Point3d$distanceFrom,
					$ianmackenzie$elm_3d_camera$Camera3d$eyePoint(camera),
					labelCenter)));
		return (_Utils_cmp(distanceM, $author$project$Constants$Graphics$healthBarMaxDistanceM) > 0) ? $elm$core$Maybe$Nothing : A2(
			$elm$core$Maybe$map,
			function (_v0) {
				var sx = _v0.a;
				var sy = _v0.b;
				var total = $author$project$Constants$Graphics$healthBarSegments;
				var segW = 6;
				var segH = 3;
				var gap = 2;
				var totalW = (total * segW) + ((total - 1) * gap);
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
							A2(
							$elm$html$Html$Attributes$style,
							'left',
							$elm$core$String$fromFloat(sx) + 'px'),
							A2(
							$elm$html$Html$Attributes$style,
							'top',
							$elm$core$String$fromFloat(sy) + 'px'),
							A2($elm$html$Html$Attributes$style, 'transform', 'translate(-50%, -100%)'),
							A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
							A2($elm$html$Html$Attributes$style, 'user-select', 'none'),
							A2($elm$html$Html$Attributes$style, '-webkit-user-select', 'none')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$svg,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$width(
									$elm$core$String$fromInt(totalW)),
									$elm$svg$Svg$Attributes$height(
									$elm$core$String$fromInt(segH))
								]),
							A2(
								$elm$core$List$map,
								function (i) {
									return A2(
										$elm$svg$Svg$rect,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$x(
												$elm$core$String$fromInt(i * (segW + gap))),
												$elm$svg$Svg$Attributes$y('0'),
												$elm$svg$Svg$Attributes$width(
												$elm$core$String$fromInt(segW)),
												$elm$svg$Svg$Attributes$height(
												$elm$core$String$fromInt(segH)),
												$elm$svg$Svg$Attributes$rx('2'),
												$elm$svg$Svg$Attributes$ry('2'),
												$elm$svg$Svg$Attributes$fill(
												(_Utils_cmp(i, hp) < 0) ? '#44dd44' : 'rgba(255,255,255,0.2)')
											]),
										_List_Nil);
								},
								A2($elm$core$List$range, 0, total - 1)))
						]));
			},
			A4($author$project$Scene3d$Entity$Player$projectToScreen, camera, screenW, screenH, labelCenter));
	});
var $author$project$Scene3d$Entity$Player$nameLabel = F5(
	function (body, name, camera, screenW, screenH) {
		var labelCenter = A3(
			$ianmackenzie$elm_geometry$Point3d$translateIn,
			$ianmackenzie$elm_geometry$Direction3d$z,
			$ianmackenzie$elm_units$Length$meters($author$project$Constants$Graphics$healthBarElevationM),
			$author$project$Me$getEyePoint(body));
		var distanceM = A2(
			$elm$core$Basics$max,
			0.1,
			$ianmackenzie$elm_units$Length$inMeters(
				A2(
					$ianmackenzie$elm_geometry$Point3d$distanceFrom,
					$ianmackenzie$elm_3d_camera$Camera3d$eyePoint(camera),
					labelCenter)));
		return ($elm$core$String$isEmpty(name) || (_Utils_cmp(distanceM, $author$project$Constants$Graphics$healthBarMaxDistanceM) > 0)) ? $elm$core$Maybe$Nothing : A2(
			$elm$core$Maybe$map,
			function (_v0) {
				var sx = _v0.a;
				var sy = _v0.b;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
							A2(
							$elm$html$Html$Attributes$style,
							'left',
							$elm$core$String$fromFloat(sx) + 'px'),
							A2(
							$elm$html$Html$Attributes$style,
							'top',
							$elm$core$String$fromFloat(sy) + 'px'),
							A2($elm$html$Html$Attributes$style, 'transform', 'translate(-50%, calc(-100% - 16px))'),
							A2($elm$html$Html$Attributes$style, 'color', 'white'),
							A2($elm$html$Html$Attributes$style, 'font-size', '0.7rem'),
							A2($elm$html$Html$Attributes$style, 'text-shadow', '0 1px 3px rgba(0,0,0,0.85)'),
							A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
							A2($elm$html$Html$Attributes$style, 'user-select', 'none'),
							A2($elm$html$Html$Attributes$style, '-webkit-user-select', 'none'),
							A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(name)
								]))
						]));
			},
			A4($author$project$Scene3d$Entity$Player$projectToScreen, camera, screenW, screenH, labelCenter));
	});
var $author$project$Internal$Transform3d$directionRelativeTo = F2(
	function (_v0, worldVector) {
		var localOrientation = _v0.b;
		return A2($author$project$Internal$Transform3d$derotate, localOrientation, worldVector);
	});
var $author$project$Shapes$Convex$raycast = F2(
	function (_v0, convex) {
		var direction = _v0.eW;
		var from = _v0.hI;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, maybeHit) {
					var normal = _v1.aS;
					var vertices = _v1.cE;
					var point = function () {
						if (vertices.b) {
							var first = vertices.a;
							return first;
						} else {
							return $author$project$Internal$Vector3$zero;
						}
					}();
					var dot = A2($author$project$Internal$Vector3$dot, direction, normal);
					if (dot < 0) {
						var pointToFrom = A2($author$project$Internal$Vector3$sub, point, from);
						var scalar = A2($author$project$Internal$Vector3$dot, normal, pointToFrom) / dot;
						if (scalar >= 0) {
							var intersectionPoint = {cF: (direction.cF * scalar) + from.cF, cG: (direction.cG * scalar) + from.cG, cH: (direction.cH * scalar) + from.cH};
							var isInsidePolygon = A3(
								$author$project$Shapes$Convex$foldFaceEdges,
								F3(
									function (p1, p2, result) {
										return result && (A2(
											$author$project$Internal$Vector3$dot,
											A2($author$project$Internal$Vector3$sub, intersectionPoint, p1),
											A2(
												$author$project$Internal$Vector3$cross,
												normal,
												A2($author$project$Internal$Vector3$sub, p2, p1))) > 0);
									}),
								true,
								vertices);
							if (isInsidePolygon) {
								if (!maybeHit.$) {
									var distance = maybeHit.a.eX;
									return ((scalar - distance) < 0) ? $elm$core$Maybe$Just(
										{eX: scalar, aS: normal, dp: intersectionPoint}) : maybeHit;
								} else {
									return $elm$core$Maybe$Just(
										{eX: scalar, aS: normal, dp: intersectionPoint});
								}
							} else {
								return maybeHit;
							}
						} else {
							return maybeHit;
						}
					} else {
						return maybeHit;
					}
				}),
			$elm$core$Maybe$Nothing,
			convex.e5);
	});
var $author$project$Shapes$Plane$raycast = F2(
	function (_v0, _v1) {
		var from = _v0.hI;
		var direction = _v0.eW;
		var normal = _v1.aS;
		var position = _v1.f9;
		var dot = A2($author$project$Internal$Vector3$dot, direction, normal);
		if (dot < 0) {
			var pointToFrom = A2($author$project$Internal$Vector3$sub, position, from);
			var scalar = A2($author$project$Internal$Vector3$dot, normal, pointToFrom) / dot;
			return (scalar >= 0) ? $elm$core$Maybe$Just(
				{
					eX: scalar,
					aS: normal,
					dp: {cF: (direction.cF * scalar) + from.cF, cG: (direction.cG * scalar) + from.cG, cH: (direction.cH * scalar) + from.cH}
				}) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Shapes$Sphere$raycast = F2(
	function (_v0, _v1) {
		var from = _v0.hI;
		var direction = _v0.eW;
		var position = _v1.f9;
		var radius = _v1.em;
		var c = ((((from.cF - position.cF) * (from.cF - position.cF)) + ((from.cG - position.cG) * (from.cG - position.cG))) + ((from.cH - position.cH) * (from.cH - position.cH))) - (radius * radius);
		var b = 2 * (((direction.cF * (from.cF - position.cF)) + (direction.cG * (from.cG - position.cG))) + (direction.cH * (from.cH - position.cH)));
		var a = ((direction.cF * direction.cF) + (direction.cG * direction.cG)) + (direction.cH * direction.cH);
		var delta = (b * b) - ((4 * a) * c);
		if (delta < 0) {
			return $elm$core$Maybe$Nothing;
		} else {
			var distance = ((-b) - $elm$core$Basics$sqrt(delta)) / (2 * a);
			if (distance >= 0) {
				var point = {cF: from.cF + (direction.cF * distance), cG: from.cG + (direction.cG * distance), cH: from.cH + (direction.cH * distance)};
				var normal = A2($author$project$Internal$Vector3$sub, point, position);
				return $elm$core$Maybe$Just(
					{eX: distance, aS: normal, dp: point});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$Internal$Shape$raycast = F2(
	function (ray, shape) {
		switch (shape.$) {
			case 1:
				var plane = shape.a;
				return A2($author$project$Shapes$Plane$raycast, ray, plane);
			case 2:
				var sphere = shape.a;
				return A2($author$project$Shapes$Sphere$raycast, ray, sphere);
			case 0:
				var convex = shape.a;
				return A2($author$project$Shapes$Convex$raycast, ray, convex);
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Internal$Body$raycast = F2(
	function (ray, body) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (shape, maybeClosestRaycastResult) {
					var _v0 = A2($author$project$Internal$Shape$raycast, ray, shape);
					if (!_v0.$) {
						var raycastResult = _v0.a;
						if (!maybeClosestRaycastResult.$) {
							var closestRaycastResult = maybeClosestRaycastResult.a;
							return ((raycastResult.eX - closestRaycastResult.eX) < 0) ? $elm$core$Maybe$Just(raycastResult) : maybeClosestRaycastResult;
						} else {
							return $elm$core$Maybe$Just(raycastResult);
						}
					} else {
						return maybeClosestRaycastResult;
					}
				}),
			$elm$core$Maybe$Nothing,
			body.eD);
	});
var $author$project$Internal$World$raycast = F2(
	function (ray, _v0) {
		var bodies = _v0.eK;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (body, maybeClosestRaycastResult) {
					var _v1 = A2($author$project$Internal$Body$raycast, ray, body);
					if (!_v1.$) {
						var raycastResult = _v1.a;
						if (!maybeClosestRaycastResult.$) {
							var closestRaycastResult = maybeClosestRaycastResult.a;
							return ((raycastResult.eX - closestRaycastResult.eX) < 0) ? $elm$core$Maybe$Just(
								{gW: body, eX: raycastResult.eX, aS: raycastResult.aS, dp: raycastResult.dp}) : maybeClosestRaycastResult;
						} else {
							return $elm$core$Maybe$Just(
								{gW: body, eX: raycastResult.eX, aS: raycastResult.aS, dp: raycastResult.dp});
						}
					} else {
						return maybeClosestRaycastResult;
					}
				}),
			$elm$core$Maybe$Nothing,
			bodies);
	});
var $author$project$Physics$World$raycast = F2(
	function (ray, _v0) {
		var world = _v0;
		var _v1 = A2(
			$author$project$Internal$World$raycast,
			{
				eW: $ianmackenzie$elm_geometry$Direction3d$unwrap(
					$ianmackenzie$elm_geometry$Axis3d$direction(ray)),
				hI: $ianmackenzie$elm_geometry$Point3d$toMeters(
					$ianmackenzie$elm_geometry$Axis3d$originPoint(ray))
			},
			world);
		if (!_v1.$) {
			var body = _v1.a.gW;
			var point = _v1.a.dp;
			var normal = _v1.a.aS;
			return $elm$core$Maybe$Just(
				{
					gW: body,
					aS: $ianmackenzie$elm_geometry$Direction3d$unsafe(
						A2(
							$author$project$Internal$Transform3d$directionRelativeTo,
							A2(
								$author$project$Internal$Transform3d$placeIn,
								body.cA,
								$author$project$Internal$Transform3d$inverse(body.cR)),
							normal)),
					dp: $ianmackenzie$elm_geometry$Point3d$fromMeters(
						A2(
							$author$project$Internal$Transform3d$pointRelativeTo,
							A2(
								$author$project$Internal$Transform3d$placeIn,
								body.cA,
								$author$project$Internal$Transform3d$inverse(body.cR)),
							point))
				});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Game$Playing$viewNpcLabels = function (model) {
	var camera = A4(
		$author$project$Me$getCamera,
		model.q,
		model.aE,
		model.as,
		A2($author$project$Game$Playing$fovAngle, model.aB, model.aA));
	var cameraEye = $ianmackenzie$elm_3d_camera$Camera3d$eyePoint(camera);
	var cameraForward = $ianmackenzie$elm_geometry$Direction3d$reverse(
		$ianmackenzie$elm_geometry$Frame3d$zDirection(
			$ianmackenzie$elm_3d_camera$Camera3d$frame(camera)));
	var isVisible = function (npcBody) {
		var _v0 = A2(
			$ianmackenzie$elm_geometry$Direction3d$from,
			cameraEye,
			$author$project$Physics$Body$originPoint(npcBody));
		if (_v0.$ === 1) {
			return false;
		} else {
			var toNpc = _v0.a;
			if ($ianmackenzie$elm_units$Angle$inDegrees(
				A2($ianmackenzie$elm_geometry$Direction3d$angleFrom, cameraForward, toNpc)) > 35) {
				return false;
			} else {
				var _v1 = A2(
					$author$project$Physics$World$raycast,
					A2($ianmackenzie$elm_geometry$Axis3d$through, cameraEye, toNpc),
					model.q);
				if (_v1.$ === 1) {
					return true;
				} else {
					var body = _v1.a.gW;
					return $author$project$Physics$Body$data(body).hb !== 3;
				}
			}
		}
	};
	var toLabels = function (body) {
		var data = $author$project$Physics$Body$data(body);
		if ((data.hb === 1) && isVisible(body)) {
			var name = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Dict$get, data.hT, model.ek));
			var maybeName = A5($author$project$Scene3d$Entity$Player$nameLabel, body, name, camera, model.aB, model.aA);
			var maybeHealthBar = (data.hS > 0) ? A5($author$project$Scene3d$Entity$Player$healthBarLabel, body, data.hS, camera, model.aB, model.aA) : $elm$core$Maybe$Nothing;
			return A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[maybeName, maybeHealthBar]));
		} else {
			return _List_Nil;
		}
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
				A2($elm$html$Html$Attributes$style, 'top', '0'),
				A2($elm$html$Html$Attributes$style, 'left', '0'),
				A2($elm$html$Html$Attributes$style, 'width', '100%'),
				A2($elm$html$Html$Attributes$style, 'height', '100%'),
				A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
				A2($elm$html$Html$Attributes$style, 'z-index', '5')
			]),
		A2(
			$elm$core$List$concatMap,
			toLabels,
			$author$project$Physics$World$bodies(model.q)));
};
var $author$project$Game$Playing$viewReticle = function (hitMarkers) {
	var r2 = 18;
	var r1 = 12;
	var hitMarkerColor = function (kind) {
		if (!kind) {
			return '255,255,255';
		} else {
			return '255,70,70';
		}
	};
	var diagonals = _List_fromArray(
		[
			_Utils_Tuple2(0.7071, 0.7071),
			_Utils_Tuple2(-0.7071, 0.7071),
			_Utils_Tuple2(-0.7071, -0.7071),
			_Utils_Tuple2(0.7071, -0.7071)
		]);
	var cy = 24;
	var cx = 24;
	var hitMarkerLines = function (marker) {
		var opacity = A2($elm$core$Basics$max, 0, 1 - (marker.aq / $author$project$Game$Playing$hitMarkerMaxAgeMs));
		var color = hitMarkerColor(marker.dS);
		var stroke = 'rgba(' + (color + (',' + ($elm$core$String$fromFloat(opacity) + ')')));
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var dx = _v0.a;
				var dy = _v0.b;
				return A2(
					$elm$svg$Svg$line,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$x1(
							$elm$core$String$fromFloat(cx + (r1 * dx))),
							$elm$svg$Svg$Attributes$y1(
							$elm$core$String$fromFloat(cy + (r1 * dy))),
							$elm$svg$Svg$Attributes$x2(
							$elm$core$String$fromFloat(cx + (r2 * dx))),
							$elm$svg$Svg$Attributes$y2(
							$elm$core$String$fromFloat(cy + (r2 * dy))),
							$elm$svg$Svg$Attributes$stroke(stroke),
							$elm$svg$Svg$Attributes$strokeWidth('2.5'),
							$elm$svg$Svg$Attributes$strokeLinecap('round')
						]),
					_List_Nil);
			},
			diagonals);
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
				A2($elm$html$Html$Attributes$style, 'top', '50%'),
				A2($elm$html$Html$Attributes$style, 'left', '50%'),
				A2($elm$html$Html$Attributes$style, 'transform', 'translate(-50%, -50%)'),
				A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
				A2($elm$html$Html$Attributes$style, 'z-index', '10')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$svg,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$width('48'),
						$elm$svg$Svg$Attributes$height('48')
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$cx(
									$elm$core$String$fromInt(cx)),
									$elm$svg$Svg$Attributes$cy(
									$elm$core$String$fromInt(cy)),
									$elm$svg$Svg$Attributes$r('9'),
									$elm$svg$Svg$Attributes$fill('none'),
									$elm$svg$Svg$Attributes$stroke('rgba(255,255,255,0.75)'),
									$elm$svg$Svg$Attributes$strokeWidth('1.5')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$circle,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$cx(
									$elm$core$String$fromInt(cx)),
									$elm$svg$Svg$Attributes$cy(
									$elm$core$String$fromInt(cy)),
									$elm$svg$Svg$Attributes$r('1.5'),
									$elm$svg$Svg$Attributes$fill('rgba(255,255,255,0.9)')
								]),
							_List_Nil)
						]),
					A2($elm$core$List$concatMap, hitMarkerLines, hitMarkers)))
			]));
};
var $author$project$Game$Playing$view = function (playingState) {
	var maybeMe = $author$project$Me$getInWorld(playingState.q);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'height', '100%'),
				A2($elm$html$Html$Attributes$style, 'width', '100%'),
				A2($elm$html$Html$Attributes$style, 'touch-action', 'none'),
				A2($elm$html$Html$Attributes$style, 'position', 'relative'),
				A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
				A2($elm$html$Html$Attributes$style, 'background', $author$project$Constants$Graphics$skyGradientCss)
			]),
		_List_fromArray(
			[
				$author$project$Game$Playing$viewGameScene(playingState.q)(playingState.ci)(playingState.dN)(playingState.df)(playingState.cw)(playingState.dn)(playingState.$7)(playingState.aE)(playingState.as)(playingState.aB)(playingState.aA)(playingState.cl),
				_Utils_eq(playingState.ci, $elm$core$Maybe$Nothing) ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
						A2($elm$html$Html$Attributes$style, 'top', '50%'),
						A2($elm$html$Html$Attributes$style, 'left', '50%'),
						A2($elm$html$Html$Attributes$style, 'transform', 'translate(-50%, -50%)'),
						A2($elm$html$Html$Attributes$style, 'color', 'white'),
						A2($elm$html$Html$Attributes$style, 'background', 'rgba(0,0,0,0.5)'),
						A2($elm$html$Html$Attributes$style, 'padding', '8px 16px'),
						A2($elm$html$Html$Attributes$style, 'border-radius', '4px'),
						A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
						A2($elm$html$Html$Attributes$style, 'z-index', '20')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Loading…')
					])) : $elm$html$Html$text(''),
				$author$project$Game$Playing$viewNpcLabels(playingState),
				$author$project$Game$Playing$viewDamageFlash(playingState.ba),
				A2($author$project$Game$Playing$viewHud, playingState, maybeMe),
				$author$project$Game$Playing$viewReticle(playingState.a4),
				function () {
				if (!maybeMe.$) {
					var me = maybeMe.a;
					return (!$author$project$Game$Playing$isAlive(me)) ? $author$project$Game$Playing$viewDeathOverlay : $elm$html$Html$text('');
				} else {
					return $elm$html$Html$text('');
				}
			}(),
				playingState.bY ? $elm$html$Html$text('') : $author$project$Game$Playing$viewControlPad(playingState)
			]));
};
var $author$project$Game$PostGame$PlayAgain = 1;
var $author$project$Game$PostGame$accuracyText = function (stats) {
	if (!stats.iV) {
		return '--';
	} else {
		var pct = (stats.iW / stats.iV) * 100;
		return $elm$core$String$fromInt(
			$elm$core$Basics$round(pct)) + '%';
	}
};
var $author$project$Game$PostGame$colorTint = F2(
	function (alpha, color) {
		var _v0 = $avh4$elm_color$Color$toRgba(color);
		var red = _v0.iM;
		var green = _v0.hK;
		var blue = _v0.gV;
		return 'rgba(' + ($elm$core$String$fromInt(
			$elm$core$Basics$round(red * 255)) + (',' + ($elm$core$String$fromInt(
			$elm$core$Basics$round(green * 255)) + (',' + ($elm$core$String$fromInt(
			$elm$core$Basics$round(blue * 255)) + (',' + ($elm$core$String$fromFloat(alpha) + ')')))))));
	});
var $author$project$Game$PostGame$playersForTeam = F2(
	function (players, team) {
		return A2(
			$elm$core$List$filter,
			function (_v0) {
				var p = _v0.a;
				return _Utils_eq(
					p.i7,
					$elm$core$Maybe$Just(team.hT));
			},
			players);
	});
var $author$project$Game$PostGame$teamTotalHp = F2(
	function (players, team) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, acc) {
					var stats = _v0.b;
					return acc + stats.hS;
				}),
			0,
			A2($author$project$Game$PostGame$playersForTeam, players, team));
	});
var $author$project$Game$PostGame$determineWinner = F2(
	function (players, teams) {
		var getHp = $author$project$Game$PostGame$teamTotalHp(players);
		var sorted = $elm$core$List$reverse(
			A2($elm$core$List$sortBy, getHp, teams));
		if (sorted.b) {
			if (sorted.b.b) {
				var first = sorted.a;
				var _v1 = sorted.b;
				var second = _v1.a;
				return (_Utils_cmp(
					getHp(first),
					getHp(second)) > 0) ? $elm$core$Maybe$Just(first) : $elm$core$Maybe$Nothing;
			} else {
				var first = sorted.a;
				return (getHp(first) > 0) ? $elm$core$Maybe$Just(first) : $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $elm_community$list_extra$List$Extra$foldl1 = F2(
	function (func, list) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var x = list.a;
			var xs = list.b;
			return $elm$core$Maybe$Just(
				A3($elm$core$List$foldl, func, x, xs));
		}
	});
var $elm_community$list_extra$List$Extra$maximumWith = F2(
	function (comparator, list) {
		return A2(
			$elm_community$list_extra$List$Extra$foldl1,
			F2(
				function (x, y) {
					var _v0 = A2(comparator, x, y);
					if (_v0 === 2) {
						return x;
					} else {
						return y;
					}
				}),
			list);
	});
var $author$project$Game$PostGame$overallLeaderId = function (players) {
	return A2(
		$elm$core$Maybe$map,
		function (_v3) {
			var p = _v3.a;
			return p.hT;
		},
		A2(
			$elm_community$list_extra$List$Extra$maximumWith,
			F2(
				function (_v0, _v1) {
					var a = _v0.b;
					var b = _v1.b;
					var _v2 = A2($elm$core$Basics$compare, a.hu, b.hu);
					if (_v2 === 1) {
						return A2($elm$core$Basics$compare, a.iW, b.iW);
					} else {
						var ord = _v2;
						return ord;
					}
				}),
			players));
};
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$td = _VirtualDom_node('td');
var $author$project$Game$PostGame$td = F2(
	function (value, color) {
		return A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'padding', '3px 4px 3px 0'),
					A2(
					$elm$html$Html$Attributes$style,
					'color',
					$elm$core$String$isEmpty(color) ? 'inherit' : color)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(value)
				]));
	});
var $elm$html$Html$th = _VirtualDom_node('th');
var $author$project$Game$PostGame$th = F3(
	function (color, label, width) {
		return A2(
			$elm$html$Html$th,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'text-align', 'left'),
					A2($elm$html$Html$Attributes$style, 'padding', '2px 4px 6px 0'),
					A2($elm$html$Html$Attributes$style, 'color', '#777'),
					A2($elm$html$Html$Attributes$style, 'font-weight', 'normal'),
					A2(
					$elm$html$Html$Attributes$style,
					'border-bottom',
					'1px solid ' + A2($author$project$Game$PostGame$colorTint, 0.3, color)),
					A2($elm$html$Html$Attributes$style, 'width', width)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $author$project$Game$PostGame$view = function (postGameState) {
	var viewPlayerRow = F2(
		function (maybeLeader, _v5) {
			var p = _v5.a;
			var pStats = _v5.b;
			var playerName = function () {
				var _v4 = p.aH;
				if (_v4 === '') {
					return 'Anonymous';
				} else {
					var name = _v4;
					return name;
				}
			}();
			var isLeader = _Utils_eq(
				$elm$core$Maybe$Just(p.hT),
				maybeLeader);
			return A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'padding', '3px 4px 3px 0'),
								A2(
								$elm$html$Html$Attributes$style,
								'font-weight',
								isLeader ? '600' : 'normal')
							]),
						_List_fromArray(
							[
								isLeader ? A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('👑 ' + playerName)
									])) : $elm$html$Html$text(playerName)
							])),
						A2(
						$author$project$Game$PostGame$td,
						(!pStats.hS) ? '💀' : ($elm$core$String$fromInt(pStats.hS) + ' HP'),
						(!pStats.hS) ? '#888' : 'green'),
						A2(
						$author$project$Game$PostGame$td,
						$elm$core$String$fromInt(pStats.hu),
						''),
						A2(
						$author$project$Game$PostGame$td,
						$elm$core$String$fromInt(pStats.iW),
						''),
						A2(
						$author$project$Game$PostGame$td,
						$author$project$Game$PostGame$accuracyText(pStats),
						'')
					]));
		});
	var rankLabel = function (index) {
		switch (index) {
			case 0:
				return '🥇';
			case 1:
				return '🥈';
			case 2:
				return '🥉';
			default:
				var n = index;
				return $elm$core$String$fromInt(n + 1) + '.';
		}
	};
	var maybeWinningTeam = A2($author$project$Game$PostGame$determineWinner, postGameState.an, postGameState.bV);
	var maybeLeaderId = $author$project$Game$PostGame$overallLeaderId(postGameState.an);
	var viewStatsTable = F2(
		function (color, teamPlayers) {
			return A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'width', '100%'),
						A2($elm$html$Html$Attributes$style, 'table-layout', 'fixed'),
						A2($elm$html$Html$Attributes$style, 'border-collapse', 'collapse'),
						A2($elm$html$Html$Attributes$style, 'font-size', '1rem'),
						A2($elm$html$Html$Attributes$style, 'margin-top', '6px')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A3($author$project$Game$PostGame$th, color, 'Player', '44%'),
										A3($author$project$Game$PostGame$th, color, 'HP', '16%'),
										A3($author$project$Game$PostGame$th, color, 'Elims', '13%'),
										A3($author$project$Game$PostGame$th, color, 'Hits', '13%'),
										A3($author$project$Game$PostGame$th, color, 'Accuracy', '14%')
									]))
							])),
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$elm$core$List$map,
							viewPlayerRow(maybeLeaderId),
							$elm$core$List$reverse(
								A2(
									$elm$core$List$sortBy,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$Tuple$second,
										function ($) {
											return $.hu;
										}),
									teamPlayers))))
					]));
		});
	var isOwner = _Utils_eq(
		postGameState.iF,
		$elm$core$Maybe$Just(postGameState.iJ));
	var getHp = $author$project$Game$PostGame$teamTotalHp(postGameState.an);
	var teamsByHp = $elm$core$List$reverse(
		A2($elm$core$List$sortBy, getHp, postGameState.bV));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
				A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
				A2($elm$html$Html$Attributes$style, 'padding', '20px'),
				A2($elm$html$Html$Attributes$style, 'max-width', '520px'),
				A2($elm$html$Html$Attributes$style, 'margin', '0 auto')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'text-align', 'center'),
						A2($elm$html$Html$Attributes$style, 'margin-bottom', '20px')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'font-size', '0.75rem'),
								A2($elm$html$Html$Attributes$style, 'color', '#aaa'),
								A2($elm$html$Html$Attributes$style, 'text-transform', 'uppercase'),
								A2($elm$html$Html$Attributes$style, 'letter-spacing', '0.08em'),
								A2($elm$html$Html$Attributes$style, 'margin-bottom', '4px')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Debate topic')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'color', '#555'),
								A2($elm$html$Html$Attributes$style, 'font-size', '1rem')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(postGameState.jd)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'text-align', 'center'),
						A2($elm$html$Html$Attributes$style, 'margin-bottom', '20px'),
						A2($elm$html$Html$Attributes$style, 'width', '100%'),
						A2($elm$html$Html$Attributes$style, 'padding', '16px 20px'),
						A2($elm$html$Html$Attributes$style, 'border-radius', '10px'),
						function () {
						if (!maybeWinningTeam.$) {
							var winningTeam = maybeWinningTeam.a;
							return A2(
								$elm$html$Html$Attributes$style,
								'background',
								A2($author$project$Game$PostGame$colorTint, 0.09, winningTeam.he));
						} else {
							return A2($elm$html$Html$Attributes$style, 'background', '#f5f5f5');
						}
					}(),
						function () {
						if (!maybeWinningTeam.$) {
							var winningTeam = maybeWinningTeam.a;
							return A2(
								$elm$html$Html$Attributes$style,
								'border',
								'2px solid ' + A2($author$project$Game$PostGame$colorTint, 0.3, winningTeam.he));
						} else {
							return A2($elm$html$Html$Attributes$style, 'border', '2px solid #ddd');
						}
					}()
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'font-size', '0.75rem'),
								A2($elm$html$Html$Attributes$style, 'color', '#888'),
								A2($elm$html$Html$Attributes$style, 'text-transform', 'uppercase'),
								A2($elm$html$Html$Attributes$style, 'letter-spacing', '0.08em'),
								A2($elm$html$Html$Attributes$style, 'margin-bottom', '6px')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Winner')
							])),
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('soda-bubble'),
								A2($elm$html$Html$Attributes$style, 'padding', '0'),
								A2($elm$html$Html$Attributes$style, 'display', 'inline-block')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								function () {
									if (!maybeWinningTeam.$) {
										var winningTeam = maybeWinningTeam.a;
										return winningTeam.g5;
									} else {
										return 'Draw';
									}
								}())
							]))
					])),
				isOwner ? A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(1),
						A2($elm$html$Html$Attributes$style, 'margin-bottom', '24px'),
						A2($elm$html$Html$Attributes$style, 'width', '100%')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Play Again')
					])) : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'margin-bottom', '24px'),
						A2($elm$html$Html$Attributes$style, 'color', '#aaa'),
						A2($elm$html$Html$Attributes$style, 'font-size', '0.9rem'),
						A2($elm$html$Html$Attributes$style, 'text-align', 'center')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Waiting for the host to start a new game…')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'width', '100%')
					]),
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, team) {
							var teamPlayers = A2($author$project$Game$PostGame$playersForTeam, postGameState.an, team);
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'padding', '12px 14px'),
										A2(
										$elm$html$Html$Attributes$style,
										'border-left',
										'5px solid ' + $avh4$elm_color$Color$toCssString(team.he)),
										A2(
										$elm$html$Html$Attributes$style,
										'background',
										A2($author$project$Game$PostGame$colorTint, 0.06, team.he)),
										A2($elm$html$Html$Attributes$style, 'margin', '8px 0'),
										A2($elm$html$Html$Attributes$style, 'border-radius', '0 8px 8px 0')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'display', 'flex'),
												A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
												A2($elm$html$Html$Attributes$style, 'gap', '8px'),
												A2($elm$html$Html$Attributes$style, 'margin-bottom', '4px')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														A2($elm$html$Html$Attributes$style, 'font-size', '1.2rem')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														rankLabel(index))
													])),
												A2(
												$elm$html$Html$h3,
												_List_fromArray(
													[
														A2($elm$html$Html$Attributes$style, 'padding', '0')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(team.g5)
													]))
											])),
										A2(viewStatsTable, team.he, teamPlayers)
									]));
						}),
					teamsByHp))
			]));
};
var $author$project$Game$PreLobby$CreateGame = {$: 3};
var $author$project$Game$PreLobby$GameCodeInputUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Game$PreLobby$JoinGame = {$: 2};
var $author$project$Game$PreLobby$TopicUpdated = function (a) {
	return {$: 1, a: a};
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $author$project$Game$PreLobby$view = function (preLobbyState) {
	var onEnter = function (msg) {
		return A2(
			$elm$html$Html$Events$on,
			'keydown',
			A2(
				$elm$json$Json$Decode$andThen,
				function (key) {
					return (key === 'Enter') ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('not enter');
				},
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)));
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'flex', '1'),
				A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
				A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
				A2($elm$html$Html$Attributes$style, 'justify-content', 'space-around'),
				A2($elm$html$Html$Attributes$style, 'height', '90%'),
				A2($elm$html$Html$Attributes$style, 'display', 'flex')
			]),
		preLobbyState.h_ ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex-column-item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Settle It')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'margin-top', '16px'),
								A2($elm$html$Html$Attributes$style, 'color', '#666'),
								$elm$html$Html$Attributes$class('connecting')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Connecting…')
							]))
					]))
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex-column-item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Settle It')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'color', '#888'),
								A2($elm$html$Html$Attributes$style, 'font-size', '0.9rem'),
								A2($elm$html$Html$Attributes$style, 'margin-bottom', '4px')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Settle debates with a paintball shootout')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex-column-item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Join a debate topic')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'display', 'flex'),
								A2($elm$html$Html$Attributes$style, 'gap', '8px'),
								A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
								A2($elm$html$Html$Attributes$style, 'width', '100%')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_Utils_ap(
									_List_fromArray(
										[
											$elm$html$Html$Events$onInput($author$project$Game$PreLobby$GameCodeInputUpdated),
											$elm$html$Html$Attributes$value(preLobbyState.hJ),
											$elm$html$Html$Attributes$placeholder('4-letter game code'),
											A2($elm$html$Html$Attributes$attribute, 'autocorrect', 'off'),
											A2($elm$html$Html$Attributes$attribute, 'autocapitalize', 'off'),
											A2($elm$html$Html$Attributes$attribute, 'spellcheck', 'false'),
											A2($elm$html$Html$Attributes$style, 'margin', '0'),
											A2($elm$html$Html$Attributes$style, 'flex', '1')
										]),
									($elm$core$String$length(preLobbyState.hJ) === 4) ? _List_fromArray(
										[
											onEnter($author$project$Game$PreLobby$JoinGame)
										]) : _List_Nil),
								_List_Nil),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$disabled(
										$elm$core$String$length(preLobbyState.hJ) !== 4),
										$elm$html$Html$Events$onClick($author$project$Game$PreLobby$JoinGame),
										A2($elm$html$Html$Attributes$style, 'margin', '0'),
										A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Join')
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex-column-item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'display', 'flex'),
								A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
								A2($elm$html$Html$Attributes$style, 'gap', '12px'),
								A2($elm$html$Html$Attributes$style, 'width', '100%'),
								A2($elm$html$Html$Attributes$style, 'color', '#aaa')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'flex', '1'),
										A2($elm$html$Html$Attributes$style, 'height', '1px'),
										A2($elm$html$Html$Attributes$style, 'background', '#ddd')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'font-size', '0.85rem')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('OR')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'flex', '1'),
										A2($elm$html$Html$Attributes$style, 'height', '1px'),
										A2($elm$html$Html$Attributes$style, 'background', '#ddd')
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex-column-item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Start a new debate topic')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'color', '#888'),
								A2($elm$html$Html$Attributes$style, 'font-size', '0.85rem'),
								A2($elm$html$Html$Attributes$style, 'margin-bottom', '6px')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('e.g. \"Where should we eat tonight?\"')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'display', 'flex'),
								A2($elm$html$Html$Attributes$style, 'gap', '8px'),
								A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
								A2($elm$html$Html$Attributes$style, 'width', '100%')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_Utils_ap(
									_List_fromArray(
										[
											$elm$html$Html$Events$onInput($author$project$Game$PreLobby$TopicUpdated),
											$elm$html$Html$Attributes$value(preLobbyState.jd),
											$elm$html$Html$Attributes$placeholder('Enter a topic'),
											A2($elm$html$Html$Attributes$style, 'margin', '0'),
											A2($elm$html$Html$Attributes$style, 'flex', '1')
										]),
									($elm$core$String$length(preLobbyState.jd) > 0) ? _List_fromArray(
										[
											onEnter($author$project$Game$PreLobby$CreateGame)
										]) : _List_Nil),
								_List_Nil),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$disabled(
										!$elm$core$String$length(preLobbyState.jd)),
										$elm$html$Html$Events$onClick($author$project$Game$PreLobby$CreateGame),
										A2($elm$html$Html$Attributes$style, 'margin', '0'),
										A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Start')
									]))
							]))
					]))
			]));
};
var $author$project$Game$view = function (game) {
	switch (game.$) {
		case 0:
			var preLobbyState = game.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Game$PreLobbyMsg,
				$author$project$Game$PreLobby$view(preLobbyState));
		case 1:
			var lobbyState = game.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Game$LobbyMsg,
				$author$project$Game$Lobby$view(lobbyState));
		case 2:
			var playingState = game.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Game$PlayingMsg,
				$author$project$Game$Playing$view(playingState));
		default:
			var postGameState = game.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Game$PostGameMsg,
				$author$project$Game$PostGame$view(postGameState));
	}
};
var $author$project$Main$view = function (model) {
	return A2(
		$elm$html$Html$map,
		$author$project$Main$ClientUpdate,
		$author$project$Game$view(model.aO));
};
var $author$project$Main$main = $elm$browser$Browser$element(
	{
		hX: $author$project$Main$init,
		i2: function (model) {
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						function () {
						var _v0 = model.aO;
						switch (_v0.$) {
							case 2:
								return $elm$core$Platform$Sub$batch(
									_List_fromArray(
										[
											$elm$browser$Browser$Events$onAnimationFrameDelta(
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Main$ClientUpdate, $author$project$Game$PlayingMsg),
												$author$project$Game$Playing$Delta)),
											$elm$browser$Browser$Events$onResize(
											F2(
												function (_v1, _v2) {
													return $author$project$Main$ClientUpdate(
														$author$project$Game$PlayingMsg($author$project$Game$Playing$WindowResized));
												})),
											$elm$browser$Browser$Events$onKeyDown(
											A2(
												$elm$json$Json$Decode$map,
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$Main$ClientUpdate, $author$project$Game$PlayingMsg),
													$author$project$Game$Playing$KeyDown),
												A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string))),
											$elm$browser$Browser$Events$onKeyUp(
											A2(
												$elm$json$Json$Decode$map,
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$Main$ClientUpdate, $author$project$Game$PlayingMsg),
													$author$project$Game$Playing$KeyUp),
												A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)))
										]));
							case 1:
								return $author$project$Game$Lobby$gameLinkAction(
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Main$ClientUpdate, $author$project$Game$LobbyMsg),
										$author$project$Game$Lobby$LinkActionReceived));
							default:
								return $elm$core$Platform$Sub$none;
						}
					}(),
						$author$project$Main$gameUpdated($author$project$Main$ServerUpdate),
						$author$project$Main$bodiesUpdated(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Main$ClientUpdate, $author$project$Game$PlayingMsg),
							$author$project$Game$Playing$BodiesUpdated)),
						$author$project$Main$playerMeshLoaded(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Main$ClientUpdate, $author$project$Game$PlayingMsg),
							$author$project$Game$Playing$PlayerMeshLoaded))
					]));
		},
		jg: $author$project$Main$update,
		ji: $author$project$Main$view
	});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (skipGameSetup) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (savedPlayerName) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (playerId) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (gameCode) {
									return $elm$json$Json$Decode$succeed(
										{hJ: gameCode, iJ: playerId, be: savedPlayerName, es: skipGameSetup});
								},
								A2(
									$elm$json$Json$Decode$field,
									'gameCode',
									$elm$json$Json$Decode$oneOf(
										_List_fromArray(
											[
												$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
												A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
											]))));
						},
						A2($elm$json$Json$Decode$field, 'playerId', $elm$json$Json$Decode$string));
				},
				A2(
					$elm$json$Json$Decode$field,
					'savedPlayerName',
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
							]))));
		},
		A2($elm$json$Json$Decode$field, 'skipGameSetup', $elm$json$Json$Decode$bool)))(0)}});}(this));